(() => {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("78uex", function(module, exports) {




/*!
 * Outlayer v2.1.1
 * the brains and guts of a layout library
 * MIT license
 */ (function(window1, factory) {
    'use strict';
    // universal module definition
    /* jshint strict: false */ /* globals define, module, require */ if (typeof define == 'function' && define.amd) // AMD - RequireJS
    define([
        'ev-emitter/ev-emitter',
        'get-size/get-size',
        'fizzy-ui-utils/utils',
        './item'
    ], function(EvEmitter, getSize, utils, Item) {
        return factory(window1, EvEmitter, getSize, utils, Item);
    });
    else if (0, module.exports) // CommonJS - Browserify, Webpack
    module.exports = factory(window1, (parcelRequire("6egII")), (parcelRequire("7Xjok")), (parcelRequire("lddSr")), (parcelRequire("8WzJs")));
    else // browser global
    window1.Outlayer = factory(window1, window1.EvEmitter, window1.getSize, window1.fizzyUIUtils, window1.Outlayer.Item);
})(window, function factory(window1, EvEmitter, getSize, utils, Item) {
    'use strict';
    // ----- vars ----- //
    var console = window1.console;
    var jQuery = window1.jQuery;
    var noop = function() {};
    // -------------------------- Outlayer -------------------------- //
    // globally unique identifiers
    var GUID = 0;
    // internal store of all Outlayer intances
    var instances = {};
    /**
 * @param {Element, String} element
 * @param {Object} options
 * @constructor
 */ function Outlayer(element, options) {
        var queryElement = utils.getQueryElement(element);
        if (!queryElement) {
            if (console) console.error('Bad element for ' + this.constructor.namespace + ': ' + (queryElement || element));
            return;
        }
        this.element = queryElement;
        // add jQuery
        if (jQuery) this.$element = jQuery(this.element);
        // options
        this.options = utils.extend({}, this.constructor.defaults);
        this.option(options);
        // add id for Outlayer.getFromElement
        var id = ++GUID;
        this.element.outlayerGUID = id; // expando
        instances[id] = this; // associate via id
        // kick it off
        this._create();
        var isInitLayout = this._getOption('initLayout');
        if (isInitLayout) this.layout();
    }
    // settings are for internal use only
    Outlayer.namespace = 'outlayer';
    Outlayer.Item = Item;
    // default options
    Outlayer.defaults = {
        containerStyle: {
            position: 'relative'
        },
        initLayout: true,
        originLeft: true,
        originTop: true,
        resize: true,
        resizeContainer: true,
        // item options
        transitionDuration: '0.4s',
        hiddenStyle: {
            opacity: 0,
            transform: 'scale(0.001)'
        },
        visibleStyle: {
            opacity: 1,
            transform: 'scale(1)'
        }
    };
    var proto = Outlayer.prototype;
    // inherit EvEmitter
    utils.extend(proto, EvEmitter.prototype);
    /**
 * set options
 * @param {Object} opts
 */ proto.option = function(opts) {
        utils.extend(this.options, opts);
    };
    /**
 * get backwards compatible option value, check old name
 */ proto._getOption = function(option) {
        var oldOption = this.constructor.compatOptions[option];
        return oldOption && this.options[oldOption] !== undefined ? this.options[oldOption] : this.options[option];
    };
    Outlayer.compatOptions = {
        // currentName: oldName
        initLayout: 'isInitLayout',
        horizontal: 'isHorizontal',
        layoutInstant: 'isLayoutInstant',
        originLeft: 'isOriginLeft',
        originTop: 'isOriginTop',
        resize: 'isResizeBound',
        resizeContainer: 'isResizingContainer'
    };
    proto._create = function() {
        // get items from children
        this.reloadItems();
        // elements that affect layout, but are not laid out
        this.stamps = [];
        this.stamp(this.options.stamp);
        // set container style
        utils.extend(this.element.style, this.options.containerStyle);
        // bind resize method
        var canBindResize = this._getOption('resize');
        if (canBindResize) this.bindResize();
    };
    // goes through all children again and gets bricks in proper order
    proto.reloadItems = function() {
        // collection of item elements
        this.items = this._itemize(this.element.children);
    };
    /**
 * turn elements into Outlayer.Items to be used in layout
 * @param {Array or NodeList or HTMLElement} elems
 * @returns {Array} items - collection of new Outlayer Items
 */ proto._itemize = function(elems) {
        var itemElems = this._filterFindItemElements(elems);
        var Item = this.constructor.Item;
        // create new Outlayer Items for collection
        var items = [];
        for(var i = 0; i < itemElems.length; i++){
            var elem = itemElems[i];
            var item = new Item(elem, this);
            items.push(item);
        }
        return items;
    };
    /**
 * get item elements to be used in layout
 * @param {Array or NodeList or HTMLElement} elems
 * @returns {Array} items - item elements
 */ proto._filterFindItemElements = function(elems) {
        return utils.filterFindElements(elems, this.options.itemSelector);
    };
    /**
 * getter method for getting item elements
 * @returns {Array} elems - collection of item elements
 */ proto.getItemElements = function() {
        return this.items.map(function(item) {
            return item.element;
        });
    };
    // ----- init & layout ----- //
    /**
 * lays out all items
 */ proto.layout = function() {
        this._resetLayout();
        this._manageStamps();
        // don't animate first layout
        var layoutInstant = this._getOption('layoutInstant');
        var isInstant = layoutInstant !== undefined ? layoutInstant : !this._isLayoutInited;
        this.layoutItems(this.items, isInstant);
        // flag for initalized
        this._isLayoutInited = true;
    };
    // _init is alias for layout
    proto._init = proto.layout;
    /**
 * logic before any new layout
 */ proto._resetLayout = function() {
        this.getSize();
    };
    proto.getSize = function() {
        this.size = getSize(this.element);
    };
    /**
 * get measurement from option, for columnWidth, rowHeight, gutter
 * if option is String -> get element from selector string, & get size of element
 * if option is Element -> get size of element
 * else use option as a number
 *
 * @param {String} measurement
 * @param {String} size - width or height
 * @private
 */ proto._getMeasurement = function(measurement, size) {
        var option = this.options[measurement];
        var elem;
        if (!option) // default to 0
        this[measurement] = 0;
        else {
            // use option as an element
            if (typeof option == 'string') elem = this.element.querySelector(option);
            else if (option instanceof HTMLElement) elem = option;
            // use size of element, if element
            this[measurement] = elem ? getSize(elem)[size] : option;
        }
    };
    /**
 * layout a collection of item elements
 * @api public
 */ proto.layoutItems = function(items, isInstant) {
        items = this._getItemsForLayout(items);
        this._layoutItems(items, isInstant);
        this._postLayout();
    };
    /**
 * get the items to be laid out
 * you may want to skip over some items
 * @param {Array} items
 * @returns {Array} items
 */ proto._getItemsForLayout = function(items) {
        return items.filter(function(item) {
            return !item.isIgnored;
        });
    };
    /**
 * layout items
 * @param {Array} items
 * @param {Boolean} isInstant
 */ proto._layoutItems = function(items, isInstant) {
        this._emitCompleteOnItems('layout', items);
        if (!items || !items.length) // no items, emit event with empty array
        return;
        var queue = [];
        items.forEach(function(item) {
            // get x/y object from method
            var position = this._getItemLayoutPosition(item);
            // enqueue
            position.item = item;
            position.isInstant = isInstant || item.isLayoutInstant;
            queue.push(position);
        }, this);
        this._processLayoutQueue(queue);
    };
    /**
 * get item layout position
 * @param {Outlayer.Item} item
 * @returns {Object} x and y position
 */ proto._getItemLayoutPosition = function() {
        return {
            x: 0,
            y: 0
        };
    };
    /**
 * iterate over array and position each item
 * Reason being - separating this logic prevents 'layout invalidation'
 * thx @paul_irish
 * @param {Array} queue
 */ proto._processLayoutQueue = function(queue) {
        this.updateStagger();
        queue.forEach(function(obj, i) {
            this._positionItem(obj.item, obj.x, obj.y, obj.isInstant, i);
        }, this);
    };
    // set stagger from option in milliseconds number
    proto.updateStagger = function() {
        var stagger = this.options.stagger;
        if (stagger === null || stagger === undefined) {
            this.stagger = 0;
            return;
        }
        this.stagger = getMilliseconds(stagger);
        return this.stagger;
    };
    /**
 * Sets position of item in DOM
 * @param {Outlayer.Item} item
 * @param {Number} x - horizontal position
 * @param {Number} y - vertical position
 * @param {Boolean} isInstant - disables transitions
 */ proto._positionItem = function(item, x, y, isInstant, i) {
        if (isInstant) // if not transition, just set CSS
        item.goTo(x, y);
        else {
            item.stagger(i * this.stagger);
            item.moveTo(x, y);
        }
    };
    /**
 * Any logic you want to do after each layout,
 * i.e. size the container
 */ proto._postLayout = function() {
        this.resizeContainer();
    };
    proto.resizeContainer = function() {
        var isResizingContainer = this._getOption('resizeContainer');
        if (!isResizingContainer) return;
        var size = this._getContainerSize();
        if (size) {
            this._setContainerMeasure(size.width, true);
            this._setContainerMeasure(size.height, false);
        }
    };
    /**
 * Sets width or height of container if returned
 * @returns {Object} size
 *   @param {Number} width
 *   @param {Number} height
 */ proto._getContainerSize = noop;
    /**
 * @param {Number} measure - size of width or height
 * @param {Boolean} isWidth
 */ proto._setContainerMeasure = function(measure, isWidth) {
        if (measure === undefined) return;
        var elemSize = this.size;
        // add padding and border width if border box
        if (elemSize.isBorderBox) measure += isWidth ? elemSize.paddingLeft + elemSize.paddingRight + elemSize.borderLeftWidth + elemSize.borderRightWidth : elemSize.paddingBottom + elemSize.paddingTop + elemSize.borderTopWidth + elemSize.borderBottomWidth;
        measure = Math.max(measure, 0);
        this.element.style[isWidth ? 'width' : 'height'] = measure + 'px';
    };
    /**
 * emit eventComplete on a collection of items events
 * @param {String} eventName
 * @param {Array} items - Outlayer.Items
 */ proto._emitCompleteOnItems = function(eventName, items) {
        var _this = this;
        function onComplete() {
            _this.dispatchEvent(eventName + 'Complete', null, [
                items
            ]);
        }
        var count = items.length;
        if (!items || !count) {
            onComplete();
            return;
        }
        var doneCount = 0;
        function tick() {
            doneCount++;
            if (doneCount == count) onComplete();
        }
        // bind callback
        items.forEach(function(item) {
            item.once(eventName, tick);
        });
    };
    /**
 * emits events via EvEmitter and jQuery events
 * @param {String} type - name of event
 * @param {Event} event - original event
 * @param {Array} args - extra arguments
 */ proto.dispatchEvent = function(type, event, args) {
        // add original event to arguments
        var emitArgs = event ? [
            event
        ].concat(args) : args;
        this.emitEvent(type, emitArgs);
        if (jQuery) {
            // set this.$element
            this.$element = this.$element || jQuery(this.element);
            if (event) {
                // create jQuery event
                var $event = jQuery.Event(event);
                $event.type = type;
                this.$element.trigger($event, args);
            } else // just trigger with type if no event available
            this.$element.trigger(type, args);
        }
    };
    // -------------------------- ignore & stamps -------------------------- //
    /**
 * keep item in collection, but do not lay it out
 * ignored items do not get skipped in layout
 * @param {Element} elem
 */ proto.ignore = function(elem) {
        var item = this.getItem(elem);
        if (item) item.isIgnored = true;
    };
    /**
 * return item to layout collection
 * @param {Element} elem
 */ proto.unignore = function(elem) {
        var item = this.getItem(elem);
        if (item) delete item.isIgnored;
    };
    /**
 * adds elements to stamps
 * @param {NodeList, Array, Element, or String} elems
 */ proto.stamp = function(elems) {
        elems = this._find(elems);
        if (!elems) return;
        this.stamps = this.stamps.concat(elems);
        // ignore
        elems.forEach(this.ignore, this);
    };
    /**
 * removes elements to stamps
 * @param {NodeList, Array, or Element} elems
 */ proto.unstamp = function(elems) {
        elems = this._find(elems);
        if (!elems) return;
        elems.forEach(function(elem) {
            // filter out removed stamp elements
            utils.removeFrom(this.stamps, elem);
            this.unignore(elem);
        }, this);
    };
    /**
 * finds child elements
 * @param {NodeList, Array, Element, or String} elems
 * @returns {Array} elems
 */ proto._find = function(elems) {
        if (!elems) return;
        // if string, use argument as selector string
        if (typeof elems == 'string') elems = this.element.querySelectorAll(elems);
        elems = utils.makeArray(elems);
        return elems;
    };
    proto._manageStamps = function() {
        if (!this.stamps || !this.stamps.length) return;
        this._getBoundingRect();
        this.stamps.forEach(this._manageStamp, this);
    };
    // update boundingLeft / Top
    proto._getBoundingRect = function() {
        // get bounding rect for container element
        var boundingRect = this.element.getBoundingClientRect();
        var size = this.size;
        this._boundingRect = {
            left: boundingRect.left + size.paddingLeft + size.borderLeftWidth,
            top: boundingRect.top + size.paddingTop + size.borderTopWidth,
            right: boundingRect.right - (size.paddingRight + size.borderRightWidth),
            bottom: boundingRect.bottom - (size.paddingBottom + size.borderBottomWidth)
        };
    };
    /**
 * @param {Element} stamp
**/ proto._manageStamp = noop;
    /**
 * get x/y position of element relative to container element
 * @param {Element} elem
 * @returns {Object} offset - has left, top, right, bottom
 */ proto._getElementOffset = function(elem) {
        var boundingRect = elem.getBoundingClientRect();
        var thisRect = this._boundingRect;
        var size = getSize(elem);
        var offset = {
            left: boundingRect.left - thisRect.left - size.marginLeft,
            top: boundingRect.top - thisRect.top - size.marginTop,
            right: thisRect.right - boundingRect.right - size.marginRight,
            bottom: thisRect.bottom - boundingRect.bottom - size.marginBottom
        };
        return offset;
    };
    // -------------------------- resize -------------------------- //
    // enable event handlers for listeners
    // i.e. resize -> onresize
    proto.handleEvent = utils.handleEvent;
    /**
 * Bind layout to window resizing
 */ proto.bindResize = function() {
        window1.addEventListener('resize', this);
        this.isResizeBound = true;
    };
    /**
 * Unbind layout to window resizing
 */ proto.unbindResize = function() {
        window1.removeEventListener('resize', this);
        this.isResizeBound = false;
    };
    proto.onresize = function() {
        this.resize();
    };
    utils.debounceMethod(Outlayer, 'onresize', 100);
    proto.resize = function() {
        // don't trigger if size did not change
        // or if resize was unbound. See #9
        if (!this.isResizeBound || !this.needsResizeLayout()) return;
        this.layout();
    };
    /**
 * check if layout is needed post layout
 * @returns Boolean
 */ proto.needsResizeLayout = function() {
        var size = getSize(this.element);
        // check that this.size and size are there
        // IE8 triggers resize on body size change, so they might not be
        var hasSizes = this.size && size;
        return hasSizes && size.innerWidth !== this.size.innerWidth;
    };
    // -------------------------- methods -------------------------- //
    /**
 * add items to Outlayer instance
 * @param {Array or NodeList or Element} elems
 * @returns {Array} items - Outlayer.Items
**/ proto.addItems = function(elems) {
        var items = this._itemize(elems);
        // add items to collection
        if (items.length) this.items = this.items.concat(items);
        return items;
    };
    /**
 * Layout newly-appended item elements
 * @param {Array or NodeList or Element} elems
 */ proto.appended = function(elems) {
        var items = this.addItems(elems);
        if (!items.length) return;
        // layout and reveal just the new items
        this.layoutItems(items, true);
        this.reveal(items);
    };
    /**
 * Layout prepended elements
 * @param {Array or NodeList or Element} elems
 */ proto.prepended = function(elems) {
        var items = this._itemize(elems);
        if (!items.length) return;
        // add items to beginning of collection
        var previousItems = this.items.slice(0);
        this.items = items.concat(previousItems);
        // start new layout
        this._resetLayout();
        this._manageStamps();
        // layout new stuff without transition
        this.layoutItems(items, true);
        this.reveal(items);
        // layout previous items
        this.layoutItems(previousItems);
    };
    /**
 * reveal a collection of items
 * @param {Array of Outlayer.Items} items
 */ proto.reveal = function(items) {
        this._emitCompleteOnItems('reveal', items);
        if (!items || !items.length) return;
        var stagger = this.updateStagger();
        items.forEach(function(item, i) {
            item.stagger(i * stagger);
            item.reveal();
        });
    };
    /**
 * hide a collection of items
 * @param {Array of Outlayer.Items} items
 */ proto.hide = function(items) {
        this._emitCompleteOnItems('hide', items);
        if (!items || !items.length) return;
        var stagger = this.updateStagger();
        items.forEach(function(item, i) {
            item.stagger(i * stagger);
            item.hide();
        });
    };
    /**
 * reveal item elements
 * @param {Array}, {Element}, {NodeList} items
 */ proto.revealItemElements = function(elems) {
        var items = this.getItems(elems);
        this.reveal(items);
    };
    /**
 * hide item elements
 * @param {Array}, {Element}, {NodeList} items
 */ proto.hideItemElements = function(elems) {
        var items = this.getItems(elems);
        this.hide(items);
    };
    /**
 * get Outlayer.Item, given an Element
 * @param {Element} elem
 * @param {Function} callback
 * @returns {Outlayer.Item} item
 */ proto.getItem = function(elem) {
        // loop through items to get the one that matches
        for(var i = 0; i < this.items.length; i++){
            var item = this.items[i];
            if (item.element == elem) // return item
            return item;
        }
    };
    /**
 * get collection of Outlayer.Items, given Elements
 * @param {Array} elems
 * @returns {Array} items - Outlayer.Items
 */ proto.getItems = function(elems) {
        elems = utils.makeArray(elems);
        var items = [];
        elems.forEach(function(elem) {
            var item = this.getItem(elem);
            if (item) items.push(item);
        }, this);
        return items;
    };
    /**
 * remove element(s) from instance and DOM
 * @param {Array or NodeList or Element} elems
 */ proto.remove = function(elems) {
        var removeItems = this.getItems(elems);
        this._emitCompleteOnItems('remove', removeItems);
        // bail if no items to remove
        if (!removeItems || !removeItems.length) return;
        removeItems.forEach(function(item) {
            item.remove();
            // remove item from collection
            utils.removeFrom(this.items, item);
        }, this);
    };
    // ----- destroy ----- //
    // remove and disable Outlayer instance
    proto.destroy = function() {
        // clean up dynamic styles
        var style = this.element.style;
        style.height = '';
        style.position = '';
        style.width = '';
        // destroy items
        this.items.forEach(function(item) {
            item.destroy();
        });
        this.unbindResize();
        var id = this.element.outlayerGUID;
        delete instances[id]; // remove reference to instance by id
        delete this.element.outlayerGUID;
        // remove data for jQuery
        if (jQuery) jQuery.removeData(this.element, this.constructor.namespace);
    };
    // -------------------------- data -------------------------- //
    /**
 * get Outlayer instance from element
 * @param {Element} elem
 * @returns {Outlayer}
 */ Outlayer.data = function(elem) {
        elem = utils.getQueryElement(elem);
        var id = elem && elem.outlayerGUID;
        return id && instances[id];
    };
    // -------------------------- create Outlayer class -------------------------- //
    /**
 * create a layout class
 * @param {String} namespace
 */ Outlayer.create = function(namespace, options) {
        // sub-class Outlayer
        var Layout = subclass(Outlayer);
        // apply new options and compatOptions
        Layout.defaults = utils.extend({}, Outlayer.defaults);
        utils.extend(Layout.defaults, options);
        Layout.compatOptions = utils.extend({}, Outlayer.compatOptions);
        Layout.namespace = namespace;
        Layout.data = Outlayer.data;
        // sub-class Item
        Layout.Item = subclass(Item);
        // -------------------------- declarative -------------------------- //
        utils.htmlInit(Layout, namespace);
        // -------------------------- jQuery bridge -------------------------- //
        // make into jQuery plugin
        if (jQuery && jQuery.bridget) jQuery.bridget(namespace, Layout);
        return Layout;
    };
    function subclass(Parent) {
        function SubClass() {
            Parent.apply(this, arguments);
        }
        SubClass.prototype = Object.create(Parent.prototype);
        SubClass.prototype.constructor = SubClass;
        return SubClass;
    }
    // ----- helpers ----- //
    // how many milliseconds are in each unit
    var msUnits = {
        ms: 1,
        s: 1000
    };
    // munge time-like parameter into millisecond number
    // '0.4s' -> 40
    function getMilliseconds(time) {
        if (typeof time == 'number') return time;
        var matches = time.match(/(^\d*\.?\d*)(\w*)/);
        var num = matches && matches[1];
        var unit = matches && matches[2];
        if (!num.length) return 0;
        num = parseFloat(num);
        var mult = msUnits[unit] || 1;
        return num * mult;
    }
    // ----- fin ----- //
    // back in global
    Outlayer.Item = Item;
    return Outlayer;
});

});
parcelRegister("6egII", function(module, exports) {
/**
 * EvEmitter v1.1.0
 * Lil' event emitter
 * MIT License
 */ /* jshint unused: true, undef: true, strict: true */ (function(global, factory) {
    // universal module definition
    /* jshint strict: false */ /* globals define, module, window */ if (typeof define == 'function' && define.amd) // AMD - RequireJS
    define(factory);
    else if (0, module.exports) // CommonJS - Browserify, Webpack
    module.exports = factory();
    else // Browser globals
    global.EvEmitter = factory();
})(typeof window != 'undefined' ? window : module.exports, function() {
    "use strict";
    function EvEmitter() {}
    var proto = EvEmitter.prototype;
    proto.on = function(eventName, listener) {
        if (!eventName || !listener) return;
        // set events hash
        var events = this._events = this._events || {};
        // set listeners array
        var listeners = events[eventName] = events[eventName] || [];
        // only add once
        if (listeners.indexOf(listener) == -1) listeners.push(listener);
        return this;
    };
    proto.once = function(eventName, listener) {
        if (!eventName || !listener) return;
        // add event
        this.on(eventName, listener);
        // set once flag
        // set onceEvents hash
        var onceEvents = this._onceEvents = this._onceEvents || {};
        // set onceListeners object
        var onceListeners = onceEvents[eventName] = onceEvents[eventName] || {};
        // set flag
        onceListeners[listener] = true;
        return this;
    };
    proto.off = function(eventName, listener) {
        var listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length) return;
        var index = listeners.indexOf(listener);
        if (index != -1) listeners.splice(index, 1);
        return this;
    };
    proto.emitEvent = function(eventName, args) {
        var listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length) return;
        // copy over to avoid interference if .off() in listener
        listeners = listeners.slice(0);
        args = args || [];
        // once stuff
        var onceListeners = this._onceEvents && this._onceEvents[eventName];
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            var isOnce = onceListeners && onceListeners[listener];
            if (isOnce) {
                // remove listener
                // remove before trigger to prevent recursion
                this.off(eventName, listener);
                // unset once flag
                delete onceListeners[listener];
            }
            // trigger listener
            listener.apply(this, args);
        }
        return this;
    };
    proto.allOff = function() {
        delete this._events;
        delete this._onceEvents;
    };
    return EvEmitter;
});

});

parcelRegister("7Xjok", function(module, exports) {
/*!
 * getSize v2.0.3
 * measure size of elements
 * MIT license
 */ /* jshint browser: true, strict: true, undef: true, unused: true */ /* globals console: false */ (function(window1, factory) {
    /* jshint strict: false */ /* globals define, module */ if (typeof define == 'function' && define.amd) // AMD
    define(factory);
    else if (0, module.exports) // CommonJS
    module.exports = factory();
    else // browser global
    window1.getSize = factory();
})(window, function factory() {
    'use strict';
    // -------------------------- helpers -------------------------- //
    // get a number from a string, not a percentage
    function getStyleSize(value) {
        var num = parseFloat(value);
        // not a percent like '100%', and a number
        var isValid = value.indexOf('%') == -1 && !isNaN(num);
        return isValid && num;
    }
    function noop() {}
    var logError = typeof console == 'undefined' ? noop : function(message) {
        console.error(message);
    };
    // -------------------------- measurements -------------------------- //
    var measurements = [
        'paddingLeft',
        'paddingRight',
        'paddingTop',
        'paddingBottom',
        'marginLeft',
        'marginRight',
        'marginTop',
        'marginBottom',
        'borderLeftWidth',
        'borderRightWidth',
        'borderTopWidth',
        'borderBottomWidth'
    ];
    var measurementsLength = measurements.length;
    function getZeroSize() {
        var size = {
            width: 0,
            height: 0,
            innerWidth: 0,
            innerHeight: 0,
            outerWidth: 0,
            outerHeight: 0
        };
        for(var i = 0; i < measurementsLength; i++){
            var measurement = measurements[i];
            size[measurement] = 0;
        }
        return size;
    }
    // -------------------------- getStyle -------------------------- //
    /**
 * getStyle, get style of element, check for Firefox bug
 * https://bugzilla.mozilla.org/show_bug.cgi?id=548397
 */ function getStyle(elem) {
        var style = getComputedStyle(elem);
        if (!style) logError('Style returned ' + style + '. Are you running this code in a hidden iframe on Firefox? ' + 'See https://bit.ly/getsizebug1');
        return style;
    }
    // -------------------------- setup -------------------------- //
    var isSetup = false;
    var isBoxSizeOuter;
    /**
 * setup
 * check isBoxSizerOuter
 * do on first getSize() rather than on page load for Firefox bug
 */ function setup() {
        // setup once
        if (isSetup) return;
        isSetup = true;
        // -------------------------- box sizing -------------------------- //
        /**
   * Chrome & Safari measure the outer-width on style.width on border-box elems
   * IE11 & Firefox<29 measures the inner-width
   */ var div = document.createElement('div');
        div.style.width = '200px';
        div.style.padding = '1px 2px 3px 4px';
        div.style.borderStyle = 'solid';
        div.style.borderWidth = '1px 2px 3px 4px';
        div.style.boxSizing = 'border-box';
        var body = document.body || document.documentElement;
        body.appendChild(div);
        var style = getStyle(div);
        // round value for browser zoom. desandro/masonry#928
        isBoxSizeOuter = Math.round(getStyleSize(style.width)) == 200;
        getSize.isBoxSizeOuter = isBoxSizeOuter;
        body.removeChild(div);
    }
    // -------------------------- getSize -------------------------- //
    function getSize(elem) {
        setup();
        // use querySeletor if elem is string
        if (typeof elem == 'string') elem = document.querySelector(elem);
        // do not proceed on non-objects
        if (!elem || typeof elem != 'object' || !elem.nodeType) return;
        var style = getStyle(elem);
        // if hidden, everything is 0
        if (style.display == 'none') return getZeroSize();
        var size = {};
        size.width = elem.offsetWidth;
        size.height = elem.offsetHeight;
        var isBorderBox = size.isBorderBox = style.boxSizing == 'border-box';
        // get all measurements
        for(var i = 0; i < measurementsLength; i++){
            var measurement = measurements[i];
            var value = style[measurement];
            var num = parseFloat(value);
            // any 'auto', 'medium' value will be 0
            size[measurement] = !isNaN(num) ? num : 0;
        }
        var paddingWidth = size.paddingLeft + size.paddingRight;
        var paddingHeight = size.paddingTop + size.paddingBottom;
        var marginWidth = size.marginLeft + size.marginRight;
        var marginHeight = size.marginTop + size.marginBottom;
        var borderWidth = size.borderLeftWidth + size.borderRightWidth;
        var borderHeight = size.borderTopWidth + size.borderBottomWidth;
        var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;
        // overwrite width and height if we can get it from style
        var styleWidth = getStyleSize(style.width);
        if (styleWidth !== false) size.width = styleWidth + // add padding and border unless it's already including it
        (isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth);
        var styleHeight = getStyleSize(style.height);
        if (styleHeight !== false) size.height = styleHeight + // add padding and border unless it's already including it
        (isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight);
        size.innerWidth = size.width - (paddingWidth + borderWidth);
        size.innerHeight = size.height - (paddingHeight + borderHeight);
        size.outerWidth = size.width + marginWidth;
        size.outerHeight = size.height + marginHeight;
        return size;
    }
    return getSize;
});

});

parcelRegister("lddSr", function(module, exports) {

/**
 * Fizzy UI utils v2.0.7
 * MIT license
 */ /*jshint browser: true, undef: true, unused: true, strict: true */ (function(window1, factory) {
    // universal module definition
    /*jshint strict: false */ /*globals define, module, require */ if (typeof define == 'function' && define.amd) // AMD
    define([
        'desandro-matches-selector/matches-selector'
    ], function(matchesSelector) {
        return factory(window1, matchesSelector);
    });
    else if (0, module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("2cy71")));
    else // browser global
    window1.fizzyUIUtils = factory(window1, window1.matchesSelector);
})(window, function factory(window1, matchesSelector) {
    'use strict';
    var utils = {};
    // ----- extend ----- //
    // extends objects
    utils.extend = function(a, b) {
        for(var prop in b)a[prop] = b[prop];
        return a;
    };
    // ----- modulo ----- //
    utils.modulo = function(num, div) {
        return (num % div + div) % div;
    };
    // ----- makeArray ----- //
    var arraySlice = Array.prototype.slice;
    // turn element or nodeList into an array
    utils.makeArray = function(obj) {
        if (Array.isArray(obj)) // use object if already an array
        return obj;
        // return empty array if undefined or null. #6
        if (obj === null || obj === undefined) return [];
        var isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
        if (isArrayLike) // convert nodeList to array
        return arraySlice.call(obj);
        // array of single index
        return [
            obj
        ];
    };
    // ----- removeFrom ----- //
    utils.removeFrom = function(ary, obj) {
        var index = ary.indexOf(obj);
        if (index != -1) ary.splice(index, 1);
    };
    // ----- getParent ----- //
    utils.getParent = function(elem, selector) {
        while(elem.parentNode && elem != document.body){
            elem = elem.parentNode;
            if (matchesSelector(elem, selector)) return elem;
        }
    };
    // ----- getQueryElement ----- //
    // use element as selector string
    utils.getQueryElement = function(elem) {
        if (typeof elem == 'string') return document.querySelector(elem);
        return elem;
    };
    // ----- handleEvent ----- //
    // enable .ontype to trigger from .addEventListener( elem, 'type' )
    utils.handleEvent = function(event) {
        var method = 'on' + event.type;
        if (this[method]) this[method](event);
    };
    // ----- filterFindElements ----- //
    utils.filterFindElements = function(elems, selector) {
        // make array of elems
        elems = utils.makeArray(elems);
        var ffElems = [];
        elems.forEach(function(elem) {
            // check that elem is an actual element
            if (!(elem instanceof HTMLElement)) return;
            // add elem if no selector
            if (!selector) {
                ffElems.push(elem);
                return;
            }
            // filter & find items if we have a selector
            // filter
            if (matchesSelector(elem, selector)) ffElems.push(elem);
            // find children
            var childElems = elem.querySelectorAll(selector);
            // concat childElems to filterFound array
            for(var i = 0; i < childElems.length; i++)ffElems.push(childElems[i]);
        });
        return ffElems;
    };
    // ----- debounceMethod ----- //
    utils.debounceMethod = function(_class, methodName, threshold) {
        threshold = threshold || 100;
        // original method
        var method = _class.prototype[methodName];
        var timeoutName = methodName + 'Timeout';
        _class.prototype[methodName] = function() {
            var timeout = this[timeoutName];
            clearTimeout(timeout);
            var args = arguments;
            var _this = this;
            this[timeoutName] = setTimeout(function() {
                method.apply(_this, args);
                delete _this[timeoutName];
            }, threshold);
        };
    };
    // ----- docReady ----- //
    utils.docReady = function(callback) {
        var readyState = document.readyState;
        if (readyState == 'complete' || readyState == 'interactive') // do async to allow for other scripts to run. metafizzy/flickity#441
        setTimeout(callback);
        else document.addEventListener('DOMContentLoaded', callback);
    };
    // ----- htmlInit ----- //
    // http://jamesroberts.name/blog/2010/02/22/string-functions-for-javascript-trim-to-camel-case-to-dashed-and-to-underscore/
    utils.toDashed = function(str) {
        return str.replace(/(.)([A-Z])/g, function(match, $1, $2) {
            return $1 + '-' + $2;
        }).toLowerCase();
    };
    var console = window1.console;
    /**
 * allow user to initialize classes via [data-namespace] or .js-namespace class
 * htmlInit( Widget, 'widgetName' )
 * options are parsed from data-namespace-options
 */ utils.htmlInit = function(WidgetClass, namespace) {
        utils.docReady(function() {
            var dashedNamespace = utils.toDashed(namespace);
            var dataAttr = 'data-' + dashedNamespace;
            var dataAttrElems = document.querySelectorAll('[' + dataAttr + ']');
            var jsDashElems = document.querySelectorAll('.js-' + dashedNamespace);
            var elems = utils.makeArray(dataAttrElems).concat(utils.makeArray(jsDashElems));
            var dataOptionsAttr = dataAttr + '-options';
            var jQuery = window1.jQuery;
            elems.forEach(function(elem) {
                var attr = elem.getAttribute(dataAttr) || elem.getAttribute(dataOptionsAttr);
                var options;
                try {
                    options = attr && JSON.parse(attr);
                } catch (error) {
                    // log error, do not initialize
                    if (console) console.error('Error parsing ' + dataAttr + ' on ' + elem.className + ': ' + error);
                    return;
                }
                // initialize
                var instance = new WidgetClass(elem, options);
                // make available via $().data('namespace')
                if (jQuery) jQuery.data(elem, namespace, instance);
            });
        });
    };
    // -----  ----- //
    return utils;
});

});
parcelRegister("2cy71", function(module, exports) {
/**
 * matchesSelector v2.0.2
 * matchesSelector( element, '.selector' )
 * MIT license
 */ /*jshint browser: true, strict: true, undef: true, unused: true */ (function(window1, factory) {
    /*global define: false, module: false */ 'use strict';
    // universal module definition
    if (typeof define == 'function' && define.amd) // AMD
    define(factory);
    else if (0, module.exports) // CommonJS
    module.exports = factory();
    else // browser global
    window1.matchesSelector = factory();
})(window, function factory() {
    'use strict';
    var matchesMethod = function() {
        var ElemProto = window.Element.prototype;
        // check for the standard method name first
        if (ElemProto.matches) return 'matches';
        // check un-prefixed
        if (ElemProto.matchesSelector) return 'matchesSelector';
        // check vendor prefixes
        var prefixes = [
            'webkit',
            'moz',
            'ms',
            'o'
        ];
        for(var i = 0; i < prefixes.length; i++){
            var prefix = prefixes[i];
            var method = prefix + 'MatchesSelector';
            if (ElemProto[method]) return method;
        }
    }();
    return function matchesSelector(elem, selector) {
        return elem[matchesMethod](selector);
    };
});

});


parcelRegister("8WzJs", function(module, exports) {


/**
 * Outlayer Item
 */ (function(window1, factory) {
    // universal module definition
    /* jshint strict: false */ /* globals define, module, require */ if (typeof define == 'function' && define.amd) // AMD - RequireJS
    define([
        'ev-emitter/ev-emitter',
        'get-size/get-size'
    ], factory);
    else if (0, module.exports) // CommonJS - Browserify, Webpack
    module.exports = factory((parcelRequire("6egII")), (parcelRequire("7Xjok")));
    else {
        // browser global
        window1.Outlayer = {};
        window1.Outlayer.Item = factory(window1.EvEmitter, window1.getSize);
    }
})(window, function factory(EvEmitter, getSize) {
    'use strict';
    // ----- helpers ----- //
    function isEmptyObj(obj) {
        for(var prop in obj)return false;
        prop = null;
        return true;
    }
    // -------------------------- CSS3 support -------------------------- //
    var docElemStyle = document.documentElement.style;
    var transitionProperty = typeof docElemStyle.transition == 'string' ? 'transition' : 'WebkitTransition';
    var transformProperty = typeof docElemStyle.transform == 'string' ? 'transform' : 'WebkitTransform';
    var transitionEndEvent = {
        WebkitTransition: 'webkitTransitionEnd',
        transition: 'transitionend'
    }[transitionProperty];
    // cache all vendor properties that could have vendor prefix
    var vendorProperties = {
        transform: transformProperty,
        transition: transitionProperty,
        transitionDuration: transitionProperty + 'Duration',
        transitionProperty: transitionProperty + 'Property',
        transitionDelay: transitionProperty + 'Delay'
    };
    // -------------------------- Item -------------------------- //
    function Item(element, layout) {
        if (!element) return;
        this.element = element;
        // parent layout class, i.e. Masonry, Isotope, or Packery
        this.layout = layout;
        this.position = {
            x: 0,
            y: 0
        };
        this._create();
    }
    // inherit EvEmitter
    var proto = Item.prototype = Object.create(EvEmitter.prototype);
    proto.constructor = Item;
    proto._create = function() {
        // transition objects
        this._transn = {
            ingProperties: {},
            clean: {},
            onEnd: {}
        };
        this.css({
            position: 'absolute'
        });
    };
    // trigger specified handler for event type
    proto.handleEvent = function(event) {
        var method = 'on' + event.type;
        if (this[method]) this[method](event);
    };
    proto.getSize = function() {
        this.size = getSize(this.element);
    };
    /**
 * apply CSS styles to element
 * @param {Object} style
 */ proto.css = function(style) {
        var elemStyle = this.element.style;
        for(var prop in style){
            // use vendor property if available
            var supportedProp = vendorProperties[prop] || prop;
            elemStyle[supportedProp] = style[prop];
        }
    };
    // measure position, and sets it
    proto.getPosition = function() {
        var style = getComputedStyle(this.element);
        var isOriginLeft = this.layout._getOption('originLeft');
        var isOriginTop = this.layout._getOption('originTop');
        var xValue = style[isOriginLeft ? 'left' : 'right'];
        var yValue = style[isOriginTop ? 'top' : 'bottom'];
        var x = parseFloat(xValue);
        var y = parseFloat(yValue);
        // convert percent to pixels
        var layoutSize = this.layout.size;
        if (xValue.indexOf('%') != -1) x = x / 100 * layoutSize.width;
        if (yValue.indexOf('%') != -1) y = y / 100 * layoutSize.height;
        // clean up 'auto' or other non-integer values
        x = isNaN(x) ? 0 : x;
        y = isNaN(y) ? 0 : y;
        // remove padding from measurement
        x -= isOriginLeft ? layoutSize.paddingLeft : layoutSize.paddingRight;
        y -= isOriginTop ? layoutSize.paddingTop : layoutSize.paddingBottom;
        this.position.x = x;
        this.position.y = y;
    };
    // set settled position, apply padding
    proto.layoutPosition = function() {
        var layoutSize = this.layout.size;
        var style = {};
        var isOriginLeft = this.layout._getOption('originLeft');
        var isOriginTop = this.layout._getOption('originTop');
        // x
        var xPadding = isOriginLeft ? 'paddingLeft' : 'paddingRight';
        var xProperty = isOriginLeft ? 'left' : 'right';
        var xResetProperty = isOriginLeft ? 'right' : 'left';
        var x = this.position.x + layoutSize[xPadding];
        // set in percentage or pixels
        style[xProperty] = this.getXValue(x);
        // reset other property
        style[xResetProperty] = '';
        // y
        var yPadding = isOriginTop ? 'paddingTop' : 'paddingBottom';
        var yProperty = isOriginTop ? 'top' : 'bottom';
        var yResetProperty = isOriginTop ? 'bottom' : 'top';
        var y = this.position.y + layoutSize[yPadding];
        // set in percentage or pixels
        style[yProperty] = this.getYValue(y);
        // reset other property
        style[yResetProperty] = '';
        this.css(style);
        this.emitEvent('layout', [
            this
        ]);
    };
    proto.getXValue = function(x) {
        var isHorizontal = this.layout._getOption('horizontal');
        return this.layout.options.percentPosition && !isHorizontal ? x / this.layout.size.width * 100 + '%' : x + 'px';
    };
    proto.getYValue = function(y) {
        var isHorizontal = this.layout._getOption('horizontal');
        return this.layout.options.percentPosition && isHorizontal ? y / this.layout.size.height * 100 + '%' : y + 'px';
    };
    proto._transitionTo = function(x, y) {
        this.getPosition();
        // get current x & y from top/left
        var curX = this.position.x;
        var curY = this.position.y;
        var didNotMove = x == this.position.x && y == this.position.y;
        // save end position
        this.setPosition(x, y);
        // if did not move and not transitioning, just go to layout
        if (didNotMove && !this.isTransitioning) {
            this.layoutPosition();
            return;
        }
        var transX = x - curX;
        var transY = y - curY;
        var transitionStyle = {};
        transitionStyle.transform = this.getTranslate(transX, transY);
        this.transition({
            to: transitionStyle,
            onTransitionEnd: {
                transform: this.layoutPosition
            },
            isCleaning: true
        });
    };
    proto.getTranslate = function(x, y) {
        // flip cooridinates if origin on right or bottom
        var isOriginLeft = this.layout._getOption('originLeft');
        var isOriginTop = this.layout._getOption('originTop');
        x = isOriginLeft ? x : -x;
        y = isOriginTop ? y : -y;
        return 'translate3d(' + x + 'px, ' + y + 'px, 0)';
    };
    // non transition + transform support
    proto.goTo = function(x, y) {
        this.setPosition(x, y);
        this.layoutPosition();
    };
    proto.moveTo = proto._transitionTo;
    proto.setPosition = function(x, y) {
        this.position.x = parseFloat(x);
        this.position.y = parseFloat(y);
    };
    // ----- transition ----- //
    /**
 * @param {Object} style - CSS
 * @param {Function} onTransitionEnd
 */ // non transition, just trigger callback
    proto._nonTransition = function(args) {
        this.css(args.to);
        if (args.isCleaning) this._removeStyles(args.to);
        for(var prop in args.onTransitionEnd)args.onTransitionEnd[prop].call(this);
    };
    /**
 * proper transition
 * @param {Object} args - arguments
 *   @param {Object} to - style to transition to
 *   @param {Object} from - style to start transition from
 *   @param {Boolean} isCleaning - removes transition styles after transition
 *   @param {Function} onTransitionEnd - callback
 */ proto.transition = function(args) {
        // redirect to nonTransition if no transition duration
        if (!parseFloat(this.layout.options.transitionDuration)) {
            this._nonTransition(args);
            return;
        }
        var _transition = this._transn;
        // keep track of onTransitionEnd callback by css property
        for(var prop in args.onTransitionEnd)_transition.onEnd[prop] = args.onTransitionEnd[prop];
        // keep track of properties that are transitioning
        for(prop in args.to){
            _transition.ingProperties[prop] = true;
            // keep track of properties to clean up when transition is done
            if (args.isCleaning) _transition.clean[prop] = true;
        }
        // set from styles
        if (args.from) {
            this.css(args.from);
            // force redraw. http://blog.alexmaccaw.com/css-transitions
            var h = this.element.offsetHeight;
            // hack for JSHint to hush about unused var
            h = null;
        }
        // enable transition
        this.enableTransition(args.to);
        // set styles that are transitioning
        this.css(args.to);
        this.isTransitioning = true;
    };
    // dash before all cap letters, including first for
    // WebkitTransform => -webkit-transform
    function toDashedAll(str) {
        return str.replace(/([A-Z])/g, function($1) {
            return '-' + $1.toLowerCase();
        });
    }
    var transitionProps = 'opacity,' + toDashedAll(transformProperty);
    proto.enableTransition = function() {
        // HACK changing transitionProperty during a transition
        // will cause transition to jump
        if (this.isTransitioning) return;
        // make `transition: foo, bar, baz` from style object
        // HACK un-comment this when enableTransition can work
        // while a transition is happening
        // var transitionValues = [];
        // for ( var prop in style ) {
        //   // dash-ify camelCased properties like WebkitTransition
        //   prop = vendorProperties[ prop ] || prop;
        //   transitionValues.push( toDashedAll( prop ) );
        // }
        // munge number to millisecond, to match stagger
        var duration = this.layout.options.transitionDuration;
        duration = typeof duration == 'number' ? duration + 'ms' : duration;
        // enable transition styles
        this.css({
            transitionProperty: transitionProps,
            transitionDuration: duration,
            transitionDelay: this.staggerDelay || 0
        });
        // listen for transition end event
        this.element.addEventListener(transitionEndEvent, this, false);
    };
    // ----- events ----- //
    proto.onwebkitTransitionEnd = function(event) {
        this.ontransitionend(event);
    };
    proto.onotransitionend = function(event) {
        this.ontransitionend(event);
    };
    // properties that I munge to make my life easier
    var dashedVendorProperties = {
        '-webkit-transform': 'transform'
    };
    proto.ontransitionend = function(event) {
        // disregard bubbled events from children
        if (event.target !== this.element) return;
        var _transition = this._transn;
        // get property name of transitioned property, convert to prefix-free
        var propertyName = dashedVendorProperties[event.propertyName] || event.propertyName;
        // remove property that has completed transitioning
        delete _transition.ingProperties[propertyName];
        // check if any properties are still transitioning
        if (isEmptyObj(_transition.ingProperties)) // all properties have completed transitioning
        this.disableTransition();
        // clean style
        if (propertyName in _transition.clean) {
            // clean up style
            this.element.style[event.propertyName] = '';
            delete _transition.clean[propertyName];
        }
        // trigger onTransitionEnd callback
        if (propertyName in _transition.onEnd) {
            var onTransitionEnd = _transition.onEnd[propertyName];
            onTransitionEnd.call(this);
            delete _transition.onEnd[propertyName];
        }
        this.emitEvent('transitionEnd', [
            this
        ]);
    };
    proto.disableTransition = function() {
        this.removeTransitionStyles();
        this.element.removeEventListener(transitionEndEvent, this, false);
        this.isTransitioning = false;
    };
    /**
 * removes style property from element
 * @param {Object} style
**/ proto._removeStyles = function(style) {
        // clean up transition styles
        var cleanStyle = {};
        for(var prop in style)cleanStyle[prop] = '';
        this.css(cleanStyle);
    };
    var cleanTransitionStyle = {
        transitionProperty: '',
        transitionDuration: '',
        transitionDelay: ''
    };
    proto.removeTransitionStyles = function() {
        // remove transition
        this.css(cleanTransitionStyle);
    };
    // ----- stagger ----- //
    proto.stagger = function(delay) {
        delay = isNaN(delay) ? 0 : delay;
        this.staggerDelay = delay + 'ms';
    };
    // ----- show/hide/remove ----- //
    // remove element from DOM
    proto.removeElem = function() {
        this.element.parentNode.removeChild(this.element);
        // remove display: none
        this.css({
            display: ''
        });
        this.emitEvent('remove', [
            this
        ]);
    };
    proto.remove = function() {
        // just remove element if no transition support or no transition
        if (!transitionProperty || !parseFloat(this.layout.options.transitionDuration)) {
            this.removeElem();
            return;
        }
        // start transition
        this.once('transitionEnd', function() {
            this.removeElem();
        });
        this.hide();
    };
    proto.reveal = function() {
        delete this.isHidden;
        // remove display: none
        this.css({
            display: ''
        });
        var options = this.layout.options;
        var onTransitionEnd = {};
        var transitionEndProperty = this.getHideRevealTransitionEndProperty('visibleStyle');
        onTransitionEnd[transitionEndProperty] = this.onRevealTransitionEnd;
        this.transition({
            from: options.hiddenStyle,
            to: options.visibleStyle,
            isCleaning: true,
            onTransitionEnd: onTransitionEnd
        });
    };
    proto.onRevealTransitionEnd = function() {
        // check if still visible
        // during transition, item may have been hidden
        if (!this.isHidden) this.emitEvent('reveal');
    };
    /**
 * get style property use for hide/reveal transition end
 * @param {String} styleProperty - hiddenStyle/visibleStyle
 * @returns {String}
 */ proto.getHideRevealTransitionEndProperty = function(styleProperty) {
        var optionStyle = this.layout.options[styleProperty];
        // use opacity
        if (optionStyle.opacity) return 'opacity';
        // get first property
        for(var prop in optionStyle)return prop;
    };
    proto.hide = function() {
        // set flag
        this.isHidden = true;
        // remove display: none
        this.css({
            display: ''
        });
        var options = this.layout.options;
        var onTransitionEnd = {};
        var transitionEndProperty = this.getHideRevealTransitionEndProperty('hiddenStyle');
        onTransitionEnd[transitionEndProperty] = this.onHideTransitionEnd;
        this.transition({
            from: options.visibleStyle,
            to: options.hiddenStyle,
            // keep hidden stuff hidden
            isCleaning: true,
            onTransitionEnd: onTransitionEnd
        });
    };
    proto.onHideTransitionEnd = function() {
        // check if still hidden
        // during transition, item may have been un-hidden
        if (this.isHidden) {
            this.css({
                display: 'none'
            });
            this.emitEvent('hide');
        }
    };
    proto.destroy = function() {
        this.css({
            position: '',
            left: '',
            right: '',
            top: '',
            bottom: '',
            transition: '',
            transform: ''
        });
    };
    return Item;
});

});


var $c5b45d56ccbd55bb$exports = {};


/*!
 * Masonry v4.2.2
 * Cascading grid layout library
 * https://masonry.desandro.com
 * MIT License
 * by David DeSandro
 */ (function(window1, factory) {
    // universal module definition
    /* jshint strict: false */ /*globals define, module, require */ if (typeof define == 'function' && define.amd) // AMD
    define([
        'outlayer/outlayer',
        'get-size/get-size'
    ], factory);
    else if (0, $c5b45d56ccbd55bb$exports) // CommonJS
    $c5b45d56ccbd55bb$exports = factory((parcelRequire("78uex")), (parcelRequire("7Xjok")));
    else // browser global
    window1.Masonry = factory(window1.Outlayer, window1.getSize);
})(window, function factory(Outlayer, getSize) {
    'use strict';
    // -------------------------- masonryDefinition -------------------------- //
    // create an Outlayer layout class
    var Masonry = Outlayer.create('masonry');
    // isFitWidth -> fitWidth
    Masonry.compatOptions.fitWidth = 'isFitWidth';
    var proto = Masonry.prototype;
    proto._resetLayout = function() {
        this.getSize();
        this._getMeasurement('columnWidth', 'outerWidth');
        this._getMeasurement('gutter', 'outerWidth');
        this.measureColumns();
        // reset column Y
        this.colYs = [];
        for(var i = 0; i < this.cols; i++)this.colYs.push(0);
        this.maxY = 0;
        this.horizontalColIndex = 0;
    };
    proto.measureColumns = function() {
        this.getContainerWidth();
        // if columnWidth is 0, default to outerWidth of first item
        if (!this.columnWidth) {
            var firstItem = this.items[0];
            var firstItemElem = firstItem && firstItem.element;
            // columnWidth fall back to item of first element
            this.columnWidth = firstItemElem && getSize(firstItemElem).outerWidth || // if first elem has no width, default to size of container
            this.containerWidth;
        }
        var columnWidth = this.columnWidth += this.gutter;
        // calculate columns
        var containerWidth = this.containerWidth + this.gutter;
        var cols = containerWidth / columnWidth;
        // fix rounding errors, typically with gutters
        var excess = columnWidth - containerWidth % columnWidth;
        // if overshoot is less than a pixel, round up, otherwise floor it
        var mathMethod = excess && excess < 1 ? 'round' : 'floor';
        cols = Math[mathMethod](cols);
        this.cols = Math.max(cols, 1);
    };
    proto.getContainerWidth = function() {
        // container is parent if fit width
        var isFitWidth = this._getOption('fitWidth');
        var container = isFitWidth ? this.element.parentNode : this.element;
        // check that this.size and size are there
        // IE8 triggers resize on body size change, so they might not be
        var size = getSize(container);
        this.containerWidth = size && size.innerWidth;
    };
    proto._getItemLayoutPosition = function(item) {
        item.getSize();
        // how many columns does this brick span
        var remainder = item.size.outerWidth % this.columnWidth;
        var mathMethod = remainder && remainder < 1 ? 'round' : 'ceil';
        // round if off by 1 pixel, otherwise use ceil
        var colSpan = Math[mathMethod](item.size.outerWidth / this.columnWidth);
        colSpan = Math.min(colSpan, this.cols);
        // use horizontal or top column position
        var colPosMethod = this.options.horizontalOrder ? '_getHorizontalColPosition' : '_getTopColPosition';
        var colPosition = this[colPosMethod](colSpan, item);
        // position the brick
        var position = {
            x: this.columnWidth * colPosition.col,
            y: colPosition.y
        };
        // apply setHeight to necessary columns
        var setHeight = colPosition.y + item.size.outerHeight;
        var setMax = colSpan + colPosition.col;
        for(var i = colPosition.col; i < setMax; i++)this.colYs[i] = setHeight;
        return position;
    };
    proto._getTopColPosition = function(colSpan) {
        var colGroup = this._getTopColGroup(colSpan);
        // get the minimum Y value from the columns
        var minimumY = Math.min.apply(Math, colGroup);
        return {
            col: colGroup.indexOf(minimumY),
            y: minimumY
        };
    };
    /**
   * @param {Number} colSpan - number of columns the element spans
   * @returns {Array} colGroup
   */ proto._getTopColGroup = function(colSpan) {
        if (colSpan < 2) // if brick spans only one column, use all the column Ys
        return this.colYs;
        var colGroup = [];
        // how many different places could this brick fit horizontally
        var groupCount = this.cols + 1 - colSpan;
        // for each group potential horizontal position
        for(var i = 0; i < groupCount; i++)colGroup[i] = this._getColGroupY(i, colSpan);
        return colGroup;
    };
    proto._getColGroupY = function(col, colSpan) {
        if (colSpan < 2) return this.colYs[col];
        // make an array of colY values for that one group
        var groupColYs = this.colYs.slice(col, col + colSpan);
        // and get the max value of the array
        return Math.max.apply(Math, groupColYs);
    };
    // get column position based on horizontal index. #873
    proto._getHorizontalColPosition = function(colSpan, item) {
        var col = this.horizontalColIndex % this.cols;
        var isOver = colSpan > 1 && col + colSpan > this.cols;
        // shift to next row if item can't fit on current row
        col = isOver ? 0 : col;
        // don't let zero-size items take up space
        var hasSize = item.size.outerWidth && item.size.outerHeight;
        this.horizontalColIndex = hasSize ? col + colSpan : this.horizontalColIndex;
        return {
            col: col,
            y: this._getColGroupY(col, colSpan)
        };
    };
    proto._manageStamp = function(stamp) {
        var stampSize = getSize(stamp);
        var offset = this._getElementOffset(stamp);
        // get the columns that this stamp affects
        var isOriginLeft = this._getOption('originLeft');
        var firstX = isOriginLeft ? offset.left : offset.right;
        var lastX = firstX + stampSize.outerWidth;
        var firstCol = Math.floor(firstX / this.columnWidth);
        firstCol = Math.max(0, firstCol);
        var lastCol = Math.floor(lastX / this.columnWidth);
        // lastCol should not go over if multiple of columnWidth #425
        lastCol -= lastX % this.columnWidth ? 0 : 1;
        lastCol = Math.min(this.cols - 1, lastCol);
        // set colYs to bottom of the stamp
        var isOriginTop = this._getOption('originTop');
        var stampMaxY = (isOriginTop ? offset.top : offset.bottom) + stampSize.outerHeight;
        for(var i = firstCol; i <= lastCol; i++)this.colYs[i] = Math.max(stampMaxY, this.colYs[i]);
    };
    proto._getContainerSize = function() {
        this.maxY = Math.max.apply(Math, this.colYs);
        var size = {
            height: this.maxY
        };
        if (this._getOption('fitWidth')) size.width = this._getContainerFitWidth();
        return size;
    };
    proto._getContainerFitWidth = function() {
        var unusedCols = 0;
        // count unused columns
        var i = this.cols;
        while(--i){
            if (this.colYs[i] !== 0) break;
            unusedCols++;
        }
        // fit container to columns that have been used
        return (this.cols - unusedCols) * this.columnWidth - this.gutter;
    };
    proto.needsResizeLayout = function() {
        var previousWidth = this.containerWidth;
        this.getContainerWidth();
        return previousWidth != this.containerWidth;
    };
    return Masonry;
});


/*
 * Naja.js
 * 2.6.1
 *
 * by Jiří Pudil <https://jiripudil.cz>
 */ // ready
const $da6d917fcd2d3fe8$var$onDomReady = (callback)=>{
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', callback);
    else callback();
};
// assert
class $da6d917fcd2d3fe8$var$AssertionError extends Error {
}
const $da6d917fcd2d3fe8$var$assert = (condition, description)=>{
    if (!condition) {
        const message = `Assertion failed${description !== undefined ? `: ${description}` : '.'}`;
        throw new $da6d917fcd2d3fe8$var$AssertionError(message);
    }
};
class $da6d917fcd2d3fe8$var$UIHandler extends EventTarget {
    constructor(naja){
        super();
        this.naja = naja;
        this.selector = '.ajax';
        this.allowedOrigins = [
            window.location.origin
        ];
        this.handler = this.handleUI.bind(this);
        naja.addEventListener('init', this.initialize.bind(this));
    }
    initialize() {
        $da6d917fcd2d3fe8$var$onDomReady(()=>this.bindUI(window.document.body));
        this.naja.snippetHandler.addEventListener('afterUpdate', (event)=>{
            const { snippet: snippet } = event.detail;
            this.bindUI(snippet);
        });
    }
    bindUI(element) {
        const selectors = [
            `a${this.selector}`,
            `input[type="submit"]${this.selector}`,
            `input[type="image"]${this.selector}`,
            `button[type="submit"]${this.selector}`,
            `form${this.selector} input[type="submit"]`,
            `form${this.selector} input[type="image"]`,
            `form${this.selector} button[type="submit"]`
        ].join(', ');
        const bindElement = (element)=>{
            element.removeEventListener('click', this.handler);
            element.addEventListener('click', this.handler);
        };
        const elements = element.querySelectorAll(selectors);
        for(let i = 0; i < elements.length; i++)bindElement(elements.item(i));
        if (element.matches(selectors)) bindElement(element);
        const bindForm = (form)=>{
            form.removeEventListener('submit', this.handler);
            form.addEventListener('submit', this.handler);
        };
        if (element.matches(`form${this.selector}`)) bindForm(element);
        const forms = element.querySelectorAll(`form${this.selector}`);
        for(let i = 0; i < forms.length; i++)bindForm(forms.item(i));
    }
    handleUI(event) {
        const mouseEvent = event;
        if (mouseEvent.altKey || mouseEvent.ctrlKey || mouseEvent.shiftKey || mouseEvent.metaKey || mouseEvent.button) return;
        const element = event.currentTarget;
        const options = this.naja.prepareOptions();
        const ignoreErrors = ()=>{
        // don't reject the promise in case of an error as developers have no way of handling the rejection
        // in this situation; errors should be handled in `naja.addEventListener('error', errorHandler)`
        };
        if (event.type === 'submit') this.submitForm(element, options, event).catch(ignoreErrors);
        else if (event.type === 'click') this.clickElement(element, options, mouseEvent).catch(ignoreErrors);
    }
    async clickElement(element, options = {}, event) {
        let method = 'GET', url = '', data;
        if (!this.dispatchEvent(new CustomEvent('interaction', {
            cancelable: true,
            detail: {
                element: element,
                originalEvent: event,
                options: options
            }
        }))) {
            event?.preventDefault();
            return {};
        }
        if (element.tagName === 'A') {
            $da6d917fcd2d3fe8$var$assert(element instanceof HTMLAnchorElement);
            method = 'GET';
            url = element.href;
            data = null;
        } else if (element.tagName === 'INPUT' || element.tagName === 'BUTTON') {
            $da6d917fcd2d3fe8$var$assert(element instanceof HTMLInputElement || element instanceof HTMLButtonElement);
            const { form: form } = element;
            // eslint-disable-next-line no-nested-ternary,no-extra-parens
            method = element.getAttribute('formmethod')?.toUpperCase() ?? form?.getAttribute('method')?.toUpperCase() ?? 'GET';
            url = element.getAttribute('formaction') ?? form?.getAttribute('action') ?? window.location.pathname + window.location.search;
            data = new FormData(form ?? undefined);
            if (element.type === 'submit' && element.name !== '') data.append(element.name, element.value || '');
            else if (element.type === 'image') {
                const coords = element.getBoundingClientRect();
                const prefix = element.name !== '' ? `${element.name}.` : '';
                data.append(`${prefix}x`, Math.max(0, Math.floor(event !== undefined ? event.pageX - coords.left : 0)));
                data.append(`${prefix}y`, Math.max(0, Math.floor(event !== undefined ? event.pageY - coords.top : 0)));
            }
        }
        if (!this.isUrlAllowed(url)) throw new Error(`Cannot dispatch async request, URL is not allowed: ${url}`);
        event?.preventDefault();
        return this.naja.makeRequest(method, url, data, options);
    }
    async submitForm(form, options = {}, event) {
        if (!this.dispatchEvent(new CustomEvent('interaction', {
            cancelable: true,
            detail: {
                element: form,
                originalEvent: event,
                options: options
            }
        }))) {
            event?.preventDefault();
            return {};
        }
        const method = form.getAttribute('method')?.toUpperCase() ?? 'GET';
        const url = form.getAttribute('action') ?? window.location.pathname + window.location.search;
        const data = new FormData(form);
        if (!this.isUrlAllowed(url)) throw new Error(`Cannot dispatch async request, URL is not allowed: ${url}`);
        event?.preventDefault();
        return this.naja.makeRequest(method, url, data, options);
    }
    isUrlAllowed(url) {
        const urlObject = new URL(url, location.href);
        // ignore non-URL URIs (javascript:, data:, mailto:, ...)
        if (urlObject.origin === 'null') return false;
        return this.allowedOrigins.includes(urlObject.origin);
    }
}
class $da6d917fcd2d3fe8$var$FormsHandler {
    constructor(naja){
        this.naja = naja;
        naja.addEventListener('init', this.initialize.bind(this));
        naja.uiHandler.addEventListener('interaction', this.processForm.bind(this));
    }
    initialize() {
        $da6d917fcd2d3fe8$var$onDomReady(()=>this.initForms(window.document.body));
        this.naja.snippetHandler.addEventListener('afterUpdate', (event)=>{
            const { snippet: snippet } = event.detail;
            this.initForms(snippet);
        });
    }
    initForms(element) {
        const netteForms = this.netteForms || window.Nette;
        if (netteForms) {
            if (element.tagName === 'form') netteForms.initForm(element);
            const forms = element.querySelectorAll('form');
            for(let i = 0; i < forms.length; i++)netteForms.initForm(forms.item(i));
        }
    }
    processForm(event) {
        const { element: element, originalEvent: originalEvent } = event.detail;
        const inputElement = element;
        if (inputElement.form !== undefined && inputElement.form !== null) inputElement.form['nette-submittedBy'] = element;
        const netteForms = this.netteForms || window.Nette;
        if ((element.tagName === 'FORM' || element.form) && netteForms && !netteForms.validateForm(element)) {
            if (originalEvent) {
                originalEvent.stopImmediatePropagation();
                originalEvent.preventDefault();
            }
            event.preventDefault();
        }
    }
}
class $da6d917fcd2d3fe8$var$RedirectHandler extends EventTarget {
    constructor(naja){
        super();
        this.naja = naja;
        naja.uiHandler.addEventListener('interaction', (event)=>{
            const { element: element, options: options } = event.detail;
            if (!element) return;
            if (element.hasAttribute('data-naja-force-redirect') || element.form?.hasAttribute('data-naja-force-redirect')) {
                const value = element.getAttribute('data-naja-force-redirect') ?? element.form?.getAttribute('data-naja-force-redirect');
                options.forceRedirect = value !== 'off';
            }
        });
        naja.addEventListener('success', (event)=>{
            const { payload: payload, options: options } = event.detail;
            if (payload.redirect) {
                this.makeRedirect(payload.redirect, options.forceRedirect ?? false, options);
                event.stopImmediatePropagation();
            }
        });
        this.locationAdapter = {
            assign: (url)=>window.location.assign(url)
        };
    }
    makeRedirect(url, force, options = {}) {
        if (url instanceof URL) url = url.href;
        let isHardRedirect = force || !this.naja.uiHandler.isUrlAllowed(url);
        const canRedirect = this.dispatchEvent(new CustomEvent('redirect', {
            cancelable: true,
            detail: {
                url: url,
                setUrl (value) {
                    url = value;
                },
                isHardRedirect: isHardRedirect,
                setHardRedirect (value) {
                    isHardRedirect = !!value;
                },
                options: options
            }
        }));
        if (!canRedirect) return;
        if (isHardRedirect) this.locationAdapter.assign(url);
        else this.naja.makeRequest('GET', url, null, options);
    }
}
class $da6d917fcd2d3fe8$var$SnippetHandler extends EventTarget {
    constructor(naja){
        super();
        this.naja = naja;
        this.op = {
            replace: (snippet, content)=>{
                snippet.innerHTML = content;
            },
            prepend: (snippet, content)=>snippet.insertAdjacentHTML('afterbegin', content),
            append: (snippet, content)=>snippet.insertAdjacentHTML('beforeend', content)
        };
        naja.addEventListener('success', (event)=>{
            const { options: options, payload: payload } = event.detail;
            if (payload.snippets) this.updateSnippets(payload.snippets, false, options);
        });
    }
    static findSnippets(predicate) {
        const result = {};
        const snippets = window.document.querySelectorAll('[id^="snippet-"]');
        for(let i = 0; i < snippets.length; i++){
            const snippet = snippets.item(i);
            if (predicate?.(snippet) ?? true) result[snippet.id] = snippet.innerHTML;
        }
        return result;
    }
    updateSnippets(snippets, fromCache = false, options = {}) {
        Object.keys(snippets).forEach((id)=>{
            const snippet = document.getElementById(id);
            if (snippet) this.updateSnippet(snippet, snippets[id], fromCache, options);
        });
    }
    updateSnippet(snippet, content, fromCache, options) {
        let operation = this.op.replace;
        if ((snippet.hasAttribute('data-naja-snippet-prepend') || snippet.hasAttribute('data-ajax-prepend')) && !fromCache) operation = this.op.prepend;
        else if ((snippet.hasAttribute('data-naja-snippet-append') || snippet.hasAttribute('data-ajax-append')) && !fromCache) operation = this.op.append;
        const canUpdate = this.dispatchEvent(new CustomEvent('beforeUpdate', {
            cancelable: true,
            detail: {
                snippet: snippet,
                content: content,
                fromCache: fromCache,
                operation: operation,
                changeOperation (value) {
                    operation = value;
                },
                options: options
            }
        }));
        if (!canUpdate) return;
        if (snippet.tagName.toLowerCase() === 'title') document.title = content;
        else operation(snippet, content);
        this.dispatchEvent(new CustomEvent('afterUpdate', {
            cancelable: true,
            detail: {
                snippet: snippet,
                content: content,
                fromCache: fromCache,
                operation: operation,
                options: options
            }
        }));
    }
}
class $da6d917fcd2d3fe8$var$HistoryHandler extends EventTarget {
    constructor(naja){
        super();
        this.naja = naja;
        this.initialized = false;
        this.cursor = 0;
        this.popStateHandler = this.handlePopState.bind(this);
        naja.addEventListener('init', this.initialize.bind(this));
        naja.addEventListener('before', this.saveUrl.bind(this));
        naja.addEventListener('before', this.replaceInitialState.bind(this));
        naja.addEventListener('success', this.pushNewState.bind(this));
        naja.redirectHandler.addEventListener('redirect', this.saveRedirectedUrl.bind(this));
        naja.uiHandler.addEventListener('interaction', this.configureMode.bind(this));
        this.historyAdapter = {
            replaceState: (state, title, url)=>window.history.replaceState(state, title, url),
            pushState: (state, title, url)=>window.history.pushState(state, title, url)
        };
    }
    set uiCache(value) {
        console.warn('Naja: HistoryHandler.uiCache is deprecated, use options.snippetCache instead.');
        this.naja.defaultOptions.snippetCache = value;
    }
    handlePopState(event) {
        const { state: state } = event;
        if (state?.source !== 'naja') return;
        const direction = state.cursor - this.cursor;
        this.cursor = state.cursor;
        const options = this.naja.prepareOptions();
        this.dispatchEvent(new CustomEvent('restoreState', {
            detail: {
                state: state,
                direction: direction,
                options: options
            }
        }));
    }
    initialize() {
        window.addEventListener('popstate', this.popStateHandler);
    }
    saveUrl(event) {
        const { url: url, options: options } = event.detail;
        options.href ??= url;
    }
    saveRedirectedUrl(event) {
        const { url: url, options: options } = event.detail;
        options.href = url;
    }
    replaceInitialState(event) {
        const { options: options } = event.detail;
        const mode = $da6d917fcd2d3fe8$var$HistoryHandler.normalizeMode(options.history);
        if (mode !== false && !this.initialized) {
            $da6d917fcd2d3fe8$var$onDomReady(()=>this.historyAdapter.replaceState(this.buildState(window.location.href, 'replace', this.cursor, options), window.document.title, window.location.href));
            this.initialized = true;
        }
    }
    configureMode(event) {
        const { element: element, options: options } = event.detail;
        // propagate mode to options
        if (!element) return;
        if (element.hasAttribute('data-naja-history') || element.form?.hasAttribute('data-naja-history')) {
            const value = element.getAttribute('data-naja-history') ?? element.form?.getAttribute('data-naja-history');
            options.history = $da6d917fcd2d3fe8$var$HistoryHandler.normalizeMode(value);
        }
    }
    static normalizeMode(mode) {
        if (mode === 'off' || mode === false) return false;
        else if (mode === 'replace') return 'replace';
        return true;
    }
    pushNewState(event) {
        const { payload: payload, options: options } = event.detail;
        const mode = $da6d917fcd2d3fe8$var$HistoryHandler.normalizeMode(options.history);
        if (mode === false) return;
        if (payload.postGet && payload.url) options.href = payload.url;
        const method = mode === 'replace' ? 'replaceState' : 'pushState';
        const cursor = mode === 'replace' ? this.cursor : ++this.cursor;
        this.historyAdapter[method](this.buildState(options.href, mode, cursor, options), window.document.title, options.href);
    }
    buildState(href, mode, cursor, options) {
        const state = {
            source: 'naja',
            cursor: cursor,
            href: href
        };
        this.dispatchEvent(new CustomEvent('buildState', {
            detail: {
                state: state,
                operation: mode === 'replace' ? 'replaceState' : 'pushState',
                options: options
            }
        }));
        return state;
    }
}
class $da6d917fcd2d3fe8$var$SnippetCache extends EventTarget {
    constructor(naja){
        super();
        this.naja = naja;
        this.storages = {
            off: new $da6d917fcd2d3fe8$var$OffCacheStorage(naja),
            history: new $da6d917fcd2d3fe8$var$HistoryCacheStorage(),
            session: new $da6d917fcd2d3fe8$var$SessionCacheStorage()
        };
        naja.uiHandler.addEventListener('interaction', this.configureCache.bind(this));
        naja.historyHandler.addEventListener('buildState', this.buildHistoryState.bind(this));
        naja.historyHandler.addEventListener('restoreState', this.restoreHistoryState.bind(this));
    }
    resolveStorage(option) {
        let storageType;
        if (option === true || option === undefined) storageType = 'history';
        else if (option === false) storageType = 'off';
        else storageType = option;
        return this.storages[storageType];
    }
    configureCache(event) {
        const { element: element, options: options } = event.detail;
        if (!element) return;
        if (element.hasAttribute('data-naja-snippet-cache') || element.form?.hasAttribute('data-naja-snippet-cache') || element.hasAttribute('data-naja-history-cache') || element.form?.hasAttribute('data-naja-history-cache')) {
            const value = element.getAttribute('data-naja-snippet-cache') ?? element.form?.getAttribute('data-naja-snippet-cache') ?? element.getAttribute('data-naja-history-cache') ?? element.form?.getAttribute('data-naja-history-cache');
            options.snippetCache = value;
        }
    }
    buildHistoryState(event) {
        const { state: state, options: options } = event.detail;
        if ('historyUiCache' in options) {
            console.warn('Naja: options.historyUiCache is deprecated, use options.snippetCache instead.');
            options.snippetCache = options.historyUiCache;
        }
        const snippets = $da6d917fcd2d3fe8$var$SnippetHandler.findSnippets((snippet)=>!snippet.hasAttribute('data-naja-history-nocache') && !snippet.hasAttribute('data-history-nocache') && (!snippet.hasAttribute('data-naja-snippet-cache') || snippet.getAttribute('data-naja-snippet-cache') !== 'off'));
        if (!this.dispatchEvent(new CustomEvent('store', {
            cancelable: true,
            detail: {
                snippets: snippets,
                state: state,
                options: options
            }
        }))) return;
        const storage = this.resolveStorage(options.snippetCache);
        state.snippets = {
            storage: storage.type,
            key: storage.store(snippets)
        };
    }
    restoreHistoryState(event) {
        const { state: state, options: options } = event.detail;
        if (state.snippets === undefined) return;
        options.snippetCache = state.snippets.storage;
        if (!this.dispatchEvent(new CustomEvent('fetch', {
            cancelable: true,
            detail: {
                state: state,
                options: options
            }
        }))) return;
        const storage = this.resolveStorage(options.snippetCache);
        const snippets = storage.fetch(state.snippets.key, state, options);
        if (snippets === null) return;
        if (!this.dispatchEvent(new CustomEvent('restore', {
            cancelable: true,
            detail: {
                snippets: snippets,
                state: state,
                options: options
            }
        }))) return;
        this.naja.snippetHandler.updateSnippets(snippets, true, options);
    }
}
class $da6d917fcd2d3fe8$var$OffCacheStorage {
    constructor(naja){
        this.naja = naja;
        this.type = 'off';
    }
    store() {
        return null;
    }
    fetch(key, state, options) {
        this.naja.makeRequest('GET', state.href, null, {
            ...options,
            history: false,
            snippetCache: false
        });
        return null;
    }
}
class $da6d917fcd2d3fe8$var$HistoryCacheStorage {
    constructor(){
        this.type = 'history';
    }
    store(data) {
        return data;
    }
    fetch(key) {
        return key;
    }
}
class $da6d917fcd2d3fe8$var$SessionCacheStorage {
    constructor(){
        this.type = 'session';
    }
    store(data) {
        const key = Math.random().toString(36).substring(2, 8);
        window.sessionStorage.setItem(key, JSON.stringify(data));
        return key;
    }
    fetch(key) {
        const data = window.sessionStorage.getItem(key);
        if (data === null) return null;
        return JSON.parse(data);
    }
}
class $da6d917fcd2d3fe8$var$ScriptLoader {
    constructor(naja){
        this.loadedScripts = new Set();
        naja.addEventListener('init', ()=>{
            $da6d917fcd2d3fe8$var$onDomReady(()=>{
                document.querySelectorAll('script[data-naja-script-id]').forEach((script)=>{
                    const scriptId = script.getAttribute('data-naja-script-id');
                    if (scriptId !== null && scriptId !== '') this.loadedScripts.add(scriptId);
                });
            });
            naja.snippetHandler.addEventListener('afterUpdate', (event)=>{
                const { content: content } = event.detail;
                this.loadScripts(content);
            });
        });
    }
    loadScripts(snippetsOrSnippet) {
        if (typeof snippetsOrSnippet === 'string') {
            this.loadScriptsInSnippet(snippetsOrSnippet);
            return;
        }
        Object.keys(snippetsOrSnippet).forEach((id)=>{
            const content = snippetsOrSnippet[id];
            this.loadScriptsInSnippet(content);
        });
    }
    loadScriptsInSnippet(content) {
        if (!/<script/i.test(content)) return;
        const el = window.document.createElement('div');
        el.innerHTML = content;
        const scripts = el.querySelectorAll('script');
        for(let i = 0; i < scripts.length; i++){
            const script = scripts.item(i);
            const scriptId = script.getAttribute('data-naja-script-id');
            if (scriptId !== null && scriptId !== '' && this.loadedScripts.has(scriptId)) continue;
            const scriptEl = window.document.createElement('script');
            scriptEl.innerHTML = script.innerHTML;
            if (script.hasAttributes()) {
                const attrs = script.attributes;
                for(let j = 0; j < attrs.length; j++){
                    const attrName = attrs[j].name;
                    scriptEl.setAttribute(attrName, attrs[j].value);
                }
            }
            window.document.head.appendChild(scriptEl).parentNode.removeChild(scriptEl);
            if (scriptId !== null && scriptId !== '') this.loadedScripts.add(scriptId);
        }
    }
}
class $da6d917fcd2d3fe8$export$95ec5579791cc610 extends EventTarget {
    constructor(uiHandler, redirectHandler, snippetHandler, formsHandler, historyHandler, snippetCache, scriptLoader){
        super();
        this.VERSION = 2;
        this.initialized = false;
        this.extensions = [];
        this.defaultOptions = {};
        this.uiHandler = new (uiHandler ?? $da6d917fcd2d3fe8$var$UIHandler)(this);
        this.redirectHandler = new (redirectHandler ?? $da6d917fcd2d3fe8$var$RedirectHandler)(this);
        this.snippetHandler = new (snippetHandler ?? $da6d917fcd2d3fe8$var$SnippetHandler)(this);
        this.formsHandler = new (formsHandler ?? $da6d917fcd2d3fe8$var$FormsHandler)(this);
        this.historyHandler = new (historyHandler ?? $da6d917fcd2d3fe8$var$HistoryHandler)(this);
        this.snippetCache = new (snippetCache ?? $da6d917fcd2d3fe8$var$SnippetCache)(this);
        this.scriptLoader = new (scriptLoader ?? $da6d917fcd2d3fe8$var$ScriptLoader)(this);
    }
    registerExtension(extension) {
        if (this.initialized) extension.initialize(this);
        this.extensions.push(extension);
    }
    initialize(defaultOptions = {}) {
        if (this.initialized) throw new Error('Cannot initialize Naja, it is already initialized.');
        this.defaultOptions = this.prepareOptions(defaultOptions);
        this.extensions.forEach((extension)=>extension.initialize(this));
        this.dispatchEvent(new CustomEvent('init', {
            detail: {
                defaultOptions: this.defaultOptions
            }
        }));
        this.initialized = true;
    }
    prepareOptions(options) {
        return {
            ...this.defaultOptions,
            ...options,
            fetch: {
                ...this.defaultOptions.fetch,
                ...options?.fetch
            }
        };
    }
    async makeRequest(method, url, data = null, options = {}) {
        // normalize url to instanceof URL
        if (typeof url === 'string') url = new URL(url, location.href);
        options = this.prepareOptions(options);
        const headers = new Headers(options.fetch.headers || {});
        const body = this.transformData(url, method, data);
        const abortController = new AbortController();
        const request = new Request(url.toString(), {
            credentials: 'same-origin',
            ...options.fetch,
            method: method,
            headers: headers,
            body: body,
            signal: abortController.signal
        });
        // impersonate XHR so that Nette can detect isAjax()
        request.headers.set('X-Requested-With', 'XMLHttpRequest');
        // hint the server that Naja expects response to be JSON
        request.headers.set('Accept', 'application/json');
        if (!this.dispatchEvent(new CustomEvent('before', {
            cancelable: true,
            detail: {
                request: request,
                method: method,
                url: url.toString(),
                data: data,
                options: options
            }
        }))) return {};
        const promise = window.fetch(request);
        this.dispatchEvent(new CustomEvent('start', {
            detail: {
                request: request,
                promise: promise,
                abortController: abortController,
                options: options
            }
        }));
        let response, payload;
        try {
            response = await promise;
            if (!response.ok) throw new $da6d917fcd2d3fe8$export$65bd6083489bd8bb(response);
            payload = await response.json();
        } catch (error) {
            if (error.name === 'AbortError') {
                this.dispatchEvent(new CustomEvent('abort', {
                    detail: {
                        request: request,
                        error: error,
                        options: options
                    }
                }));
                this.dispatchEvent(new CustomEvent('complete', {
                    detail: {
                        request: request,
                        response: response,
                        payload: undefined,
                        error: error,
                        options: options
                    }
                }));
                return {};
            }
            this.dispatchEvent(new CustomEvent('error', {
                detail: {
                    request: request,
                    response: response,
                    error: error,
                    options: options
                }
            }));
            this.dispatchEvent(new CustomEvent('complete', {
                detail: {
                    request: request,
                    response: response,
                    payload: undefined,
                    error: error,
                    options: options
                }
            }));
            throw error;
        }
        this.dispatchEvent(new CustomEvent('payload', {
            detail: {
                request: request,
                response: response,
                payload: payload,
                options: options
            }
        }));
        this.dispatchEvent(new CustomEvent('success', {
            detail: {
                request: request,
                response: response,
                payload: payload,
                options: options
            }
        }));
        this.dispatchEvent(new CustomEvent('complete', {
            detail: {
                request: request,
                response: response,
                payload: payload,
                error: undefined,
                options: options
            }
        }));
        return payload;
    }
    appendToQueryString(searchParams, key, value) {
        if (value === null || value === undefined) return;
        if (Array.isArray(value) || Object.getPrototypeOf(value) === Object.prototype) for (const [subkey, subvalue] of Object.entries(value))this.appendToQueryString(searchParams, `${key}[${subkey}]`, subvalue);
        else searchParams.append(key, String(value));
    }
    transformData(url, method, data) {
        const isGet = [
            'GET',
            'HEAD'
        ].includes(method.toUpperCase());
        // sending a form via GET -> serialize FormData into URL and return empty request body
        if (isGet && data instanceof FormData) {
            for (const [key, value] of data)if (value !== null && value !== undefined) url.searchParams.append(key, String(value));
            return null;
        }
        // sending a POJO -> serialize it recursively into URLSearchParams
        const isDataPojo = data !== null && Object.getPrototypeOf(data) === Object.prototype;
        if (isDataPojo || Array.isArray(data)) {
            // for GET requests, append values to URL and return empty request body
            // otherwise build `new URLSearchParams()` to act as the request body
            const transformedData = isGet ? url.searchParams : new URLSearchParams();
            for (const [key, value] of Object.entries(data))this.appendToQueryString(transformedData, key, value);
            return isGet ? null : transformedData;
        }
        return data;
    }
}
class $da6d917fcd2d3fe8$export$65bd6083489bd8bb extends Error {
    constructor(response){
        const message = `HTTP ${response.status}: ${response.statusText}`;
        super(message);
        this.name = this.constructor.name;
        this.stack = new Error(message).stack;
        this.response = response;
    }
}
class $da6d917fcd2d3fe8$var$AbortExtension {
    constructor(){
        this.abortControllers = new Set();
    }
    initialize(naja) {
        naja.uiHandler.addEventListener('interaction', this.checkAbortable.bind(this));
        naja.addEventListener('init', this.onInitialize.bind(this));
        naja.addEventListener('start', this.saveAbortController.bind(this));
        naja.addEventListener('complete', this.removeAbortController.bind(this));
    }
    onInitialize() {
        document.addEventListener('keydown', (event)=>{
            if (event.key === 'Escape' && !(event.ctrlKey || event.shiftKey || event.altKey || event.metaKey)) {
                for (const controller of this.abortControllers)controller.abort();
                this.abortControllers.clear();
            }
        });
    }
    checkAbortable(event) {
        const { element: element, options: options } = event.detail;
        if (element.hasAttribute('data-naja-abort') || element.form?.hasAttribute('data-naja-abort')) options.abort = (element.getAttribute('data-naja-abort') ?? element.form?.getAttribute('data-naja-abort')) !== 'off';
    }
    saveAbortController(event) {
        const { abortController: abortController, options: options } = event.detail;
        if (options.abort !== false) {
            this.abortControllers.add(abortController);
            options.clearAbortExtension = ()=>this.abortControllers.delete(abortController);
        }
    }
    removeAbortController(event) {
        const { options: options } = event.detail;
        if (options.abort !== false && !!options.clearAbortExtension) options.clearAbortExtension();
    }
}
class $da6d917fcd2d3fe8$var$UniqueExtension {
    constructor(){
        this.abortControllers = new Map();
    }
    initialize(naja) {
        naja.uiHandler.addEventListener('interaction', this.checkUniqueness.bind(this));
        naja.addEventListener('start', this.abortPreviousRequest.bind(this));
        naja.addEventListener('complete', this.clearRequest.bind(this));
    }
    checkUniqueness(event) {
        const { element: element, options: options } = event.detail;
        if (element.hasAttribute('data-naja-unique') ?? element.form?.hasAttribute('data-naja-unique')) {
            const unique = element.getAttribute('data-naja-unique') ?? element.form?.getAttribute('data-naja-unique');
            options.unique = unique === 'off' ? false : unique ?? 'default';
        }
    }
    abortPreviousRequest(event) {
        const { abortController: abortController, options: options } = event.detail;
        if (options.unique !== false) {
            this.abortControllers.get(options.unique ?? 'default')?.abort();
            this.abortControllers.set(options.unique ?? 'default', abortController);
        }
    }
    clearRequest(event) {
        const { request: request, options: options } = event.detail;
        if (!request.signal.aborted && options.unique !== false) this.abortControllers.delete(options.unique ?? 'default');
    }
}
const $da6d917fcd2d3fe8$export$2e2bcd8739ae039 = new $da6d917fcd2d3fe8$export$95ec5579791cc610();
$da6d917fcd2d3fe8$export$2e2bcd8739ae039.registerExtension(new $da6d917fcd2d3fe8$var$AbortExtension());
$da6d917fcd2d3fe8$export$2e2bcd8739ae039.registerExtension(new $da6d917fcd2d3fe8$var$UniqueExtension());



class $114f9ddfce66cf9a$export$7a330199b2e76989 {
    #html;
    #onAfterUpdate = [];
    constructor(html, interaction = true){
        this.#html = html;
        if (interaction) (0, $da6d917fcd2d3fe8$export$2e2bcd8739ae039).uiHandler.addEventListener('interaction', (event)=>{
            if (event.detail.element.hasAttribute('data-confirm') && !window.confirm(event.detail.element.getAttribute('data-confirm'))) event.preventDefault();
        });
        (0, $da6d917fcd2d3fe8$export$2e2bcd8739ae039).snippetHandler.addEventListener('afterUpdate', (event)=>{
            const root = document.getElementById(event.detail.snippet.id);
            this.run(root, event);
        });
    }
    onAfterUpdate(callback) {
        this.#onAfterUpdate.push(callback);
        return this;
    }
    run(root, event) {
        if (typeof root === "undefined") root = this.#html;
        for (const callback of this.#onAfterUpdate)callback.call(null, root, event);
    }
}


function $1a2837bba20a495a$export$2e2bcd8739ae039(html) {
    html.querySelectorAll('.articles-loader').forEach((el)=>{
        const grid = el.closest('.row').previousElementSibling;
        el.querySelector('a').addEventListener('click', (e)=>{
            e.preventDefault();
            const icon = e.currentTarget.querySelector('i.fas');
            icon.classList.remove('d-none');
            const start = parseInt(el.dataset.start);
            const end = parseInt(el.dataset.end);
            if (start >= 1 && end > 1 && start <= end) {
                const url = e.currentTarget.getAttribute('href');
                const pageNo = start + 1;
                el.dataset.start = pageNo.toString();
                (0, $da6d917fcd2d3fe8$export$2e2bcd8739ae039).makeRequest('GET', url, {
                    pageNo: pageNo
                }, {
                    history: false
                }).then((payload)=>{
                    if (pageNo >= end) el.classList.add('d-none');
                    if (typeof grid.dataset.najaSnippetAppend === "undefined") grid.innerHTML += payload.snippets['snippet--articles'];
                    $1a2837bba20a495a$var$init(html);
                    setTimeout(()=>{
                        icon.classList.add('d-none');
                    }, 500);
                }).catch((err)=>{
                    icon.classList.add('d-none');
                    alert(err);
                });
            }
        });
    });
    const ajax = new (0, $114f9ddfce66cf9a$export$7a330199b2e76989)(document, false);
    ajax.onAfterUpdate((root)=>{
        $1a2837bba20a495a$var$init(root);
    }).run(html);
}
function $1a2837bba20a495a$var$init(html) {
    html.querySelectorAll('.masonry-grid').forEach((grid)=>{
        if (grid.querySelectorAll('.grid-item').length > 0) {
            let imagesCounter = grid.querySelectorAll('.article img:not(.loaded)').length;
            if (imagesCounter > 0) grid.querySelectorAll('.article img:not(.loaded)').forEach((img)=>{
                const callback = (e)=>{
                    imagesCounter--;
                    e.currentTarget.classList.add('loaded');
                    if (imagesCounter === 0) $1a2837bba20a495a$var$initMasonry(grid);
                };
                img.addEventListener('load', callback);
                img.addEventListener('error', callback);
                if (img.complete) {
                    imagesCounter--;
                    img.classList.add('loaded');
                    if (imagesCounter === 0) $1a2837bba20a495a$var$initMasonry(grid);
                }
            });
            else $1a2837bba20a495a$var$initMasonry(grid);
        }
    });
    html.querySelectorAll('.read-more-toggler').forEach((el)=>{
        el.addEventListener('click', (e)=>{
            e.preventDefault();
            const content = e.currentTarget.previousElementSibling;
            if (content.classList.contains('content-more')) {
                content.classList.toggle('d-none');
                const text = e.currentTarget.textContent;
                e.currentTarget.textContent = e.currentTarget.dataset.opposite;
                e.currentTarget.dataset.opposite = text;
            }
        });
    });
    html.querySelectorAll('.widget-four-tiles').forEach((el)=>{
        let fourTiles = [];
        let max = 0;
        el.querySelectorAll('.tile-block a').forEach((a)=>{
            let h = parseInt(window.getComputedStyle(a, null)?.getPropertyValue('height'));
            if (max < h) max = h;
            fourTiles.push({
                el: a,
                height: h
            });
        });
        for (let data of fourTiles){
            data.el.style.height = max + 'px';
            let pt = max - data.height;
            if (pt > 0) data.el.style.paddingTop = parseInt(window.getComputedStyle(data.el, null)?.getPropertyValue('padding-top')) + pt / 2 + 'px';
        }
    });
}
function $1a2837bba20a495a$var$initMasonry(el) {
    new (0, (/*@__PURE__*/$parcel$interopDefault($c5b45d56ccbd55bb$exports)))(el, {
        itemSelector: '.grid-item',
        percentPosition: true,
        horizontalOrder: true
    });
}


function $a762211eb604cd4e$export$2e2bcd8739ae039(html) {
    html.querySelectorAll('[data-bs-toggle="modal"][data-bs-target="#contentPreviewModal"]').forEach((el)=>{
        el.addEventListener('click', (e)=>{
            const editBtn = html.querySelector('#contentPreviewModal .modal-footer .edit-btn');
            editBtn.setAttribute('href', el.dataset.edit);
            const publishBtn = html.querySelector('#contentPreviewModal .modal-footer .publish-btn');
            const rejectBtn = html.querySelector('#contentPreviewModal .modal-footer .reject-btn');
            const publishUrl = el.dataset.publish;
            if (publishUrl === '#') {
                publishBtn.classList.add('d-none');
                rejectBtn.classList.add('d-none');
            } else {
                publishBtn.classList.remove('d-none');
                rejectBtn.classList.remove('d-none');
                publishBtn.setAttribute('href', publishUrl);
            }
            html.querySelector('#returnForRevisionModal').querySelector('input[name=id]').value = el.dataset.id;
        });
    });
    for (let section of [
        'web',
        'intranet'
    ]){
        const selector = '[data-bs-toggle="modal"][data-bs-target="#contentPreviewModal"][data-' + section + '-url]';
        html.querySelectorAll(selector).forEach((el)=>{
            el.addEventListener('click', (e)=>{
                html.querySelectorAll('#contentPreviewModal iframe').forEach((el)=>{
                    el.classList.add('d-none');
                });
                const loader = html.querySelector('#contentPreviewLoader');
                loader.classList.remove('d-none');
                html.querySelectorAll('#contentPreviewModal li.nav-item button.nav-link').forEach((el)=>{
                    el.classList.add('disabled');
                    el.classList.remove('active');
                });
                const navBtn = html.querySelector('#contentPreviewModal li.nav-item.' + section + ' button.nav-link');
                navBtn.classList.remove('disabled');
                if (html.querySelectorAll('#contentPreviewModal li.nav-item button.nav-link.active').length === 0) navBtn.classList.add('active');
                const iframe = html.querySelector('#contentPreviewModal iframe.' + section);
                iframe.classList.add('d-none');
                const url = e.currentTarget.getAttribute('data-' + section + '-url');
                if (url) {
                    const callback = (e)=>{
                        loader.classList.add('d-none');
                        e.currentTarget.classList.remove('d-none');
                    };
                    iframe.removeEventListener('load', callback);
                    iframe.addEventListener('load', callback);
                    iframe.setAttribute('src', url);
                } else alert('URL not found.');
            });
        });
    }
}


function $726ddecc56fb830c$export$2e2bcd8739ae039(html) {
    for (let section of [
        'web',
        'intranet'
    ]){
        const selector = '[data-bs-toggle=modal][data-' + section + '-url]';
        html.querySelectorAll(selector).forEach((el)=>{
            document.querySelectorAll('#contentPreviewModal li.nav-item button.nav-link').forEach((el)=>{
                el.classList.add('disabled');
            });
            el.addEventListener('click', (e)=>{
                const loader = document.querySelector('#contentPreviewLoader');
                loader.classList.remove('d-none');
                document.querySelectorAll('#contentPreviewModal iframe').forEach((el)=>{
                    el.classList.add('d-none');
                });
                document.querySelectorAll('#contentPreviewModal li.nav-item button.nav-link').forEach((el)=>{
                    el.classList.remove('active');
                });
                const navBtn = document.querySelector('#contentPreviewModal li.nav-item.' + section + ' button.nav-link');
                navBtn.classList.remove('disabled');
                navBtn.classList.add('active');
                const iframe = document.querySelector('#contentPreviewModal iframe.' + section);
                iframe.classList.add('d-none');
                const url = e.currentTarget.getAttribute('data-' + section + '-url');
                if (url) {
                    const callback = (e)=>{
                        loader.classList.add('d-none');
                        e.currentTarget.classList.remove('d-none');
                    };
                    iframe.removeEventListener('load', callback);
                    iframe.addEventListener('load', callback);
                    iframe.setAttribute('src', url);
                } else alert('URL not found.');
            });
        });
    }
}



/* eslint-env browser */ /**
 * Get or set data on element
 * @param {HTMLElement} element
 * @param {string} key
 * @param {any} value
 * @return {*}
 */ function $97e990934cd9828e$export$6853292f627997e4(element, key, value) {
    if (value === undefined) return element && element.h5s && element.h5s.data && element.h5s.data[key];
    else {
        element.h5s = element.h5s || {};
        element.h5s.data = element.h5s.data || {};
        element.h5s.data[key] = value;
    }
}
/**
 * Remove data from element
 * @param {HTMLElement} element
 */ function $97e990934cd9828e$export$33f1b464f736cf21(element) {
    if (element.h5s) delete element.h5s.data;
}


/* eslint-env browser */ /**
 * Filter only wanted nodes
 * @param {NodeList|HTMLCollection|Array} nodes
 * @param {String} selector
 * @returns {Array}
 */ var $ab490f4a72c38eea$export$2e2bcd8739ae039 = (nodes, selector)=>{
    if (!(nodes instanceof NodeList || nodes instanceof HTMLCollection || nodes instanceof Array)) throw new Error('You must provide a nodeList/HTMLCollection/Array of elements to be filtered.');
    if (typeof selector !== 'string') return Array.from(nodes);
    return Array.from(nodes).filter((item)=>item.nodeType === 1 && item.matches(selector));
};


/* eslint-env browser */ /* eslint-disable no-use-before-define */ const $1339acd9acf0bad6$export$bba5ab050e462fa8 = new Map();
class $1339acd9acf0bad6$export$390f32400eaf98c9 {
    /**
   * set the configuration of a class instance
   * @method config
   * @param {object} config object of configurations
   */ set config(config) {
        if (typeof config !== 'object') throw new Error('You must provide a valid configuration object to the config setter.');
        // combine config with default
        const mergedConfig = Object.assign({}, config);
        // add config to map
        this._config = new Map(Object.entries(mergedConfig));
    }
    /**
   * get the configuration map of a class instance
   * @method config
   * @return {object}
   */ get config() {
        // transform Map to object
        const config = {};
        this._config.forEach((value, key)=>{
            config[key] = value;
        });
        // return object
        return config;
    }
    /**
   * set individual configuration of a class instance
   * @method setConfig
   * @param  key valid configuration key
   * @param  value any value
   * @return void
   */ setConfig(key, value) {
        if (!this._config.has(key)) throw new Error(`Trying to set invalid configuration item: ${key}`);
        // set config
        this._config.set(key, value);
    }
    /**
   * get an individual configuration of a class instance
   * @method getConfig
   * @param  key valid configuration key
   * @return any configuration value
   */ getConfig(key) {
        if (!this._config.has(key)) throw new Error(`Invalid configuration item requested: ${key}`);
        return this._config.get(key);
    }
    /**
   * get the placeholder for a class instance
   * @method placeholder
   * @return {HTMLElement|null}
   */ get placeholder() {
        return this._placeholder;
    }
    /**
   * set the placeholder for a class instance
   * @method placeholder
   * @param {HTMLElement} placeholder
   * @return {void}
   */ set placeholder(placeholder) {
        if (!(placeholder instanceof HTMLElement) && placeholder !== null) throw new Error('A placeholder must be an html element or null.');
        this._placeholder = placeholder;
    }
    /**
   * set an data entry
   * @method setData
   * @param {string} key
   * @param {any} value
   * @return {void}
   */ setData(key, value) {
        if (typeof key !== 'string') throw new Error('The key must be a string.');
        this._data.set(key, value);
    }
    /**
   * get an data entry
   * @method getData
   * @param {string} key an existing key
   * @return {any}
   */ getData(key) {
        if (typeof key !== 'string') throw new Error('The key must be a string.');
        return this._data.get(key);
    }
    /**
   * delete an data entry
   * @method deleteData
   * @param {string} key an existing key
   * @return {boolean}
   */ deleteData(key) {
        if (typeof key !== 'string') throw new Error('The key must be a string.');
        return this._data.delete(key);
    }
    constructor(){
        this._config = new Map() // eslint-disable-line no-undef
        ;
        this._placeholder = undefined // eslint-disable-line no-undef
        ;
        this._data = new Map() // eslint-disable-line no-undef
        ;
    }
}
var /**
 * @param {HTMLElement} sortableElement
 * @returns {Class: Store}
 */ $1339acd9acf0bad6$export$2e2bcd8739ae039 = (sortableElement)=>{
    // if sortableElement is wrong type
    if (!(sortableElement instanceof HTMLElement)) throw new Error('Please provide a sortable to the store function.');
    // create new instance if not avilable
    if (!$1339acd9acf0bad6$export$bba5ab050e462fa8.has(sortableElement)) $1339acd9acf0bad6$export$bba5ab050e462fa8.set(sortableElement, new $1339acd9acf0bad6$export$390f32400eaf98c9());
    // return instance
    return $1339acd9acf0bad6$export$bba5ab050e462fa8.get(sortableElement);
};


/**
 * @param {Array|HTMLElement} element
 * @param {Function} callback
 * @param {string} event
 */ function $56efcfc01ad50440$export$3f65cefe8380dbea(element, eventName, callback) {
    if (element instanceof Array) {
        for(let i = 0; i < element.length; ++i)$56efcfc01ad50440$export$3f65cefe8380dbea(element[i], eventName, callback);
        return;
    }
    element.addEventListener(eventName, callback);
    (0, $1339acd9acf0bad6$export$2e2bcd8739ae039)(element).setData(`event${eventName}`, callback);
}
/**
 * @param {Array<HTMLElement>|HTMLElement} element
 * @param {string} eventName
 */ function $56efcfc01ad50440$export$8ff9f68337b520c0(element, eventName) {
    if (element instanceof Array) {
        for(let i = 0; i < element.length; ++i)$56efcfc01ad50440$export$8ff9f68337b520c0(element[i], eventName);
        return;
    }
    element.removeEventListener(eventName, (0, $1339acd9acf0bad6$export$2e2bcd8739ae039)(element).getData(`event${eventName}`));
    (0, $1339acd9acf0bad6$export$2e2bcd8739ae039)(element).deleteData(`event${eventName}`);
}


/**
 * @param {Array<HTMLElement>|HTMLElement} element
 * @param {string} attribute
 * @param {string} value
 */ function $16e2e3aa115d4a46$export$5dcb5c23b6ba980a(element, attribute, value) {
    if (element instanceof Array) {
        for(let i = 0; i < element.length; ++i)$16e2e3aa115d4a46$export$5dcb5c23b6ba980a(element[i], attribute, value);
        return;
    }
    element.setAttribute(attribute, value);
}
/**
 * @param {Array|HTMLElement} element
 * @param {string} attribute
 */ function $16e2e3aa115d4a46$export$6399f3bb52316b2c(element, attribute) {
    if (element instanceof Array) {
        for(let i = 0; i < element.length; ++i)$16e2e3aa115d4a46$export$6399f3bb52316b2c(element[i], attribute);
        return;
    }
    element.removeAttribute(attribute);
}


/**
 * @param {HTMLElement} element
 * @returns {Object}
 */ var $b14a773b48141421$export$2e2bcd8739ae039 = (element)=>{
    if (!element.parentElement || element.getClientRects().length === 0) throw new Error('target element must be part of the dom');
    const rect = element.getClientRects()[0];
    return {
        left: rect.left + window.pageXOffset,
        right: rect.right + window.pageXOffset,
        top: rect.top + window.pageYOffset,
        bottom: rect.bottom + window.pageYOffset
    };
};


/**
 * Creates and returns a new debounced version of the passed function which will postpone its execution until after wait milliseconds have elapsed
 * @param {Function} func to debounce
 * @param {number} time to wait before calling function with latest arguments, 0 - no debounce
 * @returns {function} - debounced function
 */ var $089454e91a0022de$export$2e2bcd8739ae039 = (func, wait = 0)=>{
    let timeout;
    return (...args)=>{
        clearTimeout(timeout);
        timeout = setTimeout(()=>{
            func(...args);
        }, wait);
    };
};


/* eslint-env browser */ /**
 * Get position of the element relatively to its sibling elements
 * @param {HTMLElement} element
 * @returns {number}
 */ var $c1b7347bcbcda66e$export$2e2bcd8739ae039 = (element, elementList)=>{
    if (!(element instanceof HTMLElement) || !(elementList instanceof NodeList || elementList instanceof HTMLCollection || elementList instanceof Array)) throw new Error('You must provide an element and a list of elements.');
    return Array.from(elementList).indexOf(element);
};


/* eslint-env browser */ /**
 * Test whether element is in DOM
 * @param {HTMLElement} element
 * @returns {boolean}
 */ var $44012169bef03cff$export$2e2bcd8739ae039 = (element)=>{
    if (!(element instanceof HTMLElement)) throw new Error('Element is not a node element.');
    return element.parentNode !== null;
};


/* eslint-env browser */ /**
 * Insert node before or after target
 * @param {HTMLElement} referenceNode - reference element
 * @param {HTMLElement} newElement - element to be inserted
 * @param {String} position - insert before or after reference element
 */ const $6b88599688b290d7$var$insertNode = (referenceNode, newElement, position)=>{
    if (!(referenceNode instanceof HTMLElement) || !(referenceNode.parentElement instanceof HTMLElement)) throw new Error('target and element must be a node');
    referenceNode.parentElement.insertBefore(newElement, position === 'before' ? referenceNode : referenceNode.nextElementSibling);
};
/**
 * Insert before target
 * @param {HTMLElement} target
 * @param {HTMLElement} element
 */ const $6b88599688b290d7$export$86b68c7dbeb53c22 = (target, element)=>$6b88599688b290d7$var$insertNode(target, element, 'before');
/**
 * Insert after target
 * @param {HTMLElement} target
 * @param {HTMLElement} element
 */ const $6b88599688b290d7$export$c4f94c8b3850a5a9 = (target, element)=>$6b88599688b290d7$var$insertNode(target, element, 'after');


/* eslint-env browser */ 


var /**
 * Filter only wanted nodes
 * @param {HTMLElement} sortableContainer
 * @param {Function} customSerializer
 * @returns {Array}
 */ $19f2af5f2b36f2f6$export$2e2bcd8739ae039 = (sortableContainer, customItemSerializer = (serializedItem, sortableContainer)=>serializedItem, customContainerSerializer = (serializedContainer)=>serializedContainer)=>{
    // check for valid sortableContainer
    if (!(sortableContainer instanceof HTMLElement) || !sortableContainer.isSortable === true) throw new Error('You need to provide a sortableContainer to be serialized.');
    // check for valid serializers
    if (typeof customItemSerializer !== 'function' || typeof customContainerSerializer !== 'function') throw new Error('You need to provide a valid serializer for items and the container.');
    // get options
    const options = (0, $97e990934cd9828e$export$6853292f627997e4)(sortableContainer, 'opts');
    const item = options.items;
    // serialize container
    const items = (0, $ab490f4a72c38eea$export$2e2bcd8739ae039)(sortableContainer.children, item);
    const serializedItems = items.map((item)=>{
        return {
            parent: sortableContainer,
            node: item,
            html: item.outerHTML,
            index: (0, $c1b7347bcbcda66e$export$2e2bcd8739ae039)(item, items)
        };
    });
    // serialize container
    const container = {
        node: sortableContainer,
        itemCount: serializedItems.length
    };
    return {
        container: customContainerSerializer(container),
        items: serializedItems.map((item)=>customItemSerializer(item, sortableContainer))
    };
};


/* eslint-env browser */ /**
 * create a placeholder element
 * @param {HTMLElement} sortableElement a single sortable
 * @param {string|undefined} placeholder a string representing an html element
 * @param {string} placeholderClasses a string representing the classes that should be added to the placeholder
 */ var $f6a6f07da946e8b3$export$2e2bcd8739ae039 = (sortableElement, placeholder, placeholderClass = 'sortable-placeholder')=>{
    if (!(sortableElement instanceof HTMLElement)) throw new Error('You must provide a valid element as a sortable.');
    // if placeholder is not an element
    if (!(placeholder instanceof HTMLElement) && placeholder !== undefined) throw new Error('You must provide a valid element as a placeholder or set ot to undefined.');
    // if no placeholder element is given
    if (placeholder === undefined) {
        if ([
            'UL',
            'OL'
        ].includes(sortableElement.tagName)) placeholder = document.createElement('li');
        else if ([
            'TABLE',
            'TBODY'
        ].includes(sortableElement.tagName)) {
            placeholder = document.createElement('tr');
            // set colspan to always all rows, otherwise the item can only be dropped in first column
            placeholder.innerHTML = '<td colspan="100"></td>';
        } else placeholder = document.createElement('div');
    }
    // add classes to placeholder
    if (typeof placeholderClass === 'string') placeholder.classList.add(...placeholderClass.split(' '));
    return placeholder;
};


/* eslint-env browser */ /**
 * Get height of an element including padding
 * @param {HTMLElement} element an dom element
 */ var $7e9ab24da004e163$export$2e2bcd8739ae039 = (element)=>{
    if (!(element instanceof HTMLElement)) throw new Error('You must provide a valid dom element');
    // get calculated style of element
    const style = window.getComputedStyle(element);
    // get only height if element has box-sizing: border-box specified
    if (style.getPropertyValue('box-sizing') === 'border-box') return parseInt(style.getPropertyValue('height'), 10);
    // pick applicable properties, convert to int and reduce by adding
    return [
        'height',
        'padding-top',
        'padding-bottom'
    ].map((key)=>{
        const int = parseInt(style.getPropertyValue(key), 10);
        return isNaN(int) ? 0 : int;
    }).reduce((sum, value)=>sum + value);
};


/* eslint-env browser */ /**
 * Get width of an element including padding
 * @param {HTMLElement} element an dom element
 */ var $3d233ceb2c90c8ac$export$2e2bcd8739ae039 = (element)=>{
    if (!(element instanceof HTMLElement)) throw new Error('You must provide a valid dom element');
    // get calculated style of element
    const style = window.getComputedStyle(element);
    // pick applicable properties, convert to int and reduce by adding
    return [
        'width',
        'padding-left',
        'padding-right'
    ].map((key)=>{
        const int = parseInt(style.getPropertyValue(key), 10);
        return isNaN(int) ? 0 : int;
    }).reduce((sum, value)=>sum + value);
};


/* eslint-env browser */ /**
 * get handle or return item
 * @param {Array<HTMLElement>} items
 * @param {string} selector
 */ var $2c76aeb066ed946e$export$2e2bcd8739ae039 = (items, selector)=>{
    if (!(items instanceof Array)) throw new Error('You must provide a Array of HTMLElements to be filtered.');
    if (typeof selector !== 'string') return items;
    return items// remove items without handle from array
    .filter((item)=>{
        return item.querySelector(selector) instanceof HTMLElement || item.shadowRoot && item.shadowRoot.querySelector(selector) instanceof HTMLElement;
    })// replace item with handle in array
    .map((item)=>{
        return item.querySelector(selector) || item.shadowRoot && item.shadowRoot.querySelector(selector);
    });
};


/**
 * @param {Event} event
 * @returns {HTMLElement}
 */ var $a5e3d963b0e44c2c$export$2e2bcd8739ae039 = (event)=>{
    return event.composedPath && event.composedPath()[0] || event.target;
};


/* eslint-env browser */ 

/**
 * defaultDragImage returns the current item as dragged image
 * @param {HTMLElement} draggedElement - the item that the user drags
 * @param {object} elementOffset - an object with the offsets top, left, right & bottom
 * @param {Event} event - the original drag event object
 * @return {object} with element, posX and posY properties
 */ const $9c58ad1ac86c73cb$var$defaultDragImage = (draggedElement, elementOffset, event)=>{
    return {
        element: draggedElement,
        posX: event.pageX - elementOffset.left,
        posY: event.pageY - elementOffset.top
    };
};
var /**
 * attaches an element as the drag image to an event
 * @param {Event} event - the original drag event object
 * @param {HTMLElement} draggedElement - the item that the user drags
 * @param {Function} customDragImage - function to create a custom dragImage
 * @return void
 */ $9c58ad1ac86c73cb$export$2e2bcd8739ae039 = (event, draggedElement, customDragImage)=>{
    // check if event is provided
    if (!(event instanceof Event)) throw new Error('setDragImage requires a DragEvent as the first argument.');
    // check if draggedElement is provided
    if (!(draggedElement instanceof HTMLElement)) throw new Error('setDragImage requires the dragged element as the second argument.');
    // set default function of none provided
    if (!customDragImage) customDragImage = $9c58ad1ac86c73cb$var$defaultDragImage;
    // set default function if none is provided
    if (customDragImage instanceof HTMLElement) {
        const elementOffset = (0, $b14a773b48141421$export$2e2bcd8739ae039)(customDragImage);
        const dragImage = {
            element: customDragImage,
            posX: event.pageX - elementOffset.left,
            posY: event.pageY - elementOffset.top
        };
        // set the drag image on the event
        event.dataTransfer.effectAllowed = 'copyMove';
        event.dataTransfer.setData('text/plain', (0, $a5e3d963b0e44c2c$export$2e2bcd8739ae039)(event).id);
        event.dataTransfer.setDragImage(dragImage.element, event.offsetX, event.offsetY);
    } else if (typeof customDragImage === 'function' && event.dataTransfer.setDragImage) {
        // check if setDragImage method is available
        // get the elements offset
        const elementOffset = (0, $b14a773b48141421$export$2e2bcd8739ae039)(draggedElement);
        // get the dragImage
        const dragImage = customDragImage(draggedElement, elementOffset, event);
        // check if custom function returns correct values
        if (!(dragImage.element instanceof HTMLElement) || typeof dragImage.posX !== 'number' || typeof dragImage.posY !== 'number') throw new Error('The customDragImage function you provided must return and object with the properties element[string], posX[integer], posY[integer].');
        // needs to be set for HTML5 drag & drop to work
        event.dataTransfer.effectAllowed = 'copyMove';
        // Firefox requires it to use the event target's id for the data
        event.dataTransfer.setData('text/plain', (0, $a5e3d963b0e44c2c$export$2e2bcd8739ae039)(event).id);
        // set the drag image on the event
        event.dataTransfer.setDragImage(dragImage.element, dragImage.posX, dragImage.posY);
    }
};




var /**
 * Check if curList accepts items from destList
 * @param {sortable} destination the container an item is move to
 * @param {sortable} origin the container an item comes from
 */ $89f048003a9fbf1a$export$2e2bcd8739ae039 = (destination, origin)=>{
    // check if valid sortable
    if (destination.isSortable === true) {
        const acceptFrom = (0, $1339acd9acf0bad6$export$2e2bcd8739ae039)(destination).getConfig('acceptFrom');
        // check if acceptFrom is valid
        if (acceptFrom !== null && acceptFrom !== false && typeof acceptFrom !== 'string') throw new Error('HTML5Sortable: Wrong argument, "acceptFrom" must be "null", "false", or a valid selector string.');
        if (acceptFrom !== null) return acceptFrom !== false && acceptFrom.split(',').filter(function(sel) {
            return sel.length > 0 && origin.matches(sel);
        }).length > 0;
        // drop in same list
        if (destination === origin) return true;
        // check if lists are connected with connectWith
        if ((0, $1339acd9acf0bad6$export$2e2bcd8739ae039)(destination).getConfig('connectWith') !== undefined && (0, $1339acd9acf0bad6$export$2e2bcd8739ae039)(destination).getConfig('connectWith') !== null) return (0, $1339acd9acf0bad6$export$2e2bcd8739ae039)(destination).getConfig('connectWith') === (0, $1339acd9acf0bad6$export$2e2bcd8739ae039)(origin).getConfig('connectWith');
    }
    return false;
};


/**
 * default configurations
 */ var $2ff8965fb8e47872$export$2e2bcd8739ae039 = {
    items: null,
    // deprecated
    connectWith: null,
    // deprecated
    disableIEFix: null,
    acceptFrom: null,
    copy: false,
    placeholder: null,
    placeholderClass: 'sortable-placeholder',
    draggingClass: 'sortable-dragging',
    hoverClass: false,
    dropTargetContainerClass: false,
    debounce: 0,
    throttleTime: 100,
    maxItems: 0,
    itemSerializer: undefined,
    containerSerializer: undefined,
    customDragImage: null,
    orientation: 'vertical'
};


/* eslint-env browser */ 

/**
 * make sure a function is only called once within the given amount of time
 * @param {Function} fn the function to throttle
 * @param {number} threshold time limit for throttling
 */ // must use function to keep this context
function $1ecced028baca1a2$export$2e2bcd8739ae039(fn, threshold = 250) {
    // check function
    if (typeof fn !== 'function') throw new Error('You must provide a function as the first argument for throttle.');
    // check threshold
    if (typeof threshold !== 'number') throw new Error('You must provide a number as the second argument for throttle.');
    let lastEventTimestamp = null;
    return (...args)=>{
        const now = Date.now();
        if (lastEventTimestamp === null || now - lastEventTimestamp >= threshold) {
            lastEventTimestamp = now;
            fn.apply(this, args);
        }
    };
}



var /**
 * enable or disable hoverClass on mouseenter/leave if container Items
 * @param {sortable} sortableContainer a valid sortableContainer
 * @param {boolean} enable enable or disable event
 */ $b52010667b25d787$export$2e2bcd8739ae039 = (sortableContainer, enable)=>{
    if (typeof (0, $1339acd9acf0bad6$export$2e2bcd8739ae039)(sortableContainer).getConfig('hoverClass') === 'string') {
        const hoverClasses = (0, $1339acd9acf0bad6$export$2e2bcd8739ae039)(sortableContainer).getConfig('hoverClass').split(' ');
        // add class on hover
        if (enable === true) {
            (0, $56efcfc01ad50440$export$3f65cefe8380dbea)(sortableContainer, 'mousemove', (0, $1ecced028baca1a2$export$2e2bcd8739ae039)((event)=>{
                // check of no mouse button was pressed when mousemove started == no drag
                if (event.buttons === 0) (0, $ab490f4a72c38eea$export$2e2bcd8739ae039)(sortableContainer.children, (0, $1339acd9acf0bad6$export$2e2bcd8739ae039)(sortableContainer).getConfig('items')).forEach((item)=>{
                    if (item === event.target || item.contains(event.target)) item.classList.add(...hoverClasses);
                    else item.classList.remove(...hoverClasses);
                });
            }, (0, $1339acd9acf0bad6$export$2e2bcd8739ae039)(sortableContainer).getConfig('throttleTime')));
            // remove class on leave
            (0, $56efcfc01ad50440$export$3f65cefe8380dbea)(sortableContainer, 'mouseleave', ()=>{
                (0, $ab490f4a72c38eea$export$2e2bcd8739ae039)(sortableContainer.children, (0, $1339acd9acf0bad6$export$2e2bcd8739ae039)(sortableContainer).getConfig('items')).forEach((item)=>{
                    item.classList.remove(...hoverClasses);
                });
            });
        // remove events
        } else {
            (0, $56efcfc01ad50440$export$8ff9f68337b520c0)(sortableContainer, 'mousemove');
            (0, $56efcfc01ad50440$export$8ff9f68337b520c0)(sortableContainer, 'mouseleave');
        }
    }
};


'use strict';
/*
 * variables global to the plugin
 */ let $db58504db5b9e911$var$dragging;
let $db58504db5b9e911$var$draggingHeight;
let $db58504db5b9e911$var$draggingWidth;
/*
 * Keeps track of the initialy selected list, where 'dragstart' event was triggered
 * It allows us to move the data in between individual Sortable List instances
 */ // Origin List - data from before any item was changed
let $db58504db5b9e911$var$originContainer;
let $db58504db5b9e911$var$originIndex;
let $db58504db5b9e911$var$originElementIndex;
let $db58504db5b9e911$var$originItemsBeforeUpdate;
// Previous Sortable Container - we dispatch as sortenter event when a
// dragged item enters a sortableContainer for the first time
let $db58504db5b9e911$var$previousContainer;
// Destination List - data from before any item was changed
let $db58504db5b9e911$var$destinationItemsBeforeUpdate;
/**
 * remove event handlers from items
 * @param {Array|NodeList} items
 */ const $db58504db5b9e911$var$removeItemEvents = function(items) {
    (0, $56efcfc01ad50440$export$8ff9f68337b520c0)(items, 'dragstart');
    (0, $56efcfc01ad50440$export$8ff9f68337b520c0)(items, 'dragend');
    (0, $56efcfc01ad50440$export$8ff9f68337b520c0)(items, 'dragover');
    (0, $56efcfc01ad50440$export$8ff9f68337b520c0)(items, 'dragenter');
    (0, $56efcfc01ad50440$export$8ff9f68337b520c0)(items, 'drop');
    (0, $56efcfc01ad50440$export$8ff9f68337b520c0)(items, 'mouseenter');
    (0, $56efcfc01ad50440$export$8ff9f68337b520c0)(items, 'mouseleave');
};
/**
 *
 * remove Store map values
 * @param {Array|NodeList} items
 */ const $db58504db5b9e911$var$removeStoreData = function(items) {
    if (items instanceof Array) items.forEach((element)=>(0, $1339acd9acf0bad6$export$bba5ab050e462fa8).delete(element));
};
// Remove container events
const $db58504db5b9e911$var$removeContainerEvents = function(originContainer, previousContainer) {
    if (originContainer) (0, $56efcfc01ad50440$export$8ff9f68337b520c0)(originContainer, 'dragleave');
    if (previousContainer && previousContainer !== originContainer) (0, $56efcfc01ad50440$export$8ff9f68337b520c0)(previousContainer, 'dragleave');
};
/**
 * getDragging returns the current element to drag or
 * a copy of the element.
 * Is Copy Active for sortable
 * @param {HTMLElement} draggedItem - the item that the user drags
 * @param {HTMLElement} sortable a single sortable
 */ const $db58504db5b9e911$var$getDragging = function(draggedItem, sortable) {
    let ditem = draggedItem;
    if ((0, $1339acd9acf0bad6$export$2e2bcd8739ae039)(sortable).getConfig('copy') === true) {
        ditem = draggedItem.cloneNode(true);
        (0, $16e2e3aa115d4a46$export$5dcb5c23b6ba980a)(ditem, 'aria-copied', 'true');
        draggedItem.parentElement.appendChild(ditem);
        ditem.style.display = 'none';
        ditem.oldDisplay = draggedItem.style.display;
    }
    return ditem;
};
/**
 * Remove data from sortable
 * @param {HTMLElement} sortable a single sortable
 */ const $db58504db5b9e911$var$removeSortableData = function(sortable) {
    (0, $97e990934cd9828e$export$33f1b464f736cf21)(sortable);
    (0, $16e2e3aa115d4a46$export$6399f3bb52316b2c)(sortable, 'aria-dropeffect');
};
/**
 * Remove data from items
 * @param {Array<HTMLElement>|HTMLElement} items
 */ const $db58504db5b9e911$var$removeItemData = function(items) {
    (0, $16e2e3aa115d4a46$export$6399f3bb52316b2c)(items, 'aria-grabbed');
    (0, $16e2e3aa115d4a46$export$6399f3bb52316b2c)(items, 'aria-copied');
    (0, $16e2e3aa115d4a46$export$6399f3bb52316b2c)(items, 'draggable');
    (0, $16e2e3aa115d4a46$export$6399f3bb52316b2c)(items, 'role');
};
/**
 * find sortable from element. travels up parent element until found or null.
 * @param {HTMLElement} element a single sortable
 * @param {Event} event - the current event. We need to pass it to be able to
 * find Sortable whith shadowRoot (document fragment has no parent)
 */ function $db58504db5b9e911$var$findSortable(element, event) {
    if (event.composedPath) return event.composedPath().find((el)=>el.isSortable);
    while(element.isSortable !== true)element = element.parentElement;
    return element;
}
/**
 * Dragging event is on the sortable element. finds the top child that
 * contains the element.
 * @param {HTMLElement} sortableElement a single sortable
 * @param {HTMLElement} element is that being dragged
 */ function $db58504db5b9e911$var$findDragElement(sortableElement, element) {
    const options = (0, $97e990934cd9828e$export$6853292f627997e4)(sortableElement, 'opts');
    const items = (0, $ab490f4a72c38eea$export$2e2bcd8739ae039)(sortableElement.children, options.items);
    const itemlist = items.filter(function(ele) {
        return ele.contains(element) || ele.shadowRoot && ele.shadowRoot.contains(element);
    });
    return itemlist.length > 0 ? itemlist[0] : element;
}
/**
 * Destroy the sortable
 * @param {HTMLElement} sortableElement a single sortable
 */ const $db58504db5b9e911$var$destroySortable = function(sortableElement) {
    const opts = (0, $97e990934cd9828e$export$6853292f627997e4)(sortableElement, 'opts') || {};
    const items = (0, $ab490f4a72c38eea$export$2e2bcd8739ae039)(sortableElement.children, opts.items);
    const handles = (0, $2c76aeb066ed946e$export$2e2bcd8739ae039)(items, opts.handle);
    // disable adding hover class
    (0, $b52010667b25d787$export$2e2bcd8739ae039)(sortableElement, false);
    // remove event handlers & data from sortable
    (0, $56efcfc01ad50440$export$8ff9f68337b520c0)(sortableElement, 'dragover');
    (0, $56efcfc01ad50440$export$8ff9f68337b520c0)(sortableElement, 'dragenter');
    (0, $56efcfc01ad50440$export$8ff9f68337b520c0)(sortableElement, 'dragstart');
    (0, $56efcfc01ad50440$export$8ff9f68337b520c0)(sortableElement, 'dragend');
    (0, $56efcfc01ad50440$export$8ff9f68337b520c0)(sortableElement, 'drop');
    // remove event data from sortable
    $db58504db5b9e911$var$removeSortableData(sortableElement);
    // remove event handlers & data from items
    (0, $56efcfc01ad50440$export$8ff9f68337b520c0)(handles, 'mousedown');
    $db58504db5b9e911$var$removeItemEvents(items);
    $db58504db5b9e911$var$removeItemData(items);
    $db58504db5b9e911$var$removeStoreData(items);
    $db58504db5b9e911$var$removeStoreData([
        sortableElement
    ]);
    $db58504db5b9e911$var$removeContainerEvents($db58504db5b9e911$var$originContainer, $db58504db5b9e911$var$previousContainer);
    // clear sortable flag
    sortableElement.isSortable = false;
};
/**
 * Enable the sortable
 * @param {HTMLElement} sortableElement a single sortable
 */ const $db58504db5b9e911$var$enableSortable = function(sortableElement) {
    const opts = (0, $97e990934cd9828e$export$6853292f627997e4)(sortableElement, 'opts');
    const items = (0, $ab490f4a72c38eea$export$2e2bcd8739ae039)(sortableElement.children, opts.items);
    const handles = (0, $2c76aeb066ed946e$export$2e2bcd8739ae039)(items, opts.handle);
    (0, $16e2e3aa115d4a46$export$5dcb5c23b6ba980a)(sortableElement, 'aria-dropeffect', 'move');
    (0, $97e990934cd9828e$export$6853292f627997e4)(sortableElement, '_disabled', 'false');
    (0, $16e2e3aa115d4a46$export$5dcb5c23b6ba980a)(handles, 'draggable', 'true');
    // enable hover class
    (0, $b52010667b25d787$export$2e2bcd8739ae039)(sortableElement, true);
    // @todo: remove this fix
    // IE FIX for ghost
    // can be disabled as it has the side effect that other events
    // (e.g. click) will be ignored
    if (opts.disableIEFix === false) {
        const spanEl = (document || window.document).createElement('span');
        if (typeof spanEl.dragDrop === 'function') (0, $56efcfc01ad50440$export$3f65cefe8380dbea)(handles, 'mousedown', function() {
            if (items.indexOf(this) !== -1) this.dragDrop();
            else {
                let parent = this.parentElement;
                while(items.indexOf(parent) === -1)parent = parent.parentElement;
                parent.dragDrop();
            }
        });
    }
};
/**
 * Disable the sortable
 * @param {HTMLElement} sortableElement a single sortable
 */ const $db58504db5b9e911$var$disableSortable = function(sortableElement) {
    const opts = (0, $97e990934cd9828e$export$6853292f627997e4)(sortableElement, 'opts');
    const items = (0, $ab490f4a72c38eea$export$2e2bcd8739ae039)(sortableElement.children, opts.items);
    const handles = (0, $2c76aeb066ed946e$export$2e2bcd8739ae039)(items, opts.handle);
    (0, $16e2e3aa115d4a46$export$5dcb5c23b6ba980a)(sortableElement, 'aria-dropeffect', 'none');
    (0, $97e990934cd9828e$export$6853292f627997e4)(sortableElement, '_disabled', 'true');
    (0, $16e2e3aa115d4a46$export$5dcb5c23b6ba980a)(handles, 'draggable', 'false');
    (0, $56efcfc01ad50440$export$8ff9f68337b520c0)(handles, 'mousedown');
    (0, $b52010667b25d787$export$2e2bcd8739ae039)(sortableElement, false);
};
/**
 * Reload the sortable
 * @param {HTMLElement} sortableElement a single sortable
 * @description events need to be removed to not be double bound
 */ const $db58504db5b9e911$var$reloadSortable = function(sortableElement) {
    const opts = (0, $97e990934cd9828e$export$6853292f627997e4)(sortableElement, 'opts');
    const items = (0, $ab490f4a72c38eea$export$2e2bcd8739ae039)(sortableElement.children, opts.items);
    const handles = (0, $2c76aeb066ed946e$export$2e2bcd8739ae039)(items, opts.handle);
    (0, $97e990934cd9828e$export$6853292f627997e4)(sortableElement, '_disabled', 'false');
    // remove event handlers from items
    $db58504db5b9e911$var$removeItemEvents(items);
    $db58504db5b9e911$var$removeContainerEvents($db58504db5b9e911$var$originContainer, $db58504db5b9e911$var$previousContainer);
    (0, $56efcfc01ad50440$export$8ff9f68337b520c0)(handles, 'mousedown');
    // remove event handlers from sortable
    (0, $56efcfc01ad50440$export$8ff9f68337b520c0)(sortableElement, 'dragover');
    (0, $56efcfc01ad50440$export$8ff9f68337b520c0)(sortableElement, 'dragenter');
    (0, $56efcfc01ad50440$export$8ff9f68337b520c0)(sortableElement, 'drop');
};
function $db58504db5b9e911$export$2e2bcd8739ae039(sortableElements, options) {
    // get method string to see if a method is called
    const method = String(options);
    options = options || {};
    // check if the user provided a selector instead of an element
    if (typeof sortableElements === 'string') sortableElements = document.querySelectorAll(sortableElements);
    // if the user provided an element, return it in an array to keep the return value consistant
    if (sortableElements instanceof HTMLElement) sortableElements = [
        sortableElements
    ];
    sortableElements = Array.prototype.slice.call(sortableElements);
    if (/serialize/.test(method)) return sortableElements.map((sortableContainer)=>{
        const opts = (0, $97e990934cd9828e$export$6853292f627997e4)(sortableContainer, 'opts');
        return (0, $19f2af5f2b36f2f6$export$2e2bcd8739ae039)(sortableContainer, opts.itemSerializer, opts.containerSerializer);
    });
    sortableElements.forEach(function(sortableElement) {
        if (/enable|disable|destroy/.test(method)) return $db58504db5b9e911$export$2e2bcd8739ae039[method](sortableElement);
        // log deprecation
        [
            'connectWith',
            'disableIEFix'
        ].forEach((configKey)=>{
            if (Object.prototype.hasOwnProperty.call(options, configKey) && options[configKey] !== null) console.warn(`HTML5Sortable: You are using the deprecated configuration "${configKey}". This will be removed in an upcoming version, make sure to migrate to the new options when updating.`);
        });
        // merge options with default options
        options = Object.assign({}, (0, $2ff8965fb8e47872$export$2e2bcd8739ae039), (0, $1339acd9acf0bad6$export$2e2bcd8739ae039)(sortableElement).config, options);
        // init data store for sortable
        (0, $1339acd9acf0bad6$export$2e2bcd8739ae039)(sortableElement).config = options;
        // set options on sortable
        (0, $97e990934cd9828e$export$6853292f627997e4)(sortableElement, 'opts', options);
        // property to define as sortable
        sortableElement.isSortable = true;
        // reset sortable
        $db58504db5b9e911$var$reloadSortable(sortableElement);
        // initialize
        const listItems = (0, $ab490f4a72c38eea$export$2e2bcd8739ae039)(sortableElement.children, options.items);
        // create element if user defined a placeholder element as a string
        let customPlaceholder;
        if (options.placeholder !== null && options.placeholder !== undefined) {
            const tempContainer = document.createElement(sortableElement.tagName);
            if (options.placeholder instanceof HTMLElement) tempContainer.appendChild(options.placeholder);
            else tempContainer.innerHTML = options.placeholder;
            customPlaceholder = tempContainer.children[0];
        }
        // add placeholder
        (0, $1339acd9acf0bad6$export$2e2bcd8739ae039)(sortableElement).placeholder = (0, $f6a6f07da946e8b3$export$2e2bcd8739ae039)(sortableElement, customPlaceholder, options.placeholderClass);
        (0, $97e990934cd9828e$export$6853292f627997e4)(sortableElement, 'items', options.items);
        if (options.acceptFrom) (0, $97e990934cd9828e$export$6853292f627997e4)(sortableElement, 'acceptFrom', options.acceptFrom);
        else if (options.connectWith) (0, $97e990934cd9828e$export$6853292f627997e4)(sortableElement, 'connectWith', options.connectWith);
        $db58504db5b9e911$var$enableSortable(sortableElement);
        (0, $16e2e3aa115d4a46$export$5dcb5c23b6ba980a)(listItems, 'role', 'option');
        (0, $16e2e3aa115d4a46$export$5dcb5c23b6ba980a)(listItems, 'aria-grabbed', 'false');
        /*
     Handle drag events on draggable items
     Handle is set at the sortableElement level as it will bubble up
     from the item
     */ (0, $56efcfc01ad50440$export$3f65cefe8380dbea)(sortableElement, 'dragstart', function(e) {
            // ignore dragstart events
            const target = (0, $a5e3d963b0e44c2c$export$2e2bcd8739ae039)(e);
            if (target.isSortable === true) return;
            e.stopImmediatePropagation();
            if (options.handle && !target.matches(options.handle) || target.getAttribute('draggable') === 'false') return;
            const sortableContainer = $db58504db5b9e911$var$findSortable(target, e);
            const dragItem = $db58504db5b9e911$var$findDragElement(sortableContainer, target);
            // grab values
            $db58504db5b9e911$var$originItemsBeforeUpdate = (0, $ab490f4a72c38eea$export$2e2bcd8739ae039)(sortableContainer.children, options.items);
            $db58504db5b9e911$var$originIndex = $db58504db5b9e911$var$originItemsBeforeUpdate.indexOf(dragItem);
            $db58504db5b9e911$var$originElementIndex = (0, $c1b7347bcbcda66e$export$2e2bcd8739ae039)(dragItem, sortableContainer.children);
            $db58504db5b9e911$var$originContainer = sortableContainer;
            // add transparent clone or other ghost to cursor
            let dragImage = null;
            if (typeof options.customDragImage === 'string') {
                dragImage = document.querySelector(options.customDragImage);
                dragImage ?? console.error('The NodeList provided does not contain any valid elements.');
            } else if (options.customDragImage === 'function') dragImage = options.customDragImage;
            (0, $9c58ad1ac86c73cb$export$2e2bcd8739ae039)(e, dragItem, dragImage);
            // cache selsection & add attr for dragging
            $db58504db5b9e911$var$draggingHeight = (0, $7e9ab24da004e163$export$2e2bcd8739ae039)(dragItem);
            $db58504db5b9e911$var$draggingWidth = (0, $3d233ceb2c90c8ac$export$2e2bcd8739ae039)(dragItem);
            dragItem.classList.add(options.draggingClass);
            $db58504db5b9e911$var$dragging = $db58504db5b9e911$var$getDragging(dragItem, sortableContainer);
            (0, $16e2e3aa115d4a46$export$5dcb5c23b6ba980a)($db58504db5b9e911$var$dragging, 'aria-grabbed', 'true');
            // dispatch sortstart event on each element in group
            sortableContainer.dispatchEvent(new CustomEvent('sortstart', {
                detail: {
                    origin: {
                        elementIndex: $db58504db5b9e911$var$originElementIndex,
                        index: $db58504db5b9e911$var$originIndex,
                        container: $db58504db5b9e911$var$originContainer
                    },
                    item: $db58504db5b9e911$var$dragging,
                    originalTarget: target
                }
            }));
        });
        /*
     We are capturing targetSortable before modifications with 'dragenter' event
    */ (0, $56efcfc01ad50440$export$3f65cefe8380dbea)(sortableElement, 'dragenter', (e)=>{
            const target = (0, $a5e3d963b0e44c2c$export$2e2bcd8739ae039)(e);
            const sortableContainer = $db58504db5b9e911$var$findSortable(target, e);
            if (sortableContainer && sortableContainer !== $db58504db5b9e911$var$previousContainer) {
                $db58504db5b9e911$var$destinationItemsBeforeUpdate = (0, $ab490f4a72c38eea$export$2e2bcd8739ae039)(sortableContainer.children, (0, $97e990934cd9828e$export$6853292f627997e4)(sortableContainer, 'items')).filter((item)=>item !== (0, $1339acd9acf0bad6$export$2e2bcd8739ae039)(sortableElement).placeholder);
                if (options.dropTargetContainerClass) sortableContainer.classList.add(options.dropTargetContainerClass);
                sortableContainer.dispatchEvent(new CustomEvent('sortenter', {
                    detail: {
                        origin: {
                            elementIndex: $db58504db5b9e911$var$originElementIndex,
                            index: $db58504db5b9e911$var$originIndex,
                            container: $db58504db5b9e911$var$originContainer
                        },
                        destination: {
                            container: sortableContainer,
                            itemsBeforeUpdate: $db58504db5b9e911$var$destinationItemsBeforeUpdate
                        },
                        item: $db58504db5b9e911$var$dragging,
                        originalTarget: target
                    }
                }));
                (0, $56efcfc01ad50440$export$3f65cefe8380dbea)(sortableContainer, 'dragleave', (e)=>{
                    // TODO: rename outTarget to be more self-explanatory
                    // e.fromElement for very old browsers, similar to relatedTarget
                    const outTarget = e.relatedTarget || e.fromElement;
                    if (!e.currentTarget.contains(outTarget)) {
                        if (options.dropTargetContainerClass) sortableContainer.classList.remove(options.dropTargetContainerClass);
                        sortableContainer.dispatchEvent(new CustomEvent('sortleave', {
                            detail: {
                                origin: {
                                    elementIndex: $db58504db5b9e911$var$originElementIndex,
                                    index: $db58504db5b9e911$var$originIndex,
                                    container: sortableContainer
                                },
                                item: $db58504db5b9e911$var$dragging,
                                originalTarget: target
                            }
                        }));
                    }
                });
            }
            $db58504db5b9e911$var$previousContainer = sortableContainer;
        });
        /*
     * Dragend Event - https://developer.mozilla.org/en-US/docs/Web/Events/dragend
     * Fires each time dragEvent end, or ESC pressed
     * We are using it to clean up any draggable elements and placeholders
     */ (0, $56efcfc01ad50440$export$3f65cefe8380dbea)(sortableElement, 'dragend', function(e) {
            if (!$db58504db5b9e911$var$dragging) return;
            $db58504db5b9e911$var$dragging.classList.remove(options.draggingClass);
            (0, $16e2e3aa115d4a46$export$5dcb5c23b6ba980a)($db58504db5b9e911$var$dragging, 'aria-grabbed', 'false');
            if ($db58504db5b9e911$var$dragging.getAttribute('aria-copied') === 'true' && (0, $97e990934cd9828e$export$6853292f627997e4)($db58504db5b9e911$var$dragging, 'dropped') !== 'true') $db58504db5b9e911$var$dragging.remove();
            if ($db58504db5b9e911$var$dragging.oldDisplay !== undefined) {
                $db58504db5b9e911$var$dragging.style.display = $db58504db5b9e911$var$dragging.oldDisplay;
                delete $db58504db5b9e911$var$dragging.oldDisplay;
            }
            const visiblePlaceholder = Array.from((0, $1339acd9acf0bad6$export$bba5ab050e462fa8).values()).map((data)=>data.placeholder).filter((placeholder)=>placeholder instanceof HTMLElement).filter((0, $44012169bef03cff$export$2e2bcd8739ae039))[0];
            if (visiblePlaceholder) visiblePlaceholder.remove();
            // dispatch sortstart event on each element in group
            sortableElement.dispatchEvent(new CustomEvent('sortstop', {
                detail: {
                    origin: {
                        elementIndex: $db58504db5b9e911$var$originElementIndex,
                        index: $db58504db5b9e911$var$originIndex,
                        container: $db58504db5b9e911$var$originContainer
                    },
                    item: $db58504db5b9e911$var$dragging
                }
            }));
            $db58504db5b9e911$var$previousContainer = null;
            $db58504db5b9e911$var$dragging = null;
            $db58504db5b9e911$var$draggingHeight = null;
            $db58504db5b9e911$var$draggingWidth = null;
        });
        /*
     * Drop Event - https://developer.mozilla.org/en-US/docs/Web/Events/drop
     * Fires when valid drop target area is hit
     */ (0, $56efcfc01ad50440$export$3f65cefe8380dbea)(sortableElement, 'drop', function(e) {
            if (!(0, $89f048003a9fbf1a$export$2e2bcd8739ae039)(sortableElement, $db58504db5b9e911$var$dragging.parentElement)) return;
            e.preventDefault();
            e.stopPropagation();
            (0, $97e990934cd9828e$export$6853292f627997e4)($db58504db5b9e911$var$dragging, 'dropped', 'true');
            // get the one placeholder that is currently visible
            const visiblePlaceholder = Array.from((0, $1339acd9acf0bad6$export$bba5ab050e462fa8).values()).map((data)=>{
                return data.placeholder;
            })// filter only HTMLElements
            .filter((placeholder)=>placeholder instanceof HTMLElement)// only elements in DOM
            .filter((0, $44012169bef03cff$export$2e2bcd8739ae039))[0];
            if (visiblePlaceholder) {
                visiblePlaceholder.replaceWith($db58504db5b9e911$var$dragging);
                // to avoid flickering restoring element display immediately after replacing placeholder
                if ($db58504db5b9e911$var$dragging.oldDisplay !== undefined) {
                    $db58504db5b9e911$var$dragging.style.display = $db58504db5b9e911$var$dragging.oldDisplay;
                    delete $db58504db5b9e911$var$dragging.oldDisplay;
                }
            } else {
                // set the dropped value to 'false' to delete copied dragging at the time of 'dragend'
                (0, $97e990934cd9828e$export$6853292f627997e4)($db58504db5b9e911$var$dragging, 'dropped', 'false');
                return;
            }
            /*
       * Fires Custom Event - 'sortstop'
       */ sortableElement.dispatchEvent(new CustomEvent('sortstop', {
                detail: {
                    origin: {
                        elementIndex: $db58504db5b9e911$var$originElementIndex,
                        index: $db58504db5b9e911$var$originIndex,
                        container: $db58504db5b9e911$var$originContainer
                    },
                    item: $db58504db5b9e911$var$dragging
                }
            }));
            const placeholder = (0, $1339acd9acf0bad6$export$2e2bcd8739ae039)(sortableElement).placeholder;
            const originItems = (0, $ab490f4a72c38eea$export$2e2bcd8739ae039)($db58504db5b9e911$var$originContainer.children, options.items).filter((item)=>item !== placeholder);
            const destinationContainer = this.isSortable === true ? this : this.parentElement;
            const destinationItems = (0, $ab490f4a72c38eea$export$2e2bcd8739ae039)(destinationContainer.children, (0, $97e990934cd9828e$export$6853292f627997e4)(destinationContainer, 'items')).filter((item)=>item !== placeholder);
            const destinationElementIndex = (0, $c1b7347bcbcda66e$export$2e2bcd8739ae039)($db58504db5b9e911$var$dragging, Array.from($db58504db5b9e911$var$dragging.parentElement.children).filter((item)=>item !== placeholder));
            const destinationIndex = (0, $c1b7347bcbcda66e$export$2e2bcd8739ae039)($db58504db5b9e911$var$dragging, destinationItems);
            if (options.dropTargetContainerClass) destinationContainer.classList.remove(options.dropTargetContainerClass);
            /*
       * When a list item changed container lists or index within a list
       * Fires Custom Event - 'sortupdate'
       */ if ($db58504db5b9e911$var$originElementIndex !== destinationElementIndex || $db58504db5b9e911$var$originContainer !== destinationContainer) sortableElement.dispatchEvent(new CustomEvent('sortupdate', {
                detail: {
                    origin: {
                        elementIndex: $db58504db5b9e911$var$originElementIndex,
                        index: $db58504db5b9e911$var$originIndex,
                        container: $db58504db5b9e911$var$originContainer,
                        itemsBeforeUpdate: $db58504db5b9e911$var$originItemsBeforeUpdate,
                        items: originItems
                    },
                    destination: {
                        index: destinationIndex,
                        elementIndex: destinationElementIndex,
                        container: destinationContainer,
                        itemsBeforeUpdate: $db58504db5b9e911$var$destinationItemsBeforeUpdate,
                        items: destinationItems
                    },
                    item: $db58504db5b9e911$var$dragging
                }
            }));
        });
        const debouncedDragOverEnter = (0, $089454e91a0022de$export$2e2bcd8739ae039)((sortableElement, element, pageX, pageY)=>{
            if (!$db58504db5b9e911$var$dragging) return;
            // set placeholder height if forcePlaceholderSize option is set
            if (options.forcePlaceholderSize) {
                (0, $1339acd9acf0bad6$export$2e2bcd8739ae039)(sortableElement).placeholder.style.height = $db58504db5b9e911$var$draggingHeight + 'px';
                (0, $1339acd9acf0bad6$export$2e2bcd8739ae039)(sortableElement).placeholder.style.width = $db58504db5b9e911$var$draggingWidth + 'px';
            }
            // if element the draggedItem is dragged onto is within the array of all elements in list
            // (not only items, but also disabled, etc.)
            if (Array.from(sortableElement.children).indexOf(element) > -1) {
                const thisHeight = (0, $7e9ab24da004e163$export$2e2bcd8739ae039)(element);
                const thisWidth = (0, $3d233ceb2c90c8ac$export$2e2bcd8739ae039)(element);
                const placeholderIndex = (0, $c1b7347bcbcda66e$export$2e2bcd8739ae039)((0, $1339acd9acf0bad6$export$2e2bcd8739ae039)(sortableElement).placeholder, element.parentElement.children);
                const thisIndex = (0, $c1b7347bcbcda66e$export$2e2bcd8739ae039)(element, element.parentElement.children);
                // Check if `element` is bigger than the draggable. If it is, we have to define a dead zone to prevent flickering
                if (thisHeight > $db58504db5b9e911$var$draggingHeight || thisWidth > $db58504db5b9e911$var$draggingWidth) {
                    // Dead zone?
                    const deadZoneVertical = thisHeight - $db58504db5b9e911$var$draggingHeight;
                    const deadZoneHorizontal = thisWidth - $db58504db5b9e911$var$draggingWidth;
                    const offsetTop = (0, $b14a773b48141421$export$2e2bcd8739ae039)(element).top;
                    const offsetLeft = (0, $b14a773b48141421$export$2e2bcd8739ae039)(element).left;
                    if (placeholderIndex < thisIndex && (options.orientation === 'vertical' && pageY < offsetTop || options.orientation === 'horizontal' && pageX < offsetLeft)) return;
                    if (placeholderIndex > thisIndex && (options.orientation === 'vertical' && pageY > offsetTop + thisHeight - deadZoneVertical || options.orientation === 'horizontal' && pageX > offsetLeft + thisWidth - deadZoneHorizontal)) return;
                }
                if ($db58504db5b9e911$var$dragging.oldDisplay === undefined) $db58504db5b9e911$var$dragging.oldDisplay = $db58504db5b9e911$var$dragging.style.display;
                if ($db58504db5b9e911$var$dragging.style.display !== 'none') $db58504db5b9e911$var$dragging.style.display = 'none';
                // To avoid flicker, determine where to position the placeholder
                // based on where the mouse pointer is relative to the elements
                // vertical center.
                let placeAfter = false;
                try {
                    const elementMiddleVertical = (0, $b14a773b48141421$export$2e2bcd8739ae039)(element).top + element.offsetHeight / 2;
                    const elementMiddleHorizontal = (0, $b14a773b48141421$export$2e2bcd8739ae039)(element).left + element.offsetWidth / 2;
                    placeAfter = options.orientation === 'vertical' && pageY >= elementMiddleVertical || options.orientation === 'horizontal' && pageX >= elementMiddleHorizontal;
                } catch (e) {
                    placeAfter = placeholderIndex < thisIndex;
                }
                if (placeAfter) (0, $6b88599688b290d7$export$c4f94c8b3850a5a9)(element, (0, $1339acd9acf0bad6$export$2e2bcd8739ae039)(sortableElement).placeholder);
                else (0, $6b88599688b290d7$export$86b68c7dbeb53c22)(element, (0, $1339acd9acf0bad6$export$2e2bcd8739ae039)(sortableElement).placeholder);
                // get placeholders from all stores & remove all but current one
                Array.from((0, $1339acd9acf0bad6$export$bba5ab050e462fa8).values())// remove empty values
                .filter((data)=>data.placeholder !== undefined)// foreach placeholder in array if outside of current sorableContainer -> remove from DOM
                .forEach((data)=>{
                    if (data.placeholder !== (0, $1339acd9acf0bad6$export$2e2bcd8739ae039)(sortableElement).placeholder) data.placeholder.remove();
                });
            } else {
                // get all placeholders from store
                const placeholders = Array.from((0, $1339acd9acf0bad6$export$bba5ab050e462fa8).values()).filter((data)=>data.placeholder !== undefined).map((data)=>{
                    return data.placeholder;
                });
                // check if element is not in placeholders
                if (placeholders.indexOf(element) === -1 && sortableElement === element && !(0, $ab490f4a72c38eea$export$2e2bcd8739ae039)(element.children, options.items).length) {
                    placeholders.forEach((element)=>element.remove());
                    element.appendChild((0, $1339acd9acf0bad6$export$2e2bcd8739ae039)(sortableElement).placeholder);
                }
            }
        }, options.debounce);
        // Handle dragover and dragenter events on draggable items
        const onDragOverEnter = function(e) {
            let element = e.target;
            const sortableElement = element.isSortable === true ? element : $db58504db5b9e911$var$findSortable(element, e);
            element = $db58504db5b9e911$var$findDragElement(sortableElement, element);
            if (!$db58504db5b9e911$var$dragging || !(0, $89f048003a9fbf1a$export$2e2bcd8739ae039)(sortableElement, $db58504db5b9e911$var$dragging.parentElement) || (0, $97e990934cd9828e$export$6853292f627997e4)(sortableElement, '_disabled') === 'true') return;
            const options = (0, $97e990934cd9828e$export$6853292f627997e4)(sortableElement, 'opts');
            if (parseInt(options.maxItems) && (0, $ab490f4a72c38eea$export$2e2bcd8739ae039)(sortableElement.children, (0, $97e990934cd9828e$export$6853292f627997e4)(sortableElement, 'items')).length >= parseInt(options.maxItems) && $db58504db5b9e911$var$dragging.parentElement !== sortableElement) return;
            e.preventDefault();
            e.stopPropagation();
            e.dataTransfer.dropEffect = (0, $1339acd9acf0bad6$export$2e2bcd8739ae039)(sortableElement).getConfig('copy') === true ? 'copy' : 'move';
            debouncedDragOverEnter(sortableElement, element, e.pageX, e.pageY);
        };
        (0, $56efcfc01ad50440$export$3f65cefe8380dbea)(listItems.concat(sortableElement), 'dragover', onDragOverEnter);
        (0, $56efcfc01ad50440$export$3f65cefe8380dbea)(listItems.concat(sortableElement), 'dragenter', onDragOverEnter);
    });
    return sortableElements;
}
$db58504db5b9e911$export$2e2bcd8739ae039.destroy = function(sortableElement) {
    $db58504db5b9e911$var$destroySortable(sortableElement);
};
$db58504db5b9e911$export$2e2bcd8739ae039.enable = function(sortableElement) {
    $db58504db5b9e911$var$enableSortable(sortableElement);
};
$db58504db5b9e911$export$2e2bcd8739ae039.disable = function(sortableElement) {
    $db58504db5b9e911$var$disableSortable(sortableElement);
};
/* START.TESTS_ONLY */ $db58504db5b9e911$export$2e2bcd8739ae039.__testing = {
    data: // add internal methods here for testing purposes
    $97e990934cd9828e$export$6853292f627997e4,
    removeItemEvents: $db58504db5b9e911$var$removeItemEvents,
    removeItemData: $db58504db5b9e911$var$removeItemData,
    removeSortableData: $db58504db5b9e911$var$removeSortableData,
    removeContainerEvents: $db58504db5b9e911$var$removeContainerEvents
} /* END.TESTS_ONLY */ ;



function $9fc87da71ba88662$export$2e2bcd8739ae039(root) {
    let timeout = null;
    Array.from(root.querySelectorAll('.typeahead[data-typeahead-url]')).forEach((typeahead)=>{
        let query = '';
        let minLength = typeahead.getAttribute('data-min-length');
        let delay = typeahead.getAttribute('data-delay');
        let input = typeahead.querySelector('input.query');
        if (!input) input = typeahead.querySelector('textarea.query');
        let target = typeahead.querySelector(typeahead.getAttribute('data-target'));
        let container = document.createElement('div');
        container.setAttribute('class', 'list-group shadow-sm');
        let close = typeahead.querySelector('.close');
        if (close) close.addEventListener('click', (e)=>{
            e.preventDefault();
            const parent = e.currentTarget.parentElement;
            parent.querySelector('.response').innerHTML = '';
            parent.querySelectorAll('input, textarea').forEach((el)=>{
                el.value = '';
            });
            typeahead.querySelector('.response').innerHTML = '';
            e.currentTarget.classList.add('d-none');
        });
        input.addEventListener('keydown', (e)=>{
            if (e.keyCode === 13) {
                e.preventDefault();
                container.classList.add('d-none');
                close.classList.add('d-none');
            }
        });
        input.addEventListener('keyup', (e)=>{
            if (e.keyCode === 13) {
                e.preventDefault();
                container.classList.add('d-none');
                close.classList.add('d-none');
                if (target) {
                    const event = new Event('fill');
                    target.dispatchEvent(event);
                    const complete = new Event('complete');
                    target.dispatchEvent(complete);
                }
            } else if (e.keyCode === 38) {
                e.preventDefault();
                container.classList.remove('d-none');
                let listItem = container.querySelector('a.active');
                let newItem = listItem ? listItem.previousElementSibling : container.querySelector('a:first-child');
                if (newItem) {
                    newItem.classList.add('active');
                    if (listItem) listItem.classList.remove('active');
                    if (target) {
                        target.value = newItem.getAttribute('data-id');
                        const event = new Event('change');
                        target.dispatchEvent(event);
                    }
                    input.value = newItem.textContent;
                    if (target) {
                        const event = new Event('done');
                        target.dispatchEvent(event);
                    }
                }
            } else if (e.keyCode === 40) {
                e.preventDefault();
                container.classList.remove('d-none');
                let listItem = container.querySelector('a.active');
                let newItem = listItem ? listItem.nextElementSibling : container.querySelector('a:first-child');
                if (newItem) {
                    newItem.classList.add('active');
                    if (listItem) listItem.classList.remove('active');
                    if (target) {
                        target.value = newItem.getAttribute('data-id');
                        const event = new Event('change');
                        target.dispatchEvent(event);
                    }
                    input.value = newItem.textContent;
                    if (target) {
                        const event = new Event('done');
                        target.dispatchEvent(event);
                    }
                }
            } else if (query !== input.value) {
                if (target) {
                    target.value = '';
                    const event = new Event('change');
                    target.dispatchEvent(event);
                }
                query = input.value;
                if (query.length >= (minLength ?? 2)) {
                    if (timeout) clearTimeout(timeout);
                    let response = typeahead.querySelector('.response');
                    let loading = typeahead.querySelector('.loading');
                    if (typeof input.dataset.ignoreHttp !== "undefined" && input.value.search(/^http(s)?:\/\/.*/) !== -1) {
                        loading.classList.add('d-none');
                        response.innerHTML = '';
                        return; // ignore query
                    }
                    timeout = setTimeout(()=>{
                        loading.classList.remove('d-none');
                        response.innerHTML = '';
                        (0, $da6d917fcd2d3fe8$export$2e2bcd8739ae039).makeRequest('GET', typeahead.getAttribute('data-typeahead-url'), {
                            query: input.value
                        }, {
                            history: false
                        }).catch((error)=>{
                            response.innerHTML = error;
                        }).then((payload)=>{
                            container.innerHTML = '';
                            if (payload.length > 0) {
                                for (let item of payload){
                                    let listItem = document.createElement('a');
                                    listItem.setAttribute('class', 'list-group-item list-group-item-action');
                                    listItem.setAttribute('href', '#');
                                    listItem.setAttribute('data-id', item.id);
                                    listItem.text = item.value;
                                    listItem.addEventListener('click', (e)=>{
                                        e.preventDefault();
                                        e.target.classList.add('active');
                                        if (target) {
                                            target.value = e.target.getAttribute('data-id');
                                            const event = new Event('fill');
                                            target.dispatchEvent(event);
                                        }
                                        input.value = e.target.textContent;
                                        container.classList.add('d-none');
                                        close.classList.add('d-none');
                                        input.focus();
                                        if (target) {
                                            const event = new Event('done');
                                            target.dispatchEvent(event);
                                            const complete = new Event('complete');
                                            target.dispatchEvent(complete);
                                        }
                                    });
                                    container.appendChild(listItem);
                                }
                                loading.classList.add('d-none');
                                response.appendChild(container);
                                close.classList.remove('d-none');
                            } else {
                                loading.classList.add('d-none');
                                response.innerHTML = payload.error;
                            }
                            container.classList.remove('d-none');
                        });
                    }, delay ?? 300);
                }
            }
        });
    });
}


let $189ecab1e762bcfb$var$_html;
function $189ecab1e762bcfb$export$2e2bcd8739ae039(html) {
    $189ecab1e762bcfb$var$_html = html;
    $189ecab1e762bcfb$var$sortNavigation(html);
}
function $189ecab1e762bcfb$var$itemCallback(e) {
    e.preventDefault();
    const icon = e.currentTarget.querySelector('i.fas');
    const expand = icon.classList.contains('fa-chevron-down');
    if (expand) {
        icon.classList.remove('fa-chevron-down');
        icon.classList.add('fa-chevron-up');
    } else {
        icon.classList.remove('fa-chevron-up');
        icon.classList.add('fa-chevron-down');
    }
    const item = e.currentTarget.closest('.item');
    const level = parseInt(item.dataset.level) + 1;
    const parentKey = e.currentTarget.dataset.parentKey;
    let current = item.nextElementSibling;
    while(current){
        if (expand) {
            if (current.classList.contains('d-none') && parseInt(current.dataset.level) === level && current.dataset.parentKey === parentKey) current.classList.remove('d-none');
        } else if (!current.classList.contains('d-none') && parseInt(current.dataset.level) === level && current.dataset.parentKey === parentKey) current.classList.add('d-none');
        current = current.nextElementSibling;
    }
}
function $189ecab1e762bcfb$var$typeaheadCallback(e) {
    const input = e.currentTarget.closest('.typeahead').querySelector('input[type=text]');
    const parent = input.closest('.item.add-item');
    const url = input.dataset.createItem;
    const data = {
        dataSourceId: e.currentTarget.value,
        parentKey: parent.dataset.parentKey,
        level: parent.dataset.level
    };
    (0, $da6d917fcd2d3fe8$export$2e2bcd8739ae039).makeRequest('GET', url, data, {
        history: false
    }).then((payload)=>{
        parent.insertAdjacentHTML('beforebegin', payload.html);
        (0, $9fc87da71ba88662$export$2e2bcd8739ae039)(parent.previousElementSibling);
        $189ecab1e762bcfb$var$sortNavigation($189ecab1e762bcfb$var$_html);
        input.value = '';
        input.focus();
    }).catch((err)=>{
        alert(err);
    });
}
function $189ecab1e762bcfb$var$btnCallback(e) {
    e.preventDefault();
    e.currentTarget.classList.add('d-none');
    const typeahead = e.currentTarget.nextElementSibling;
    const input = typeahead.querySelector('input[type=text]');
    input.classList.remove('d-none');
    input.focus();
    const target = typeahead.querySelector(typeahead.dataset.target);
    target.removeEventListener('fill', $189ecab1e762bcfb$var$typeaheadCallback);
    target.addEventListener('fill', $189ecab1e762bcfb$var$typeaheadCallback);
}
function $189ecab1e762bcfb$var$removeBtnCallback(e) {
    e.preventDefault();
    const parent = e.currentTarget.dataset.parentKey;
    let i = 0;
    const queue = [
        parent
    ];
    while(i < queue.length){
        const rootKey = queue[i];
        const query = rootKey === '' ? '.item[data-parent-key="' + rootKey + '"]' : '.item[data-key="' + rootKey + '"]';
        $189ecab1e762bcfb$var$_html.querySelectorAll(query).forEach((root)=>{
            const key = root.dataset.key;
            Array.from($189ecab1e762bcfb$var$_html.querySelectorAll('.items-sortable .item[data-parent-key="' + key + '"]')).forEach((child)=>{
                if (typeof child.dataset.key !== "undefined") queue.push(child.dataset.key);
                child.remove();
            });
        });
        i++;
    }
    $189ecab1e762bcfb$var$_html.querySelector('.item[data-key="' + parent + '"]')?.remove();
}
function $189ecab1e762bcfb$var$sortNavigation(html) {
    let i = 0;
    const queue = [
        ''
    ];
    while(i < queue.length){
        const rootKey = queue[i];
        const query = rootKey === '' ? '.item[data-parent-key="' + rootKey + '"]' : '.item[data-key="' + rootKey + '"]';
        html.querySelectorAll(query).forEach((root)=>{
            const key = root.dataset.key;
            Array.from(html.querySelectorAll('.items-sortable .item[data-parent-key="' + key + '"]')).reverse().forEach((child)=>{
                if (typeof child.dataset.key !== "undefined") queue.push(child.dataset.key);
                root.after(child);
            });
        });
        i++;
    }
    const list = [];
    html.querySelectorAll('.items-sortable .item-nav').forEach((el)=>{
        const parent = el.dataset.parentKey;
        if (typeof list[parent] === "undefined") list[parent] = [];
        el.querySelector('input[name*=position]').value = list[parent].length;
        el.querySelector('input[name*=parent]').value = parent;
        list[parent].push(el.dataset.key);
    });
    html.querySelectorAll('form#frm-navigationForm .item').forEach((item)=>{
        item.querySelector('.item-children a')?.removeEventListener('click', $189ecab1e762bcfb$var$itemCallback);
        item.querySelector('.item-children a')?.addEventListener('click', $189ecab1e762bcfb$var$itemCallback);
        item.querySelector('button.remove-item')?.removeEventListener('click', $189ecab1e762bcfb$var$removeBtnCallback);
        item.querySelector('button.remove-item')?.addEventListener('click', $189ecab1e762bcfb$var$removeBtnCallback);
    });
    html.querySelectorAll('form#frm-navigationForm .item.add-item > button').forEach((btn)=>{
        btn.removeEventListener('click', $189ecab1e762bcfb$var$btnCallback);
        btn.addEventListener('click', $189ecab1e762bcfb$var$btnCallback);
    });
    (0, $db58504db5b9e911$export$2e2bcd8739ae039)('.items-sortable', {
        forcePlaceholderSize: true,
        placeholder: '<div class="sortable-placeholder">' + html.querySelector('.items-sortable').dataset.placeholder + '</div>',
        handle: '.item-move'
    })[0].addEventListener('sortupdate', (e)=>{
        const item = e.detail.item;
        let sibling = item.previousElementSibling;
        if (sibling.classList.contains('add-item')) sibling = html.querySelector('.items-sortable .item[data-key="' + sibling.dataset.parentKey + '"]');
        else while(sibling){
            if (sibling.classList.contains('item-nav') && !sibling.classList.contains('d-none')) break;
            sibling = sibling.previousElementSibling;
        }
        const level = parseInt(sibling.dataset.level);
        item.dataset.parentKey = sibling.dataset.parentKey;
        item.dataset.level = level.toString();
        item.style.marginLeft = level * 50 + 'px';
        $189ecab1e762bcfb$var$sortNavigation(html);
    });
}


function $028efab5c636e6f2$export$2e2bcd8739ae039(html) {
    html.querySelectorAll('[data-bs-toggle=modal][data-url]').forEach((el)=>{
        el.addEventListener('click', (e)=>{
            const loader = document.querySelector('#contentPreviewLoader');
            loader.classList.remove('d-none');
            const iframe = document.querySelector('#contentPreviewModal iframe');
            iframe.classList.add('d-none');
            const url = e.currentTarget.getAttribute('data-url');
            if (url) {
                const callback = (e)=>{
                    loader.classList.add('d-none');
                    e.currentTarget.classList.remove('d-none');
                };
                iframe.removeEventListener('load', callback);
                iframe.addEventListener('load', callback);
                iframe.setAttribute('src', url);
            } else alert('URL not found.');
        });
    });
}


function $80a6e9b40f3a75de$export$2e2bcd8739ae039(html, target) {
    switch(target){
        case 'front_url':
            (0, $1a2837bba20a495a$export$2e2bcd8739ae039)(html);
            break;
        case 'admin_dashboard':
            (0, $a762211eb604cd4e$export$2e2bcd8739ae039)(html);
            break;
        case 'admin_dataSources':
            (0, $726ddecc56fb830c$export$2e2bcd8739ae039)(html);
            break;
        case 'admin_addArticle':
        case 'admin_editArticle':
            break;
        case 'admin_addPage':
        case 'admin_editPage':
            break;
        case 'admin_addProfile':
        case 'admin_editProfile':
            break;
        case 'admin_editNavigation':
            (0, $189ecab1e762bcfb$export$2e2bcd8739ae039)(html);
            break;
        case 'admin_profiles':
            (0, $028efab5c636e6f2$export$2e2bcd8739ae039)(html);
            break;
        default:
            console.error('Module scope cannot be loaded: ' + target);
    }
}



var $9d6256e44361182b$exports = {};
/*!
 * NetteForms - simple form validation.
 *
 * This file is part of the Nette Framework (https://nette.org)
 * Copyright (c) 2004 David Grudl (https://davidgrudl.com)
 */ (function(global, factory) {
    $9d6256e44361182b$exports = factory();
})($9d6256e44361182b$exports, function() {
    'use strict';
    class Validators {
        filled(elem, arg, val) {
            return val !== '' && val !== false && val !== null && (!Array.isArray(val) || val.length > 0) && (!(val instanceof FileList) || val.length > 0);
        }
        blank(elem, arg, val) {
            return !this.filled(elem, arg, val);
        }
        valid(elem, arg) {
            return arg.validateControl(elem, undefined, true);
        }
        equal(elem, arg, val) {
            if (arg === undefined) return null;
            let toString = (val)=>{
                if (typeof val === 'number' || typeof val === 'string') return '' + val;
                else return val === true ? '1' : '';
            };
            let vals = Array.isArray(val) ? val : [
                val
            ];
            let args = Array.isArray(arg) ? arg : [
                arg
            ];
            loop: for (let a of vals){
                for (let b of args){
                    if (toString(a) === toString(b)) continue loop;
                }
                return false;
            }
            return vals.length > 0;
        }
        notEqual(elem, arg, val) {
            return arg === undefined ? null : !this.equal(elem, arg, val);
        }
        minLength(elem, arg, val) {
            val = typeof val === 'number' ? val.toString() : val;
            return val.length >= arg;
        }
        maxLength(elem, arg, val) {
            val = typeof val === 'number' ? val.toString() : val;
            return val.length <= arg;
        }
        length(elem, arg, val) {
            val = typeof val === 'number' ? val.toString() : val;
            arg = Array.isArray(arg) ? arg : [
                arg,
                arg
            ];
            return (arg[0] === null || val.length >= arg[0]) && (arg[1] === null || val.length <= arg[1]);
        }
        email(elem, arg, val) {
            return /^("([ !#-[\]-~]|\\[ -~])+"|[-a-z0-9!#$%&'*+/=?^_`{|}~]+(\.[-a-z0-9!#$%&'*+/=?^_`{|}~]+)*)@([0-9a-z\u00C0-\u02FF\u0370-\u1EFF]([-0-9a-z\u00C0-\u02FF\u0370-\u1EFF]{0,61}[0-9a-z\u00C0-\u02FF\u0370-\u1EFF])?\.)+[a-z\u00C0-\u02FF\u0370-\u1EFF]([-0-9a-z\u00C0-\u02FF\u0370-\u1EFF]{0,17}[a-z\u00C0-\u02FF\u0370-\u1EFF])?$/i.test(val);
        }
        url(elem, arg, val, newValue) {
            if (!/^[a-z\d+.-]+:/.test(val)) val = 'https://' + val;
            if (/^https?:\/\/((([-_0-9a-z\u00C0-\u02FF\u0370-\u1EFF]+\.)*[0-9a-z\u00C0-\u02FF\u0370-\u1EFF]([-0-9a-z\u00C0-\u02FF\u0370-\u1EFF]{0,61}[0-9a-z\u00C0-\u02FF\u0370-\u1EFF])?\.)?[a-z\u00C0-\u02FF\u0370-\u1EFF]([-0-9a-z\u00C0-\u02FF\u0370-\u1EFF]{0,17}[a-z\u00C0-\u02FF\u0370-\u1EFF])?|\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}|\[[0-9a-f:]{3,39}\])(:\d{1,5})?(\/\S*)?$/i.test(val)) {
                newValue.value = val;
                return true;
            }
            return false;
        }
        regexp(elem, arg, val) {
            let parts = typeof arg === 'string' ? arg.match(/^\/(.*)\/([imu]*)$/) : false;
            try {
                return parts && new RegExp(parts[1], parts[2].replace('u', '')).test(val);
            } catch  {
                return null;
            }
        }
        pattern(elem, arg, val, newValue, caseInsensitive) {
            if (typeof arg !== 'string') return null;
            try {
                let regExp;
                try {
                    regExp = new RegExp('^(?:' + arg + ')$', caseInsensitive ? 'ui' : 'u');
                } catch  {
                    regExp = new RegExp('^(?:' + arg + ')$', caseInsensitive ? 'i' : '');
                }
                return val instanceof FileList ? Array.from(val).every((file)=>regExp.test(file.name)) : regExp.test(val);
            } catch  {
                return null;
            }
        }
        patternCaseInsensitive(elem, arg, val) {
            return this.pattern(elem, arg, val, null, true);
        }
        numeric(elem, arg, val) {
            return /^[0-9]+$/.test(val);
        }
        integer(elem, arg, val, newValue) {
            if (/^-?[0-9]+$/.test(val)) {
                newValue.value = parseFloat(val);
                return true;
            }
            return false;
        }
        float(elem, arg, val, newValue) {
            val = val.replace(/ +/g, '').replace(/,/g, '.');
            if (/^-?[0-9]*\.?[0-9]+$/.test(val)) {
                newValue.value = parseFloat(val);
                return true;
            }
            return false;
        }
        min(elem, arg, val) {
            if (Number.isFinite(arg)) val = parseFloat(val);
            return val >= arg;
        }
        max(elem, arg, val) {
            if (Number.isFinite(arg)) val = parseFloat(val);
            return val <= arg;
        }
        range(elem, arg, val) {
            if (!Array.isArray(arg)) return null;
            else if (elem.type === 'time' && arg[0] > arg[1]) return val >= arg[0] || val <= arg[1];
            return (arg[0] === null || this.min(elem, arg[0], val)) && (arg[1] === null || this.max(elem, arg[1], val));
        }
        submitted(elem) {
            return elem.form['nette-submittedBy'] === elem;
        }
        fileSize(elem, arg, val) {
            return Array.from(val).every((file)=>file.size <= arg);
        }
        mimeType(elem, args, val) {
            let parts = [];
            args = Array.isArray(args) ? args : [
                args
            ];
            args.forEach((arg)=>parts.push('^' + arg.replace(/([^\w])/g, '\\$1').replace('\\*', '.*') + '$'));
            let re = new RegExp(parts.join('|'));
            return Array.from(val).every((file)=>!file.type || re.test(file.type));
        }
        image(elem, arg, val) {
            return this.mimeType(elem, arg ?? [
                'image/gif',
                'image/png',
                'image/jpeg',
                'image/webp'
            ], val);
        }
        static(elem, arg) {
            return arg;
        }
    }
    class FormValidator {
        formErrors = [];
        validators = new Validators;
        #preventFiltering = {};
        #formToggles = {};
        #toggleListeners = new WeakMap;
        #getFormElement(form, name) {
            let res = form.elements.namedItem(name);
            return res instanceof RadioNodeList ? res[0] : res;
        }
        #expandRadioElement(elem) {
            let res = elem.form.elements.namedItem(elem.name);
            return res instanceof RadioNodeList ? Array.from(res) : [
                res
            ];
        }
        /**
		 * Function to execute when the DOM is fully loaded.
		 */ #onDocumentReady(callback) {
            if (document.readyState !== 'loading') callback.call(this);
            else document.addEventListener('DOMContentLoaded', callback);
        }
        /**
		 * Returns the value of form element.
		 */ getValue(elem) {
            if (elem instanceof HTMLInputElement) {
                if (elem.type === 'radio') return this.#expandRadioElement(elem).find((input)=>input.checked)?.value ?? null;
                else if (elem.type === 'file') return elem.files;
                else if (elem.type === 'checkbox') return elem.name.endsWith('[]') // checkbox list
                 ? this.#expandRadioElement(elem).filter((input)=>input.checked).map((input)=>input.value) : elem.checked;
                else return elem.value.trim();
            } else if (elem instanceof HTMLSelectElement) return elem.multiple ? Array.from(elem.selectedOptions, (option)=>option.value) : elem.selectedOptions[0]?.value ?? null;
            else if (elem instanceof HTMLTextAreaElement) return elem.value;
            else if (elem instanceof RadioNodeList) return this.getValue(elem[0]);
            else return null;
        }
        /**
		 * Returns the effective value of form element.
		 */ getEffectiveValue(elem, filter = false) {
            let val = this.getValue(elem);
            if (val === elem.getAttribute('data-nette-empty-value')) val = '';
            if (filter && this.#preventFiltering[elem.name] === undefined) {
                this.#preventFiltering[elem.name] = true;
                let ref = {
                    value: val
                };
                this.validateControl(elem, undefined, true, ref);
                val = ref.value;
                delete this.#preventFiltering[elem.name];
            }
            return val;
        }
        /**
		 * Validates form element against given rules.
		 */ validateControl(elem, rules, onlyCheck = false, value, emptyOptional) {
            rules ??= JSON.parse(elem.getAttribute('data-nette-rules') ?? '[]');
            value ??= {
                value: this.getEffectiveValue(elem)
            };
            emptyOptional ??= !this.validateRule(elem, ':filled', null, value);
            for (let rule of rules){
                let op = rule.op.match(/(~)?([^?]+)/), curElem = rule.control ? this.#getFormElement(elem.form, rule.control) : elem;
                rule.neg = !!op[1];
                rule.op = op[2];
                rule.condition = !!rule.rules;
                if (!curElem) continue;
                else if (emptyOptional && !rule.condition && rule.op !== ':filled') continue;
                let success = this.validateRule(curElem, rule.op, rule.arg, elem === curElem ? value : undefined);
                if (success === null) continue;
                else if (rule.neg) success = !success;
                if (rule.condition && success) {
                    if (!this.validateControl(elem, rule.rules, onlyCheck, value, rule.op === ':blank' ? false : emptyOptional)) return false;
                } else if (!rule.condition && !success) {
                    if (this.isDisabled(curElem)) continue;
                    if (!onlyCheck) {
                        let arr = Array.isArray(rule.arg) ? rule.arg : [
                            rule.arg
                        ], message = rule.msg.replace(/%(value|\d+)/g, (foo, m)=>this.getValue(m === 'value' ? curElem : elem.form.elements.namedItem(arr[m].control)));
                        this.addError(curElem, message);
                    }
                    return false;
                }
            }
            return true;
        }
        /**
		 * Validates whole form.
		 */ validateForm(sender, onlyCheck = false) {
            let form = sender.form ?? sender, scope;
            this.formErrors = [];
            if (sender.getAttribute('formnovalidate') !== null) {
                let scopeArr = JSON.parse(sender.getAttribute('data-nette-validation-scope') ?? '[]');
                if (scopeArr.length) scope = new RegExp('^(' + scopeArr.join('-|') + '-)');
                else {
                    this.showFormErrors(form, []);
                    return true;
                }
            }
            for (let elem of form.elements)if (elem.willValidate && elem.validity.badInput) {
                elem.reportValidity();
                return false;
            }
            for (let elem of form.elements){
                if (elem.getAttribute('data-nette-rules') && (!scope || elem.name.replace(/]\[|\[|]|$/g, '-').match(scope)) && !this.isDisabled(elem) && !this.validateControl(elem, undefined, onlyCheck) && !this.formErrors.length) return false;
            }
            let success = !this.formErrors.length;
            this.showFormErrors(form, this.formErrors);
            return success;
        }
        /**
		 * Check if input is disabled.
		 */ isDisabled(elem) {
            if (elem.type === 'radio') return this.#expandRadioElement(elem).every((input)=>input.disabled);
            return elem.disabled;
        }
        /**
		 * Adds error message to the queue.
		 */ addError(elem, message) {
            this.formErrors.push({
                element: elem,
                message: message
            });
        }
        /**
		 * Display error messages.
		 */ showFormErrors(form, errors) {
            let messages = [], focusElem;
            for (let error of errors)if (messages.indexOf(error.message) < 0) {
                messages.push(error.message);
                focusElem ??= error.element;
            }
            if (messages.length) this.showModal(messages.join('\n'), ()=>{
                focusElem?.focus();
            });
        }
        /**
		 * Display modal window.
		 */ showModal(message, onclose) {
            let dialog = document.createElement('dialog');
            if (!dialog.showModal) {
                alert(message);
                onclose();
                return;
            }
            let style = document.createElement('style');
            style.innerText = '.netteFormsModal { text-align: center; margin: auto; border: 2px solid black; padding: 1rem } .netteFormsModal button { padding: .1em 2em }';
            let button = document.createElement('button');
            button.innerText = 'OK';
            button.onclick = ()=>{
                dialog.remove();
                onclose();
            };
            dialog.setAttribute('class', 'netteFormsModal');
            dialog.innerText = message + '\n\n';
            dialog.append(style, button);
            document.body.append(dialog);
            dialog.showModal();
        }
        /**
		 * Validates single rule.
		 */ validateRule(elem, op, arg, value) {
            if (elem.validity.badInput) return op === ':filled';
            value ??= {
                value: this.getEffectiveValue(elem, true)
            };
            let method = op.charAt(0) === ':' ? op.substring(1) : op;
            method = method.replace('::', '_').replaceAll('\\', '');
            let args = Array.isArray(arg) ? arg : [
                arg
            ];
            args = args.map((arg)=>{
                if (arg?.control) {
                    let control = this.#getFormElement(elem.form, arg.control);
                    return control === elem ? value.value : this.getEffectiveValue(control, true);
                }
                return arg;
            });
            if (method === 'valid') args[0] = this; // todo
            return this.validators[method] ? this.validators[method](elem, Array.isArray(arg) ? args : args[0], value.value, value) : null;
        }
        /**
		 * Process all toggles in form.
		 */ toggleForm(form, event) {
            this.#formToggles = {};
            for (let elem of Array.from(form.elements))if (elem.getAttribute('data-nette-rules')) this.toggleControl(elem, undefined, null, !event);
            for(let i in this.#formToggles)this.toggle(i, this.#formToggles[i].state, this.#formToggles[i].elem, event);
        }
        /**
		 * Process toggles on form element.
		 */ toggleControl(elem, rules, success = null, firsttime = false, value, emptyOptional) {
            rules ??= JSON.parse(elem.getAttribute('data-nette-rules') ?? '[]');
            value ??= {
                value: this.getEffectiveValue(elem)
            };
            emptyOptional ??= !this.validateRule(elem, ':filled', null, value);
            let has = false, curSuccess;
            for (let rule of rules){
                let op = rule.op.match(/(~)?([^?]+)/), curElem = rule.control ? this.#getFormElement(elem.form, rule.control) : elem;
                rule.neg = !!op[1];
                rule.op = op[2];
                rule.condition = !!rule.rules;
                if (!curElem) continue;
                else if (emptyOptional && !rule.condition && rule.op !== ':filled') continue;
                curSuccess = success;
                if (success !== false) {
                    curSuccess = this.validateRule(curElem, rule.op, rule.arg, elem === curElem ? value : undefined);
                    if (curSuccess === null) continue;
                    else if (rule.neg) curSuccess = !curSuccess;
                    if (!rule.condition) success = curSuccess;
                }
                if (rule.condition && this.toggleControl(elem, rule.rules, curSuccess, firsttime, value, rule.op === ':blank' ? false : emptyOptional) || rule.toggle) {
                    has = true;
                    if (firsttime) this.#expandRadioElement(curElem).filter((el)=>!this.#toggleListeners.has(el)).forEach((el)=>{
                        el.addEventListener('change', (e)=>this.toggleForm(elem.form, e));
                        this.#toggleListeners.set(el, null);
                    });
                    for(let id in rule.toggle ?? {}){
                        this.#formToggles[id] ??= {
                            elem: elem,
                            state: false
                        };
                        this.#formToggles[id].state ||= rule.toggle[id] ? !!curSuccess : !curSuccess;
                    }
                }
            }
            return has;
        }
        /**
		 * Displays or hides HTML element.
		 */ toggle(selector, visible, srcElement, event) {
            if (/^\w[\w.:-]*$/.test(selector)) selector = '#' + selector;
            Array.from(document.querySelectorAll(selector)).forEach((elem)=>elem.hidden = !visible);
        }
        /**
		 * Compact checkboxes
		 */ compactCheckboxes(form, formData) {
            let values = {};
            for (let elem of form.elements)if (elem instanceof HTMLInputElement && elem.type === 'checkbox' && elem.name.endsWith('[]') && elem.checked && !elem.disabled) {
                formData.delete(elem.name);
                values[elem.name] ??= [];
                values[elem.name].push(elem.value);
            }
            for(let name in values)formData.set(name.substring(0, name.length - 2), values[name].join(','));
        }
        /**
		 * Setup handlers.
		 */ initForm(form) {
            if (form.method === 'get' && form.hasAttribute('data-nette-compact')) form.addEventListener('formdata', (e)=>this.compactCheckboxes(form, e.formData));
            if (!Array.from(form.elements).some((elem)=>elem.getAttribute('data-nette-rules'))) return;
            this.toggleForm(form);
            if (form.noValidate) return;
            form.noValidate = true;
            form.addEventListener('submit', (e)=>{
                if (!this.validateForm(e.submitter || form)) {
                    e.stopPropagation();
                    e.preventDefault();
                }
            });
            form.addEventListener('reset', ()=>{
                setTimeout(()=>this.toggleForm(form));
            });
        }
        initOnLoad() {
            this.#onDocumentReady(()=>{
                Array.from(document.forms).forEach((form)=>this.initForm(form));
            });
        }
    }
    let webalizeTable = {
        "\xe1": 'a',
        "\xe4": 'a',
        \u010D: 'c',
        \u010F: 'd',
        "\xe9": 'e',
        \u011B: 'e',
        "\xed": 'i',
        \u013E: 'l',
        \u0148: 'n',
        "\xf3": 'o',
        "\xf4": 'o',
        \u0159: 'r',
        \u0161: 's',
        \u0165: 't',
        "\xfa": 'u',
        \u016F: 'u',
        "\xfd": 'y',
        \u017E: 'z'
    };
    /**
	 * Converts string to web safe characters [a-z0-9-] text.
	 * @param {string} s
	 * @return {string}
	 */ function webalize(s) {
        s = s.toLowerCase();
        let res = '';
        for(let i = 0; i < s.length; i++){
            let ch = webalizeTable[s.charAt(i)];
            res += ch ? ch : s.charAt(i);
        }
        return res.replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    }
    var version = "3.5.2";
    let nette = new FormValidator;
    nette.version = version;
    nette.webalize = webalize;
    return nette;
});


function $6861aaaf6af71002$export$2e2bcd8739ae039() {
    const deleteBtn = document.querySelector('input[type=submit][name=delete]');
    if (deleteBtn) {
        const deleteBtnEvent = (e)=>{
            deleteBtn.closest('form.needs-validation').classList.remove('needs-validation');
        };
        deleteBtn.removeEventListener('click', deleteBtnEvent);
        deleteBtn.addEventListener('click', deleteBtnEvent);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($9d6256e44361182b$exports))).showFormErrors = function(form, errors) {
        Array.from(form.querySelectorAll('.invalid-feedback')).forEach((el)=>{
            const input = el.parentElement.querySelector('.is-invalid');
            if (input) {
                input.classList.remove('is-invalid');
                input.classList.add('is-valid');
            }
            el.remove();
        });
        let focused = false;
        const list = {};
        for(const i in errors){
            const el = errors[i].element;
            const parent = el.parentElement;
            parent.classList.remove('was-validated');
            el.classList.remove('is-valid');
            el.classList.add('is-invalid');
            Array.from(parent.querySelectorAll('.valid-feedback, .invalid-feedback')).forEach((_el)=>{
                _el.remove();
            });
            const div = document.createElement('div');
            div.classList.add('invalid-feedback');
            div.textContent = errors[i].message;
            parent.append(div);
            if (!focused) {
                el.focus();
                focused = true;
            }
            const listItem = document.createElement('div');
            listItem.classList.add('text-danger');
            listItem.classList.add('mb-1');
            listItem.innerHTML = '<small><i class="fas fa-exclamation-triangle me-2"></i>' + errors[i].message + '</small>';
            list[errors[i].element.getAttribute('name')] = listItem;
            console.error(errors[i].message);
        }
        document.querySelectorAll('.form-errors-list').forEach((el)=>{
            el.classList.add('d-none');
            const items = el.querySelector('.items');
            items.innerHTML = '';
            if (Object.keys(list).length) {
                for(const name in list)items.append(list[name]);
                el.classList.remove('d-none');
            }
        });
    };
    let form = document.querySelector('form.needs-validation');
    if (form) form.addEventListener('submit', (e)=>{
        Array.from(form.querySelectorAll('.form-controls .row')).forEach((el)=>{
            el.classList.add('was-validated');
        });
        if (this.checkValidity() === false) {
            e.preventDefault();
            e.stopPropagation();
            (0, (/*@__PURE__*/$parcel$interopDefault($9d6256e44361182b$exports))).validateForm(this);
        }
    });
    window.Nette = (0, (/*@__PURE__*/$parcel$interopDefault($9d6256e44361182b$exports)));
    (0, (/*@__PURE__*/$parcel$interopDefault($9d6256e44361182b$exports))).initOnLoad();
}


/*!
  * Bootstrap v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ var $d37552697cc5ea39$exports = {};

$parcel$export($d37552697cc5ea39$exports, "popperGenerator", () => $b3c2fd6800546b4b$export$ed5e13716264f202);
$parcel$export($d37552697cc5ea39$exports, "detectOverflow", () => $f765731200b57f98$export$2e2bcd8739ae039);
$parcel$export($d37552697cc5ea39$exports, "createPopperBase", () => $b3c2fd6800546b4b$export$8f7491d57c8f97a9);
$parcel$export($d37552697cc5ea39$exports, "createPopper", () => $1bf0bf541303046d$export$8f7491d57c8f97a9);
$parcel$export($d37552697cc5ea39$exports, "createPopperLite", () => $cff5cce2532d9fa1$export$8f7491d57c8f97a9);
var $f5c54167a3c62105$exports = {};

$parcel$export($f5c54167a3c62105$exports, "top", () => $f5c54167a3c62105$export$1e95b668f3b82d);
$parcel$export($f5c54167a3c62105$exports, "bottom", () => $f5c54167a3c62105$export$40e543e69a8b3fbb);
$parcel$export($f5c54167a3c62105$exports, "right", () => $f5c54167a3c62105$export$79ffe56a765070d2);
$parcel$export($f5c54167a3c62105$exports, "left", () => $f5c54167a3c62105$export$eabcd2c8791e7bf4);
$parcel$export($f5c54167a3c62105$exports, "auto", () => $f5c54167a3c62105$export$dfb5619354ba860);
$parcel$export($f5c54167a3c62105$exports, "basePlacements", () => $f5c54167a3c62105$export$aec2ce47c367b8c3);
$parcel$export($f5c54167a3c62105$exports, "start", () => $f5c54167a3c62105$export$b3571188c770cc5a);
$parcel$export($f5c54167a3c62105$exports, "end", () => $f5c54167a3c62105$export$bd5df0f255a350f8);
$parcel$export($f5c54167a3c62105$exports, "clippingParents", () => $f5c54167a3c62105$export$390fd549c5303b4d);
$parcel$export($f5c54167a3c62105$exports, "viewport", () => $f5c54167a3c62105$export$d7b7311ec04a3e8f);
$parcel$export($f5c54167a3c62105$exports, "popper", () => $f5c54167a3c62105$export$ae5ab1c730825774);
$parcel$export($f5c54167a3c62105$exports, "reference", () => $f5c54167a3c62105$export$ca50aac9f3ba507f);
$parcel$export($f5c54167a3c62105$exports, "variationPlacements", () => $f5c54167a3c62105$export$368f9a87e87fa4e1);
$parcel$export($f5c54167a3c62105$exports, "placements", () => $f5c54167a3c62105$export$803cd8101b6c182b);
$parcel$export($f5c54167a3c62105$exports, "beforeRead", () => $f5c54167a3c62105$export$421679a7c3d56e);
$parcel$export($f5c54167a3c62105$exports, "read", () => $f5c54167a3c62105$export$aafa59e2e03f2942);
$parcel$export($f5c54167a3c62105$exports, "afterRead", () => $f5c54167a3c62105$export$6964f6c886723980);
$parcel$export($f5c54167a3c62105$exports, "beforeMain", () => $f5c54167a3c62105$export$c65e99957a05207c);
$parcel$export($f5c54167a3c62105$exports, "main", () => $f5c54167a3c62105$export$f22da7240b7add18);
$parcel$export($f5c54167a3c62105$exports, "afterMain", () => $f5c54167a3c62105$export$bab79516f2d662fe);
$parcel$export($f5c54167a3c62105$exports, "beforeWrite", () => $f5c54167a3c62105$export$8d4d2d70e7d46032);
$parcel$export($f5c54167a3c62105$exports, "write", () => $f5c54167a3c62105$export$68d8715fc104d294);
$parcel$export($f5c54167a3c62105$exports, "afterWrite", () => $f5c54167a3c62105$export$70a6e5159acce2e6);
$parcel$export($f5c54167a3c62105$exports, "modifierPhases", () => $f5c54167a3c62105$export$d087d3878fdf71d5);
var $f5c54167a3c62105$export$1e95b668f3b82d = 'top';
var $f5c54167a3c62105$export$40e543e69a8b3fbb = 'bottom';
var $f5c54167a3c62105$export$79ffe56a765070d2 = 'right';
var $f5c54167a3c62105$export$eabcd2c8791e7bf4 = 'left';
var $f5c54167a3c62105$export$dfb5619354ba860 = 'auto';
var $f5c54167a3c62105$export$aec2ce47c367b8c3 = [
    $f5c54167a3c62105$export$1e95b668f3b82d,
    $f5c54167a3c62105$export$40e543e69a8b3fbb,
    $f5c54167a3c62105$export$79ffe56a765070d2,
    $f5c54167a3c62105$export$eabcd2c8791e7bf4
];
var $f5c54167a3c62105$export$b3571188c770cc5a = 'start';
var $f5c54167a3c62105$export$bd5df0f255a350f8 = 'end';
var $f5c54167a3c62105$export$390fd549c5303b4d = 'clippingParents';
var $f5c54167a3c62105$export$d7b7311ec04a3e8f = 'viewport';
var $f5c54167a3c62105$export$ae5ab1c730825774 = 'popper';
var $f5c54167a3c62105$export$ca50aac9f3ba507f = 'reference';
var $f5c54167a3c62105$export$368f9a87e87fa4e1 = /*#__PURE__*/ $f5c54167a3c62105$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $f5c54167a3c62105$export$b3571188c770cc5a,
        placement + "-" + $f5c54167a3c62105$export$bd5df0f255a350f8
    ]);
}, []);
var $f5c54167a3c62105$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($f5c54167a3c62105$export$aec2ce47c367b8c3, [
    $f5c54167a3c62105$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $f5c54167a3c62105$export$b3571188c770cc5a,
        placement + "-" + $f5c54167a3c62105$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $f5c54167a3c62105$export$421679a7c3d56e = 'beforeRead';
var $f5c54167a3c62105$export$aafa59e2e03f2942 = 'read';
var $f5c54167a3c62105$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $f5c54167a3c62105$export$c65e99957a05207c = 'beforeMain';
var $f5c54167a3c62105$export$f22da7240b7add18 = 'main';
var $f5c54167a3c62105$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $f5c54167a3c62105$export$8d4d2d70e7d46032 = 'beforeWrite';
var $f5c54167a3c62105$export$68d8715fc104d294 = 'write';
var $f5c54167a3c62105$export$70a6e5159acce2e6 = 'afterWrite';
var $f5c54167a3c62105$export$d087d3878fdf71d5 = [
    $f5c54167a3c62105$export$421679a7c3d56e,
    $f5c54167a3c62105$export$aafa59e2e03f2942,
    $f5c54167a3c62105$export$6964f6c886723980,
    $f5c54167a3c62105$export$c65e99957a05207c,
    $f5c54167a3c62105$export$f22da7240b7add18,
    $f5c54167a3c62105$export$bab79516f2d662fe,
    $f5c54167a3c62105$export$8d4d2d70e7d46032,
    $f5c54167a3c62105$export$68d8715fc104d294,
    $f5c54167a3c62105$export$70a6e5159acce2e6
];


var $1341d386dda6ba3e$exports = {};

$parcel$export($1341d386dda6ba3e$exports, "applyStyles", () => $83c1fc4c4e58d7dd$export$2e2bcd8739ae039);
$parcel$export($1341d386dda6ba3e$exports, "arrow", () => $1992f2d714808ab6$export$2e2bcd8739ae039);
$parcel$export($1341d386dda6ba3e$exports, "computeStyles", () => $c8f8eadcf7685dc5$export$2e2bcd8739ae039);
$parcel$export($1341d386dda6ba3e$exports, "eventListeners", () => $ff355aafd082b0cd$export$2e2bcd8739ae039);
$parcel$export($1341d386dda6ba3e$exports, "flip", () => $b1f32a1d9525a032$export$2e2bcd8739ae039);
$parcel$export($1341d386dda6ba3e$exports, "hide", () => $174d14927bb4f43b$export$2e2bcd8739ae039);
$parcel$export($1341d386dda6ba3e$exports, "offset", () => $7c04da2e958a3fe8$export$2e2bcd8739ae039);
$parcel$export($1341d386dda6ba3e$exports, "popperOffsets", () => $e92fb10df1450f31$export$2e2bcd8739ae039);
$parcel$export($1341d386dda6ba3e$exports, "preventOverflow", () => $3295dac8746ffe59$export$2e2bcd8739ae039);
function $4f30cf0ce50e075e$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}


function $df9341392e6ed7b1$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $d98cb23738a6d9d0$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $d98cb23738a6d9d0$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $d98cb23738a6d9d0$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


// and applies them to the HTMLElements such as popper and arrow
function $83c1fc4c4e58d7dd$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(element) || !(0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $83c1fc4c4e58d7dd$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(element) || !(0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $83c1fc4c4e58d7dd$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $83c1fc4c4e58d7dd$var$applyStyles,
    effect: $83c1fc4c4e58d7dd$var$effect,
    requires: [
        'computeStyles'
    ]
};



function $afe288682115fde3$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}



var $7e23bad950468b82$export$8960430cfd85939f = Math.max;
var $7e23bad950468b82$export$96ec731ed4dcb222 = Math.min;
var $7e23bad950468b82$export$2077e0241d6afd3c = Math.round;



function $90ccbd5892233dd2$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $993d40d65cc118cd$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $90ccbd5892233dd2$export$2e2bcd8739ae039)());
}


function $84019ab652aa921b$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $7e23bad950468b82$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $7e23bad950468b82$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(element) ? (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $993d40d65cc118cd$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}


function $30ced62b744c6cfe$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $84019ab652aa921b$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}



function $d63950b756706495$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $d98cb23738a6d9d0$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}





function $41cae7042543c5d5$export$2e2bcd8739ae039(element) {
    return (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}




function $6829c22fb01dde5a$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(element)) >= 0;
}




function $433af39bc2fae35d$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $17f6a21d28fc02f5$export$2e2bcd8739ae039(element) {
    if ((0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $d98cb23738a6d9d0$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $433af39bc2fae35d$export$2e2bcd8739ae039)(element) // fallback
    );
}



function $a56b734280245ffb$var$getTrueOffsetParent(element) {
    if (!(0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $41cae7042543c5d5$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $a56b734280245ffb$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $90ccbd5892233dd2$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $90ccbd5892233dd2$export$2e2bcd8739ae039)());
    if (isIE && (0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $41cae7042543c5d5$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $17f6a21d28fc02f5$export$2e2bcd8739ae039)(element);
    if ((0, $d98cb23738a6d9d0$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $41cae7042543c5d5$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $a56b734280245ffb$export$2e2bcd8739ae039(element) {
    var window = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(element);
    var offsetParent = $a56b734280245ffb$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $6829c22fb01dde5a$export$2e2bcd8739ae039)(offsetParent) && (0, $41cae7042543c5d5$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $a56b734280245ffb$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $41cae7042543c5d5$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $a56b734280245ffb$var$getContainingBlock(element) || window;
}


function $b518c35b71cf930f$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $b6f0b0266e764faa$export$f28d906d67a997f3(min, value, max) {
    return (0, $7e23bad950468b82$export$8960430cfd85939f)(min, (0, $7e23bad950468b82$export$96ec731ed4dcb222)(value, max));
}
function $b6f0b0266e764faa$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $b6f0b0266e764faa$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}


function $683c5e26d5f8bfe5$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $387b887da02b7e69$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $683c5e26d5f8bfe5$export$2e2bcd8739ae039)(), paddingObject);
}


function $4d11a6decde23bf9$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}



var $1992f2d714808ab6$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $387b887da02b7e69$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $4d11a6decde23bf9$export$2e2bcd8739ae039)(padding, (0, $f5c54167a3c62105$export$aec2ce47c367b8c3)));
};
function $1992f2d714808ab6$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $afe288682115fde3$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $b518c35b71cf930f$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4),
        (0, $f5c54167a3c62105$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $1992f2d714808ab6$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $30ced62b744c6cfe$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $f5c54167a3c62105$export$1e95b668f3b82d) : (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $f5c54167a3c62105$export$40e543e69a8b3fbb) : (0, $f5c54167a3c62105$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $a56b734280245ffb$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $b6f0b0266e764faa$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $1992f2d714808ab6$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $d63950b756706495$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $1992f2d714808ab6$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $1992f2d714808ab6$var$arrow,
    effect: $1992f2d714808ab6$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};








function $7b08f0526e425773$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}



var $c8f8eadcf7685dc5$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $c8f8eadcf7685dc5$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $7e23bad950468b82$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $7e23bad950468b82$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $c8f8eadcf7685dc5$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4);
    var sideY = (0, $f5c54167a3c62105$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $a56b734280245ffb$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $433af39bc2fae35d$export$2e2bcd8739ae039)(popper);
            if ((0, $41cae7042543c5d5$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $f5c54167a3c62105$export$1e95b668f3b82d) || (placement === (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4) || placement === (0, $f5c54167a3c62105$export$79ffe56a765070d2)) && variation === (0, $f5c54167a3c62105$export$bd5df0f255a350f8)) {
            sideY = (0, $f5c54167a3c62105$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4) || (placement === (0, $f5c54167a3c62105$export$1e95b668f3b82d) || placement === (0, $f5c54167a3c62105$export$40e543e69a8b3fbb)) && variation === (0, $f5c54167a3c62105$export$bd5df0f255a350f8)) {
            sideX = (0, $f5c54167a3c62105$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $c8f8eadcf7685dc5$var$unsetSides);
    var _ref4 = roundOffsets === true ? $c8f8eadcf7685dc5$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $c8f8eadcf7685dc5$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $afe288682115fde3$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $7b08f0526e425773$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $c8f8eadcf7685dc5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $c8f8eadcf7685dc5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $c8f8eadcf7685dc5$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $c8f8eadcf7685dc5$var$computeStyles,
    data: {}
};



var $ff355aafd082b0cd$var$passive = {
    passive: true
};
function $ff355aafd082b0cd$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $ff355aafd082b0cd$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $ff355aafd082b0cd$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $ff355aafd082b0cd$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $ff355aafd082b0cd$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $ff355aafd082b0cd$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $ff355aafd082b0cd$var$effect,
    data: {}
};


var $825ae98fe4f5d029$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $825ae98fe4f5d029$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $825ae98fe4f5d029$var$hash[matched];
    });
}



var $76c023b5f4bd6339$var$hash = {
    start: 'end',
    end: 'start'
};
function $76c023b5f4bd6339$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $76c023b5f4bd6339$var$hash[matched];
    });
}








function $68a584be1dc90596$export$2e2bcd8739ae039(node) {
    var win = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}


function $943aee5c7065ad53$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $84019ab652aa921b$export$2e2bcd8739ae039)((0, $433af39bc2fae35d$export$2e2bcd8739ae039)(element)).left + (0, $68a584be1dc90596$export$2e2bcd8739ae039)(element).scrollLeft;
}



function $7b0a0ce1fa68929f$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(element);
    var html = (0, $433af39bc2fae35d$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $993d40d65cc118cd$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $943aee5c7065ad53$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $3e70615fb3e74824$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $433af39bc2fae35d$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $68a584be1dc90596$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $7e23bad950468b82$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $7e23bad950468b82$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $943aee5c7065ad53$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $41cae7042543c5d5$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $7e23bad950468b82$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}




function $18583dfdff147fd4$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $41cae7042543c5d5$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}




function $3eb5703c925e0e5d$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(node) && (0, $18583dfdff147fd4$export$2e2bcd8739ae039)(node)) return node;
    return $3eb5703c925e0e5d$export$2e2bcd8739ae039((0, $17f6a21d28fc02f5$export$2e2bcd8739ae039)(node));
}





function $a621d360f1a81b88$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $3eb5703c925e0e5d$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $18583dfdff147fd4$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($a621d360f1a81b88$export$2e2bcd8739ae039((0, $17f6a21d28fc02f5$export$2e2bcd8739ae039)(target)));
}










function $b0d5f0927fb8bf5c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $631049efb60e96c6$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $84019ab652aa921b$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $631049efb60e96c6$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $f5c54167a3c62105$export$d7b7311ec04a3e8f) ? (0, $b0d5f0927fb8bf5c$export$2e2bcd8739ae039)((0, $7b0a0ce1fa68929f$export$2e2bcd8739ae039)(element, strategy)) : (0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(clippingParent) ? $631049efb60e96c6$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $b0d5f0927fb8bf5c$export$2e2bcd8739ae039)((0, $3e70615fb3e74824$export$2e2bcd8739ae039)((0, $433af39bc2fae35d$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $631049efb60e96c6$var$getClippingParents(element) {
    var clippingParents = (0, $a621d360f1a81b88$export$2e2bcd8739ae039)((0, $17f6a21d28fc02f5$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $41cae7042543c5d5$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(element) ? (0, $a56b734280245ffb$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(clippingParent) && (0, $d63950b756706495$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $631049efb60e96c6$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $631049efb60e96c6$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $631049efb60e96c6$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $7e23bad950468b82$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $7e23bad950468b82$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $7e23bad950468b82$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $7e23bad950468b82$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $631049efb60e96c6$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $03cba2f7a1498b5f$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $afe288682115fde3$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $7b08f0526e425773$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $f5c54167a3c62105$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $f5c54167a3c62105$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $f5c54167a3c62105$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $f5c54167a3c62105$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $b518c35b71cf930f$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $f5c54167a3c62105$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $f5c54167a3c62105$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}







function $f765731200b57f98$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $f5c54167a3c62105$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $f5c54167a3c62105$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $f5c54167a3c62105$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $387b887da02b7e69$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $4d11a6decde23bf9$export$2e2bcd8739ae039)(padding, (0, $f5c54167a3c62105$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $f5c54167a3c62105$export$ae5ab1c730825774) ? (0, $f5c54167a3c62105$export$ca50aac9f3ba507f) : (0, $f5c54167a3c62105$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $631049efb60e96c6$export$2e2bcd8739ae039)((0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $433af39bc2fae35d$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $84019ab652aa921b$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $03cba2f7a1498b5f$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $b0d5f0927fb8bf5c$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $f5c54167a3c62105$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $f5c54167a3c62105$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $f5c54167a3c62105$export$79ffe56a765070d2),
                (0, $f5c54167a3c62105$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $f5c54167a3c62105$export$1e95b668f3b82d),
                (0, $f5c54167a3c62105$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $dbd70d4ba9902caa$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $f5c54167a3c62105$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $7b08f0526e425773$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $f5c54167a3c62105$export$368f9a87e87fa4e1) : (0, $f5c54167a3c62105$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $7b08f0526e425773$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $f5c54167a3c62105$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $f765731200b57f98$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $afe288682115fde3$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $b1f32a1d9525a032$var$getExpandedFallbackPlacements(placement) {
    if ((0, $afe288682115fde3$export$2e2bcd8739ae039)(placement) === (0, $f5c54167a3c62105$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $825ae98fe4f5d029$export$2e2bcd8739ae039)(placement);
    return [
        (0, $76c023b5f4bd6339$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $76c023b5f4bd6339$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $b1f32a1d9525a032$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $afe288682115fde3$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $825ae98fe4f5d029$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $b1f32a1d9525a032$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $afe288682115fde3$export$2e2bcd8739ae039)(placement) === (0, $f5c54167a3c62105$export$dfb5619354ba860) ? (0, $dbd70d4ba9902caa$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $afe288682115fde3$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $7b08f0526e425773$export$2e2bcd8739ae039)(placement) === (0, $f5c54167a3c62105$export$b3571188c770cc5a);
        var isVertical = [
            (0, $f5c54167a3c62105$export$1e95b668f3b82d),
            (0, $f5c54167a3c62105$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $f765731200b57f98$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $f5c54167a3c62105$export$79ffe56a765070d2) : (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $f5c54167a3c62105$export$40e543e69a8b3fbb) : (0, $f5c54167a3c62105$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $825ae98fe4f5d029$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $825ae98fe4f5d029$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $b1f32a1d9525a032$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $b1f32a1d9525a032$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};




function $174d14927bb4f43b$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $174d14927bb4f43b$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $f5c54167a3c62105$export$1e95b668f3b82d),
        (0, $f5c54167a3c62105$export$79ffe56a765070d2),
        (0, $f5c54167a3c62105$export$40e543e69a8b3fbb),
        (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $174d14927bb4f43b$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $f765731200b57f98$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $f765731200b57f98$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $174d14927bb4f43b$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $174d14927bb4f43b$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $174d14927bb4f43b$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $174d14927bb4f43b$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $174d14927bb4f43b$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $174d14927bb4f43b$var$hide
};




function $7c04da2e958a3fe8$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $afe288682115fde3$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4),
        (0, $f5c54167a3c62105$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4),
        (0, $f5c54167a3c62105$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $7c04da2e958a3fe8$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $f5c54167a3c62105$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $7c04da2e958a3fe8$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $7c04da2e958a3fe8$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $7c04da2e958a3fe8$var$offset
};



function $e92fb10df1450f31$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $03cba2f7a1498b5f$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $e92fb10df1450f31$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $e92fb10df1450f31$var$popperOffsets,
    data: {}
};





function $d8b68132b61080af$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}









function $3295dac8746ffe59$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $f765731200b57f98$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $afe288682115fde3$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $7b08f0526e425773$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $b518c35b71cf930f$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $d8b68132b61080af$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $f5c54167a3c62105$export$1e95b668f3b82d) : (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $f5c54167a3c62105$export$40e543e69a8b3fbb) : (0, $f5c54167a3c62105$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $f5c54167a3c62105$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $f5c54167a3c62105$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $30ced62b744c6cfe$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $683c5e26d5f8bfe5$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $b6f0b0266e764faa$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $a56b734280245ffb$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $b6f0b0266e764faa$export$f28d906d67a997f3)(tether ? (0, $7e23bad950468b82$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $7e23bad950468b82$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $f5c54167a3c62105$export$1e95b668f3b82d) : (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $f5c54167a3c62105$export$40e543e69a8b3fbb) : (0, $f5c54167a3c62105$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $f5c54167a3c62105$export$1e95b668f3b82d),
            (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $b6f0b0266e764faa$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $b6f0b0266e764faa$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $3295dac8746ffe59$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $3295dac8746ffe59$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};








function $9102221f9e13ae54$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $ca14c6927ef497ac$export$2e2bcd8739ae039(node) {
    if (node === (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(node) || !(0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(node)) return (0, $68a584be1dc90596$export$2e2bcd8739ae039)(node);
    else return (0, $9102221f9e13ae54$export$2e2bcd8739ae039)(node);
}








function $34abf65a06d63352$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $7e23bad950468b82$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $7e23bad950468b82$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $34abf65a06d63352$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(offsetParent) && $34abf65a06d63352$var$isElementScaled(offsetParent);
    var documentElement = (0, $433af39bc2fae35d$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $84019ab652aa921b$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $18583dfdff147fd4$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $ca14c6927ef497ac$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $84019ab652aa921b$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $943aee5c7065ad53$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}






function $0baf5472b5ad4a5a$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $0baf5472b5ad4a5a$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $0baf5472b5ad4a5a$var$order(modifiers); // order based on phase
    return (0, $f5c54167a3c62105$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $9b65b878009bf47f$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $46d929ffbbd3136a$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $b3c2fd6800546b4b$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $b3c2fd6800546b4b$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $b3c2fd6800546b4b$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $b3c2fd6800546b4b$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $b3c2fd6800546b4b$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(reference) ? (0, $a621d360f1a81b88$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $a621d360f1a81b88$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $a621d360f1a81b88$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $0baf5472b5ad4a5a$export$2e2bcd8739ae039)((0, $46d929ffbbd3136a$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$b3c2fd6800546b4b$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $34abf65a06d63352$export$2e2bcd8739ae039)(reference, (0, $a56b734280245ffb$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $30ced62b744c6cfe$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $9b65b878009bf47f$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$b3c2fd6800546b4b$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $b3c2fd6800546b4b$export$8f7491d57c8f97a9 = /*#__PURE__*/ $b3c2fd6800546b4b$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules














var $1bf0bf541303046d$export$d34966752335dd47 = [
    (0, $ff355aafd082b0cd$export$2e2bcd8739ae039),
    (0, $e92fb10df1450f31$export$2e2bcd8739ae039),
    (0, $c8f8eadcf7685dc5$export$2e2bcd8739ae039),
    (0, $83c1fc4c4e58d7dd$export$2e2bcd8739ae039),
    (0, $7c04da2e958a3fe8$export$2e2bcd8739ae039),
    (0, $b1f32a1d9525a032$export$2e2bcd8739ae039),
    (0, $3295dac8746ffe59$export$2e2bcd8739ae039),
    (0, $1992f2d714808ab6$export$2e2bcd8739ae039),
    (0, $174d14927bb4f43b$export$2e2bcd8739ae039)
];
var $1bf0bf541303046d$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $b3c2fd6800546b4b$export$ed5e13716264f202)({
    defaultModifiers: $1bf0bf541303046d$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules







var $cff5cce2532d9fa1$export$d34966752335dd47 = [
    (0, $ff355aafd082b0cd$export$2e2bcd8739ae039),
    (0, $e92fb10df1450f31$export$2e2bcd8739ae039),
    (0, $c8f8eadcf7685dc5$export$2e2bcd8739ae039),
    (0, $83c1fc4c4e58d7dd$export$2e2bcd8739ae039)
];
var $cff5cce2532d9fa1$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $b3c2fd6800546b4b$export$ed5e13716264f202)({
    defaultModifiers: $cff5cce2532d9fa1$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


$parcel$exportWildcard($d37552697cc5ea39$exports, $f5c54167a3c62105$exports);
$parcel$exportWildcard($d37552697cc5ea39$exports, $1341d386dda6ba3e$exports);


/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/data.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$elementMap = new Map();
const $91ca15859685b28b$var$Data = {
    set (element, key, instance) {
        if (!$91ca15859685b28b$var$elementMap.has(element)) $91ca15859685b28b$var$elementMap.set(element, new Map());
        const instanceMap = $91ca15859685b28b$var$elementMap.get(element);
        // make it clear we only want one instance per element
        // can be removed later when multiple key/instances are fine to be used
        if (!instanceMap.has(key) && instanceMap.size !== 0) {
            // eslint-disable-next-line no-console
            console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(instanceMap.keys())[0]}.`);
            return;
        }
        instanceMap.set(key, instance);
    },
    get (element, key) {
        if ($91ca15859685b28b$var$elementMap.has(element)) return $91ca15859685b28b$var$elementMap.get(element).get(key) || null;
        return null;
    },
    remove (element, key) {
        if (!$91ca15859685b28b$var$elementMap.has(element)) return;
        const instanceMap = $91ca15859685b28b$var$elementMap.get(element);
        instanceMap.delete(key);
        // free up element references if there are no instances left for an element
        if (instanceMap.size === 0) $91ca15859685b28b$var$elementMap.delete(element);
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/index.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $91ca15859685b28b$var$MAX_UID = 1000000;
const $91ca15859685b28b$var$MILLISECONDS_MULTIPLIER = 1000;
const $91ca15859685b28b$var$TRANSITION_END = 'transitionend';
/**
 * Properly escape IDs selectors to handle weird IDs
 * @param {string} selector
 * @returns {string}
 */ const $91ca15859685b28b$var$parseSelector = (selector)=>{
    if (selector && window.CSS && window.CSS.escape) // document.querySelector needs escaping to handle IDs (html5+) containing for instance /
    selector = selector.replace(/#([^\s"#']+)/g, (match, id)=>`#${CSS.escape(id)}`);
    return selector;
};
// Shout-out Angus Croll (https://goo.gl/pxwQGp)
const $91ca15859685b28b$var$toType = (object)=>{
    if (object === null || object === undefined) return `${object}`;
    return Object.prototype.toString.call(object).match(/\s([a-z]+)/i)[1].toLowerCase();
};
/**
 * Public Util API
 */ const $91ca15859685b28b$var$getUID = (prefix)=>{
    do prefix += Math.floor(Math.random() * $91ca15859685b28b$var$MAX_UID);
    while (document.getElementById(prefix));
    return prefix;
};
const $91ca15859685b28b$var$getTransitionDurationFromElement = (element)=>{
    if (!element) return 0;
    // Get transition-duration of the element
    let { transitionDuration: transitionDuration, transitionDelay: transitionDelay } = window.getComputedStyle(element);
    const floatTransitionDuration = Number.parseFloat(transitionDuration);
    const floatTransitionDelay = Number.parseFloat(transitionDelay);
    // Return 0 if element or transition duration is not found
    if (!floatTransitionDuration && !floatTransitionDelay) return 0;
    // If multiple durations are defined, take the first
    transitionDuration = transitionDuration.split(',')[0];
    transitionDelay = transitionDelay.split(',')[0];
    return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * $91ca15859685b28b$var$MILLISECONDS_MULTIPLIER;
};
const $91ca15859685b28b$var$triggerTransitionEnd = (element)=>{
    element.dispatchEvent(new Event($91ca15859685b28b$var$TRANSITION_END));
};
const $91ca15859685b28b$var$isElement = (object)=>{
    if (!object || typeof object !== 'object') return false;
    if (typeof object.jquery !== 'undefined') object = object[0];
    return typeof object.nodeType !== 'undefined';
};
const $91ca15859685b28b$var$getElement = (object)=>{
    // it's a jQuery object or a node element
    if ($91ca15859685b28b$var$isElement(object)) return object.jquery ? object[0] : object;
    if (typeof object === 'string' && object.length > 0) return document.querySelector($91ca15859685b28b$var$parseSelector(object));
    return null;
};
const $91ca15859685b28b$var$isVisible = (element)=>{
    if (!$91ca15859685b28b$var$isElement(element) || element.getClientRects().length === 0) return false;
    const elementIsVisible = getComputedStyle(element).getPropertyValue('visibility') === 'visible';
    // Handle `details` element as its content may falsie appear visible when it is closed
    const closedDetails = element.closest('details:not([open])');
    if (!closedDetails) return elementIsVisible;
    if (closedDetails !== element) {
        const summary = element.closest('summary');
        if (summary && summary.parentNode !== closedDetails) return false;
        if (summary === null) return false;
    }
    return elementIsVisible;
};
const $91ca15859685b28b$var$isDisabled = (element)=>{
    if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
    if (element.classList.contains('disabled')) return true;
    if (typeof element.disabled !== 'undefined') return element.disabled;
    return element.hasAttribute('disabled') && element.getAttribute('disabled') !== 'false';
};
const $91ca15859685b28b$var$findShadowRoot = (element)=>{
    if (!document.documentElement.attachShadow) return null;
    // Can find the shadow root otherwise it'll return the document
    if (typeof element.getRootNode === 'function') {
        const root = element.getRootNode();
        return root instanceof ShadowRoot ? root : null;
    }
    if (element instanceof ShadowRoot) return element;
    // when we don't find a shadow root
    if (!element.parentNode) return null;
    return $91ca15859685b28b$var$findShadowRoot(element.parentNode);
};
const $91ca15859685b28b$var$noop = ()=>{};
/**
 * Trick to restart an element's animation
 *
 * @param {HTMLElement} element
 * @return void
 *
 * @see https://www.charistheo.io/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
 */ const $91ca15859685b28b$var$reflow = (element)=>{
    element.offsetHeight; // eslint-disable-line no-unused-expressions
};
const $91ca15859685b28b$var$getjQuery = ()=>{
    if (window.jQuery && !document.body.hasAttribute('data-bs-no-jquery')) return window.jQuery;
    return null;
};
const $91ca15859685b28b$var$DOMContentLoadedCallbacks = [];
const $91ca15859685b28b$var$onDOMContentLoaded = (callback)=>{
    if (document.readyState === 'loading') {
        // add listener on the first call when the document is in loading state
        if (!$91ca15859685b28b$var$DOMContentLoadedCallbacks.length) document.addEventListener('DOMContentLoaded', ()=>{
            for (const callback of $91ca15859685b28b$var$DOMContentLoadedCallbacks)callback();
        });
        $91ca15859685b28b$var$DOMContentLoadedCallbacks.push(callback);
    } else callback();
};
const $91ca15859685b28b$var$isRTL = ()=>document.documentElement.dir === 'rtl';
const $91ca15859685b28b$var$defineJQueryPlugin = (plugin)=>{
    $91ca15859685b28b$var$onDOMContentLoaded(()=>{
        const $ = $91ca15859685b28b$var$getjQuery();
        /* istanbul ignore if */ if ($) {
            const name = plugin.NAME;
            const JQUERY_NO_CONFLICT = $.fn[name];
            $.fn[name] = plugin.jQueryInterface;
            $.fn[name].Constructor = plugin;
            $.fn[name].noConflict = ()=>{
                $.fn[name] = JQUERY_NO_CONFLICT;
                return plugin.jQueryInterface;
            };
        }
    });
};
const $91ca15859685b28b$var$execute = (possibleCallback, args = [], defaultValue = possibleCallback)=>{
    return typeof possibleCallback === 'function' ? possibleCallback(...args) : defaultValue;
};
const $91ca15859685b28b$var$executeAfterTransition = (callback, transitionElement, waitForTransition = true)=>{
    if (!waitForTransition) {
        $91ca15859685b28b$var$execute(callback);
        return;
    }
    const durationPadding = 5;
    const emulatedDuration = $91ca15859685b28b$var$getTransitionDurationFromElement(transitionElement) + durationPadding;
    let called = false;
    const handler = ({ target: target })=>{
        if (target !== transitionElement) return;
        called = true;
        transitionElement.removeEventListener($91ca15859685b28b$var$TRANSITION_END, handler);
        $91ca15859685b28b$var$execute(callback);
    };
    transitionElement.addEventListener($91ca15859685b28b$var$TRANSITION_END, handler);
    setTimeout(()=>{
        if (!called) $91ca15859685b28b$var$triggerTransitionEnd(transitionElement);
    }, emulatedDuration);
};
/**
 * Return the previous/next element of a list.
 *
 * @param {array} list    The list of elements
 * @param activeElement   The active element
 * @param shouldGetNext   Choose to get next or previous element
 * @param isCycleAllowed
 * @return {Element|elem} The proper element
 */ const $91ca15859685b28b$var$getNextActiveElement = (list, activeElement, shouldGetNext, isCycleAllowed)=>{
    const listLength = list.length;
    let index = list.indexOf(activeElement);
    // if the element does not exist in the list return an element
    // depending on the direction and if cycle is allowed
    if (index === -1) return !shouldGetNext && isCycleAllowed ? list[listLength - 1] : list[0];
    index += shouldGetNext ? 1 : -1;
    if (isCycleAllowed) index = (index + listLength) % listLength;
    return list[Math.max(0, Math.min(index, listLength - 1))];
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/event-handler.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$namespaceRegex = /[^.]*(?=\..*)\.|.*/;
const $91ca15859685b28b$var$stripNameRegex = /\..*/;
const $91ca15859685b28b$var$stripUidRegex = /::\d+$/;
const $91ca15859685b28b$var$eventRegistry = {}; // Events storage
let $91ca15859685b28b$var$uidEvent = 1;
const $91ca15859685b28b$var$customEvents = {
    mouseenter: 'mouseover',
    mouseleave: 'mouseout'
};
const $91ca15859685b28b$var$nativeEvents = new Set([
    'click',
    'dblclick',
    'mouseup',
    'mousedown',
    'contextmenu',
    'mousewheel',
    'DOMMouseScroll',
    'mouseover',
    'mouseout',
    'mousemove',
    'selectstart',
    'selectend',
    'keydown',
    'keypress',
    'keyup',
    'orientationchange',
    'touchstart',
    'touchmove',
    'touchend',
    'touchcancel',
    'pointerdown',
    'pointermove',
    'pointerup',
    'pointerleave',
    'pointercancel',
    'gesturestart',
    'gesturechange',
    'gestureend',
    'focus',
    'blur',
    'change',
    'reset',
    'select',
    'submit',
    'focusin',
    'focusout',
    'load',
    'unload',
    'beforeunload',
    'resize',
    'move',
    'DOMContentLoaded',
    'readystatechange',
    'error',
    'abort',
    'scroll'
]);
/**
 * Private methods
 */ function $91ca15859685b28b$var$makeEventUid(element, uid) {
    return uid && `${uid}::${$91ca15859685b28b$var$uidEvent++}` || element.uidEvent || $91ca15859685b28b$var$uidEvent++;
}
function $91ca15859685b28b$var$getElementEvents(element) {
    const uid = $91ca15859685b28b$var$makeEventUid(element);
    element.uidEvent = uid;
    $91ca15859685b28b$var$eventRegistry[uid] = $91ca15859685b28b$var$eventRegistry[uid] || {};
    return $91ca15859685b28b$var$eventRegistry[uid];
}
function $91ca15859685b28b$var$bootstrapHandler(element, fn) {
    return function handler(event) {
        $91ca15859685b28b$var$hydrateObj(event, {
            delegateTarget: element
        });
        if (handler.oneOff) $91ca15859685b28b$var$EventHandler.off(element, event.type, fn);
        return fn.apply(element, [
            event
        ]);
    };
}
function $91ca15859685b28b$var$bootstrapDelegationHandler(element, selector, fn) {
    return function handler(event) {
        const domElements = element.querySelectorAll(selector);
        for(let { target: target } = event; target && target !== this; target = target.parentNode)for (const domElement of domElements){
            if (domElement !== target) continue;
            $91ca15859685b28b$var$hydrateObj(event, {
                delegateTarget: target
            });
            if (handler.oneOff) $91ca15859685b28b$var$EventHandler.off(element, event.type, selector, fn);
            return fn.apply(target, [
                event
            ]);
        }
    };
}
function $91ca15859685b28b$var$findHandler(events, callable, delegationSelector = null) {
    return Object.values(events).find((event)=>event.callable === callable && event.delegationSelector === delegationSelector);
}
function $91ca15859685b28b$var$normalizeParameters(originalTypeEvent, handler, delegationFunction) {
    const isDelegated = typeof handler === 'string';
    // TODO: tooltip passes `false` instead of selector, so we need to check
    const callable = isDelegated ? delegationFunction : handler || delegationFunction;
    let typeEvent = $91ca15859685b28b$var$getTypeEvent(originalTypeEvent);
    if (!$91ca15859685b28b$var$nativeEvents.has(typeEvent)) typeEvent = originalTypeEvent;
    return [
        isDelegated,
        callable,
        typeEvent
    ];
}
function $91ca15859685b28b$var$addHandler(element, originalTypeEvent, handler, delegationFunction, oneOff) {
    if (typeof originalTypeEvent !== 'string' || !element) return;
    let [isDelegated, callable, typeEvent] = $91ca15859685b28b$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
    // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
    // this prevents the handler from being dispatched the same way as mouseover or mouseout does
    if (originalTypeEvent in $91ca15859685b28b$var$customEvents) {
        const wrapFunction = (fn)=>{
            return function(event) {
                if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) return fn.call(this, event);
            };
        };
        callable = wrapFunction(callable);
    }
    const events = $91ca15859685b28b$var$getElementEvents(element);
    const handlers = events[typeEvent] || (events[typeEvent] = {});
    const previousFunction = $91ca15859685b28b$var$findHandler(handlers, callable, isDelegated ? handler : null);
    if (previousFunction) {
        previousFunction.oneOff = previousFunction.oneOff && oneOff;
        return;
    }
    const uid = $91ca15859685b28b$var$makeEventUid(callable, originalTypeEvent.replace($91ca15859685b28b$var$namespaceRegex, ''));
    const fn = isDelegated ? $91ca15859685b28b$var$bootstrapDelegationHandler(element, handler, callable) : $91ca15859685b28b$var$bootstrapHandler(element, callable);
    fn.delegationSelector = isDelegated ? handler : null;
    fn.callable = callable;
    fn.oneOff = oneOff;
    fn.uidEvent = uid;
    handlers[uid] = fn;
    element.addEventListener(typeEvent, fn, isDelegated);
}
function $91ca15859685b28b$var$removeHandler(element, events, typeEvent, handler, delegationSelector) {
    const fn = $91ca15859685b28b$var$findHandler(events[typeEvent], handler, delegationSelector);
    if (!fn) return;
    element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
    delete events[typeEvent][fn.uidEvent];
}
function $91ca15859685b28b$var$removeNamespacedHandlers(element, events, typeEvent, namespace) {
    const storeElementEvent = events[typeEvent] || {};
    for (const [handlerKey, event] of Object.entries(storeElementEvent))if (handlerKey.includes(namespace)) $91ca15859685b28b$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
}
function $91ca15859685b28b$var$getTypeEvent(event) {
    // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
    event = event.replace($91ca15859685b28b$var$stripNameRegex, '');
    return $91ca15859685b28b$var$customEvents[event] || event;
}
const $91ca15859685b28b$var$EventHandler = {
    on (element, event, handler, delegationFunction) {
        $91ca15859685b28b$var$addHandler(element, event, handler, delegationFunction, false);
    },
    one (element, event, handler, delegationFunction) {
        $91ca15859685b28b$var$addHandler(element, event, handler, delegationFunction, true);
    },
    off (element, originalTypeEvent, handler, delegationFunction) {
        if (typeof originalTypeEvent !== 'string' || !element) return;
        const [isDelegated, callable, typeEvent] = $91ca15859685b28b$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
        const inNamespace = typeEvent !== originalTypeEvent;
        const events = $91ca15859685b28b$var$getElementEvents(element);
        const storeElementEvent = events[typeEvent] || {};
        const isNamespace = originalTypeEvent.startsWith('.');
        if (typeof callable !== 'undefined') {
            // Simplest case: handler is passed, remove that listener ONLY.
            if (!Object.keys(storeElementEvent).length) return;
            $91ca15859685b28b$var$removeHandler(element, events, typeEvent, callable, isDelegated ? handler : null);
            return;
        }
        if (isNamespace) for (const elementEvent of Object.keys(events))$91ca15859685b28b$var$removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
        for (const [keyHandlers, event] of Object.entries(storeElementEvent)){
            const handlerKey = keyHandlers.replace($91ca15859685b28b$var$stripUidRegex, '');
            if (!inNamespace || originalTypeEvent.includes(handlerKey)) $91ca15859685b28b$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
        }
    },
    trigger (element, event, args) {
        if (typeof event !== 'string' || !element) return null;
        const $ = $91ca15859685b28b$var$getjQuery();
        const typeEvent = $91ca15859685b28b$var$getTypeEvent(event);
        const inNamespace = event !== typeEvent;
        let jQueryEvent = null;
        let bubbles = true;
        let nativeDispatch = true;
        let defaultPrevented = false;
        if (inNamespace && $) {
            jQueryEvent = $.Event(event, args);
            $(element).trigger(jQueryEvent);
            bubbles = !jQueryEvent.isPropagationStopped();
            nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
            defaultPrevented = jQueryEvent.isDefaultPrevented();
        }
        const evt = $91ca15859685b28b$var$hydrateObj(new Event(event, {
            bubbles: bubbles,
            cancelable: true
        }), args);
        if (defaultPrevented) evt.preventDefault();
        if (nativeDispatch) element.dispatchEvent(evt);
        if (evt.defaultPrevented && jQueryEvent) jQueryEvent.preventDefault();
        return evt;
    }
};
function $91ca15859685b28b$var$hydrateObj(obj, meta = {}) {
    for (const [key, value] of Object.entries(meta))try {
        obj[key] = value;
    } catch (_unused) {
        Object.defineProperty(obj, key, {
            configurable: true,
            get () {
                return value;
            }
        });
    }
    return obj;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/manipulator.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ function $91ca15859685b28b$var$normalizeData(value) {
    if (value === 'true') return true;
    if (value === 'false') return false;
    if (value === Number(value).toString()) return Number(value);
    if (value === '' || value === 'null') return null;
    if (typeof value !== 'string') return value;
    try {
        return JSON.parse(decodeURIComponent(value));
    } catch (_unused) {
        return value;
    }
}
function $91ca15859685b28b$var$normalizeDataKey(key) {
    return key.replace(/[A-Z]/g, (chr)=>`-${chr.toLowerCase()}`);
}
const $91ca15859685b28b$var$Manipulator = {
    setDataAttribute (element, key, value) {
        element.setAttribute(`data-bs-${$91ca15859685b28b$var$normalizeDataKey(key)}`, value);
    },
    removeDataAttribute (element, key) {
        element.removeAttribute(`data-bs-${$91ca15859685b28b$var$normalizeDataKey(key)}`);
    },
    getDataAttributes (element) {
        if (!element) return {};
        const attributes = {};
        const bsKeys = Object.keys(element.dataset).filter((key)=>key.startsWith('bs') && !key.startsWith('bsConfig'));
        for (const key of bsKeys){
            let pureKey = key.replace(/^bs/, '');
            pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1, pureKey.length);
            attributes[pureKey] = $91ca15859685b28b$var$normalizeData(element.dataset[key]);
        }
        return attributes;
    },
    getDataAttribute (element, key) {
        return $91ca15859685b28b$var$normalizeData(element.getAttribute(`data-bs-${$91ca15859685b28b$var$normalizeDataKey(key)}`));
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/config.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Class definition
 */ class $91ca15859685b28b$var$Config {
    // Getters
    static get Default() {
        return {};
    }
    static get DefaultType() {
        return {};
    }
    static get NAME() {
        throw new Error('You have to implement the static method "NAME", for each component!');
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        return config;
    }
    _mergeConfigObj(config, element) {
        const jsonConfig = $91ca15859685b28b$var$isElement(element) ? $91ca15859685b28b$var$Manipulator.getDataAttribute(element, 'config') : {}; // try to parse
        return {
            ...this.constructor.Default,
            ...typeof jsonConfig === 'object' ? jsonConfig : {},
            ...$91ca15859685b28b$var$isElement(element) ? $91ca15859685b28b$var$Manipulator.getDataAttributes(element) : {},
            ...typeof config === 'object' ? config : {}
        };
    }
    _typeCheckConfig(config, configTypes = this.constructor.DefaultType) {
        for (const [property, expectedTypes] of Object.entries(configTypes)){
            const value = config[property];
            const valueType = $91ca15859685b28b$var$isElement(value) ? 'element' : $91ca15859685b28b$var$toType(value);
            if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError(`${this.constructor.NAME.toUpperCase()}: Option "${property}" provided type "${valueType}" but expected type "${expectedTypes}".`);
        }
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap base-component.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$VERSION = '5.3.3';
/**
 * Class definition
 */ class $91ca15859685b28b$var$BaseComponent extends $91ca15859685b28b$var$Config {
    constructor(element, config){
        super();
        element = $91ca15859685b28b$var$getElement(element);
        if (!element) return;
        this._element = element;
        this._config = this._getConfig(config);
        $91ca15859685b28b$var$Data.set(this._element, this.constructor.DATA_KEY, this);
    }
    // Public
    dispose() {
        $91ca15859685b28b$var$Data.remove(this._element, this.constructor.DATA_KEY);
        $91ca15859685b28b$var$EventHandler.off(this._element, this.constructor.EVENT_KEY);
        for (const propertyName of Object.getOwnPropertyNames(this))this[propertyName] = null;
    }
    _queueCallback(callback, element, isAnimated = true) {
        $91ca15859685b28b$var$executeAfterTransition(callback, element, isAnimated);
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config, this._element);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    // Static
    static getInstance(element) {
        return $91ca15859685b28b$var$Data.get($91ca15859685b28b$var$getElement(element), this.DATA_KEY);
    }
    static getOrCreateInstance(element, config = {}) {
        return this.getInstance(element) || new this(element, typeof config === 'object' ? config : null);
    }
    static get VERSION() {
        return $91ca15859685b28b$var$VERSION;
    }
    static get DATA_KEY() {
        return `bs.${this.NAME}`;
    }
    static get EVENT_KEY() {
        return `.${this.DATA_KEY}`;
    }
    static eventName(name) {
        return `${name}${this.EVENT_KEY}`;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/selector-engine.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $91ca15859685b28b$var$getSelector = (element)=>{
    let selector = element.getAttribute('data-bs-target');
    if (!selector || selector === '#') {
        let hrefAttribute = element.getAttribute('href');
        // The only valid content that could double as a selector are IDs or classes,
        // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
        // `document.querySelector` will rightfully complain it is invalid.
        // See https://github.com/twbs/bootstrap/issues/32273
        if (!hrefAttribute || !hrefAttribute.includes('#') && !hrefAttribute.startsWith('.')) return null;
        // Just in case some CMS puts out a full URL with the anchor appended
        if (hrefAttribute.includes('#') && !hrefAttribute.startsWith('#')) hrefAttribute = `#${hrefAttribute.split('#')[1]}`;
        selector = hrefAttribute && hrefAttribute !== '#' ? hrefAttribute.trim() : null;
    }
    return selector ? selector.split(',').map((sel)=>$91ca15859685b28b$var$parseSelector(sel)).join(',') : null;
};
const $91ca15859685b28b$var$SelectorEngine = {
    find (selector, element = document.documentElement) {
        return [].concat(...Element.prototype.querySelectorAll.call(element, selector));
    },
    findOne (selector, element = document.documentElement) {
        return Element.prototype.querySelector.call(element, selector);
    },
    children (element, selector) {
        return [].concat(...element.children).filter((child)=>child.matches(selector));
    },
    parents (element, selector) {
        const parents = [];
        let ancestor = element.parentNode.closest(selector);
        while(ancestor){
            parents.push(ancestor);
            ancestor = ancestor.parentNode.closest(selector);
        }
        return parents;
    },
    prev (element, selector) {
        let previous = element.previousElementSibling;
        while(previous){
            if (previous.matches(selector)) return [
                previous
            ];
            previous = previous.previousElementSibling;
        }
        return [];
    },
    // TODO: this is now unused; remove later along with prev()
    next (element, selector) {
        let next = element.nextElementSibling;
        while(next){
            if (next.matches(selector)) return [
                next
            ];
            next = next.nextElementSibling;
        }
        return [];
    },
    focusableChildren (element) {
        const focusables = [
            'a',
            'button',
            'input',
            'textarea',
            'select',
            'details',
            '[tabindex]',
            '[contenteditable="true"]'
        ].map((selector)=>`${selector}:not([tabindex^="-"])`).join(',');
        return this.find(focusables, element).filter((el)=>!$91ca15859685b28b$var$isDisabled(el) && $91ca15859685b28b$var$isVisible(el));
    },
    getSelectorFromElement (element) {
        const selector = $91ca15859685b28b$var$getSelector(element);
        if (selector) return $91ca15859685b28b$var$SelectorEngine.findOne(selector) ? selector : null;
        return null;
    },
    getElementFromSelector (element) {
        const selector = $91ca15859685b28b$var$getSelector(element);
        return selector ? $91ca15859685b28b$var$SelectorEngine.findOne(selector) : null;
    },
    getMultipleElementsFromSelector (element) {
        const selector = $91ca15859685b28b$var$getSelector(element);
        return selector ? $91ca15859685b28b$var$SelectorEngine.find(selector) : [];
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/component-functions.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $91ca15859685b28b$var$enableDismissTrigger = (component, method = 'hide')=>{
    const clickEvent = `click.dismiss${component.EVENT_KEY}`;
    const name = component.NAME;
    $91ca15859685b28b$var$EventHandler.on(document, clickEvent, `[data-bs-dismiss="${name}"]`, function(event) {
        if ([
            'A',
            'AREA'
        ].includes(this.tagName)) event.preventDefault();
        if ($91ca15859685b28b$var$isDisabled(this)) return;
        const target = $91ca15859685b28b$var$SelectorEngine.getElementFromSelector(this) || this.closest(`.${name}`);
        const instance = component.getOrCreateInstance(target);
        // Method argument is left, for Alert and only, as it doesn't implement the 'hide' method
        instance[method]();
    });
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap alert.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$f = 'alert';
const $91ca15859685b28b$var$DATA_KEY$a = 'bs.alert';
const $91ca15859685b28b$var$EVENT_KEY$b = `.${$91ca15859685b28b$var$DATA_KEY$a}`;
const $91ca15859685b28b$var$EVENT_CLOSE = `close${$91ca15859685b28b$var$EVENT_KEY$b}`;
const $91ca15859685b28b$var$EVENT_CLOSED = `closed${$91ca15859685b28b$var$EVENT_KEY$b}`;
const $91ca15859685b28b$var$CLASS_NAME_FADE$5 = 'fade';
const $91ca15859685b28b$var$CLASS_NAME_SHOW$8 = 'show';
/**
 * Class definition
 */ class $91ca15859685b28b$export$caec2af78bcc877f extends $91ca15859685b28b$var$BaseComponent {
    // Getters
    static get NAME() {
        return $91ca15859685b28b$var$NAME$f;
    }
    // Public
    close() {
        const closeEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_CLOSE);
        if (closeEvent.defaultPrevented) return;
        this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW$8);
        const isAnimated = this._element.classList.contains($91ca15859685b28b$var$CLASS_NAME_FADE$5);
        this._queueCallback(()=>this._destroyElement(), this._element, isAnimated);
    }
    // Private
    _destroyElement() {
        this._element.remove();
        $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_CLOSED);
        this.dispose();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$caec2af78bcc877f.getOrCreateInstance(this);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$enableDismissTrigger($91ca15859685b28b$export$caec2af78bcc877f, 'close');
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$caec2af78bcc877f);
/**
 * --------------------------------------------------------------------------
 * Bootstrap button.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$e = 'button';
const $91ca15859685b28b$var$DATA_KEY$9 = 'bs.button';
const $91ca15859685b28b$var$EVENT_KEY$a = `.${$91ca15859685b28b$var$DATA_KEY$9}`;
const $91ca15859685b28b$var$DATA_API_KEY$6 = '.data-api';
const $91ca15859685b28b$var$CLASS_NAME_ACTIVE$3 = 'active';
const $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$5 = '[data-bs-toggle="button"]';
const $91ca15859685b28b$var$EVENT_CLICK_DATA_API$6 = `click${$91ca15859685b28b$var$EVENT_KEY$a}${$91ca15859685b28b$var$DATA_API_KEY$6}`;
/**
 * Class definition
 */ class $91ca15859685b28b$export$353f5b6fc5456de1 extends $91ca15859685b28b$var$BaseComponent {
    // Getters
    static get NAME() {
        return $91ca15859685b28b$var$NAME$e;
    }
    // Public
    toggle() {
        // Toggle class and sync the `aria-pressed` attribute with the return value of the `.toggle()` method
        this._element.setAttribute('aria-pressed', this._element.classList.toggle($91ca15859685b28b$var$CLASS_NAME_ACTIVE$3));
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$353f5b6fc5456de1.getOrCreateInstance(this);
            if (config === 'toggle') data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_CLICK_DATA_API$6, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$5, (event)=>{
    event.preventDefault();
    const button = event.target.closest($91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$5);
    const data = $91ca15859685b28b$export$353f5b6fc5456de1.getOrCreateInstance(button);
    data.toggle();
});
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$353f5b6fc5456de1);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/swipe.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$d = 'swipe';
const $91ca15859685b28b$var$EVENT_KEY$9 = '.bs.swipe';
const $91ca15859685b28b$var$EVENT_TOUCHSTART = `touchstart${$91ca15859685b28b$var$EVENT_KEY$9}`;
const $91ca15859685b28b$var$EVENT_TOUCHMOVE = `touchmove${$91ca15859685b28b$var$EVENT_KEY$9}`;
const $91ca15859685b28b$var$EVENT_TOUCHEND = `touchend${$91ca15859685b28b$var$EVENT_KEY$9}`;
const $91ca15859685b28b$var$EVENT_POINTERDOWN = `pointerdown${$91ca15859685b28b$var$EVENT_KEY$9}`;
const $91ca15859685b28b$var$EVENT_POINTERUP = `pointerup${$91ca15859685b28b$var$EVENT_KEY$9}`;
const $91ca15859685b28b$var$POINTER_TYPE_TOUCH = 'touch';
const $91ca15859685b28b$var$POINTER_TYPE_PEN = 'pen';
const $91ca15859685b28b$var$CLASS_NAME_POINTER_EVENT = 'pointer-event';
const $91ca15859685b28b$var$SWIPE_THRESHOLD = 40;
const $91ca15859685b28b$var$Default$c = {
    endCallback: null,
    leftCallback: null,
    rightCallback: null
};
const $91ca15859685b28b$var$DefaultType$c = {
    endCallback: '(function|null)',
    leftCallback: '(function|null)',
    rightCallback: '(function|null)'
};
/**
 * Class definition
 */ class $91ca15859685b28b$var$Swipe extends $91ca15859685b28b$var$Config {
    constructor(element, config){
        super();
        this._element = element;
        if (!element || !$91ca15859685b28b$var$Swipe.isSupported()) return;
        this._config = this._getConfig(config);
        this._deltaX = 0;
        this._supportPointerEvents = Boolean(window.PointerEvent);
        this._initEvents();
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$c;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$c;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$d;
    }
    // Public
    dispose() {
        $91ca15859685b28b$var$EventHandler.off(this._element, $91ca15859685b28b$var$EVENT_KEY$9);
    }
    // Private
    _start(event) {
        if (!this._supportPointerEvents) {
            this._deltaX = event.touches[0].clientX;
            return;
        }
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX;
    }
    _end(event) {
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX - this._deltaX;
        this._handleSwipe();
        $91ca15859685b28b$var$execute(this._config.endCallback);
    }
    _move(event) {
        this._deltaX = event.touches && event.touches.length > 1 ? 0 : event.touches[0].clientX - this._deltaX;
    }
    _handleSwipe() {
        const absDeltaX = Math.abs(this._deltaX);
        if (absDeltaX <= $91ca15859685b28b$var$SWIPE_THRESHOLD) return;
        const direction = absDeltaX / this._deltaX;
        this._deltaX = 0;
        if (!direction) return;
        $91ca15859685b28b$var$execute(direction > 0 ? this._config.rightCallback : this._config.leftCallback);
    }
    _initEvents() {
        if (this._supportPointerEvents) {
            $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_POINTERDOWN, (event)=>this._start(event));
            $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_POINTERUP, (event)=>this._end(event));
            this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_POINTER_EVENT);
        } else {
            $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_TOUCHSTART, (event)=>this._start(event));
            $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_TOUCHMOVE, (event)=>this._move(event));
            $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_TOUCHEND, (event)=>this._end(event));
        }
    }
    _eventIsPointerPenTouch(event) {
        return this._supportPointerEvents && (event.pointerType === $91ca15859685b28b$var$POINTER_TYPE_PEN || event.pointerType === $91ca15859685b28b$var$POINTER_TYPE_TOUCH);
    }
    // Static
    static isSupported() {
        return 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap carousel.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$c = 'carousel';
const $91ca15859685b28b$var$DATA_KEY$8 = 'bs.carousel';
const $91ca15859685b28b$var$EVENT_KEY$8 = `.${$91ca15859685b28b$var$DATA_KEY$8}`;
const $91ca15859685b28b$var$DATA_API_KEY$5 = '.data-api';
const $91ca15859685b28b$var$ARROW_LEFT_KEY$1 = 'ArrowLeft';
const $91ca15859685b28b$var$ARROW_RIGHT_KEY$1 = 'ArrowRight';
const $91ca15859685b28b$var$TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch
const $91ca15859685b28b$var$ORDER_NEXT = 'next';
const $91ca15859685b28b$var$ORDER_PREV = 'prev';
const $91ca15859685b28b$var$DIRECTION_LEFT = 'left';
const $91ca15859685b28b$var$DIRECTION_RIGHT = 'right';
const $91ca15859685b28b$var$EVENT_SLIDE = `slide${$91ca15859685b28b$var$EVENT_KEY$8}`;
const $91ca15859685b28b$var$EVENT_SLID = `slid${$91ca15859685b28b$var$EVENT_KEY$8}`;
const $91ca15859685b28b$var$EVENT_KEYDOWN$1 = `keydown${$91ca15859685b28b$var$EVENT_KEY$8}`;
const $91ca15859685b28b$var$EVENT_MOUSEENTER$1 = `mouseenter${$91ca15859685b28b$var$EVENT_KEY$8}`;
const $91ca15859685b28b$var$EVENT_MOUSELEAVE$1 = `mouseleave${$91ca15859685b28b$var$EVENT_KEY$8}`;
const $91ca15859685b28b$var$EVENT_DRAG_START = `dragstart${$91ca15859685b28b$var$EVENT_KEY$8}`;
const $91ca15859685b28b$var$EVENT_LOAD_DATA_API$3 = `load${$91ca15859685b28b$var$EVENT_KEY$8}${$91ca15859685b28b$var$DATA_API_KEY$5}`;
const $91ca15859685b28b$var$EVENT_CLICK_DATA_API$5 = `click${$91ca15859685b28b$var$EVENT_KEY$8}${$91ca15859685b28b$var$DATA_API_KEY$5}`;
const $91ca15859685b28b$var$CLASS_NAME_CAROUSEL = 'carousel';
const $91ca15859685b28b$var$CLASS_NAME_ACTIVE$2 = 'active';
const $91ca15859685b28b$var$CLASS_NAME_SLIDE = 'slide';
const $91ca15859685b28b$var$CLASS_NAME_END = 'carousel-item-end';
const $91ca15859685b28b$var$CLASS_NAME_START = 'carousel-item-start';
const $91ca15859685b28b$var$CLASS_NAME_NEXT = 'carousel-item-next';
const $91ca15859685b28b$var$CLASS_NAME_PREV = 'carousel-item-prev';
const $91ca15859685b28b$var$SELECTOR_ACTIVE = '.active';
const $91ca15859685b28b$var$SELECTOR_ITEM = '.carousel-item';
const $91ca15859685b28b$var$SELECTOR_ACTIVE_ITEM = $91ca15859685b28b$var$SELECTOR_ACTIVE + $91ca15859685b28b$var$SELECTOR_ITEM;
const $91ca15859685b28b$var$SELECTOR_ITEM_IMG = '.carousel-item img';
const $91ca15859685b28b$var$SELECTOR_INDICATORS = '.carousel-indicators';
const $91ca15859685b28b$var$SELECTOR_DATA_SLIDE = '[data-bs-slide], [data-bs-slide-to]';
const $91ca15859685b28b$var$SELECTOR_DATA_RIDE = '[data-bs-ride="carousel"]';
const $91ca15859685b28b$var$KEY_TO_DIRECTION = {
    [$91ca15859685b28b$var$ARROW_LEFT_KEY$1]: $91ca15859685b28b$var$DIRECTION_RIGHT,
    [$91ca15859685b28b$var$ARROW_RIGHT_KEY$1]: $91ca15859685b28b$var$DIRECTION_LEFT
};
const $91ca15859685b28b$var$Default$b = {
    interval: 5000,
    keyboard: true,
    pause: 'hover',
    ride: false,
    touch: true,
    wrap: true
};
const $91ca15859685b28b$var$DefaultType$b = {
    interval: '(number|boolean)',
    // TODO:v6 remove boolean support
    keyboard: 'boolean',
    pause: '(string|boolean)',
    ride: '(boolean|string)',
    touch: 'boolean',
    wrap: 'boolean'
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$144901db2ea8e967 extends $91ca15859685b28b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._interval = null;
        this._activeElement = null;
        this._isSliding = false;
        this.touchTimeout = null;
        this._swipeHelper = null;
        this._indicatorsElement = $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_INDICATORS, this._element);
        this._addEventListeners();
        if (this._config.ride === $91ca15859685b28b$var$CLASS_NAME_CAROUSEL) this.cycle();
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$b;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$b;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$c;
    }
    // Public
    next() {
        this._slide($91ca15859685b28b$var$ORDER_NEXT);
    }
    nextWhenVisible() {
        // FIXME TODO use `document.visibilityState`
        // Don't call next when the page isn't visible
        // or the carousel or its parent isn't visible
        if (!document.hidden && $91ca15859685b28b$var$isVisible(this._element)) this.next();
    }
    prev() {
        this._slide($91ca15859685b28b$var$ORDER_PREV);
    }
    pause() {
        if (this._isSliding) $91ca15859685b28b$var$triggerTransitionEnd(this._element);
        this._clearInterval();
    }
    cycle() {
        this._clearInterval();
        this._updateInterval();
        this._interval = setInterval(()=>this.nextWhenVisible(), this._config.interval);
    }
    _maybeEnableCycle() {
        if (!this._config.ride) return;
        if (this._isSliding) {
            $91ca15859685b28b$var$EventHandler.one(this._element, $91ca15859685b28b$var$EVENT_SLID, ()=>this.cycle());
            return;
        }
        this.cycle();
    }
    to(index) {
        const items = this._getItems();
        if (index > items.length - 1 || index < 0) return;
        if (this._isSliding) {
            $91ca15859685b28b$var$EventHandler.one(this._element, $91ca15859685b28b$var$EVENT_SLID, ()=>this.to(index));
            return;
        }
        const activeIndex = this._getItemIndex(this._getActive());
        if (activeIndex === index) return;
        const order = index > activeIndex ? $91ca15859685b28b$var$ORDER_NEXT : $91ca15859685b28b$var$ORDER_PREV;
        this._slide(order, items[index]);
    }
    dispose() {
        if (this._swipeHelper) this._swipeHelper.dispose();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        config.defaultInterval = config.interval;
        return config;
    }
    _addEventListeners() {
        if (this._config.keyboard) $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_KEYDOWN$1, (event)=>this._keydown(event));
        if (this._config.pause === 'hover') {
            $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_MOUSEENTER$1, ()=>this.pause());
            $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_MOUSELEAVE$1, ()=>this._maybeEnableCycle());
        }
        if (this._config.touch && $91ca15859685b28b$var$Swipe.isSupported()) this._addTouchEventListeners();
    }
    _addTouchEventListeners() {
        for (const img of $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_ITEM_IMG, this._element))$91ca15859685b28b$var$EventHandler.on(img, $91ca15859685b28b$var$EVENT_DRAG_START, (event)=>event.preventDefault());
        const endCallBack = ()=>{
            if (this._config.pause !== 'hover') return;
            // If it's a touch-enabled device, mouseenter/leave are fired as
            // part of the mouse compatibility events on first tap - the carousel
            // would stop cycling until user tapped out of it;
            // here, we listen for touchend, explicitly pause the carousel
            // (as if it's the second time we tap on it, mouseenter compat event
            // is NOT fired) and after a timeout (to allow for mouse compatibility
            // events to fire) we explicitly restart cycling
            this.pause();
            if (this.touchTimeout) clearTimeout(this.touchTimeout);
            this.touchTimeout = setTimeout(()=>this._maybeEnableCycle(), $91ca15859685b28b$var$TOUCHEVENT_COMPAT_WAIT + this._config.interval);
        };
        const swipeConfig = {
            leftCallback: ()=>this._slide(this._directionToOrder($91ca15859685b28b$var$DIRECTION_LEFT)),
            rightCallback: ()=>this._slide(this._directionToOrder($91ca15859685b28b$var$DIRECTION_RIGHT)),
            endCallback: endCallBack
        };
        this._swipeHelper = new $91ca15859685b28b$var$Swipe(this._element, swipeConfig);
    }
    _keydown(event) {
        if (/input|textarea/i.test(event.target.tagName)) return;
        const direction = $91ca15859685b28b$var$KEY_TO_DIRECTION[event.key];
        if (direction) {
            event.preventDefault();
            this._slide(this._directionToOrder(direction));
        }
    }
    _getItemIndex(element) {
        return this._getItems().indexOf(element);
    }
    _setActiveIndicatorElement(index) {
        if (!this._indicatorsElement) return;
        const activeIndicator = $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_ACTIVE, this._indicatorsElement);
        activeIndicator.classList.remove($91ca15859685b28b$var$CLASS_NAME_ACTIVE$2);
        activeIndicator.removeAttribute('aria-current');
        const newActiveIndicator = $91ca15859685b28b$var$SelectorEngine.findOne(`[data-bs-slide-to="${index}"]`, this._indicatorsElement);
        if (newActiveIndicator) {
            newActiveIndicator.classList.add($91ca15859685b28b$var$CLASS_NAME_ACTIVE$2);
            newActiveIndicator.setAttribute('aria-current', 'true');
        }
    }
    _updateInterval() {
        const element = this._activeElement || this._getActive();
        if (!element) return;
        const elementInterval = Number.parseInt(element.getAttribute('data-bs-interval'), 10);
        this._config.interval = elementInterval || this._config.defaultInterval;
    }
    _slide(order, element = null) {
        if (this._isSliding) return;
        const activeElement = this._getActive();
        const isNext = order === $91ca15859685b28b$var$ORDER_NEXT;
        const nextElement = element || $91ca15859685b28b$var$getNextActiveElement(this._getItems(), activeElement, isNext, this._config.wrap);
        if (nextElement === activeElement) return;
        const nextElementIndex = this._getItemIndex(nextElement);
        const triggerEvent = (eventName)=>{
            return $91ca15859685b28b$var$EventHandler.trigger(this._element, eventName, {
                relatedTarget: nextElement,
                direction: this._orderToDirection(order),
                from: this._getItemIndex(activeElement),
                to: nextElementIndex
            });
        };
        const slideEvent = triggerEvent($91ca15859685b28b$var$EVENT_SLIDE);
        if (slideEvent.defaultPrevented) return;
        if (!activeElement || !nextElement) // Some weirdness is happening, so we bail
        // TODO: change tests that use empty divs to avoid this check
        return;
        const isCycling = Boolean(this._interval);
        this.pause();
        this._isSliding = true;
        this._setActiveIndicatorElement(nextElementIndex);
        this._activeElement = nextElement;
        const directionalClassName = isNext ? $91ca15859685b28b$var$CLASS_NAME_START : $91ca15859685b28b$var$CLASS_NAME_END;
        const orderClassName = isNext ? $91ca15859685b28b$var$CLASS_NAME_NEXT : $91ca15859685b28b$var$CLASS_NAME_PREV;
        nextElement.classList.add(orderClassName);
        $91ca15859685b28b$var$reflow(nextElement);
        activeElement.classList.add(directionalClassName);
        nextElement.classList.add(directionalClassName);
        const completeCallBack = ()=>{
            nextElement.classList.remove(directionalClassName, orderClassName);
            nextElement.classList.add($91ca15859685b28b$var$CLASS_NAME_ACTIVE$2);
            activeElement.classList.remove($91ca15859685b28b$var$CLASS_NAME_ACTIVE$2, orderClassName, directionalClassName);
            this._isSliding = false;
            triggerEvent($91ca15859685b28b$var$EVENT_SLID);
        };
        this._queueCallback(completeCallBack, activeElement, this._isAnimated());
        if (isCycling) this.cycle();
    }
    _isAnimated() {
        return this._element.classList.contains($91ca15859685b28b$var$CLASS_NAME_SLIDE);
    }
    _getActive() {
        return $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_ACTIVE_ITEM, this._element);
    }
    _getItems() {
        return $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_ITEM, this._element);
    }
    _clearInterval() {
        if (this._interval) {
            clearInterval(this._interval);
            this._interval = null;
        }
    }
    _directionToOrder(direction) {
        if ($91ca15859685b28b$var$isRTL()) return direction === $91ca15859685b28b$var$DIRECTION_LEFT ? $91ca15859685b28b$var$ORDER_PREV : $91ca15859685b28b$var$ORDER_NEXT;
        return direction === $91ca15859685b28b$var$DIRECTION_LEFT ? $91ca15859685b28b$var$ORDER_NEXT : $91ca15859685b28b$var$ORDER_PREV;
    }
    _orderToDirection(order) {
        if ($91ca15859685b28b$var$isRTL()) return order === $91ca15859685b28b$var$ORDER_PREV ? $91ca15859685b28b$var$DIRECTION_LEFT : $91ca15859685b28b$var$DIRECTION_RIGHT;
        return order === $91ca15859685b28b$var$ORDER_PREV ? $91ca15859685b28b$var$DIRECTION_RIGHT : $91ca15859685b28b$var$DIRECTION_LEFT;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$144901db2ea8e967.getOrCreateInstance(this, config);
            if (typeof config === 'number') {
                data.to(config);
                return;
            }
            if (typeof config === 'string') {
                if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_CLICK_DATA_API$5, $91ca15859685b28b$var$SELECTOR_DATA_SLIDE, function(event) {
    const target = $91ca15859685b28b$var$SelectorEngine.getElementFromSelector(this);
    if (!target || !target.classList.contains($91ca15859685b28b$var$CLASS_NAME_CAROUSEL)) return;
    event.preventDefault();
    const carousel = $91ca15859685b28b$export$144901db2ea8e967.getOrCreateInstance(target);
    const slideIndex = this.getAttribute('data-bs-slide-to');
    if (slideIndex) {
        carousel.to(slideIndex);
        carousel._maybeEnableCycle();
        return;
    }
    if ($91ca15859685b28b$var$Manipulator.getDataAttribute(this, 'slide') === 'next') {
        carousel.next();
        carousel._maybeEnableCycle();
        return;
    }
    carousel.prev();
    carousel._maybeEnableCycle();
});
$91ca15859685b28b$var$EventHandler.on(window, $91ca15859685b28b$var$EVENT_LOAD_DATA_API$3, ()=>{
    const carousels = $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_DATA_RIDE);
    for (const carousel of carousels)$91ca15859685b28b$export$144901db2ea8e967.getOrCreateInstance(carousel);
});
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$144901db2ea8e967);
/**
 * --------------------------------------------------------------------------
 * Bootstrap collapse.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$b = 'collapse';
const $91ca15859685b28b$var$DATA_KEY$7 = 'bs.collapse';
const $91ca15859685b28b$var$EVENT_KEY$7 = `.${$91ca15859685b28b$var$DATA_KEY$7}`;
const $91ca15859685b28b$var$DATA_API_KEY$4 = '.data-api';
const $91ca15859685b28b$var$EVENT_SHOW$6 = `show${$91ca15859685b28b$var$EVENT_KEY$7}`;
const $91ca15859685b28b$var$EVENT_SHOWN$6 = `shown${$91ca15859685b28b$var$EVENT_KEY$7}`;
const $91ca15859685b28b$var$EVENT_HIDE$6 = `hide${$91ca15859685b28b$var$EVENT_KEY$7}`;
const $91ca15859685b28b$var$EVENT_HIDDEN$6 = `hidden${$91ca15859685b28b$var$EVENT_KEY$7}`;
const $91ca15859685b28b$var$EVENT_CLICK_DATA_API$4 = `click${$91ca15859685b28b$var$EVENT_KEY$7}${$91ca15859685b28b$var$DATA_API_KEY$4}`;
const $91ca15859685b28b$var$CLASS_NAME_SHOW$7 = 'show';
const $91ca15859685b28b$var$CLASS_NAME_COLLAPSE = 'collapse';
const $91ca15859685b28b$var$CLASS_NAME_COLLAPSING = 'collapsing';
const $91ca15859685b28b$var$CLASS_NAME_COLLAPSED = 'collapsed';
const $91ca15859685b28b$var$CLASS_NAME_DEEPER_CHILDREN = `:scope .${$91ca15859685b28b$var$CLASS_NAME_COLLAPSE} .${$91ca15859685b28b$var$CLASS_NAME_COLLAPSE}`;
const $91ca15859685b28b$var$CLASS_NAME_HORIZONTAL = 'collapse-horizontal';
const $91ca15859685b28b$var$WIDTH = 'width';
const $91ca15859685b28b$var$HEIGHT = 'height';
const $91ca15859685b28b$var$SELECTOR_ACTIVES = '.collapse.show, .collapse.collapsing';
const $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$4 = '[data-bs-toggle="collapse"]';
const $91ca15859685b28b$var$Default$a = {
    parent: null,
    toggle: true
};
const $91ca15859685b28b$var$DefaultType$a = {
    parent: '(null|element)',
    toggle: 'boolean'
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$78768a9af065a7b extends $91ca15859685b28b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isTransitioning = false;
        this._triggerArray = [];
        const toggleList = $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$4);
        for (const elem of toggleList){
            const selector = $91ca15859685b28b$var$SelectorEngine.getSelectorFromElement(elem);
            const filterElement = $91ca15859685b28b$var$SelectorEngine.find(selector).filter((foundElement)=>foundElement === this._element);
            if (selector !== null && filterElement.length) this._triggerArray.push(elem);
        }
        this._initializeChildren();
        if (!this._config.parent) this._addAriaAndCollapsedClass(this._triggerArray, this._isShown());
        if (this._config.toggle) this.toggle();
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$a;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$a;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$b;
    }
    // Public
    toggle() {
        if (this._isShown()) this.hide();
        else this.show();
    }
    show() {
        if (this._isTransitioning || this._isShown()) return;
        let activeChildren = [];
        // find active children
        if (this._config.parent) activeChildren = this._getFirstLevelChildren($91ca15859685b28b$var$SELECTOR_ACTIVES).filter((element)=>element !== this._element).map((element)=>$91ca15859685b28b$export$78768a9af065a7b.getOrCreateInstance(element, {
                toggle: false
            }));
        if (activeChildren.length && activeChildren[0]._isTransitioning) return;
        const startEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOW$6);
        if (startEvent.defaultPrevented) return;
        for (const activeInstance of activeChildren)activeInstance.hide();
        const dimension = this._getDimension();
        this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_COLLAPSE);
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_COLLAPSING);
        this._element.style[dimension] = 0;
        this._addAriaAndCollapsedClass(this._triggerArray, true);
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_COLLAPSE, $91ca15859685b28b$var$CLASS_NAME_SHOW$7);
            this._element.style[dimension] = '';
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOWN$6);
        };
        const capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
        const scrollSize = `scroll${capitalizedDimension}`;
        this._queueCallback(complete, this._element, true);
        this._element.style[dimension] = `${this._element[scrollSize]}px`;
    }
    hide() {
        if (this._isTransitioning || !this._isShown()) return;
        const startEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDE$6);
        if (startEvent.defaultPrevented) return;
        const dimension = this._getDimension();
        this._element.style[dimension] = `${this._element.getBoundingClientRect()[dimension]}px`;
        $91ca15859685b28b$var$reflow(this._element);
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_COLLAPSING);
        this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_COLLAPSE, $91ca15859685b28b$var$CLASS_NAME_SHOW$7);
        for (const trigger of this._triggerArray){
            const element = $91ca15859685b28b$var$SelectorEngine.getElementFromSelector(trigger);
            if (element && !this._isShown(element)) this._addAriaAndCollapsedClass([
                trigger
            ], false);
        }
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_COLLAPSE);
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDDEN$6);
        };
        this._element.style[dimension] = '';
        this._queueCallback(complete, this._element, true);
    }
    _isShown(element = this._element) {
        return element.classList.contains($91ca15859685b28b$var$CLASS_NAME_SHOW$7);
    }
    // Private
    _configAfterMerge(config) {
        config.toggle = Boolean(config.toggle); // Coerce string values
        config.parent = $91ca15859685b28b$var$getElement(config.parent);
        return config;
    }
    _getDimension() {
        return this._element.classList.contains($91ca15859685b28b$var$CLASS_NAME_HORIZONTAL) ? $91ca15859685b28b$var$WIDTH : $91ca15859685b28b$var$HEIGHT;
    }
    _initializeChildren() {
        if (!this._config.parent) return;
        const children = this._getFirstLevelChildren($91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$4);
        for (const element of children){
            const selected = $91ca15859685b28b$var$SelectorEngine.getElementFromSelector(element);
            if (selected) this._addAriaAndCollapsedClass([
                element
            ], this._isShown(selected));
        }
    }
    _getFirstLevelChildren(selector) {
        const children = $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$CLASS_NAME_DEEPER_CHILDREN, this._config.parent);
        // remove children if greater depth
        return $91ca15859685b28b$var$SelectorEngine.find(selector, this._config.parent).filter((element)=>!children.includes(element));
    }
    _addAriaAndCollapsedClass(triggerArray, isOpen) {
        if (!triggerArray.length) return;
        for (const element of triggerArray){
            element.classList.toggle($91ca15859685b28b$var$CLASS_NAME_COLLAPSED, !isOpen);
            element.setAttribute('aria-expanded', isOpen);
        }
    }
    // Static
    static jQueryInterface(config) {
        const _config = {};
        if (typeof config === 'string' && /show|hide/.test(config)) _config.toggle = false;
        return this.each(function() {
            const data = $91ca15859685b28b$export$78768a9af065a7b.getOrCreateInstance(this, _config);
            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_CLICK_DATA_API$4, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$4, function(event) {
    // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
    if (event.target.tagName === 'A' || event.delegateTarget && event.delegateTarget.tagName === 'A') event.preventDefault();
    for (const element of $91ca15859685b28b$var$SelectorEngine.getMultipleElementsFromSelector(this))$91ca15859685b28b$export$78768a9af065a7b.getOrCreateInstance(element, {
        toggle: false
    }).toggle();
});
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$78768a9af065a7b);
/**
 * --------------------------------------------------------------------------
 * Bootstrap dropdown.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$a = 'dropdown';
const $91ca15859685b28b$var$DATA_KEY$6 = 'bs.dropdown';
const $91ca15859685b28b$var$EVENT_KEY$6 = `.${$91ca15859685b28b$var$DATA_KEY$6}`;
const $91ca15859685b28b$var$DATA_API_KEY$3 = '.data-api';
const $91ca15859685b28b$var$ESCAPE_KEY$2 = 'Escape';
const $91ca15859685b28b$var$TAB_KEY$1 = 'Tab';
const $91ca15859685b28b$var$ARROW_UP_KEY$1 = 'ArrowUp';
const $91ca15859685b28b$var$ARROW_DOWN_KEY$1 = 'ArrowDown';
const $91ca15859685b28b$var$RIGHT_MOUSE_BUTTON = 2; // MouseEvent.button value for the secondary button, usually the right button
const $91ca15859685b28b$var$EVENT_HIDE$5 = `hide${$91ca15859685b28b$var$EVENT_KEY$6}`;
const $91ca15859685b28b$var$EVENT_HIDDEN$5 = `hidden${$91ca15859685b28b$var$EVENT_KEY$6}`;
const $91ca15859685b28b$var$EVENT_SHOW$5 = `show${$91ca15859685b28b$var$EVENT_KEY$6}`;
const $91ca15859685b28b$var$EVENT_SHOWN$5 = `shown${$91ca15859685b28b$var$EVENT_KEY$6}`;
const $91ca15859685b28b$var$EVENT_CLICK_DATA_API$3 = `click${$91ca15859685b28b$var$EVENT_KEY$6}${$91ca15859685b28b$var$DATA_API_KEY$3}`;
const $91ca15859685b28b$var$EVENT_KEYDOWN_DATA_API = `keydown${$91ca15859685b28b$var$EVENT_KEY$6}${$91ca15859685b28b$var$DATA_API_KEY$3}`;
const $91ca15859685b28b$var$EVENT_KEYUP_DATA_API = `keyup${$91ca15859685b28b$var$EVENT_KEY$6}${$91ca15859685b28b$var$DATA_API_KEY$3}`;
const $91ca15859685b28b$var$CLASS_NAME_SHOW$6 = 'show';
const $91ca15859685b28b$var$CLASS_NAME_DROPUP = 'dropup';
const $91ca15859685b28b$var$CLASS_NAME_DROPEND = 'dropend';
const $91ca15859685b28b$var$CLASS_NAME_DROPSTART = 'dropstart';
const $91ca15859685b28b$var$CLASS_NAME_DROPUP_CENTER = 'dropup-center';
const $91ca15859685b28b$var$CLASS_NAME_DROPDOWN_CENTER = 'dropdown-center';
const $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$3 = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)';
const $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE_SHOWN = `${$91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$3}.${$91ca15859685b28b$var$CLASS_NAME_SHOW$6}`;
const $91ca15859685b28b$var$SELECTOR_MENU = '.dropdown-menu';
const $91ca15859685b28b$var$SELECTOR_NAVBAR = '.navbar';
const $91ca15859685b28b$var$SELECTOR_NAVBAR_NAV = '.navbar-nav';
const $91ca15859685b28b$var$SELECTOR_VISIBLE_ITEMS = '.dropdown-menu .dropdown-item:not(.disabled):not(:disabled)';
const $91ca15859685b28b$var$PLACEMENT_TOP = $91ca15859685b28b$var$isRTL() ? 'top-end' : 'top-start';
const $91ca15859685b28b$var$PLACEMENT_TOPEND = $91ca15859685b28b$var$isRTL() ? 'top-start' : 'top-end';
const $91ca15859685b28b$var$PLACEMENT_BOTTOM = $91ca15859685b28b$var$isRTL() ? 'bottom-end' : 'bottom-start';
const $91ca15859685b28b$var$PLACEMENT_BOTTOMEND = $91ca15859685b28b$var$isRTL() ? 'bottom-start' : 'bottom-end';
const $91ca15859685b28b$var$PLACEMENT_RIGHT = $91ca15859685b28b$var$isRTL() ? 'left-start' : 'right-start';
const $91ca15859685b28b$var$PLACEMENT_LEFT = $91ca15859685b28b$var$isRTL() ? 'right-start' : 'left-start';
const $91ca15859685b28b$var$PLACEMENT_TOPCENTER = 'top';
const $91ca15859685b28b$var$PLACEMENT_BOTTOMCENTER = 'bottom';
const $91ca15859685b28b$var$Default$9 = {
    autoClose: true,
    boundary: 'clippingParents',
    display: 'dynamic',
    offset: [
        0,
        2
    ],
    popperConfig: null,
    reference: 'toggle'
};
const $91ca15859685b28b$var$DefaultType$9 = {
    autoClose: '(boolean|string)',
    boundary: '(string|element)',
    display: 'string',
    offset: '(array|string|function)',
    popperConfig: '(null|object|function)',
    reference: '(string|element|object)'
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$931cbfb6bfb85fc extends $91ca15859685b28b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._popper = null;
        this._parent = this._element.parentNode; // dropdown wrapper
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        this._menu = $91ca15859685b28b$var$SelectorEngine.next(this._element, $91ca15859685b28b$var$SELECTOR_MENU)[0] || $91ca15859685b28b$var$SelectorEngine.prev(this._element, $91ca15859685b28b$var$SELECTOR_MENU)[0] || $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_MENU, this._parent);
        this._inNavbar = this._detectNavbar();
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$9;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$9;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$a;
    }
    // Public
    toggle() {
        return this._isShown() ? this.hide() : this.show();
    }
    show() {
        if ($91ca15859685b28b$var$isDisabled(this._element) || this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        const showEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOW$5, relatedTarget);
        if (showEvent.defaultPrevented) return;
        this._createPopper();
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ('ontouchstart' in document.documentElement && !this._parent.closest($91ca15859685b28b$var$SELECTOR_NAVBAR_NAV)) for (const element of [].concat(...document.body.children))$91ca15859685b28b$var$EventHandler.on(element, 'mouseover', $91ca15859685b28b$var$noop);
        this._element.focus();
        this._element.setAttribute('aria-expanded', true);
        this._menu.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOW$6);
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOW$6);
        $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOWN$5, relatedTarget);
    }
    hide() {
        if ($91ca15859685b28b$var$isDisabled(this._element) || !this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        this._completeHide(relatedTarget);
    }
    dispose() {
        if (this._popper) this._popper.destroy();
        super.dispose();
    }
    update() {
        this._inNavbar = this._detectNavbar();
        if (this._popper) this._popper.update();
    }
    // Private
    _completeHide(relatedTarget) {
        const hideEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDE$5, relatedTarget);
        if (hideEvent.defaultPrevented) return;
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))$91ca15859685b28b$var$EventHandler.off(element, 'mouseover', $91ca15859685b28b$var$noop);
        if (this._popper) this._popper.destroy();
        this._menu.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW$6);
        this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW$6);
        this._element.setAttribute('aria-expanded', 'false');
        $91ca15859685b28b$var$Manipulator.removeDataAttribute(this._menu, 'popper');
        $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDDEN$5, relatedTarget);
    }
    _getConfig(config) {
        config = super._getConfig(config);
        if (typeof config.reference === 'object' && !$91ca15859685b28b$var$isElement(config.reference) && typeof config.reference.getBoundingClientRect !== 'function') // Popper virtual elements require a getBoundingClientRect method
        throw new TypeError(`${$91ca15859685b28b$var$NAME$a.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);
        return config;
    }
    _createPopper() {
        if (typeof $d37552697cc5ea39$exports === 'undefined') throw new TypeError('Bootstrap\'s dropdowns require Popper (https://popper.js.org)');
        let referenceElement = this._element;
        if (this._config.reference === 'parent') referenceElement = this._parent;
        else if ($91ca15859685b28b$var$isElement(this._config.reference)) referenceElement = $91ca15859685b28b$var$getElement(this._config.reference);
        else if (typeof this._config.reference === 'object') referenceElement = this._config.reference;
        const popperConfig = this._getPopperConfig();
        this._popper = $d37552697cc5ea39$exports.createPopper(referenceElement, this._menu, popperConfig);
    }
    _isShown() {
        return this._menu.classList.contains($91ca15859685b28b$var$CLASS_NAME_SHOW$6);
    }
    _getPlacement() {
        const parentDropdown = this._parent;
        if (parentDropdown.classList.contains($91ca15859685b28b$var$CLASS_NAME_DROPEND)) return $91ca15859685b28b$var$PLACEMENT_RIGHT;
        if (parentDropdown.classList.contains($91ca15859685b28b$var$CLASS_NAME_DROPSTART)) return $91ca15859685b28b$var$PLACEMENT_LEFT;
        if (parentDropdown.classList.contains($91ca15859685b28b$var$CLASS_NAME_DROPUP_CENTER)) return $91ca15859685b28b$var$PLACEMENT_TOPCENTER;
        if (parentDropdown.classList.contains($91ca15859685b28b$var$CLASS_NAME_DROPDOWN_CENTER)) return $91ca15859685b28b$var$PLACEMENT_BOTTOMCENTER;
        // We need to trim the value because custom properties can also include spaces
        const isEnd = getComputedStyle(this._menu).getPropertyValue('--bs-position').trim() === 'end';
        if (parentDropdown.classList.contains($91ca15859685b28b$var$CLASS_NAME_DROPUP)) return isEnd ? $91ca15859685b28b$var$PLACEMENT_TOPEND : $91ca15859685b28b$var$PLACEMENT_TOP;
        return isEnd ? $91ca15859685b28b$var$PLACEMENT_BOTTOMEND : $91ca15859685b28b$var$PLACEMENT_BOTTOM;
    }
    _detectNavbar() {
        return this._element.closest($91ca15859685b28b$var$SELECTOR_NAVBAR) !== null;
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === 'string') return offset.split(',').map((value)=>Number.parseInt(value, 10));
        if (typeof offset === 'function') return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _getPopperConfig() {
        const defaultBsPopperConfig = {
            placement: this._getPlacement(),
            modifiers: [
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: 'offset',
                    options: {
                        offset: this._getOffset()
                    }
                }
            ]
        };
        // Disable Popper if we have a static display or Dropdown is in Navbar
        if (this._inNavbar || this._config.display === 'static') {
            $91ca15859685b28b$var$Manipulator.setDataAttribute(this._menu, 'popper', 'static'); // TODO: v6 remove
            defaultBsPopperConfig.modifiers = [
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ];
        }
        return {
            ...defaultBsPopperConfig,
            ...$91ca15859685b28b$var$execute(this._config.popperConfig, [
                defaultBsPopperConfig
            ])
        };
    }
    _selectMenuItem({ key: key, target: target }) {
        const items = $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_VISIBLE_ITEMS, this._menu).filter((element)=>$91ca15859685b28b$var$isVisible(element));
        if (!items.length) return;
        // if target isn't included in items (e.g. when expanding the dropdown)
        // allow cycling to get the last item in case key equals ARROW_UP_KEY
        $91ca15859685b28b$var$getNextActiveElement(items, target, key === $91ca15859685b28b$var$ARROW_DOWN_KEY$1, !items.includes(target)).focus();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$931cbfb6bfb85fc.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
    static clearMenus(event) {
        if (event.button === $91ca15859685b28b$var$RIGHT_MOUSE_BUTTON || event.type === 'keyup' && event.key !== $91ca15859685b28b$var$TAB_KEY$1) return;
        const openToggles = $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_DATA_TOGGLE_SHOWN);
        for (const toggle of openToggles){
            const context = $91ca15859685b28b$export$931cbfb6bfb85fc.getInstance(toggle);
            if (!context || context._config.autoClose === false) continue;
            const composedPath = event.composedPath();
            const isMenuTarget = composedPath.includes(context._menu);
            if (composedPath.includes(context._element) || context._config.autoClose === 'inside' && !isMenuTarget || context._config.autoClose === 'outside' && isMenuTarget) continue;
            // Tab navigation through the dropdown menu or events from contained inputs shouldn't close the menu
            if (context._menu.contains(event.target) && (event.type === 'keyup' && event.key === $91ca15859685b28b$var$TAB_KEY$1 || /input|select|option|textarea|form/i.test(event.target.tagName))) continue;
            const relatedTarget = {
                relatedTarget: context._element
            };
            if (event.type === 'click') relatedTarget.clickEvent = event;
            context._completeHide(relatedTarget);
        }
    }
    static dataApiKeydownHandler(event) {
        // If not an UP | DOWN | ESCAPE key => not a dropdown command
        // If input/textarea && if key is other than ESCAPE => not a dropdown command
        const isInput = /input|textarea/i.test(event.target.tagName);
        const isEscapeEvent = event.key === $91ca15859685b28b$var$ESCAPE_KEY$2;
        const isUpOrDownEvent = [
            $91ca15859685b28b$var$ARROW_UP_KEY$1,
            $91ca15859685b28b$var$ARROW_DOWN_KEY$1
        ].includes(event.key);
        if (!isUpOrDownEvent && !isEscapeEvent) return;
        if (isInput && !isEscapeEvent) return;
        event.preventDefault();
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        const getToggleButton = this.matches($91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$3) ? this : $91ca15859685b28b$var$SelectorEngine.prev(this, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$3)[0] || $91ca15859685b28b$var$SelectorEngine.next(this, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$3)[0] || $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$3, event.delegateTarget.parentNode);
        const instance = $91ca15859685b28b$export$931cbfb6bfb85fc.getOrCreateInstance(getToggleButton);
        if (isUpOrDownEvent) {
            event.stopPropagation();
            instance.show();
            instance._selectMenuItem(event);
            return;
        }
        if (instance._isShown()) {
            // else is escape and we check if it is shown
            event.stopPropagation();
            instance.hide();
            getToggleButton.focus();
        }
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_KEYDOWN_DATA_API, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$3, $91ca15859685b28b$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_KEYDOWN_DATA_API, $91ca15859685b28b$var$SELECTOR_MENU, $91ca15859685b28b$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_CLICK_DATA_API$3, $91ca15859685b28b$export$931cbfb6bfb85fc.clearMenus);
$91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_KEYUP_DATA_API, $91ca15859685b28b$export$931cbfb6bfb85fc.clearMenus);
$91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_CLICK_DATA_API$3, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$3, function(event) {
    event.preventDefault();
    $91ca15859685b28b$export$931cbfb6bfb85fc.getOrCreateInstance(this).toggle();
});
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$931cbfb6bfb85fc);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/backdrop.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$9 = 'backdrop';
const $91ca15859685b28b$var$CLASS_NAME_FADE$4 = 'fade';
const $91ca15859685b28b$var$CLASS_NAME_SHOW$5 = 'show';
const $91ca15859685b28b$var$EVENT_MOUSEDOWN = `mousedown.bs.${$91ca15859685b28b$var$NAME$9}`;
const $91ca15859685b28b$var$Default$8 = {
    className: 'modal-backdrop',
    clickCallback: null,
    isAnimated: false,
    isVisible: true,
    // if false, we use the backdrop helper without adding any element to the dom
    rootElement: 'body' // give the choice to place backdrop under different elements
};
const $91ca15859685b28b$var$DefaultType$8 = {
    className: 'string',
    clickCallback: '(function|null)',
    isAnimated: 'boolean',
    isVisible: 'boolean',
    rootElement: '(element|string)'
};
/**
 * Class definition
 */ class $91ca15859685b28b$var$Backdrop extends $91ca15859685b28b$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isAppended = false;
        this._element = null;
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$8;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$8;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$9;
    }
    // Public
    show(callback) {
        if (!this._config.isVisible) {
            $91ca15859685b28b$var$execute(callback);
            return;
        }
        this._append();
        const element = this._getElement();
        if (this._config.isAnimated) $91ca15859685b28b$var$reflow(element);
        element.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            $91ca15859685b28b$var$execute(callback);
        });
    }
    hide(callback) {
        if (!this._config.isVisible) {
            $91ca15859685b28b$var$execute(callback);
            return;
        }
        this._getElement().classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            this.dispose();
            $91ca15859685b28b$var$execute(callback);
        });
    }
    dispose() {
        if (!this._isAppended) return;
        $91ca15859685b28b$var$EventHandler.off(this._element, $91ca15859685b28b$var$EVENT_MOUSEDOWN);
        this._element.remove();
        this._isAppended = false;
    }
    // Private
    _getElement() {
        if (!this._element) {
            const backdrop = document.createElement('div');
            backdrop.className = this._config.className;
            if (this._config.isAnimated) backdrop.classList.add($91ca15859685b28b$var$CLASS_NAME_FADE$4);
            this._element = backdrop;
        }
        return this._element;
    }
    _configAfterMerge(config) {
        // use getElement() with the default "body" to get a fresh Element on each instantiation
        config.rootElement = $91ca15859685b28b$var$getElement(config.rootElement);
        return config;
    }
    _append() {
        if (this._isAppended) return;
        const element = this._getElement();
        this._config.rootElement.append(element);
        $91ca15859685b28b$var$EventHandler.on(element, $91ca15859685b28b$var$EVENT_MOUSEDOWN, ()=>{
            $91ca15859685b28b$var$execute(this._config.clickCallback);
        });
        this._isAppended = true;
    }
    _emulateAnimation(callback) {
        $91ca15859685b28b$var$executeAfterTransition(callback, this._getElement(), this._config.isAnimated);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/focustrap.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$8 = 'focustrap';
const $91ca15859685b28b$var$DATA_KEY$5 = 'bs.focustrap';
const $91ca15859685b28b$var$EVENT_KEY$5 = `.${$91ca15859685b28b$var$DATA_KEY$5}`;
const $91ca15859685b28b$var$EVENT_FOCUSIN$2 = `focusin${$91ca15859685b28b$var$EVENT_KEY$5}`;
const $91ca15859685b28b$var$EVENT_KEYDOWN_TAB = `keydown.tab${$91ca15859685b28b$var$EVENT_KEY$5}`;
const $91ca15859685b28b$var$TAB_KEY = 'Tab';
const $91ca15859685b28b$var$TAB_NAV_FORWARD = 'forward';
const $91ca15859685b28b$var$TAB_NAV_BACKWARD = 'backward';
const $91ca15859685b28b$var$Default$7 = {
    autofocus: true,
    trapElement: null // The element to trap focus inside of
};
const $91ca15859685b28b$var$DefaultType$7 = {
    autofocus: 'boolean',
    trapElement: 'element'
};
/**
 * Class definition
 */ class $91ca15859685b28b$var$FocusTrap extends $91ca15859685b28b$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isActive = false;
        this._lastTabNavDirection = null;
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$7;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$7;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$8;
    }
    // Public
    activate() {
        if (this._isActive) return;
        if (this._config.autofocus) this._config.trapElement.focus();
        $91ca15859685b28b$var$EventHandler.off(document, $91ca15859685b28b$var$EVENT_KEY$5); // guard against infinite focus loop
        $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_FOCUSIN$2, (event)=>this._handleFocusin(event));
        $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_KEYDOWN_TAB, (event)=>this._handleKeydown(event));
        this._isActive = true;
    }
    deactivate() {
        if (!this._isActive) return;
        this._isActive = false;
        $91ca15859685b28b$var$EventHandler.off(document, $91ca15859685b28b$var$EVENT_KEY$5);
    }
    // Private
    _handleFocusin(event) {
        const { trapElement: trapElement } = this._config;
        if (event.target === document || event.target === trapElement || trapElement.contains(event.target)) return;
        const elements = $91ca15859685b28b$var$SelectorEngine.focusableChildren(trapElement);
        if (elements.length === 0) trapElement.focus();
        else if (this._lastTabNavDirection === $91ca15859685b28b$var$TAB_NAV_BACKWARD) elements[elements.length - 1].focus();
        else elements[0].focus();
    }
    _handleKeydown(event) {
        if (event.key !== $91ca15859685b28b$var$TAB_KEY) return;
        this._lastTabNavDirection = event.shiftKey ? $91ca15859685b28b$var$TAB_NAV_BACKWARD : $91ca15859685b28b$var$TAB_NAV_FORWARD;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/scrollBar.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$SELECTOR_FIXED_CONTENT = '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top';
const $91ca15859685b28b$var$SELECTOR_STICKY_CONTENT = '.sticky-top';
const $91ca15859685b28b$var$PROPERTY_PADDING = 'padding-right';
const $91ca15859685b28b$var$PROPERTY_MARGIN = 'margin-right';
/**
 * Class definition
 */ class $91ca15859685b28b$var$ScrollBarHelper {
    constructor(){
        this._element = document.body;
    }
    // Public
    getWidth() {
        // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
        const documentWidth = document.documentElement.clientWidth;
        return Math.abs(window.innerWidth - documentWidth);
    }
    hide() {
        const width = this.getWidth();
        this._disableOverFlow();
        // give padding to element to balance the hidden scrollbar width
        this._setElementAttributes(this._element, $91ca15859685b28b$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        // trick: We adjust positive paddingRight and negative marginRight to sticky-top elements to keep showing fullwidth
        this._setElementAttributes($91ca15859685b28b$var$SELECTOR_FIXED_CONTENT, $91ca15859685b28b$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        this._setElementAttributes($91ca15859685b28b$var$SELECTOR_STICKY_CONTENT, $91ca15859685b28b$var$PROPERTY_MARGIN, (calculatedValue)=>calculatedValue - width);
    }
    reset() {
        this._resetElementAttributes(this._element, 'overflow');
        this._resetElementAttributes(this._element, $91ca15859685b28b$var$PROPERTY_PADDING);
        this._resetElementAttributes($91ca15859685b28b$var$SELECTOR_FIXED_CONTENT, $91ca15859685b28b$var$PROPERTY_PADDING);
        this._resetElementAttributes($91ca15859685b28b$var$SELECTOR_STICKY_CONTENT, $91ca15859685b28b$var$PROPERTY_MARGIN);
    }
    isOverflowing() {
        return this.getWidth() > 0;
    }
    // Private
    _disableOverFlow() {
        this._saveInitialAttribute(this._element, 'overflow');
        this._element.style.overflow = 'hidden';
    }
    _setElementAttributes(selector, styleProperty, callback) {
        const scrollbarWidth = this.getWidth();
        const manipulationCallBack = (element)=>{
            if (element !== this._element && window.innerWidth > element.clientWidth + scrollbarWidth) return;
            this._saveInitialAttribute(element, styleProperty);
            const calculatedValue = window.getComputedStyle(element).getPropertyValue(styleProperty);
            element.style.setProperty(styleProperty, `${callback(Number.parseFloat(calculatedValue))}px`);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _saveInitialAttribute(element, styleProperty) {
        const actualValue = element.style.getPropertyValue(styleProperty);
        if (actualValue) $91ca15859685b28b$var$Manipulator.setDataAttribute(element, styleProperty, actualValue);
    }
    _resetElementAttributes(selector, styleProperty) {
        const manipulationCallBack = (element)=>{
            const value = $91ca15859685b28b$var$Manipulator.getDataAttribute(element, styleProperty);
            // We only want to remove the property if the value is `null`; the value can also be zero
            if (value === null) {
                element.style.removeProperty(styleProperty);
                return;
            }
            $91ca15859685b28b$var$Manipulator.removeDataAttribute(element, styleProperty);
            element.style.setProperty(styleProperty, value);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _applyManipulationCallback(selector, callBack) {
        if ($91ca15859685b28b$var$isElement(selector)) {
            callBack(selector);
            return;
        }
        for (const sel of $91ca15859685b28b$var$SelectorEngine.find(selector, this._element))callBack(sel);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap modal.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$7 = 'modal';
const $91ca15859685b28b$var$DATA_KEY$4 = 'bs.modal';
const $91ca15859685b28b$var$EVENT_KEY$4 = `.${$91ca15859685b28b$var$DATA_KEY$4}`;
const $91ca15859685b28b$var$DATA_API_KEY$2 = '.data-api';
const $91ca15859685b28b$var$ESCAPE_KEY$1 = 'Escape';
const $91ca15859685b28b$var$EVENT_HIDE$4 = `hide${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_HIDE_PREVENTED$1 = `hidePrevented${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_HIDDEN$4 = `hidden${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_SHOW$4 = `show${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_SHOWN$4 = `shown${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_RESIZE$1 = `resize${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_CLICK_DISMISS = `click.dismiss${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_MOUSEDOWN_DISMISS = `mousedown.dismiss${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_KEYDOWN_DISMISS$1 = `keydown.dismiss${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_CLICK_DATA_API$2 = `click${$91ca15859685b28b$var$EVENT_KEY$4}${$91ca15859685b28b$var$DATA_API_KEY$2}`;
const $91ca15859685b28b$var$CLASS_NAME_OPEN = 'modal-open';
const $91ca15859685b28b$var$CLASS_NAME_FADE$3 = 'fade';
const $91ca15859685b28b$var$CLASS_NAME_SHOW$4 = 'show';
const $91ca15859685b28b$var$CLASS_NAME_STATIC = 'modal-static';
const $91ca15859685b28b$var$OPEN_SELECTOR$1 = '.modal.show';
const $91ca15859685b28b$var$SELECTOR_DIALOG = '.modal-dialog';
const $91ca15859685b28b$var$SELECTOR_MODAL_BODY = '.modal-body';
const $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$2 = '[data-bs-toggle="modal"]';
const $91ca15859685b28b$var$Default$6 = {
    backdrop: true,
    focus: true,
    keyboard: true
};
const $91ca15859685b28b$var$DefaultType$6 = {
    backdrop: '(boolean|string)',
    focus: 'boolean',
    keyboard: 'boolean'
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$2b77a92f1a5ad772 extends $91ca15859685b28b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._dialog = $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_DIALOG, this._element);
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._isShown = false;
        this._isTransitioning = false;
        this._scrollBar = new $91ca15859685b28b$var$ScrollBarHelper();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$6;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$6;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$7;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown || this._isTransitioning) return;
        const showEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOW$4, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._isTransitioning = true;
        this._scrollBar.hide();
        document.body.classList.add($91ca15859685b28b$var$CLASS_NAME_OPEN);
        this._adjustDialog();
        this._backdrop.show(()=>this._showElement(relatedTarget));
    }
    hide() {
        if (!this._isShown || this._isTransitioning) return;
        const hideEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDE$4);
        if (hideEvent.defaultPrevented) return;
        this._isShown = false;
        this._isTransitioning = true;
        this._focustrap.deactivate();
        this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW$4);
        this._queueCallback(()=>this._hideModal(), this._element, this._isAnimated());
    }
    dispose() {
        $91ca15859685b28b$var$EventHandler.off(window, $91ca15859685b28b$var$EVENT_KEY$4);
        $91ca15859685b28b$var$EventHandler.off(this._dialog, $91ca15859685b28b$var$EVENT_KEY$4);
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    handleUpdate() {
        this._adjustDialog();
    }
    // Private
    _initializeBackDrop() {
        return new $91ca15859685b28b$var$Backdrop({
            isVisible: Boolean(this._config.backdrop),
            // 'static' option will be translated to true, and booleans will keep their value,
            isAnimated: this._isAnimated()
        });
    }
    _initializeFocusTrap() {
        return new $91ca15859685b28b$var$FocusTrap({
            trapElement: this._element
        });
    }
    _showElement(relatedTarget) {
        // try to append dynamic modal
        if (!document.body.contains(this._element)) document.body.append(this._element);
        this._element.style.display = 'block';
        this._element.removeAttribute('aria-hidden');
        this._element.setAttribute('aria-modal', true);
        this._element.setAttribute('role', 'dialog');
        this._element.scrollTop = 0;
        const modalBody = $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_MODAL_BODY, this._dialog);
        if (modalBody) modalBody.scrollTop = 0;
        $91ca15859685b28b$var$reflow(this._element);
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOW$4);
        const transitionComplete = ()=>{
            if (this._config.focus) this._focustrap.activate();
            this._isTransitioning = false;
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOWN$4, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(transitionComplete, this._dialog, this._isAnimated());
    }
    _addEventListeners() {
        $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_KEYDOWN_DISMISS$1, (event)=>{
            if (event.key !== $91ca15859685b28b$var$ESCAPE_KEY$1) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            this._triggerBackdropTransition();
        });
        $91ca15859685b28b$var$EventHandler.on(window, $91ca15859685b28b$var$EVENT_RESIZE$1, ()=>{
            if (this._isShown && !this._isTransitioning) this._adjustDialog();
        });
        $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_MOUSEDOWN_DISMISS, (event)=>{
            // a bad trick to segregate clicks that may start inside dialog but end outside, and avoid listen to scrollbar clicks
            $91ca15859685b28b$var$EventHandler.one(this._element, $91ca15859685b28b$var$EVENT_CLICK_DISMISS, (event2)=>{
                if (this._element !== event.target || this._element !== event2.target) return;
                if (this._config.backdrop === 'static') {
                    this._triggerBackdropTransition();
                    return;
                }
                if (this._config.backdrop) this.hide();
            });
        });
    }
    _hideModal() {
        this._element.style.display = 'none';
        this._element.setAttribute('aria-hidden', true);
        this._element.removeAttribute('aria-modal');
        this._element.removeAttribute('role');
        this._isTransitioning = false;
        this._backdrop.hide(()=>{
            document.body.classList.remove($91ca15859685b28b$var$CLASS_NAME_OPEN);
            this._resetAdjustments();
            this._scrollBar.reset();
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDDEN$4);
        });
    }
    _isAnimated() {
        return this._element.classList.contains($91ca15859685b28b$var$CLASS_NAME_FADE$3);
    }
    _triggerBackdropTransition() {
        const hideEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDE_PREVENTED$1);
        if (hideEvent.defaultPrevented) return;
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const initialOverflowY = this._element.style.overflowY;
        // return if the following background transition hasn't yet completed
        if (initialOverflowY === 'hidden' || this._element.classList.contains($91ca15859685b28b$var$CLASS_NAME_STATIC)) return;
        if (!isModalOverflowing) this._element.style.overflowY = 'hidden';
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_STATIC);
        this._queueCallback(()=>{
            this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_STATIC);
            this._queueCallback(()=>{
                this._element.style.overflowY = initialOverflowY;
            }, this._dialog);
        }, this._dialog);
        this._element.focus();
    }
    /**
   * The following methods are used to handle overflowing modals
   */ _adjustDialog() {
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const scrollbarWidth = this._scrollBar.getWidth();
        const isBodyOverflowing = scrollbarWidth > 0;
        if (isBodyOverflowing && !isModalOverflowing) {
            const property = $91ca15859685b28b$var$isRTL() ? 'paddingLeft' : 'paddingRight';
            this._element.style[property] = `${scrollbarWidth}px`;
        }
        if (!isBodyOverflowing && isModalOverflowing) {
            const property = $91ca15859685b28b$var$isRTL() ? 'paddingRight' : 'paddingLeft';
            this._element.style[property] = `${scrollbarWidth}px`;
        }
    }
    _resetAdjustments() {
        this._element.style.paddingLeft = '';
        this._element.style.paddingRight = '';
    }
    // Static
    static jQueryInterface(config, relatedTarget) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$2b77a92f1a5ad772.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config](relatedTarget);
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_CLICK_DATA_API$2, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$2, function(event) {
    const target = $91ca15859685b28b$var$SelectorEngine.getElementFromSelector(this);
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    $91ca15859685b28b$var$EventHandler.one(target, $91ca15859685b28b$var$EVENT_SHOW$4, (showEvent)=>{
        if (showEvent.defaultPrevented) // only register focus restorer if modal will actually get shown
        return;
        $91ca15859685b28b$var$EventHandler.one(target, $91ca15859685b28b$var$EVENT_HIDDEN$4, ()=>{
            if ($91ca15859685b28b$var$isVisible(this)) this.focus();
        });
    });
    // avoid conflict when clicking modal toggler while another one is open
    const alreadyOpen = $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$OPEN_SELECTOR$1);
    if (alreadyOpen) $91ca15859685b28b$export$2b77a92f1a5ad772.getInstance(alreadyOpen).hide();
    const data = $91ca15859685b28b$export$2b77a92f1a5ad772.getOrCreateInstance(target);
    data.toggle(this);
});
$91ca15859685b28b$var$enableDismissTrigger($91ca15859685b28b$export$2b77a92f1a5ad772);
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$2b77a92f1a5ad772);
/**
 * --------------------------------------------------------------------------
 * Bootstrap offcanvas.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$6 = 'offcanvas';
const $91ca15859685b28b$var$DATA_KEY$3 = 'bs.offcanvas';
const $91ca15859685b28b$var$EVENT_KEY$3 = `.${$91ca15859685b28b$var$DATA_KEY$3}`;
const $91ca15859685b28b$var$DATA_API_KEY$1 = '.data-api';
const $91ca15859685b28b$var$EVENT_LOAD_DATA_API$2 = `load${$91ca15859685b28b$var$EVENT_KEY$3}${$91ca15859685b28b$var$DATA_API_KEY$1}`;
const $91ca15859685b28b$var$ESCAPE_KEY = 'Escape';
const $91ca15859685b28b$var$CLASS_NAME_SHOW$3 = 'show';
const $91ca15859685b28b$var$CLASS_NAME_SHOWING$1 = 'showing';
const $91ca15859685b28b$var$CLASS_NAME_HIDING = 'hiding';
const $91ca15859685b28b$var$CLASS_NAME_BACKDROP = 'offcanvas-backdrop';
const $91ca15859685b28b$var$OPEN_SELECTOR = '.offcanvas.show';
const $91ca15859685b28b$var$EVENT_SHOW$3 = `show${$91ca15859685b28b$var$EVENT_KEY$3}`;
const $91ca15859685b28b$var$EVENT_SHOWN$3 = `shown${$91ca15859685b28b$var$EVENT_KEY$3}`;
const $91ca15859685b28b$var$EVENT_HIDE$3 = `hide${$91ca15859685b28b$var$EVENT_KEY$3}`;
const $91ca15859685b28b$var$EVENT_HIDE_PREVENTED = `hidePrevented${$91ca15859685b28b$var$EVENT_KEY$3}`;
const $91ca15859685b28b$var$EVENT_HIDDEN$3 = `hidden${$91ca15859685b28b$var$EVENT_KEY$3}`;
const $91ca15859685b28b$var$EVENT_RESIZE = `resize${$91ca15859685b28b$var$EVENT_KEY$3}`;
const $91ca15859685b28b$var$EVENT_CLICK_DATA_API$1 = `click${$91ca15859685b28b$var$EVENT_KEY$3}${$91ca15859685b28b$var$DATA_API_KEY$1}`;
const $91ca15859685b28b$var$EVENT_KEYDOWN_DISMISS = `keydown.dismiss${$91ca15859685b28b$var$EVENT_KEY$3}`;
const $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$1 = '[data-bs-toggle="offcanvas"]';
const $91ca15859685b28b$var$Default$5 = {
    backdrop: true,
    keyboard: true,
    scroll: false
};
const $91ca15859685b28b$var$DefaultType$5 = {
    backdrop: '(boolean|string)',
    keyboard: 'boolean',
    scroll: 'boolean'
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$591ca0244c9dfcd4 extends $91ca15859685b28b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isShown = false;
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$5;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$5;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$6;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown) return;
        const showEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOW$3, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._backdrop.show();
        if (!this._config.scroll) new $91ca15859685b28b$var$ScrollBarHelper().hide();
        this._element.setAttribute('aria-modal', true);
        this._element.setAttribute('role', 'dialog');
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOWING$1);
        const completeCallBack = ()=>{
            if (!this._config.scroll || this._config.backdrop) this._focustrap.activate();
            this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOW$3);
            this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOWING$1);
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOWN$3, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(completeCallBack, this._element, true);
    }
    hide() {
        if (!this._isShown) return;
        const hideEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDE$3);
        if (hideEvent.defaultPrevented) return;
        this._focustrap.deactivate();
        this._element.blur();
        this._isShown = false;
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_HIDING);
        this._backdrop.hide();
        const completeCallback = ()=>{
            this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW$3, $91ca15859685b28b$var$CLASS_NAME_HIDING);
            this._element.removeAttribute('aria-modal');
            this._element.removeAttribute('role');
            if (!this._config.scroll) new $91ca15859685b28b$var$ScrollBarHelper().reset();
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDDEN$3);
        };
        this._queueCallback(completeCallback, this._element, true);
    }
    dispose() {
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    // Private
    _initializeBackDrop() {
        const clickCallback = ()=>{
            if (this._config.backdrop === 'static') {
                $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDE_PREVENTED);
                return;
            }
            this.hide();
        };
        // 'static' option will be translated to true, and booleans will keep their value
        const isVisible = Boolean(this._config.backdrop);
        return new $91ca15859685b28b$var$Backdrop({
            className: $91ca15859685b28b$var$CLASS_NAME_BACKDROP,
            isVisible: isVisible,
            isAnimated: true,
            rootElement: this._element.parentNode,
            clickCallback: isVisible ? clickCallback : null
        });
    }
    _initializeFocusTrap() {
        return new $91ca15859685b28b$var$FocusTrap({
            trapElement: this._element
        });
    }
    _addEventListeners() {
        $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_KEYDOWN_DISMISS, (event)=>{
            if (event.key !== $91ca15859685b28b$var$ESCAPE_KEY) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDE_PREVENTED);
        });
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$591ca0244c9dfcd4.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_CLICK_DATA_API$1, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$1, function(event) {
    const target = $91ca15859685b28b$var$SelectorEngine.getElementFromSelector(this);
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    if ($91ca15859685b28b$var$isDisabled(this)) return;
    $91ca15859685b28b$var$EventHandler.one(target, $91ca15859685b28b$var$EVENT_HIDDEN$3, ()=>{
        // focus on trigger when it is closed
        if ($91ca15859685b28b$var$isVisible(this)) this.focus();
    });
    // avoid conflict when clicking a toggler of an offcanvas, while another is open
    const alreadyOpen = $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$OPEN_SELECTOR);
    if (alreadyOpen && alreadyOpen !== target) $91ca15859685b28b$export$591ca0244c9dfcd4.getInstance(alreadyOpen).hide();
    const data = $91ca15859685b28b$export$591ca0244c9dfcd4.getOrCreateInstance(target);
    data.toggle(this);
});
$91ca15859685b28b$var$EventHandler.on(window, $91ca15859685b28b$var$EVENT_LOAD_DATA_API$2, ()=>{
    for (const selector of $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$OPEN_SELECTOR))$91ca15859685b28b$export$591ca0244c9dfcd4.getOrCreateInstance(selector).show();
});
$91ca15859685b28b$var$EventHandler.on(window, $91ca15859685b28b$var$EVENT_RESIZE, ()=>{
    for (const element of $91ca15859685b28b$var$SelectorEngine.find('[aria-modal][class*=show][class*=offcanvas-]'))if (getComputedStyle(element).position !== 'fixed') $91ca15859685b28b$export$591ca0244c9dfcd4.getOrCreateInstance(element).hide();
});
$91ca15859685b28b$var$enableDismissTrigger($91ca15859685b28b$export$591ca0244c9dfcd4);
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$591ca0244c9dfcd4);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/sanitizer.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ // js-docs-start allow-list
const $91ca15859685b28b$var$ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
const $91ca15859685b28b$var$DefaultAllowlist = {
    // Global attributes allowed on any supplied element below.
    '*': [
        'class',
        'dir',
        'id',
        'lang',
        'role',
        $91ca15859685b28b$var$ARIA_ATTRIBUTE_PATTERN
    ],
    a: [
        'target',
        'href',
        'title',
        'rel'
    ],
    area: [],
    b: [],
    br: [],
    col: [],
    code: [],
    dd: [],
    div: [],
    dl: [],
    dt: [],
    em: [],
    hr: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    img: [
        'src',
        'srcset',
        'alt',
        'title',
        'width',
        'height'
    ],
    li: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    u: [],
    ul: []
};
// js-docs-end allow-list
const $91ca15859685b28b$var$uriAttributes = new Set([
    'background',
    'cite',
    'href',
    'itemtype',
    'longdesc',
    'poster',
    'src',
    'xlink:href'
]);
/**
 * A pattern that recognizes URLs that are safe wrt. XSS in URL navigation
 * contexts.
 *
 * Shout-out to Angular https://github.com/angular/angular/blob/15.2.8/packages/core/src/sanitization/url_sanitizer.ts#L38
 */ // eslint-disable-next-line unicorn/better-regex
const $91ca15859685b28b$var$SAFE_URL_PATTERN = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i;
const $91ca15859685b28b$var$allowedAttribute = (attribute, allowedAttributeList)=>{
    const attributeName = attribute.nodeName.toLowerCase();
    if (allowedAttributeList.includes(attributeName)) {
        if ($91ca15859685b28b$var$uriAttributes.has(attributeName)) return Boolean($91ca15859685b28b$var$SAFE_URL_PATTERN.test(attribute.nodeValue));
        return true;
    }
    // Check if a regular expression validates the attribute.
    return allowedAttributeList.filter((attributeRegex)=>attributeRegex instanceof RegExp).some((regex)=>regex.test(attributeName));
};
function $91ca15859685b28b$var$sanitizeHtml(unsafeHtml, allowList, sanitizeFunction) {
    if (!unsafeHtml.length) return unsafeHtml;
    if (sanitizeFunction && typeof sanitizeFunction === 'function') return sanitizeFunction(unsafeHtml);
    const domParser = new window.DOMParser();
    const createdDocument = domParser.parseFromString(unsafeHtml, 'text/html');
    const elements = [].concat(...createdDocument.body.querySelectorAll('*'));
    for (const element of elements){
        const elementName = element.nodeName.toLowerCase();
        if (!Object.keys(allowList).includes(elementName)) {
            element.remove();
            continue;
        }
        const attributeList = [].concat(...element.attributes);
        const allowedAttributes = [].concat(allowList['*'] || [], allowList[elementName] || []);
        for (const attribute of attributeList)if (!$91ca15859685b28b$var$allowedAttribute(attribute, allowedAttributes)) element.removeAttribute(attribute.nodeName);
    }
    return createdDocument.body.innerHTML;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/template-factory.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$5 = 'TemplateFactory';
const $91ca15859685b28b$var$Default$4 = {
    allowList: $91ca15859685b28b$var$DefaultAllowlist,
    content: {},
    // { selector : text ,  selector2 : text2 , }
    extraClass: '',
    html: false,
    sanitize: true,
    sanitizeFn: null,
    template: '<div></div>'
};
const $91ca15859685b28b$var$DefaultType$4 = {
    allowList: 'object',
    content: 'object',
    extraClass: '(string|function)',
    html: 'boolean',
    sanitize: 'boolean',
    sanitizeFn: '(null|function)',
    template: 'string'
};
const $91ca15859685b28b$var$DefaultContentType = {
    entry: '(string|element|function|null)',
    selector: '(string|element)'
};
/**
 * Class definition
 */ class $91ca15859685b28b$var$TemplateFactory extends $91ca15859685b28b$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$4;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$4;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$5;
    }
    // Public
    getContent() {
        return Object.values(this._config.content).map((config)=>this._resolvePossibleFunction(config)).filter(Boolean);
    }
    hasContent() {
        return this.getContent().length > 0;
    }
    changeContent(content) {
        this._checkContent(content);
        this._config.content = {
            ...this._config.content,
            ...content
        };
        return this;
    }
    toHtml() {
        const templateWrapper = document.createElement('div');
        templateWrapper.innerHTML = this._maybeSanitize(this._config.template);
        for (const [selector, text] of Object.entries(this._config.content))this._setContent(templateWrapper, text, selector);
        const template = templateWrapper.children[0];
        const extraClass = this._resolvePossibleFunction(this._config.extraClass);
        if (extraClass) template.classList.add(...extraClass.split(' '));
        return template;
    }
    // Private
    _typeCheckConfig(config) {
        super._typeCheckConfig(config);
        this._checkContent(config.content);
    }
    _checkContent(arg) {
        for (const [selector, content] of Object.entries(arg))super._typeCheckConfig({
            selector: selector,
            entry: content
        }, $91ca15859685b28b$var$DefaultContentType);
    }
    _setContent(template, content, selector) {
        const templateElement = $91ca15859685b28b$var$SelectorEngine.findOne(selector, template);
        if (!templateElement) return;
        content = this._resolvePossibleFunction(content);
        if (!content) {
            templateElement.remove();
            return;
        }
        if ($91ca15859685b28b$var$isElement(content)) {
            this._putElementInTemplate($91ca15859685b28b$var$getElement(content), templateElement);
            return;
        }
        if (this._config.html) {
            templateElement.innerHTML = this._maybeSanitize(content);
            return;
        }
        templateElement.textContent = content;
    }
    _maybeSanitize(arg) {
        return this._config.sanitize ? $91ca15859685b28b$var$sanitizeHtml(arg, this._config.allowList, this._config.sanitizeFn) : arg;
    }
    _resolvePossibleFunction(arg) {
        return $91ca15859685b28b$var$execute(arg, [
            this
        ]);
    }
    _putElementInTemplate(element, templateElement) {
        if (this._config.html) {
            templateElement.innerHTML = '';
            templateElement.append(element);
            return;
        }
        templateElement.textContent = element.textContent;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap tooltip.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$4 = 'tooltip';
const $91ca15859685b28b$var$DISALLOWED_ATTRIBUTES = new Set([
    'sanitize',
    'allowList',
    'sanitizeFn'
]);
const $91ca15859685b28b$var$CLASS_NAME_FADE$2 = 'fade';
const $91ca15859685b28b$var$CLASS_NAME_MODAL = 'modal';
const $91ca15859685b28b$var$CLASS_NAME_SHOW$2 = 'show';
const $91ca15859685b28b$var$SELECTOR_TOOLTIP_INNER = '.tooltip-inner';
const $91ca15859685b28b$var$SELECTOR_MODAL = `.${$91ca15859685b28b$var$CLASS_NAME_MODAL}`;
const $91ca15859685b28b$var$EVENT_MODAL_HIDE = 'hide.bs.modal';
const $91ca15859685b28b$var$TRIGGER_HOVER = 'hover';
const $91ca15859685b28b$var$TRIGGER_FOCUS = 'focus';
const $91ca15859685b28b$var$TRIGGER_CLICK = 'click';
const $91ca15859685b28b$var$TRIGGER_MANUAL = 'manual';
const $91ca15859685b28b$var$EVENT_HIDE$2 = 'hide';
const $91ca15859685b28b$var$EVENT_HIDDEN$2 = 'hidden';
const $91ca15859685b28b$var$EVENT_SHOW$2 = 'show';
const $91ca15859685b28b$var$EVENT_SHOWN$2 = 'shown';
const $91ca15859685b28b$var$EVENT_INSERTED = 'inserted';
const $91ca15859685b28b$var$EVENT_CLICK$1 = 'click';
const $91ca15859685b28b$var$EVENT_FOCUSIN$1 = 'focusin';
const $91ca15859685b28b$var$EVENT_FOCUSOUT$1 = 'focusout';
const $91ca15859685b28b$var$EVENT_MOUSEENTER = 'mouseenter';
const $91ca15859685b28b$var$EVENT_MOUSELEAVE = 'mouseleave';
const $91ca15859685b28b$var$AttachmentMap = {
    AUTO: 'auto',
    TOP: 'top',
    RIGHT: $91ca15859685b28b$var$isRTL() ? 'left' : 'right',
    BOTTOM: 'bottom',
    LEFT: $91ca15859685b28b$var$isRTL() ? 'right' : 'left'
};
const $91ca15859685b28b$var$Default$3 = {
    allowList: $91ca15859685b28b$var$DefaultAllowlist,
    animation: true,
    boundary: 'clippingParents',
    container: false,
    customClass: '',
    delay: 0,
    fallbackPlacements: [
        'top',
        'right',
        'bottom',
        'left'
    ],
    html: false,
    offset: [
        0,
        6
    ],
    placement: 'top',
    popperConfig: null,
    sanitize: true,
    sanitizeFn: null,
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    title: '',
    trigger: 'hover focus'
};
const $91ca15859685b28b$var$DefaultType$3 = {
    allowList: 'object',
    animation: 'boolean',
    boundary: '(string|element)',
    container: '(string|element|boolean)',
    customClass: '(string|function)',
    delay: '(number|object)',
    fallbackPlacements: 'array',
    html: 'boolean',
    offset: '(array|string|function)',
    placement: '(string|function)',
    popperConfig: '(null|object|function)',
    sanitize: 'boolean',
    sanitizeFn: '(null|function)',
    selector: '(string|boolean)',
    template: 'string',
    title: '(string|element|function)',
    trigger: 'string'
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$28c660c63b792dea extends $91ca15859685b28b$var$BaseComponent {
    constructor(element, config){
        if (typeof $d37552697cc5ea39$exports === 'undefined') throw new TypeError('Bootstrap\'s tooltips require Popper (https://popper.js.org)');
        super(element, config);
        // Private
        this._isEnabled = true;
        this._timeout = 0;
        this._isHovered = null;
        this._activeTrigger = {};
        this._popper = null;
        this._templateFactory = null;
        this._newContent = null;
        // Protected
        this.tip = null;
        this._setListeners();
        if (!this._config.selector) this._fixTitle();
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$3;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$3;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$4;
    }
    // Public
    enable() {
        this._isEnabled = true;
    }
    disable() {
        this._isEnabled = false;
    }
    toggleEnabled() {
        this._isEnabled = !this._isEnabled;
    }
    toggle() {
        if (!this._isEnabled) return;
        this._activeTrigger.click = !this._activeTrigger.click;
        if (this._isShown()) {
            this._leave();
            return;
        }
        this._enter();
    }
    dispose() {
        clearTimeout(this._timeout);
        $91ca15859685b28b$var$EventHandler.off(this._element.closest($91ca15859685b28b$var$SELECTOR_MODAL), $91ca15859685b28b$var$EVENT_MODAL_HIDE, this._hideModalHandler);
        if (this._element.getAttribute('data-bs-original-title')) this._element.setAttribute('title', this._element.getAttribute('data-bs-original-title'));
        this._disposePopper();
        super.dispose();
    }
    show() {
        if (this._element.style.display === 'none') throw new Error('Please use show on visible elements');
        if (!(this._isWithContent() && this._isEnabled)) return;
        const showEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, this.constructor.eventName($91ca15859685b28b$var$EVENT_SHOW$2));
        const shadowRoot = $91ca15859685b28b$var$findShadowRoot(this._element);
        const isInTheDom = (shadowRoot || this._element.ownerDocument.documentElement).contains(this._element);
        if (showEvent.defaultPrevented || !isInTheDom) return;
        // TODO: v6 remove this or make it optional
        this._disposePopper();
        const tip = this._getTipElement();
        this._element.setAttribute('aria-describedby', tip.getAttribute('id'));
        const { container: container } = this._config;
        if (!this._element.ownerDocument.documentElement.contains(this.tip)) {
            container.append(tip);
            $91ca15859685b28b$var$EventHandler.trigger(this._element, this.constructor.eventName($91ca15859685b28b$var$EVENT_INSERTED));
        }
        this._popper = this._createPopper(tip);
        tip.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))$91ca15859685b28b$var$EventHandler.on(element, 'mouseover', $91ca15859685b28b$var$noop);
        const complete = ()=>{
            $91ca15859685b28b$var$EventHandler.trigger(this._element, this.constructor.eventName($91ca15859685b28b$var$EVENT_SHOWN$2));
            if (this._isHovered === false) this._leave();
            this._isHovered = false;
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    hide() {
        if (!this._isShown()) return;
        const hideEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, this.constructor.eventName($91ca15859685b28b$var$EVENT_HIDE$2));
        if (hideEvent.defaultPrevented) return;
        const tip = this._getTipElement();
        tip.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))$91ca15859685b28b$var$EventHandler.off(element, 'mouseover', $91ca15859685b28b$var$noop);
        this._activeTrigger[$91ca15859685b28b$var$TRIGGER_CLICK] = false;
        this._activeTrigger[$91ca15859685b28b$var$TRIGGER_FOCUS] = false;
        this._activeTrigger[$91ca15859685b28b$var$TRIGGER_HOVER] = false;
        this._isHovered = null; // it is a trick to support manual triggering
        const complete = ()=>{
            if (this._isWithActiveTrigger()) return;
            if (!this._isHovered) this._disposePopper();
            this._element.removeAttribute('aria-describedby');
            $91ca15859685b28b$var$EventHandler.trigger(this._element, this.constructor.eventName($91ca15859685b28b$var$EVENT_HIDDEN$2));
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    update() {
        if (this._popper) this._popper.update();
    }
    // Protected
    _isWithContent() {
        return Boolean(this._getTitle());
    }
    _getTipElement() {
        if (!this.tip) this.tip = this._createTipElement(this._newContent || this._getContentForTemplate());
        return this.tip;
    }
    _createTipElement(content) {
        const tip = this._getTemplateFactory(content).toHtml();
        // TODO: remove this check in v6
        if (!tip) return null;
        tip.classList.remove($91ca15859685b28b$var$CLASS_NAME_FADE$2, $91ca15859685b28b$var$CLASS_NAME_SHOW$2);
        // TODO: v6 the following can be achieved with CSS only
        tip.classList.add(`bs-${this.constructor.NAME}-auto`);
        const tipId = $91ca15859685b28b$var$getUID(this.constructor.NAME).toString();
        tip.setAttribute('id', tipId);
        if (this._isAnimated()) tip.classList.add($91ca15859685b28b$var$CLASS_NAME_FADE$2);
        return tip;
    }
    setContent(content) {
        this._newContent = content;
        if (this._isShown()) {
            this._disposePopper();
            this.show();
        }
    }
    _getTemplateFactory(content) {
        if (this._templateFactory) this._templateFactory.changeContent(content);
        else this._templateFactory = new $91ca15859685b28b$var$TemplateFactory({
            ...this._config,
            content: // the `content` var has to be after `this._config`
            // to override config.content in case of popover
            content,
            extraClass: this._resolvePossibleFunction(this._config.customClass)
        });
        return this._templateFactory;
    }
    _getContentForTemplate() {
        return {
            [$91ca15859685b28b$var$SELECTOR_TOOLTIP_INNER]: this._getTitle()
        };
    }
    _getTitle() {
        return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute('data-bs-original-title');
    }
    // Private
    _initializeOnDelegatedTarget(event) {
        return this.constructor.getOrCreateInstance(event.delegateTarget, this._getDelegateConfig());
    }
    _isAnimated() {
        return this._config.animation || this.tip && this.tip.classList.contains($91ca15859685b28b$var$CLASS_NAME_FADE$2);
    }
    _isShown() {
        return this.tip && this.tip.classList.contains($91ca15859685b28b$var$CLASS_NAME_SHOW$2);
    }
    _createPopper(tip) {
        const placement = $91ca15859685b28b$var$execute(this._config.placement, [
            this,
            tip,
            this._element
        ]);
        const attachment = $91ca15859685b28b$var$AttachmentMap[placement.toUpperCase()];
        return $d37552697cc5ea39$exports.createPopper(this._element, tip, this._getPopperConfig(attachment));
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === 'string') return offset.split(',').map((value)=>Number.parseInt(value, 10));
        if (typeof offset === 'function') return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _resolvePossibleFunction(arg) {
        return $91ca15859685b28b$var$execute(arg, [
            this._element
        ]);
    }
    _getPopperConfig(attachment) {
        const defaultBsPopperConfig = {
            placement: attachment,
            modifiers: [
                {
                    name: 'flip',
                    options: {
                        fallbackPlacements: this._config.fallbackPlacements
                    }
                },
                {
                    name: 'offset',
                    options: {
                        offset: this._getOffset()
                    }
                },
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: 'arrow',
                    options: {
                        element: `.${this.constructor.NAME}-arrow`
                    }
                },
                {
                    name: 'preSetPlacement',
                    enabled: true,
                    phase: 'beforeMain',
                    fn: (data)=>{
                        // Pre-set Popper's placement attribute in order to read the arrow sizes properly.
                        // Otherwise, Popper mixes up the width and height dimensions since the initial arrow style is for top placement
                        this._getTipElement().setAttribute('data-popper-placement', data.state.placement);
                    }
                }
            ]
        };
        return {
            ...defaultBsPopperConfig,
            ...$91ca15859685b28b$var$execute(this._config.popperConfig, [
                defaultBsPopperConfig
            ])
        };
    }
    _setListeners() {
        const triggers = this._config.trigger.split(' ');
        for (const trigger of triggers){
            if (trigger === 'click') $91ca15859685b28b$var$EventHandler.on(this._element, this.constructor.eventName($91ca15859685b28b$var$EVENT_CLICK$1), this._config.selector, (event)=>{
                const context = this._initializeOnDelegatedTarget(event);
                context.toggle();
            });
            else if (trigger !== $91ca15859685b28b$var$TRIGGER_MANUAL) {
                const eventIn = trigger === $91ca15859685b28b$var$TRIGGER_HOVER ? this.constructor.eventName($91ca15859685b28b$var$EVENT_MOUSEENTER) : this.constructor.eventName($91ca15859685b28b$var$EVENT_FOCUSIN$1);
                const eventOut = trigger === $91ca15859685b28b$var$TRIGGER_HOVER ? this.constructor.eventName($91ca15859685b28b$var$EVENT_MOUSELEAVE) : this.constructor.eventName($91ca15859685b28b$var$EVENT_FOCUSOUT$1);
                $91ca15859685b28b$var$EventHandler.on(this._element, eventIn, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === 'focusin' ? $91ca15859685b28b$var$TRIGGER_FOCUS : $91ca15859685b28b$var$TRIGGER_HOVER] = true;
                    context._enter();
                });
                $91ca15859685b28b$var$EventHandler.on(this._element, eventOut, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === 'focusout' ? $91ca15859685b28b$var$TRIGGER_FOCUS : $91ca15859685b28b$var$TRIGGER_HOVER] = context._element.contains(event.relatedTarget);
                    context._leave();
                });
            }
        }
        this._hideModalHandler = ()=>{
            if (this._element) this.hide();
        };
        $91ca15859685b28b$var$EventHandler.on(this._element.closest($91ca15859685b28b$var$SELECTOR_MODAL), $91ca15859685b28b$var$EVENT_MODAL_HIDE, this._hideModalHandler);
    }
    _fixTitle() {
        const title = this._element.getAttribute('title');
        if (!title) return;
        if (!this._element.getAttribute('aria-label') && !this._element.textContent.trim()) this._element.setAttribute('aria-label', title);
        this._element.setAttribute('data-bs-original-title', title); // DO NOT USE IT. Is only for backwards compatibility
        this._element.removeAttribute('title');
    }
    _enter() {
        if (this._isShown() || this._isHovered) {
            this._isHovered = true;
            return;
        }
        this._isHovered = true;
        this._setTimeout(()=>{
            if (this._isHovered) this.show();
        }, this._config.delay.show);
    }
    _leave() {
        if (this._isWithActiveTrigger()) return;
        this._isHovered = false;
        this._setTimeout(()=>{
            if (!this._isHovered) this.hide();
        }, this._config.delay.hide);
    }
    _setTimeout(handler, timeout) {
        clearTimeout(this._timeout);
        this._timeout = setTimeout(handler, timeout);
    }
    _isWithActiveTrigger() {
        return Object.values(this._activeTrigger).includes(true);
    }
    _getConfig(config) {
        const dataAttributes = $91ca15859685b28b$var$Manipulator.getDataAttributes(this._element);
        for (const dataAttribute of Object.keys(dataAttributes))if ($91ca15859685b28b$var$DISALLOWED_ATTRIBUTES.has(dataAttribute)) delete dataAttributes[dataAttribute];
        config = {
            ...dataAttributes,
            ...typeof config === 'object' && config ? config : {}
        };
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        config.container = config.container === false ? document.body : $91ca15859685b28b$var$getElement(config.container);
        if (typeof config.delay === 'number') config.delay = {
            show: config.delay,
            hide: config.delay
        };
        if (typeof config.title === 'number') config.title = config.title.toString();
        if (typeof config.content === 'number') config.content = config.content.toString();
        return config;
    }
    _getDelegateConfig() {
        const config = {};
        for (const [key, value] of Object.entries(this._config))if (this.constructor.Default[key] !== value) config[key] = value;
        config.selector = false;
        config.trigger = 'manual';
        // In the future can be replaced with:
        // const keysWithDifferentValues = Object.entries(this._config).filter(entry => this.constructor.Default[entry[0]] !== this._config[entry[0]])
        // `Object.fromEntries(keysWithDifferentValues)`
        return config;
    }
    _disposePopper() {
        if (this._popper) {
            this._popper.destroy();
            this._popper = null;
        }
        if (this.tip) {
            this.tip.remove();
            this.tip = null;
        }
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$28c660c63b792dea.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$28c660c63b792dea);
/**
 * --------------------------------------------------------------------------
 * Bootstrap popover.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$3 = 'popover';
const $91ca15859685b28b$var$SELECTOR_TITLE = '.popover-header';
const $91ca15859685b28b$var$SELECTOR_CONTENT = '.popover-body';
const $91ca15859685b28b$var$Default$2 = {
    ...$91ca15859685b28b$export$28c660c63b792dea.Default,
    content: '',
    offset: [
        0,
        8
    ],
    placement: 'right',
    template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
    trigger: 'click'
};
const $91ca15859685b28b$var$DefaultType$2 = {
    ...$91ca15859685b28b$export$28c660c63b792dea.DefaultType,
    content: '(null|string|element|function)'
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$5b6b19405a83ff9d extends $91ca15859685b28b$export$28c660c63b792dea {
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$2;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$2;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$3;
    }
    // Overrides
    _isWithContent() {
        return this._getTitle() || this._getContent();
    }
    // Private
    _getContentForTemplate() {
        return {
            [$91ca15859685b28b$var$SELECTOR_TITLE]: this._getTitle(),
            [$91ca15859685b28b$var$SELECTOR_CONTENT]: this._getContent()
        };
    }
    _getContent() {
        return this._resolvePossibleFunction(this._config.content);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$5b6b19405a83ff9d.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$5b6b19405a83ff9d);
/**
 * --------------------------------------------------------------------------
 * Bootstrap scrollspy.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$2 = 'scrollspy';
const $91ca15859685b28b$var$DATA_KEY$2 = 'bs.scrollspy';
const $91ca15859685b28b$var$EVENT_KEY$2 = `.${$91ca15859685b28b$var$DATA_KEY$2}`;
const $91ca15859685b28b$var$DATA_API_KEY = '.data-api';
const $91ca15859685b28b$var$EVENT_ACTIVATE = `activate${$91ca15859685b28b$var$EVENT_KEY$2}`;
const $91ca15859685b28b$var$EVENT_CLICK = `click${$91ca15859685b28b$var$EVENT_KEY$2}`;
const $91ca15859685b28b$var$EVENT_LOAD_DATA_API$1 = `load${$91ca15859685b28b$var$EVENT_KEY$2}${$91ca15859685b28b$var$DATA_API_KEY}`;
const $91ca15859685b28b$var$CLASS_NAME_DROPDOWN_ITEM = 'dropdown-item';
const $91ca15859685b28b$var$CLASS_NAME_ACTIVE$1 = 'active';
const $91ca15859685b28b$var$SELECTOR_DATA_SPY = '[data-bs-spy="scroll"]';
const $91ca15859685b28b$var$SELECTOR_TARGET_LINKS = '[href]';
const $91ca15859685b28b$var$SELECTOR_NAV_LIST_GROUP = '.nav, .list-group';
const $91ca15859685b28b$var$SELECTOR_NAV_LINKS = '.nav-link';
const $91ca15859685b28b$var$SELECTOR_NAV_ITEMS = '.nav-item';
const $91ca15859685b28b$var$SELECTOR_LIST_ITEMS = '.list-group-item';
const $91ca15859685b28b$var$SELECTOR_LINK_ITEMS = `${$91ca15859685b28b$var$SELECTOR_NAV_LINKS}, ${$91ca15859685b28b$var$SELECTOR_NAV_ITEMS} > ${$91ca15859685b28b$var$SELECTOR_NAV_LINKS}, ${$91ca15859685b28b$var$SELECTOR_LIST_ITEMS}`;
const $91ca15859685b28b$var$SELECTOR_DROPDOWN = '.dropdown';
const $91ca15859685b28b$var$SELECTOR_DROPDOWN_TOGGLE$1 = '.dropdown-toggle';
const $91ca15859685b28b$var$Default$1 = {
    offset: null,
    // TODO: v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: '0px 0px -25%',
    smoothScroll: false,
    target: null,
    threshold: [
        0.1,
        0.5,
        1
    ]
};
const $91ca15859685b28b$var$DefaultType$1 = {
    offset: '(number|null)',
    // TODO v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: 'string',
    smoothScroll: 'boolean',
    target: 'element',
    threshold: 'array'
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$a6472a5298a374be extends $91ca15859685b28b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        // this._element is the observablesContainer and config.target the menu links wrapper
        this._targetLinks = new Map();
        this._observableSections = new Map();
        this._rootElement = getComputedStyle(this._element).overflowY === 'visible' ? null : this._element;
        this._activeTarget = null;
        this._observer = null;
        this._previousScrollData = {
            visibleEntryTop: 0,
            parentScrollTop: 0
        };
        this.refresh(); // initialize
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$1;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$1;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$2;
    }
    // Public
    refresh() {
        this._initializeTargetsAndObservables();
        this._maybeEnableSmoothScroll();
        if (this._observer) this._observer.disconnect();
        else this._observer = this._getNewObserver();
        for (const section of this._observableSections.values())this._observer.observe(section);
    }
    dispose() {
        this._observer.disconnect();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        // TODO: on v6 target should be given explicitly & remove the {target: 'ss-target'} case
        config.target = $91ca15859685b28b$var$getElement(config.target) || document.body;
        // TODO: v6 Only for backwards compatibility reasons. Use rootMargin only
        config.rootMargin = config.offset ? `${config.offset}px 0px -30%` : config.rootMargin;
        if (typeof config.threshold === 'string') config.threshold = config.threshold.split(',').map((value)=>Number.parseFloat(value));
        return config;
    }
    _maybeEnableSmoothScroll() {
        if (!this._config.smoothScroll) return;
        // unregister any previous listeners
        $91ca15859685b28b$var$EventHandler.off(this._config.target, $91ca15859685b28b$var$EVENT_CLICK);
        $91ca15859685b28b$var$EventHandler.on(this._config.target, $91ca15859685b28b$var$EVENT_CLICK, $91ca15859685b28b$var$SELECTOR_TARGET_LINKS, (event)=>{
            const observableSection = this._observableSections.get(event.target.hash);
            if (observableSection) {
                event.preventDefault();
                const root = this._rootElement || window;
                const height = observableSection.offsetTop - this._element.offsetTop;
                if (root.scrollTo) {
                    root.scrollTo({
                        top: height,
                        behavior: 'smooth'
                    });
                    return;
                }
                // Chrome 60 doesn't support `scrollTo`
                root.scrollTop = height;
            }
        });
    }
    _getNewObserver() {
        const options = {
            root: this._rootElement,
            threshold: this._config.threshold,
            rootMargin: this._config.rootMargin
        };
        return new IntersectionObserver((entries)=>this._observerCallback(entries), options);
    }
    // The logic of selection
    _observerCallback(entries) {
        const targetElement = (entry)=>this._targetLinks.get(`#${entry.target.id}`);
        const activate = (entry)=>{
            this._previousScrollData.visibleEntryTop = entry.target.offsetTop;
            this._process(targetElement(entry));
        };
        const parentScrollTop = (this._rootElement || document.documentElement).scrollTop;
        const userScrollsDown = parentScrollTop >= this._previousScrollData.parentScrollTop;
        this._previousScrollData.parentScrollTop = parentScrollTop;
        for (const entry of entries){
            if (!entry.isIntersecting) {
                this._activeTarget = null;
                this._clearActiveClass(targetElement(entry));
                continue;
            }
            const entryIsLowerThanPrevious = entry.target.offsetTop >= this._previousScrollData.visibleEntryTop;
            // if we are scrolling down, pick the bigger offsetTop
            if (userScrollsDown && entryIsLowerThanPrevious) {
                activate(entry);
                // if parent isn't scrolled, let's keep the first visible item, breaking the iteration
                if (!parentScrollTop) return;
                continue;
            }
            // if we are scrolling up, pick the smallest offsetTop
            if (!userScrollsDown && !entryIsLowerThanPrevious) activate(entry);
        }
    }
    _initializeTargetsAndObservables() {
        this._targetLinks = new Map();
        this._observableSections = new Map();
        const targetLinks = $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_TARGET_LINKS, this._config.target);
        for (const anchor of targetLinks){
            // ensure that the anchor has an id and is not disabled
            if (!anchor.hash || $91ca15859685b28b$var$isDisabled(anchor)) continue;
            const observableSection = $91ca15859685b28b$var$SelectorEngine.findOne(decodeURI(anchor.hash), this._element);
            // ensure that the observableSection exists & is visible
            if ($91ca15859685b28b$var$isVisible(observableSection)) {
                this._targetLinks.set(decodeURI(anchor.hash), anchor);
                this._observableSections.set(anchor.hash, observableSection);
            }
        }
    }
    _process(target) {
        if (this._activeTarget === target) return;
        this._clearActiveClass(this._config.target);
        this._activeTarget = target;
        target.classList.add($91ca15859685b28b$var$CLASS_NAME_ACTIVE$1);
        this._activateParents(target);
        $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_ACTIVATE, {
            relatedTarget: target
        });
    }
    _activateParents(target) {
        // Activate dropdown parents
        if (target.classList.contains($91ca15859685b28b$var$CLASS_NAME_DROPDOWN_ITEM)) {
            $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_DROPDOWN_TOGGLE$1, target.closest($91ca15859685b28b$var$SELECTOR_DROPDOWN)).classList.add($91ca15859685b28b$var$CLASS_NAME_ACTIVE$1);
            return;
        }
        for (const listGroup of $91ca15859685b28b$var$SelectorEngine.parents(target, $91ca15859685b28b$var$SELECTOR_NAV_LIST_GROUP))// Set triggered links parents as active
        // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
        for (const item of $91ca15859685b28b$var$SelectorEngine.prev(listGroup, $91ca15859685b28b$var$SELECTOR_LINK_ITEMS))item.classList.add($91ca15859685b28b$var$CLASS_NAME_ACTIVE$1);
    }
    _clearActiveClass(parent) {
        parent.classList.remove($91ca15859685b28b$var$CLASS_NAME_ACTIVE$1);
        const activeNodes = $91ca15859685b28b$var$SelectorEngine.find(`${$91ca15859685b28b$var$SELECTOR_TARGET_LINKS}.${$91ca15859685b28b$var$CLASS_NAME_ACTIVE$1}`, parent);
        for (const node of activeNodes)node.classList.remove($91ca15859685b28b$var$CLASS_NAME_ACTIVE$1);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$a6472a5298a374be.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$EventHandler.on(window, $91ca15859685b28b$var$EVENT_LOAD_DATA_API$1, ()=>{
    for (const spy of $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_DATA_SPY))$91ca15859685b28b$export$a6472a5298a374be.getOrCreateInstance(spy);
});
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$a6472a5298a374be);
/**
 * --------------------------------------------------------------------------
 * Bootstrap tab.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$1 = 'tab';
const $91ca15859685b28b$var$DATA_KEY$1 = 'bs.tab';
const $91ca15859685b28b$var$EVENT_KEY$1 = `.${$91ca15859685b28b$var$DATA_KEY$1}`;
const $91ca15859685b28b$var$EVENT_HIDE$1 = `hide${$91ca15859685b28b$var$EVENT_KEY$1}`;
const $91ca15859685b28b$var$EVENT_HIDDEN$1 = `hidden${$91ca15859685b28b$var$EVENT_KEY$1}`;
const $91ca15859685b28b$var$EVENT_SHOW$1 = `show${$91ca15859685b28b$var$EVENT_KEY$1}`;
const $91ca15859685b28b$var$EVENT_SHOWN$1 = `shown${$91ca15859685b28b$var$EVENT_KEY$1}`;
const $91ca15859685b28b$var$EVENT_CLICK_DATA_API = `click${$91ca15859685b28b$var$EVENT_KEY$1}`;
const $91ca15859685b28b$var$EVENT_KEYDOWN = `keydown${$91ca15859685b28b$var$EVENT_KEY$1}`;
const $91ca15859685b28b$var$EVENT_LOAD_DATA_API = `load${$91ca15859685b28b$var$EVENT_KEY$1}`;
const $91ca15859685b28b$var$ARROW_LEFT_KEY = 'ArrowLeft';
const $91ca15859685b28b$var$ARROW_RIGHT_KEY = 'ArrowRight';
const $91ca15859685b28b$var$ARROW_UP_KEY = 'ArrowUp';
const $91ca15859685b28b$var$ARROW_DOWN_KEY = 'ArrowDown';
const $91ca15859685b28b$var$HOME_KEY = 'Home';
const $91ca15859685b28b$var$END_KEY = 'End';
const $91ca15859685b28b$var$CLASS_NAME_ACTIVE = 'active';
const $91ca15859685b28b$var$CLASS_NAME_FADE$1 = 'fade';
const $91ca15859685b28b$var$CLASS_NAME_SHOW$1 = 'show';
const $91ca15859685b28b$var$CLASS_DROPDOWN = 'dropdown';
const $91ca15859685b28b$var$SELECTOR_DROPDOWN_TOGGLE = '.dropdown-toggle';
const $91ca15859685b28b$var$SELECTOR_DROPDOWN_MENU = '.dropdown-menu';
const $91ca15859685b28b$var$NOT_SELECTOR_DROPDOWN_TOGGLE = `:not(${$91ca15859685b28b$var$SELECTOR_DROPDOWN_TOGGLE})`;
const $91ca15859685b28b$var$SELECTOR_TAB_PANEL = '.list-group, .nav, [role="tablist"]';
const $91ca15859685b28b$var$SELECTOR_OUTER = '.nav-item, .list-group-item';
const $91ca15859685b28b$var$SELECTOR_INNER = `.nav-link${$91ca15859685b28b$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, .list-group-item${$91ca15859685b28b$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, [role="tab"]${$91ca15859685b28b$var$NOT_SELECTOR_DROPDOWN_TOGGLE}`;
const $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]'; // TODO: could only be `tab` in v6
const $91ca15859685b28b$var$SELECTOR_INNER_ELEM = `${$91ca15859685b28b$var$SELECTOR_INNER}, ${$91ca15859685b28b$var$SELECTOR_DATA_TOGGLE}`;
const $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE_ACTIVE = `.${$91ca15859685b28b$var$CLASS_NAME_ACTIVE}[data-bs-toggle="tab"], .${$91ca15859685b28b$var$CLASS_NAME_ACTIVE}[data-bs-toggle="pill"], .${$91ca15859685b28b$var$CLASS_NAME_ACTIVE}[data-bs-toggle="list"]`;
/**
 * Class definition
 */ class $91ca15859685b28b$export$3e41faf802a29e71 extends $91ca15859685b28b$var$BaseComponent {
    constructor(element){
        super(element);
        this._parent = this._element.closest($91ca15859685b28b$var$SELECTOR_TAB_PANEL);
        if (!this._parent) return;
        // Set up initial aria attributes
        this._setInitialAttributes(this._parent, this._getChildren());
        $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_KEYDOWN, (event)=>this._keydown(event));
    }
    // Getters
    static get NAME() {
        return $91ca15859685b28b$var$NAME$1;
    }
    // Public
    show() {
        // Shows this elem and deactivate the active sibling if exists
        const innerElem = this._element;
        if (this._elemIsActive(innerElem)) return;
        // Search for active tab on same parent to deactivate it
        const active = this._getActiveElem();
        const hideEvent = active ? $91ca15859685b28b$var$EventHandler.trigger(active, $91ca15859685b28b$var$EVENT_HIDE$1, {
            relatedTarget: innerElem
        }) : null;
        const showEvent = $91ca15859685b28b$var$EventHandler.trigger(innerElem, $91ca15859685b28b$var$EVENT_SHOW$1, {
            relatedTarget: active
        });
        if (showEvent.defaultPrevented || hideEvent && hideEvent.defaultPrevented) return;
        this._deactivate(active, innerElem);
        this._activate(innerElem, active);
    }
    // Private
    _activate(element, relatedElem) {
        if (!element) return;
        element.classList.add($91ca15859685b28b$var$CLASS_NAME_ACTIVE);
        this._activate($91ca15859685b28b$var$SelectorEngine.getElementFromSelector(element)); // Search and activate/show the proper section
        const complete = ()=>{
            if (element.getAttribute('role') !== 'tab') {
                element.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.removeAttribute('tabindex');
            element.setAttribute('aria-selected', true);
            this._toggleDropDown(element, true);
            $91ca15859685b28b$var$EventHandler.trigger(element, $91ca15859685b28b$var$EVENT_SHOWN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($91ca15859685b28b$var$CLASS_NAME_FADE$1));
    }
    _deactivate(element, relatedElem) {
        if (!element) return;
        element.classList.remove($91ca15859685b28b$var$CLASS_NAME_ACTIVE);
        element.blur();
        this._deactivate($91ca15859685b28b$var$SelectorEngine.getElementFromSelector(element)); // Search and deactivate the shown section too
        const complete = ()=>{
            if (element.getAttribute('role') !== 'tab') {
                element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.setAttribute('aria-selected', false);
            element.setAttribute('tabindex', '-1');
            this._toggleDropDown(element, false);
            $91ca15859685b28b$var$EventHandler.trigger(element, $91ca15859685b28b$var$EVENT_HIDDEN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($91ca15859685b28b$var$CLASS_NAME_FADE$1));
    }
    _keydown(event) {
        if (![
            $91ca15859685b28b$var$ARROW_LEFT_KEY,
            $91ca15859685b28b$var$ARROW_RIGHT_KEY,
            $91ca15859685b28b$var$ARROW_UP_KEY,
            $91ca15859685b28b$var$ARROW_DOWN_KEY,
            $91ca15859685b28b$var$HOME_KEY,
            $91ca15859685b28b$var$END_KEY
        ].includes(event.key)) return;
        event.stopPropagation(); // stopPropagation/preventDefault both added to support up/down keys without scrolling the page
        event.preventDefault();
        const children = this._getChildren().filter((element)=>!$91ca15859685b28b$var$isDisabled(element));
        let nextActiveElement;
        if ([
            $91ca15859685b28b$var$HOME_KEY,
            $91ca15859685b28b$var$END_KEY
        ].includes(event.key)) nextActiveElement = children[event.key === $91ca15859685b28b$var$HOME_KEY ? 0 : children.length - 1];
        else {
            const isNext = [
                $91ca15859685b28b$var$ARROW_RIGHT_KEY,
                $91ca15859685b28b$var$ARROW_DOWN_KEY
            ].includes(event.key);
            nextActiveElement = $91ca15859685b28b$var$getNextActiveElement(children, event.target, isNext, true);
        }
        if (nextActiveElement) {
            nextActiveElement.focus({
                preventScroll: true
            });
            $91ca15859685b28b$export$3e41faf802a29e71.getOrCreateInstance(nextActiveElement).show();
        }
    }
    _getChildren() {
        // collection of inner elements
        return $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_INNER_ELEM, this._parent);
    }
    _getActiveElem() {
        return this._getChildren().find((child)=>this._elemIsActive(child)) || null;
    }
    _setInitialAttributes(parent, children) {
        this._setAttributeIfNotExists(parent, 'role', 'tablist');
        for (const child of children)this._setInitialAttributesOnChild(child);
    }
    _setInitialAttributesOnChild(child) {
        child = this._getInnerElement(child);
        const isActive = this._elemIsActive(child);
        const outerElem = this._getOuterElement(child);
        child.setAttribute('aria-selected', isActive);
        if (outerElem !== child) this._setAttributeIfNotExists(outerElem, 'role', 'presentation');
        if (!isActive) child.setAttribute('tabindex', '-1');
        this._setAttributeIfNotExists(child, 'role', 'tab');
        // set attributes to the related panel too
        this._setInitialAttributesOnTargetPanel(child);
    }
    _setInitialAttributesOnTargetPanel(child) {
        const target = $91ca15859685b28b$var$SelectorEngine.getElementFromSelector(child);
        if (!target) return;
        this._setAttributeIfNotExists(target, 'role', 'tabpanel');
        if (child.id) this._setAttributeIfNotExists(target, 'aria-labelledby', `${child.id}`);
    }
    _toggleDropDown(element, open) {
        const outerElem = this._getOuterElement(element);
        if (!outerElem.classList.contains($91ca15859685b28b$var$CLASS_DROPDOWN)) return;
        const toggle = (selector, className)=>{
            const element = $91ca15859685b28b$var$SelectorEngine.findOne(selector, outerElem);
            if (element) element.classList.toggle(className, open);
        };
        toggle($91ca15859685b28b$var$SELECTOR_DROPDOWN_TOGGLE, $91ca15859685b28b$var$CLASS_NAME_ACTIVE);
        toggle($91ca15859685b28b$var$SELECTOR_DROPDOWN_MENU, $91ca15859685b28b$var$CLASS_NAME_SHOW$1);
        outerElem.setAttribute('aria-expanded', open);
    }
    _setAttributeIfNotExists(element, attribute, value) {
        if (!element.hasAttribute(attribute)) element.setAttribute(attribute, value);
    }
    _elemIsActive(elem) {
        return elem.classList.contains($91ca15859685b28b$var$CLASS_NAME_ACTIVE);
    }
    // Try to get the inner element (usually the .nav-link)
    _getInnerElement(elem) {
        return elem.matches($91ca15859685b28b$var$SELECTOR_INNER_ELEM) ? elem : $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_INNER_ELEM, elem);
    }
    // Try to get the outer element (usually the .nav-item)
    _getOuterElement(elem) {
        return elem.closest($91ca15859685b28b$var$SELECTOR_OUTER) || elem;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$3e41faf802a29e71.getOrCreateInstance(this);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_CLICK_DATA_API, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE, function(event) {
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    if ($91ca15859685b28b$var$isDisabled(this)) return;
    $91ca15859685b28b$export$3e41faf802a29e71.getOrCreateInstance(this).show();
});
/**
 * Initialize on focus
 */ $91ca15859685b28b$var$EventHandler.on(window, $91ca15859685b28b$var$EVENT_LOAD_DATA_API, ()=>{
    for (const element of $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_DATA_TOGGLE_ACTIVE))$91ca15859685b28b$export$3e41faf802a29e71.getOrCreateInstance(element);
});
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$3e41faf802a29e71);
/**
 * --------------------------------------------------------------------------
 * Bootstrap toast.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME = 'toast';
const $91ca15859685b28b$var$DATA_KEY = 'bs.toast';
const $91ca15859685b28b$var$EVENT_KEY = `.${$91ca15859685b28b$var$DATA_KEY}`;
const $91ca15859685b28b$var$EVENT_MOUSEOVER = `mouseover${$91ca15859685b28b$var$EVENT_KEY}`;
const $91ca15859685b28b$var$EVENT_MOUSEOUT = `mouseout${$91ca15859685b28b$var$EVENT_KEY}`;
const $91ca15859685b28b$var$EVENT_FOCUSIN = `focusin${$91ca15859685b28b$var$EVENT_KEY}`;
const $91ca15859685b28b$var$EVENT_FOCUSOUT = `focusout${$91ca15859685b28b$var$EVENT_KEY}`;
const $91ca15859685b28b$var$EVENT_HIDE = `hide${$91ca15859685b28b$var$EVENT_KEY}`;
const $91ca15859685b28b$var$EVENT_HIDDEN = `hidden${$91ca15859685b28b$var$EVENT_KEY}`;
const $91ca15859685b28b$var$EVENT_SHOW = `show${$91ca15859685b28b$var$EVENT_KEY}`;
const $91ca15859685b28b$var$EVENT_SHOWN = `shown${$91ca15859685b28b$var$EVENT_KEY}`;
const $91ca15859685b28b$var$CLASS_NAME_FADE = 'fade';
const $91ca15859685b28b$var$CLASS_NAME_HIDE = 'hide'; // @deprecated - kept here only for backwards compatibility
const $91ca15859685b28b$var$CLASS_NAME_SHOW = 'show';
const $91ca15859685b28b$var$CLASS_NAME_SHOWING = 'showing';
const $91ca15859685b28b$var$DefaultType = {
    animation: 'boolean',
    autohide: 'boolean',
    delay: 'number'
};
const $91ca15859685b28b$var$Default = {
    animation: true,
    autohide: true,
    delay: 5000
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$8d8dc7d5f743331b extends $91ca15859685b28b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._timeout = null;
        this._hasMouseInteraction = false;
        this._hasKeyboardInteraction = false;
        this._setListeners();
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME;
    }
    // Public
    show() {
        const showEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOW);
        if (showEvent.defaultPrevented) return;
        this._clearTimeout();
        if (this._config.animation) this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_FADE);
        const complete = ()=>{
            this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOWING);
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOWN);
            this._maybeScheduleHide();
        };
        this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_HIDE); // @deprecated
        $91ca15859685b28b$var$reflow(this._element);
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOW, $91ca15859685b28b$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    hide() {
        if (!this.isShown()) return;
        const hideEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDE);
        if (hideEvent.defaultPrevented) return;
        const complete = ()=>{
            this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_HIDE); // @deprecated
            this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOWING, $91ca15859685b28b$var$CLASS_NAME_SHOW);
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDDEN);
        };
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    dispose() {
        this._clearTimeout();
        if (this.isShown()) this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW);
        super.dispose();
    }
    isShown() {
        return this._element.classList.contains($91ca15859685b28b$var$CLASS_NAME_SHOW);
    }
    // Private
    _maybeScheduleHide() {
        if (!this._config.autohide) return;
        if (this._hasMouseInteraction || this._hasKeyboardInteraction) return;
        this._timeout = setTimeout(()=>{
            this.hide();
        }, this._config.delay);
    }
    _onInteraction(event, isInteracting) {
        switch(event.type){
            case 'mouseover':
            case 'mouseout':
                this._hasMouseInteraction = isInteracting;
                break;
            case 'focusin':
            case 'focusout':
                this._hasKeyboardInteraction = isInteracting;
                break;
        }
        if (isInteracting) {
            this._clearTimeout();
            return;
        }
        const nextElement = event.relatedTarget;
        if (this._element === nextElement || this._element.contains(nextElement)) return;
        this._maybeScheduleHide();
    }
    _setListeners() {
        $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_MOUSEOVER, (event)=>this._onInteraction(event, true));
        $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_MOUSEOUT, (event)=>this._onInteraction(event, false));
        $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_FOCUSIN, (event)=>this._onInteraction(event, true));
        $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_FOCUSOUT, (event)=>this._onInteraction(event, false));
    }
    _clearTimeout() {
        clearTimeout(this._timeout);
        this._timeout = null;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$8d8dc7d5f743331b.getOrCreateInstance(this, config);
            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
                data[config](this);
            }
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$enableDismissTrigger($91ca15859685b28b$export$8d8dc7d5f743331b);
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$8d8dc7d5f743331b);


function $9bd69b859d31db4a$export$2e2bcd8739ae039(root) {
    Array.from(root.querySelectorAll('.toast')).forEach((toastNode)=>{
        new (0, $91ca15859685b28b$export$8d8dc7d5f743331b)(toastNode, {
            autohide: true,
            delay: 15000
        }).show();
        toastNode.addEventListener('hidden.bs.toast', ()=>{
            (0, $91ca15859685b28b$export$8d8dc7d5f743331b).getInstance(toastNode).dispose();
            toastNode.remove();
        });
    });
}



function $b3610fc8bdb53218$export$2e2bcd8739ae039(root) {
    Array.from(root.querySelectorAll('[data-bs-toggle="popover"]')).forEach((popoverNode)=>{
        popoverNode.addEventListener('click', (e)=>{
            e.preventDefault();
        });
        new (0, $91ca15859685b28b$export$5b6b19405a83ff9d)(popoverNode, {
            trigger: 'click'
        });
        const autohide = popoverNode.dataset.bsAutohide;
        if (autohide && (autohide === "true" || parseInt(autohide) > 0)) popoverNode.addEventListener('show.bs.popover', ()=>{
            setTimeout(()=>{
                (0, $91ca15859685b28b$export$5b6b19405a83ff9d).getInstance(popoverNode).hide();
            }, autohide === "true" ? 5000 : parseInt(autohide));
        });
    });
}



var $d0e6c103fdd72c14$export$c34bb18505e1e253 = [
    "onChange",
    "onClose",
    "onDayCreate",
    "onDestroy",
    "onKeyDown",
    "onMonthChange",
    "onOpen",
    "onParseConfig",
    "onReady",
    "onValueUpdate",
    "onYearChange",
    "onPreCalendarPosition"
];
var $d0e6c103fdd72c14$export$ebe90cb607ad99e = {
    _disable: [],
    allowInput: false,
    allowInvalidPreload: false,
    altFormat: "F j, Y",
    altInput: false,
    altInputClass: "form-control input",
    animate: typeof window === "object" && window.navigator.userAgent.indexOf("MSIE") === -1,
    ariaDateFormat: "F j, Y",
    autoFillDefaultTime: true,
    clickOpens: true,
    closeOnSelect: true,
    conjunction: ", ",
    dateFormat: "Y-m-d",
    defaultHour: 12,
    defaultMinute: 0,
    defaultSeconds: 0,
    disable: [],
    disableMobile: false,
    enableSeconds: false,
    enableTime: false,
    errorHandler: function(err) {
        return typeof console !== "undefined" && console.warn(err);
    },
    getWeek: function(givenDate) {
        var date = new Date(givenDate.getTime());
        date.setHours(0, 0, 0, 0);
        date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
        var week1 = new Date(date.getFullYear(), 0, 4);
        return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
    },
    hourIncrement: 1,
    ignoredFocusElements: [],
    inline: false,
    locale: "default",
    minuteIncrement: 5,
    mode: "single",
    monthSelectorType: "dropdown",
    nextArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",
    noCalendar: false,
    now: new Date(),
    onChange: [],
    onClose: [],
    onDayCreate: [],
    onDestroy: [],
    onKeyDown: [],
    onMonthChange: [],
    onOpen: [],
    onParseConfig: [],
    onReady: [],
    onValueUpdate: [],
    onYearChange: [],
    onPreCalendarPosition: [],
    plugins: [],
    position: "auto",
    positionElement: undefined,
    prevArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
    shorthandCurrentMonth: false,
    showMonths: 1,
    static: false,
    time_24hr: false,
    weekNumbers: false,
    wrap: false
};


var $01c55b35388eeff4$export$33e6c23ebe2ee669 = {
    weekdays: {
        shorthand: [
            "Sun",
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat"
        ],
        longhand: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ]
    },
    months: {
        shorthand: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ],
        longhand: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ]
    },
    daysInMonth: [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ],
    firstDayOfWeek: 0,
    ordinal: function(nth) {
        var s = nth % 100;
        if (s > 3 && s < 21) return "th";
        switch(s % 10){
            case 1:
                return "st";
            case 2:
                return "nd";
            case 3:
                return "rd";
            default:
                return "th";
        }
    },
    rangeSeparator: " to ",
    weekAbbreviation: "Wk",
    scrollTitle: "Scroll to increment",
    toggleTitle: "Click to toggle",
    amPM: [
        "AM",
        "PM"
    ],
    yearAriaLabel: "Year",
    monthAriaLabel: "Month",
    hourAriaLabel: "Hour",
    minuteAriaLabel: "Minute",
    time_24hr: false
};
var $01c55b35388eeff4$export$2e2bcd8739ae039 = $01c55b35388eeff4$export$33e6c23ebe2ee669;


var $7c36d6f76aae5f22$export$5d04458e2a6c373e = function(number, length) {
    if (length === void 0) length = 2;
    return ("000" + number).slice(length * -1);
};
var $7c36d6f76aae5f22$export$7d260a2a5f8bc19e = function(bool) {
    return bool === true ? 1 : 0;
};
function $7c36d6f76aae5f22$export$61fc7d43ac8f84b0(fn, wait) {
    var t;
    return function() {
        var _this = this;
        var args = arguments;
        clearTimeout(t);
        t = setTimeout(function() {
            return fn.apply(_this, args);
        }, wait);
    };
}
var $7c36d6f76aae5f22$export$3131421a7d01b4fb = function(obj) {
    return obj instanceof Array ? obj : [
        obj
    ];
};


function $46627959f4a6cf8e$export$4a80062ca50b57c7(elem, className, bool) {
    if (bool === true) return elem.classList.add(className);
    elem.classList.remove(className);
}
function $46627959f4a6cf8e$export$c8a8987d4410bf2d(tag, className, content) {
    var e = window.document.createElement(tag);
    className = className || "";
    content = content || "";
    e.className = className;
    if (content !== undefined) e.textContent = content;
    return e;
}
function $46627959f4a6cf8e$export$51cfe97d637c237c(node) {
    while(node.firstChild)node.removeChild(node.firstChild);
}
function $46627959f4a6cf8e$export$25245567f53f158f(node, condition) {
    if (condition(node)) return node;
    else if (node.parentNode) return $46627959f4a6cf8e$export$25245567f53f158f(node.parentNode, condition);
    return undefined;
}
function $46627959f4a6cf8e$export$afe9d610a3284048(inputClassName, opts) {
    var wrapper = $46627959f4a6cf8e$export$c8a8987d4410bf2d("div", "numInputWrapper"), numInput = $46627959f4a6cf8e$export$c8a8987d4410bf2d("input", "numInput " + inputClassName), arrowUp = $46627959f4a6cf8e$export$c8a8987d4410bf2d("span", "arrowUp"), arrowDown = $46627959f4a6cf8e$export$c8a8987d4410bf2d("span", "arrowDown");
    if (navigator.userAgent.indexOf("MSIE 9.0") === -1) numInput.type = "number";
    else {
        numInput.type = "text";
        numInput.pattern = "\\d*";
    }
    if (opts !== undefined) for(var key in opts)numInput.setAttribute(key, opts[key]);
    wrapper.appendChild(numInput);
    wrapper.appendChild(arrowUp);
    wrapper.appendChild(arrowDown);
    return wrapper;
}
function $46627959f4a6cf8e$export$e58f029f0fbfdb29(event) {
    try {
        if (typeof event.composedPath === "function") {
            var path = event.composedPath();
            return path[0];
        }
        return event.target;
    } catch (error) {
        return event.target;
    }
}



var $bc1b2819a5a95bf4$var$doNothing = function() {
    return undefined;
};
var $bc1b2819a5a95bf4$export$27a2dd9af757e89c = function(monthNumber, shorthand, locale) {
    return locale.months[shorthand ? "shorthand" : "longhand"][monthNumber];
};
var $bc1b2819a5a95bf4$export$9490b78b888a863f = {
    D: $bc1b2819a5a95bf4$var$doNothing,
    F: function(dateObj, monthName, locale) {
        dateObj.setMonth(locale.months.longhand.indexOf(monthName));
    },
    G: function(dateObj, hour) {
        dateObj.setHours((dateObj.getHours() >= 12 ? 12 : 0) + parseFloat(hour));
    },
    H: function(dateObj, hour) {
        dateObj.setHours(parseFloat(hour));
    },
    J: function(dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    K: function(dateObj, amPM, locale) {
        dateObj.setHours(dateObj.getHours() % 12 + 12 * (0, $7c36d6f76aae5f22$export$7d260a2a5f8bc19e)(new RegExp(locale.amPM[1], "i").test(amPM)));
    },
    M: function(dateObj, shortMonth, locale) {
        dateObj.setMonth(locale.months.shorthand.indexOf(shortMonth));
    },
    S: function(dateObj, seconds) {
        dateObj.setSeconds(parseFloat(seconds));
    },
    U: function(_, unixSeconds) {
        return new Date(parseFloat(unixSeconds) * 1000);
    },
    W: function(dateObj, weekNum, locale) {
        var weekNumber = parseInt(weekNum);
        var date = new Date(dateObj.getFullYear(), 0, 2 + (weekNumber - 1) * 7, 0, 0, 0, 0);
        date.setDate(date.getDate() - date.getDay() + locale.firstDayOfWeek);
        return date;
    },
    Y: function(dateObj, year) {
        dateObj.setFullYear(parseFloat(year));
    },
    Z: function(_, ISODate) {
        return new Date(ISODate);
    },
    d: function(dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    h: function(dateObj, hour) {
        dateObj.setHours((dateObj.getHours() >= 12 ? 12 : 0) + parseFloat(hour));
    },
    i: function(dateObj, minutes) {
        dateObj.setMinutes(parseFloat(minutes));
    },
    j: function(dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    l: $bc1b2819a5a95bf4$var$doNothing,
    m: function(dateObj, month) {
        dateObj.setMonth(parseFloat(month) - 1);
    },
    n: function(dateObj, month) {
        dateObj.setMonth(parseFloat(month) - 1);
    },
    s: function(dateObj, seconds) {
        dateObj.setSeconds(parseFloat(seconds));
    },
    u: function(_, unixMillSeconds) {
        return new Date(parseFloat(unixMillSeconds));
    },
    w: $bc1b2819a5a95bf4$var$doNothing,
    y: function(dateObj, year) {
        dateObj.setFullYear(2000 + parseFloat(year));
    }
};
var $bc1b2819a5a95bf4$export$f5a8dc72fbf63af5 = {
    D: "",
    F: "",
    G: "(\\d\\d|\\d)",
    H: "(\\d\\d|\\d)",
    J: "(\\d\\d|\\d)\\w+",
    K: "",
    M: "",
    S: "(\\d\\d|\\d)",
    U: "(.+)",
    W: "(\\d\\d|\\d)",
    Y: "(\\d{4})",
    Z: "(.+)",
    d: "(\\d\\d|\\d)",
    h: "(\\d\\d|\\d)",
    i: "(\\d\\d|\\d)",
    j: "(\\d\\d|\\d)",
    l: "",
    m: "(\\d\\d|\\d)",
    n: "(\\d\\d|\\d)",
    s: "(\\d\\d|\\d)",
    u: "(.+)",
    w: "(\\d\\d|\\d)",
    y: "(\\d{2})"
};
var $bc1b2819a5a95bf4$export$55069460464ca7a9 = {
    Z: function(date) {
        return date.toISOString();
    },
    D: function(date, locale, options) {
        return locale.weekdays.shorthand[$bc1b2819a5a95bf4$export$55069460464ca7a9.w(date, locale, options)];
    },
    F: function(date, locale, options) {
        return $bc1b2819a5a95bf4$export$27a2dd9af757e89c($bc1b2819a5a95bf4$export$55069460464ca7a9.n(date, locale, options) - 1, false, locale);
    },
    G: function(date, locale, options) {
        return (0, $7c36d6f76aae5f22$export$5d04458e2a6c373e)($bc1b2819a5a95bf4$export$55069460464ca7a9.h(date, locale, options));
    },
    H: function(date) {
        return (0, $7c36d6f76aae5f22$export$5d04458e2a6c373e)(date.getHours());
    },
    J: function(date, locale) {
        return locale.ordinal !== undefined ? date.getDate() + locale.ordinal(date.getDate()) : date.getDate();
    },
    K: function(date, locale) {
        return locale.amPM[(0, $7c36d6f76aae5f22$export$7d260a2a5f8bc19e)(date.getHours() > 11)];
    },
    M: function(date, locale) {
        return $bc1b2819a5a95bf4$export$27a2dd9af757e89c(date.getMonth(), true, locale);
    },
    S: function(date) {
        return (0, $7c36d6f76aae5f22$export$5d04458e2a6c373e)(date.getSeconds());
    },
    U: function(date) {
        return date.getTime() / 1000;
    },
    W: function(date, _, options) {
        return options.getWeek(date);
    },
    Y: function(date) {
        return (0, $7c36d6f76aae5f22$export$5d04458e2a6c373e)(date.getFullYear(), 4);
    },
    d: function(date) {
        return (0, $7c36d6f76aae5f22$export$5d04458e2a6c373e)(date.getDate());
    },
    h: function(date) {
        return date.getHours() % 12 ? date.getHours() % 12 : 12;
    },
    i: function(date) {
        return (0, $7c36d6f76aae5f22$export$5d04458e2a6c373e)(date.getMinutes());
    },
    j: function(date) {
        return date.getDate();
    },
    l: function(date, locale) {
        return locale.weekdays.longhand[date.getDay()];
    },
    m: function(date) {
        return (0, $7c36d6f76aae5f22$export$5d04458e2a6c373e)(date.getMonth() + 1);
    },
    n: function(date) {
        return date.getMonth() + 1;
    },
    s: function(date) {
        return date.getSeconds();
    },
    u: function(date) {
        return date.getTime();
    },
    w: function(date) {
        return date.getDay();
    },
    y: function(date) {
        return String(date.getFullYear()).substring(2);
    }
};




var $68991a5a65b43fc7$export$ff1a0b75284ac636 = function(_a) {
    var _b = _a.config, config = _b === void 0 ? (0, $d0e6c103fdd72c14$export$ebe90cb607ad99e) : _b, _c = _a.l10n, l10n = _c === void 0 ? (0, $01c55b35388eeff4$export$33e6c23ebe2ee669) : _c, _d = _a.isMobile, isMobile = _d === void 0 ? false : _d;
    return function(dateObj, frmt, overrideLocale) {
        var locale = overrideLocale || l10n;
        if (config.formatDate !== undefined && !isMobile) return config.formatDate(dateObj, frmt, locale);
        return frmt.split("").map(function(c, i, arr) {
            return (0, $bc1b2819a5a95bf4$export$55069460464ca7a9)[c] && arr[i - 1] !== "\\" ? (0, $bc1b2819a5a95bf4$export$55069460464ca7a9)[c](dateObj, locale, config) : c !== "\\" ? c : "";
        }).join("");
    };
};
var $68991a5a65b43fc7$export$cfa2ef2687faeda2 = function(_a) {
    var _b = _a.config, config = _b === void 0 ? (0, $d0e6c103fdd72c14$export$ebe90cb607ad99e) : _b, _c = _a.l10n, l10n = _c === void 0 ? (0, $01c55b35388eeff4$export$33e6c23ebe2ee669) : _c;
    return function(date, givenFormat, timeless, customLocale) {
        if (date !== 0 && !date) return undefined;
        var locale = customLocale || l10n;
        var parsedDate;
        var dateOrig = date;
        if (date instanceof Date) parsedDate = new Date(date.getTime());
        else if (typeof date !== "string" && date.toFixed !== undefined) parsedDate = new Date(date);
        else if (typeof date === "string") {
            var format = givenFormat || (config || (0, $d0e6c103fdd72c14$export$ebe90cb607ad99e)).dateFormat;
            var datestr = String(date).trim();
            if (datestr === "today") {
                parsedDate = new Date();
                timeless = true;
            } else if (config && config.parseDate) parsedDate = config.parseDate(date, format);
            else if (/Z$/.test(datestr) || /GMT$/.test(datestr)) parsedDate = new Date(date);
            else {
                var matched = void 0, ops = [];
                for(var i = 0, matchIndex = 0, regexStr = ""; i < format.length; i++){
                    var token = format[i];
                    var isBackSlash = token === "\\";
                    var escaped = format[i - 1] === "\\" || isBackSlash;
                    if ((0, $bc1b2819a5a95bf4$export$f5a8dc72fbf63af5)[token] && !escaped) {
                        regexStr += (0, $bc1b2819a5a95bf4$export$f5a8dc72fbf63af5)[token];
                        var match = new RegExp(regexStr).exec(date);
                        if (match && (matched = true)) ops[token !== "Y" ? "push" : "unshift"]({
                            fn: (0, $bc1b2819a5a95bf4$export$9490b78b888a863f)[token],
                            val: match[++matchIndex]
                        });
                    } else if (!isBackSlash) regexStr += ".";
                }
                parsedDate = !config || !config.noCalendar ? new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0) : new Date(new Date().setHours(0, 0, 0, 0));
                ops.forEach(function(_a) {
                    var fn = _a.fn, val = _a.val;
                    return parsedDate = fn(parsedDate, val, locale) || parsedDate;
                });
                parsedDate = matched ? parsedDate : undefined;
            }
        }
        if (!(parsedDate instanceof Date && !isNaN(parsedDate.getTime()))) {
            config.errorHandler(new Error("Invalid date provided: " + dateOrig));
            return undefined;
        }
        if (timeless === true) parsedDate.setHours(0, 0, 0, 0);
        return parsedDate;
    };
};
function $68991a5a65b43fc7$export$c4c806e061935577(date1, date2, timeless) {
    if (timeless === void 0) timeless = true;
    if (timeless !== false) return new Date(date1.getTime()).setHours(0, 0, 0, 0) - new Date(date2.getTime()).setHours(0, 0, 0, 0);
    return date1.getTime() - date2.getTime();
}
function $68991a5a65b43fc7$export$15d252ed5f5f8636(date1, date2) {
    return 3600 * (date1.getHours() - date2.getHours()) + 60 * (date1.getMinutes() - date2.getMinutes()) + date1.getSeconds() - date2.getSeconds();
}
var $68991a5a65b43fc7$export$a4d69fb5f2026c35 = function(ts, ts1, ts2) {
    return ts > Math.min(ts1, ts2) && ts < Math.max(ts1, ts2);
};
var $68991a5a65b43fc7$export$9fafc166baa96839 = function(hours, minutes, seconds) {
    return hours * 3600 + minutes * 60 + seconds;
};
var $68991a5a65b43fc7$export$a4ce0def660bfe9e = function(secondsSinceMidnight) {
    var hours = Math.floor(secondsSinceMidnight / 3600), minutes = (secondsSinceMidnight - hours * 3600) / 60;
    return [
        hours,
        minutes,
        secondsSinceMidnight - hours * 3600 - minutes * 60
    ];
};
var $68991a5a65b43fc7$export$1f34108aa9eb96ab = {
    DAY: 86400000
};
function $68991a5a65b43fc7$export$6df0e87d3fffbd14(config) {
    var hours = config.defaultHour;
    var minutes = config.defaultMinute;
    var seconds = config.defaultSeconds;
    if (config.minDate !== undefined) {
        var minHour = config.minDate.getHours();
        var minMinutes = config.minDate.getMinutes();
        var minSeconds = config.minDate.getSeconds();
        if (hours < minHour) hours = minHour;
        if (hours === minHour && minutes < minMinutes) minutes = minMinutes;
        if (hours === minHour && minutes === minMinutes && seconds < minSeconds) seconds = config.minDate.getSeconds();
    }
    if (config.maxDate !== undefined) {
        var maxHr = config.maxDate.getHours();
        var maxMinutes = config.maxDate.getMinutes();
        hours = Math.min(hours, maxHr);
        if (hours === maxHr) minutes = Math.min(maxMinutes, minutes);
        if (hours === maxHr && minutes === maxMinutes) seconds = config.maxDate.getSeconds();
    }
    return {
        hours: hours,
        minutes: minutes,
        seconds: seconds
    };
}



"use strict";
if (typeof Object.assign !== "function") Object.assign = function(target) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (!target) throw TypeError("Cannot convert undefined or null to object");
    var _loop_1 = function(source) {
        if (source) Object.keys(source).forEach(function(key) {
            return target[key] = source[key];
        });
    };
    for(var _a = 0, args_1 = args; _a < args_1.length; _a++){
        var source = args_1[_a];
        _loop_1(source);
    }
    return target;
};


var $f56a17c2fb2ad30e$var$__assign = undefined && undefined.__assign || function() {
    $f56a17c2fb2ad30e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f56a17c2fb2ad30e$var$__assign.apply(this, arguments);
};
var $f56a17c2fb2ad30e$var$__spreadArrays = undefined && undefined.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
var $f56a17c2fb2ad30e$var$DEBOUNCED_CHANGE_MS = 300;
function $f56a17c2fb2ad30e$var$FlatpickrInstance(element, instanceConfig) {
    var self = {
        config: $f56a17c2fb2ad30e$var$__assign($f56a17c2fb2ad30e$var$__assign({}, (0, $d0e6c103fdd72c14$export$ebe90cb607ad99e)), $f56a17c2fb2ad30e$var$flatpickr.defaultConfig),
        l10n: (0, $01c55b35388eeff4$export$2e2bcd8739ae039)
    };
    self.parseDate = (0, $68991a5a65b43fc7$export$cfa2ef2687faeda2)({
        config: self.config,
        l10n: self.l10n
    });
    self._handlers = [];
    self.pluginElements = [];
    self.loadedPlugins = [];
    self._bind = bind;
    self._setHoursFromDate = setHoursFromDate;
    self._positionCalendar = positionCalendar;
    self.changeMonth = changeMonth;
    self.changeYear = changeYear;
    self.clear = clear;
    self.close = close;
    self.onMouseOver = onMouseOver;
    self._createElement = (0, $46627959f4a6cf8e$export$c8a8987d4410bf2d);
    self.createDay = createDay;
    self.destroy = destroy;
    self.isEnabled = isEnabled;
    self.jumpToDate = jumpToDate;
    self.updateValue = updateValue;
    self.open = open;
    self.redraw = redraw;
    self.set = set;
    self.setDate = setDate;
    self.toggle = toggle;
    function setupHelperFunctions() {
        self.utils = {
            getDaysInMonth: function(month, yr) {
                if (month === void 0) month = self.currentMonth;
                if (yr === void 0) yr = self.currentYear;
                if (month === 1 && (yr % 4 === 0 && yr % 100 !== 0 || yr % 400 === 0)) return 29;
                return self.l10n.daysInMonth[month];
            }
        };
    }
    function init() {
        self.element = self.input = element;
        self.isOpen = false;
        parseConfig();
        setupLocale();
        setupInputs();
        setupDates();
        setupHelperFunctions();
        if (!self.isMobile) build();
        bindEvents();
        if (self.selectedDates.length || self.config.noCalendar) {
            if (self.config.enableTime) setHoursFromDate(self.config.noCalendar ? self.latestSelectedDateObj : undefined);
            updateValue(false);
        }
        setCalendarWidth();
        var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        if (!self.isMobile && isSafari) positionCalendar();
        triggerEvent("onReady");
    }
    function getClosestActiveElement() {
        var _a;
        return ((_a = self.calendarContainer) === null || _a === void 0 ? void 0 : _a.getRootNode()).activeElement || document.activeElement;
    }
    function bindToInstance(fn) {
        return fn.bind(self);
    }
    function setCalendarWidth() {
        var config = self.config;
        if (config.weekNumbers === false && config.showMonths === 1) return;
        else if (config.noCalendar !== true) window.requestAnimationFrame(function() {
            if (self.calendarContainer !== undefined) {
                self.calendarContainer.style.visibility = "hidden";
                self.calendarContainer.style.display = "block";
            }
            if (self.daysContainer !== undefined) {
                var daysWidth = (self.days.offsetWidth + 1) * config.showMonths;
                self.daysContainer.style.width = daysWidth + "px";
                self.calendarContainer.style.width = daysWidth + (self.weekWrapper !== undefined ? self.weekWrapper.offsetWidth : 0) + "px";
                self.calendarContainer.style.removeProperty("visibility");
                self.calendarContainer.style.removeProperty("display");
            }
        });
    }
    function updateTime(e) {
        if (self.selectedDates.length === 0) {
            var defaultDate = self.config.minDate === undefined || (0, $68991a5a65b43fc7$export$c4c806e061935577)(new Date(), self.config.minDate) >= 0 ? new Date() : new Date(self.config.minDate.getTime());
            var defaults = (0, $68991a5a65b43fc7$export$6df0e87d3fffbd14)(self.config);
            defaultDate.setHours(defaults.hours, defaults.minutes, defaults.seconds, defaultDate.getMilliseconds());
            self.selectedDates = [
                defaultDate
            ];
            self.latestSelectedDateObj = defaultDate;
        }
        if (e !== undefined && e.type !== "blur") timeWrapper(e);
        var prevValue = self._input.value;
        setHoursFromInputs();
        updateValue();
        if (self._input.value !== prevValue) self._debouncedChange();
    }
    function ampm2military(hour, amPM) {
        return hour % 12 + 12 * (0, $7c36d6f76aae5f22$export$7d260a2a5f8bc19e)(amPM === self.l10n.amPM[1]);
    }
    function military2ampm(hour) {
        switch(hour % 24){
            case 0:
            case 12:
                return 12;
            default:
                return hour % 12;
        }
    }
    function setHoursFromInputs() {
        if (self.hourElement === undefined || self.minuteElement === undefined) return;
        var hours = (parseInt(self.hourElement.value.slice(-2), 10) || 0) % 24, minutes = (parseInt(self.minuteElement.value, 10) || 0) % 60, seconds = self.secondElement !== undefined ? (parseInt(self.secondElement.value, 10) || 0) % 60 : 0;
        if (self.amPM !== undefined) hours = ampm2military(hours, self.amPM.textContent);
        var limitMinHours = self.config.minTime !== undefined || self.config.minDate && self.minDateHasTime && self.latestSelectedDateObj && (0, $68991a5a65b43fc7$export$c4c806e061935577)(self.latestSelectedDateObj, self.config.minDate, true) === 0;
        var limitMaxHours = self.config.maxTime !== undefined || self.config.maxDate && self.maxDateHasTime && self.latestSelectedDateObj && (0, $68991a5a65b43fc7$export$c4c806e061935577)(self.latestSelectedDateObj, self.config.maxDate, true) === 0;
        if (self.config.maxTime !== undefined && self.config.minTime !== undefined && self.config.minTime > self.config.maxTime) {
            var minBound = (0, $68991a5a65b43fc7$export$9fafc166baa96839)(self.config.minTime.getHours(), self.config.minTime.getMinutes(), self.config.minTime.getSeconds());
            var maxBound = (0, $68991a5a65b43fc7$export$9fafc166baa96839)(self.config.maxTime.getHours(), self.config.maxTime.getMinutes(), self.config.maxTime.getSeconds());
            var currentTime = (0, $68991a5a65b43fc7$export$9fafc166baa96839)(hours, minutes, seconds);
            if (currentTime > maxBound && currentTime < minBound) {
                var result = (0, $68991a5a65b43fc7$export$a4ce0def660bfe9e)(minBound);
                hours = result[0];
                minutes = result[1];
                seconds = result[2];
            }
        } else {
            if (limitMaxHours) {
                var maxTime = self.config.maxTime !== undefined ? self.config.maxTime : self.config.maxDate;
                hours = Math.min(hours, maxTime.getHours());
                if (hours === maxTime.getHours()) minutes = Math.min(minutes, maxTime.getMinutes());
                if (minutes === maxTime.getMinutes()) seconds = Math.min(seconds, maxTime.getSeconds());
            }
            if (limitMinHours) {
                var minTime = self.config.minTime !== undefined ? self.config.minTime : self.config.minDate;
                hours = Math.max(hours, minTime.getHours());
                if (hours === minTime.getHours() && minutes < minTime.getMinutes()) minutes = minTime.getMinutes();
                if (minutes === minTime.getMinutes()) seconds = Math.max(seconds, minTime.getSeconds());
            }
        }
        setHours(hours, minutes, seconds);
    }
    function setHoursFromDate(dateObj) {
        var date = dateObj || self.latestSelectedDateObj;
        if (date && date instanceof Date) setHours(date.getHours(), date.getMinutes(), date.getSeconds());
    }
    function setHours(hours, minutes, seconds) {
        if (self.latestSelectedDateObj !== undefined) self.latestSelectedDateObj.setHours(hours % 24, minutes, seconds || 0, 0);
        if (!self.hourElement || !self.minuteElement || self.isMobile) return;
        self.hourElement.value = (0, $7c36d6f76aae5f22$export$5d04458e2a6c373e)(!self.config.time_24hr ? (12 + hours) % 12 + 12 * (0, $7c36d6f76aae5f22$export$7d260a2a5f8bc19e)(hours % 12 === 0) : hours);
        self.minuteElement.value = (0, $7c36d6f76aae5f22$export$5d04458e2a6c373e)(minutes);
        if (self.amPM !== undefined) self.amPM.textContent = self.l10n.amPM[(0, $7c36d6f76aae5f22$export$7d260a2a5f8bc19e)(hours >= 12)];
        if (self.secondElement !== undefined) self.secondElement.value = (0, $7c36d6f76aae5f22$export$5d04458e2a6c373e)(seconds);
    }
    function onYearInput(event) {
        var eventTarget = (0, $46627959f4a6cf8e$export$e58f029f0fbfdb29)(event);
        var year = parseInt(eventTarget.value) + (event.delta || 0);
        if (year / 1000 > 1 || event.key === "Enter" && !/[^\d]/.test(year.toString())) changeYear(year);
    }
    function bind(element, event, handler, options) {
        if (event instanceof Array) return event.forEach(function(ev) {
            return bind(element, ev, handler, options);
        });
        if (element instanceof Array) return element.forEach(function(el) {
            return bind(el, event, handler, options);
        });
        element.addEventListener(event, handler, options);
        self._handlers.push({
            remove: function() {
                return element.removeEventListener(event, handler, options);
            }
        });
    }
    function triggerChange() {
        triggerEvent("onChange");
    }
    function bindEvents() {
        if (self.config.wrap) [
            "open",
            "close",
            "toggle",
            "clear"
        ].forEach(function(evt) {
            Array.prototype.forEach.call(self.element.querySelectorAll("[data-" + evt + "]"), function(el) {
                return bind(el, "click", self[evt]);
            });
        });
        if (self.isMobile) {
            setupMobile();
            return;
        }
        var debouncedResize = (0, $7c36d6f76aae5f22$export$61fc7d43ac8f84b0)(onResize, 50);
        self._debouncedChange = (0, $7c36d6f76aae5f22$export$61fc7d43ac8f84b0)(triggerChange, $f56a17c2fb2ad30e$var$DEBOUNCED_CHANGE_MS);
        if (self.daysContainer && !/iPhone|iPad|iPod/i.test(navigator.userAgent)) bind(self.daysContainer, "mouseover", function(e) {
            if (self.config.mode === "range") onMouseOver((0, $46627959f4a6cf8e$export$e58f029f0fbfdb29)(e));
        });
        bind(self._input, "keydown", onKeyDown);
        if (self.calendarContainer !== undefined) bind(self.calendarContainer, "keydown", onKeyDown);
        if (!self.config.inline && !self.config.static) bind(window, "resize", debouncedResize);
        if (window.ontouchstart !== undefined) bind(window.document, "touchstart", documentClick);
        else bind(window.document, "mousedown", documentClick);
        bind(window.document, "focus", documentClick, {
            capture: true
        });
        if (self.config.clickOpens === true) {
            bind(self._input, "focus", self.open);
            bind(self._input, "click", self.open);
        }
        if (self.daysContainer !== undefined) {
            bind(self.monthNav, "click", onMonthNavClick);
            bind(self.monthNav, [
                "keyup",
                "increment"
            ], onYearInput);
            bind(self.daysContainer, "click", selectDate);
        }
        if (self.timeContainer !== undefined && self.minuteElement !== undefined && self.hourElement !== undefined) {
            var selText = function(e) {
                return (0, $46627959f4a6cf8e$export$e58f029f0fbfdb29)(e).select();
            };
            bind(self.timeContainer, [
                "increment"
            ], updateTime);
            bind(self.timeContainer, "blur", updateTime, {
                capture: true
            });
            bind(self.timeContainer, "click", timeIncrement);
            bind([
                self.hourElement,
                self.minuteElement
            ], [
                "focus",
                "click"
            ], selText);
            if (self.secondElement !== undefined) bind(self.secondElement, "focus", function() {
                return self.secondElement && self.secondElement.select();
            });
            if (self.amPM !== undefined) bind(self.amPM, "click", function(e) {
                updateTime(e);
            });
        }
        if (self.config.allowInput) bind(self._input, "blur", onBlur);
    }
    function jumpToDate(jumpDate, triggerChange) {
        var jumpTo = jumpDate !== undefined ? self.parseDate(jumpDate) : self.latestSelectedDateObj || (self.config.minDate && self.config.minDate > self.now ? self.config.minDate : self.config.maxDate && self.config.maxDate < self.now ? self.config.maxDate : self.now);
        var oldYear = self.currentYear;
        var oldMonth = self.currentMonth;
        try {
            if (jumpTo !== undefined) {
                self.currentYear = jumpTo.getFullYear();
                self.currentMonth = jumpTo.getMonth();
            }
        } catch (e) {
            e.message = "Invalid date supplied: " + jumpTo;
            self.config.errorHandler(e);
        }
        if (triggerChange && self.currentYear !== oldYear) {
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
        if (triggerChange && (self.currentYear !== oldYear || self.currentMonth !== oldMonth)) triggerEvent("onMonthChange");
        self.redraw();
    }
    function timeIncrement(e) {
        var eventTarget = (0, $46627959f4a6cf8e$export$e58f029f0fbfdb29)(e);
        if (~eventTarget.className.indexOf("arrow")) incrementNumInput(e, eventTarget.classList.contains("arrowUp") ? 1 : -1);
    }
    function incrementNumInput(e, delta, inputElem) {
        var target = e && (0, $46627959f4a6cf8e$export$e58f029f0fbfdb29)(e);
        var input = inputElem || target && target.parentNode && target.parentNode.firstChild;
        var event = createEvent("increment");
        event.delta = delta;
        input && input.dispatchEvent(event);
    }
    function build() {
        var fragment = window.document.createDocumentFragment();
        self.calendarContainer = (0, $46627959f4a6cf8e$export$c8a8987d4410bf2d)("div", "flatpickr-calendar");
        self.calendarContainer.tabIndex = -1;
        if (!self.config.noCalendar) {
            fragment.appendChild(buildMonthNav());
            self.innerContainer = (0, $46627959f4a6cf8e$export$c8a8987d4410bf2d)("div", "flatpickr-innerContainer");
            if (self.config.weekNumbers) {
                var _a = buildWeeks(), weekWrapper = _a.weekWrapper, weekNumbers = _a.weekNumbers;
                self.innerContainer.appendChild(weekWrapper);
                self.weekNumbers = weekNumbers;
                self.weekWrapper = weekWrapper;
            }
            self.rContainer = (0, $46627959f4a6cf8e$export$c8a8987d4410bf2d)("div", "flatpickr-rContainer");
            self.rContainer.appendChild(buildWeekdays());
            if (!self.daysContainer) {
                self.daysContainer = (0, $46627959f4a6cf8e$export$c8a8987d4410bf2d)("div", "flatpickr-days");
                self.daysContainer.tabIndex = -1;
            }
            buildDays();
            self.rContainer.appendChild(self.daysContainer);
            self.innerContainer.appendChild(self.rContainer);
            fragment.appendChild(self.innerContainer);
        }
        if (self.config.enableTime) fragment.appendChild(buildTime());
        (0, $46627959f4a6cf8e$export$4a80062ca50b57c7)(self.calendarContainer, "rangeMode", self.config.mode === "range");
        (0, $46627959f4a6cf8e$export$4a80062ca50b57c7)(self.calendarContainer, "animate", self.config.animate === true);
        (0, $46627959f4a6cf8e$export$4a80062ca50b57c7)(self.calendarContainer, "multiMonth", self.config.showMonths > 1);
        self.calendarContainer.appendChild(fragment);
        var customAppend = self.config.appendTo !== undefined && self.config.appendTo.nodeType !== undefined;
        if (self.config.inline || self.config.static) {
            self.calendarContainer.classList.add(self.config.inline ? "inline" : "static");
            if (self.config.inline) {
                if (!customAppend && self.element.parentNode) self.element.parentNode.insertBefore(self.calendarContainer, self._input.nextSibling);
                else if (self.config.appendTo !== undefined) self.config.appendTo.appendChild(self.calendarContainer);
            }
            if (self.config.static) {
                var wrapper = (0, $46627959f4a6cf8e$export$c8a8987d4410bf2d)("div", "flatpickr-wrapper");
                if (self.element.parentNode) self.element.parentNode.insertBefore(wrapper, self.element);
                wrapper.appendChild(self.element);
                if (self.altInput) wrapper.appendChild(self.altInput);
                wrapper.appendChild(self.calendarContainer);
            }
        }
        if (!self.config.static && !self.config.inline) (self.config.appendTo !== undefined ? self.config.appendTo : window.document.body).appendChild(self.calendarContainer);
    }
    function createDay(className, date, _dayNumber, i) {
        var dateIsEnabled = isEnabled(date, true), dayElement = (0, $46627959f4a6cf8e$export$c8a8987d4410bf2d)("span", className, date.getDate().toString());
        dayElement.dateObj = date;
        dayElement.$i = i;
        dayElement.setAttribute("aria-label", self.formatDate(date, self.config.ariaDateFormat));
        if (className.indexOf("hidden") === -1 && (0, $68991a5a65b43fc7$export$c4c806e061935577)(date, self.now) === 0) {
            self.todayDateElem = dayElement;
            dayElement.classList.add("today");
            dayElement.setAttribute("aria-current", "date");
        }
        if (dateIsEnabled) {
            dayElement.tabIndex = -1;
            if (isDateSelected(date)) {
                dayElement.classList.add("selected");
                self.selectedDateElem = dayElement;
                if (self.config.mode === "range") {
                    (0, $46627959f4a6cf8e$export$4a80062ca50b57c7)(dayElement, "startRange", self.selectedDates[0] && (0, $68991a5a65b43fc7$export$c4c806e061935577)(date, self.selectedDates[0], true) === 0);
                    (0, $46627959f4a6cf8e$export$4a80062ca50b57c7)(dayElement, "endRange", self.selectedDates[1] && (0, $68991a5a65b43fc7$export$c4c806e061935577)(date, self.selectedDates[1], true) === 0);
                    if (className === "nextMonthDay") dayElement.classList.add("inRange");
                }
            }
        } else dayElement.classList.add("flatpickr-disabled");
        if (self.config.mode === "range") {
            if (isDateInRange(date) && !isDateSelected(date)) dayElement.classList.add("inRange");
        }
        if (self.weekNumbers && self.config.showMonths === 1 && className !== "prevMonthDay" && i % 7 === 6) self.weekNumbers.insertAdjacentHTML("beforeend", "<span class='flatpickr-day'>" + self.config.getWeek(date) + "</span>");
        triggerEvent("onDayCreate", dayElement);
        return dayElement;
    }
    function focusOnDayElem(targetNode) {
        targetNode.focus();
        if (self.config.mode === "range") onMouseOver(targetNode);
    }
    function getFirstAvailableDay(delta) {
        var startMonth = delta > 0 ? 0 : self.config.showMonths - 1;
        var endMonth = delta > 0 ? self.config.showMonths : -1;
        for(var m = startMonth; m != endMonth; m += delta){
            var month = self.daysContainer.children[m];
            var startIndex = delta > 0 ? 0 : month.children.length - 1;
            var endIndex = delta > 0 ? month.children.length : -1;
            for(var i = startIndex; i != endIndex; i += delta){
                var c = month.children[i];
                if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj)) return c;
            }
        }
        return undefined;
    }
    function getNextAvailableDay(current, delta) {
        var givenMonth = current.className.indexOf("Month") === -1 ? current.dateObj.getMonth() : self.currentMonth;
        var endMonth = delta > 0 ? self.config.showMonths : -1;
        var loopDelta = delta > 0 ? 1 : -1;
        for(var m = givenMonth - self.currentMonth; m != endMonth; m += loopDelta){
            var month = self.daysContainer.children[m];
            var startIndex = givenMonth - self.currentMonth === m ? current.$i + delta : delta < 0 ? month.children.length - 1 : 0;
            var numMonthDays = month.children.length;
            for(var i = startIndex; i >= 0 && i < numMonthDays && i != (delta > 0 ? numMonthDays : -1); i += loopDelta){
                var c = month.children[i];
                if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj) && Math.abs(current.$i - i) >= Math.abs(delta)) return focusOnDayElem(c);
            }
        }
        self.changeMonth(loopDelta);
        focusOnDay(getFirstAvailableDay(loopDelta), 0);
        return undefined;
    }
    function focusOnDay(current, offset) {
        var activeElement = getClosestActiveElement();
        var dayFocused = isInView(activeElement || document.body);
        var startElem = current !== undefined ? current : dayFocused ? activeElement : self.selectedDateElem !== undefined && isInView(self.selectedDateElem) ? self.selectedDateElem : self.todayDateElem !== undefined && isInView(self.todayDateElem) ? self.todayDateElem : getFirstAvailableDay(offset > 0 ? 1 : -1);
        if (startElem === undefined) self._input.focus();
        else if (!dayFocused) focusOnDayElem(startElem);
        else getNextAvailableDay(startElem, offset);
    }
    function buildMonthDays(year, month) {
        var firstOfMonth = (new Date(year, month, 1).getDay() - self.l10n.firstDayOfWeek + 7) % 7;
        var prevMonthDays = self.utils.getDaysInMonth((month - 1 + 12) % 12, year);
        var daysInMonth = self.utils.getDaysInMonth(month, year), days = window.document.createDocumentFragment(), isMultiMonth = self.config.showMonths > 1, prevMonthDayClass = isMultiMonth ? "prevMonthDay hidden" : "prevMonthDay", nextMonthDayClass = isMultiMonth ? "nextMonthDay hidden" : "nextMonthDay";
        var dayNumber = prevMonthDays + 1 - firstOfMonth, dayIndex = 0;
        for(; dayNumber <= prevMonthDays; dayNumber++, dayIndex++)days.appendChild(createDay("flatpickr-day " + prevMonthDayClass, new Date(year, month - 1, dayNumber), dayNumber, dayIndex));
        for(dayNumber = 1; dayNumber <= daysInMonth; dayNumber++, dayIndex++)days.appendChild(createDay("flatpickr-day", new Date(year, month, dayNumber), dayNumber, dayIndex));
        for(var dayNum = daysInMonth + 1; dayNum <= 42 - firstOfMonth && (self.config.showMonths === 1 || dayIndex % 7 !== 0); dayNum++, dayIndex++)days.appendChild(createDay("flatpickr-day " + nextMonthDayClass, new Date(year, month + 1, dayNum % daysInMonth), dayNum, dayIndex));
        var dayContainer = (0, $46627959f4a6cf8e$export$c8a8987d4410bf2d)("div", "dayContainer");
        dayContainer.appendChild(days);
        return dayContainer;
    }
    function buildDays() {
        if (self.daysContainer === undefined) return;
        (0, $46627959f4a6cf8e$export$51cfe97d637c237c)(self.daysContainer);
        if (self.weekNumbers) (0, $46627959f4a6cf8e$export$51cfe97d637c237c)(self.weekNumbers);
        var frag = document.createDocumentFragment();
        for(var i = 0; i < self.config.showMonths; i++){
            var d = new Date(self.currentYear, self.currentMonth, 1);
            d.setMonth(self.currentMonth + i);
            frag.appendChild(buildMonthDays(d.getFullYear(), d.getMonth()));
        }
        self.daysContainer.appendChild(frag);
        self.days = self.daysContainer.firstChild;
        if (self.config.mode === "range" && self.selectedDates.length === 1) onMouseOver();
    }
    function buildMonthSwitch() {
        if (self.config.showMonths > 1 || self.config.monthSelectorType !== "dropdown") return;
        var shouldBuildMonth = function(month) {
            if (self.config.minDate !== undefined && self.currentYear === self.config.minDate.getFullYear() && month < self.config.minDate.getMonth()) return false;
            return !(self.config.maxDate !== undefined && self.currentYear === self.config.maxDate.getFullYear() && month > self.config.maxDate.getMonth());
        };
        self.monthsDropdownContainer.tabIndex = -1;
        self.monthsDropdownContainer.innerHTML = "";
        for(var i = 0; i < 12; i++){
            if (!shouldBuildMonth(i)) continue;
            var month = (0, $46627959f4a6cf8e$export$c8a8987d4410bf2d)("option", "flatpickr-monthDropdown-month");
            month.value = new Date(self.currentYear, i).getMonth().toString();
            month.textContent = (0, $bc1b2819a5a95bf4$export$27a2dd9af757e89c)(i, self.config.shorthandCurrentMonth, self.l10n);
            month.tabIndex = -1;
            if (self.currentMonth === i) month.selected = true;
            self.monthsDropdownContainer.appendChild(month);
        }
    }
    function buildMonth() {
        var container = (0, $46627959f4a6cf8e$export$c8a8987d4410bf2d)("div", "flatpickr-month");
        var monthNavFragment = window.document.createDocumentFragment();
        var monthElement;
        if (self.config.showMonths > 1 || self.config.monthSelectorType === "static") monthElement = (0, $46627959f4a6cf8e$export$c8a8987d4410bf2d)("span", "cur-month");
        else {
            self.monthsDropdownContainer = (0, $46627959f4a6cf8e$export$c8a8987d4410bf2d)("select", "flatpickr-monthDropdown-months");
            self.monthsDropdownContainer.setAttribute("aria-label", self.l10n.monthAriaLabel);
            bind(self.monthsDropdownContainer, "change", function(e) {
                var target = (0, $46627959f4a6cf8e$export$e58f029f0fbfdb29)(e);
                var selectedMonth = parseInt(target.value, 10);
                self.changeMonth(selectedMonth - self.currentMonth);
                triggerEvent("onMonthChange");
            });
            buildMonthSwitch();
            monthElement = self.monthsDropdownContainer;
        }
        var yearInput = (0, $46627959f4a6cf8e$export$afe9d610a3284048)("cur-year", {
            tabindex: "-1"
        });
        var yearElement = yearInput.getElementsByTagName("input")[0];
        yearElement.setAttribute("aria-label", self.l10n.yearAriaLabel);
        if (self.config.minDate) yearElement.setAttribute("min", self.config.minDate.getFullYear().toString());
        if (self.config.maxDate) {
            yearElement.setAttribute("max", self.config.maxDate.getFullYear().toString());
            yearElement.disabled = !!self.config.minDate && self.config.minDate.getFullYear() === self.config.maxDate.getFullYear();
        }
        var currentMonth = (0, $46627959f4a6cf8e$export$c8a8987d4410bf2d)("div", "flatpickr-current-month");
        currentMonth.appendChild(monthElement);
        currentMonth.appendChild(yearInput);
        monthNavFragment.appendChild(currentMonth);
        container.appendChild(monthNavFragment);
        return {
            container: container,
            yearElement: yearElement,
            monthElement: monthElement
        };
    }
    function buildMonths() {
        (0, $46627959f4a6cf8e$export$51cfe97d637c237c)(self.monthNav);
        self.monthNav.appendChild(self.prevMonthNav);
        if (self.config.showMonths) {
            self.yearElements = [];
            self.monthElements = [];
        }
        for(var m = self.config.showMonths; m--;){
            var month = buildMonth();
            self.yearElements.push(month.yearElement);
            self.monthElements.push(month.monthElement);
            self.monthNav.appendChild(month.container);
        }
        self.monthNav.appendChild(self.nextMonthNav);
    }
    function buildMonthNav() {
        self.monthNav = (0, $46627959f4a6cf8e$export$c8a8987d4410bf2d)("div", "flatpickr-months");
        self.yearElements = [];
        self.monthElements = [];
        self.prevMonthNav = (0, $46627959f4a6cf8e$export$c8a8987d4410bf2d)("span", "flatpickr-prev-month");
        self.prevMonthNav.innerHTML = self.config.prevArrow;
        self.nextMonthNav = (0, $46627959f4a6cf8e$export$c8a8987d4410bf2d)("span", "flatpickr-next-month");
        self.nextMonthNav.innerHTML = self.config.nextArrow;
        buildMonths();
        Object.defineProperty(self, "_hidePrevMonthArrow", {
            get: function() {
                return self.__hidePrevMonthArrow;
            },
            set: function(bool) {
                if (self.__hidePrevMonthArrow !== bool) {
                    (0, $46627959f4a6cf8e$export$4a80062ca50b57c7)(self.prevMonthNav, "flatpickr-disabled", bool);
                    self.__hidePrevMonthArrow = bool;
                }
            }
        });
        Object.defineProperty(self, "_hideNextMonthArrow", {
            get: function() {
                return self.__hideNextMonthArrow;
            },
            set: function(bool) {
                if (self.__hideNextMonthArrow !== bool) {
                    (0, $46627959f4a6cf8e$export$4a80062ca50b57c7)(self.nextMonthNav, "flatpickr-disabled", bool);
                    self.__hideNextMonthArrow = bool;
                }
            }
        });
        self.currentYearElement = self.yearElements[0];
        updateNavigationCurrentMonth();
        return self.monthNav;
    }
    function buildTime() {
        self.calendarContainer.classList.add("hasTime");
        if (self.config.noCalendar) self.calendarContainer.classList.add("noCalendar");
        var defaults = (0, $68991a5a65b43fc7$export$6df0e87d3fffbd14)(self.config);
        self.timeContainer = (0, $46627959f4a6cf8e$export$c8a8987d4410bf2d)("div", "flatpickr-time");
        self.timeContainer.tabIndex = -1;
        var separator = (0, $46627959f4a6cf8e$export$c8a8987d4410bf2d)("span", "flatpickr-time-separator", ":");
        var hourInput = (0, $46627959f4a6cf8e$export$afe9d610a3284048)("flatpickr-hour", {
            "aria-label": self.l10n.hourAriaLabel
        });
        self.hourElement = hourInput.getElementsByTagName("input")[0];
        var minuteInput = (0, $46627959f4a6cf8e$export$afe9d610a3284048)("flatpickr-minute", {
            "aria-label": self.l10n.minuteAriaLabel
        });
        self.minuteElement = minuteInput.getElementsByTagName("input")[0];
        self.hourElement.tabIndex = self.minuteElement.tabIndex = -1;
        self.hourElement.value = (0, $7c36d6f76aae5f22$export$5d04458e2a6c373e)(self.latestSelectedDateObj ? self.latestSelectedDateObj.getHours() : self.config.time_24hr ? defaults.hours : military2ampm(defaults.hours));
        self.minuteElement.value = (0, $7c36d6f76aae5f22$export$5d04458e2a6c373e)(self.latestSelectedDateObj ? self.latestSelectedDateObj.getMinutes() : defaults.minutes);
        self.hourElement.setAttribute("step", self.config.hourIncrement.toString());
        self.minuteElement.setAttribute("step", self.config.minuteIncrement.toString());
        self.hourElement.setAttribute("min", self.config.time_24hr ? "0" : "1");
        self.hourElement.setAttribute("max", self.config.time_24hr ? "23" : "12");
        self.hourElement.setAttribute("maxlength", "2");
        self.minuteElement.setAttribute("min", "0");
        self.minuteElement.setAttribute("max", "59");
        self.minuteElement.setAttribute("maxlength", "2");
        self.timeContainer.appendChild(hourInput);
        self.timeContainer.appendChild(separator);
        self.timeContainer.appendChild(minuteInput);
        if (self.config.time_24hr) self.timeContainer.classList.add("time24hr");
        if (self.config.enableSeconds) {
            self.timeContainer.classList.add("hasSeconds");
            var secondInput = (0, $46627959f4a6cf8e$export$afe9d610a3284048)("flatpickr-second");
            self.secondElement = secondInput.getElementsByTagName("input")[0];
            self.secondElement.value = (0, $7c36d6f76aae5f22$export$5d04458e2a6c373e)(self.latestSelectedDateObj ? self.latestSelectedDateObj.getSeconds() : defaults.seconds);
            self.secondElement.setAttribute("step", self.minuteElement.getAttribute("step"));
            self.secondElement.setAttribute("min", "0");
            self.secondElement.setAttribute("max", "59");
            self.secondElement.setAttribute("maxlength", "2");
            self.timeContainer.appendChild((0, $46627959f4a6cf8e$export$c8a8987d4410bf2d)("span", "flatpickr-time-separator", ":"));
            self.timeContainer.appendChild(secondInput);
        }
        if (!self.config.time_24hr) {
            self.amPM = (0, $46627959f4a6cf8e$export$c8a8987d4410bf2d)("span", "flatpickr-am-pm", self.l10n.amPM[(0, $7c36d6f76aae5f22$export$7d260a2a5f8bc19e)((self.latestSelectedDateObj ? self.hourElement.value : self.config.defaultHour) > 11)]);
            self.amPM.title = self.l10n.toggleTitle;
            self.amPM.tabIndex = -1;
            self.timeContainer.appendChild(self.amPM);
        }
        return self.timeContainer;
    }
    function buildWeekdays() {
        if (!self.weekdayContainer) self.weekdayContainer = (0, $46627959f4a6cf8e$export$c8a8987d4410bf2d)("div", "flatpickr-weekdays");
        else (0, $46627959f4a6cf8e$export$51cfe97d637c237c)(self.weekdayContainer);
        for(var i = self.config.showMonths; i--;){
            var container = (0, $46627959f4a6cf8e$export$c8a8987d4410bf2d)("div", "flatpickr-weekdaycontainer");
            self.weekdayContainer.appendChild(container);
        }
        updateWeekdays();
        return self.weekdayContainer;
    }
    function updateWeekdays() {
        if (!self.weekdayContainer) return;
        var firstDayOfWeek = self.l10n.firstDayOfWeek;
        var weekdays = $f56a17c2fb2ad30e$var$__spreadArrays(self.l10n.weekdays.shorthand);
        if (firstDayOfWeek > 0 && firstDayOfWeek < weekdays.length) weekdays = $f56a17c2fb2ad30e$var$__spreadArrays(weekdays.splice(firstDayOfWeek, weekdays.length), weekdays.splice(0, firstDayOfWeek));
        for(var i = self.config.showMonths; i--;)self.weekdayContainer.children[i].innerHTML = "\n      <span class='flatpickr-weekday'>\n        " + weekdays.join("</span><span class='flatpickr-weekday'>") + "\n      </span>\n      ";
    }
    function buildWeeks() {
        self.calendarContainer.classList.add("hasWeeks");
        var weekWrapper = (0, $46627959f4a6cf8e$export$c8a8987d4410bf2d)("div", "flatpickr-weekwrapper");
        weekWrapper.appendChild((0, $46627959f4a6cf8e$export$c8a8987d4410bf2d)("span", "flatpickr-weekday", self.l10n.weekAbbreviation));
        var weekNumbers = (0, $46627959f4a6cf8e$export$c8a8987d4410bf2d)("div", "flatpickr-weeks");
        weekWrapper.appendChild(weekNumbers);
        return {
            weekWrapper: weekWrapper,
            weekNumbers: weekNumbers
        };
    }
    function changeMonth(value, isOffset) {
        if (isOffset === void 0) isOffset = true;
        var delta = isOffset ? value : value - self.currentMonth;
        if (delta < 0 && self._hidePrevMonthArrow === true || delta > 0 && self._hideNextMonthArrow === true) return;
        self.currentMonth += delta;
        if (self.currentMonth < 0 || self.currentMonth > 11) {
            self.currentYear += self.currentMonth > 11 ? 1 : -1;
            self.currentMonth = (self.currentMonth + 12) % 12;
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
        buildDays();
        triggerEvent("onMonthChange");
        updateNavigationCurrentMonth();
    }
    function clear(triggerChangeEvent, toInitial) {
        if (triggerChangeEvent === void 0) triggerChangeEvent = true;
        if (toInitial === void 0) toInitial = true;
        self.input.value = "";
        if (self.altInput !== undefined) self.altInput.value = "";
        if (self.mobileInput !== undefined) self.mobileInput.value = "";
        self.selectedDates = [];
        self.latestSelectedDateObj = undefined;
        if (toInitial === true) {
            self.currentYear = self._initialDate.getFullYear();
            self.currentMonth = self._initialDate.getMonth();
        }
        if (self.config.enableTime === true) {
            var _a = (0, $68991a5a65b43fc7$export$6df0e87d3fffbd14)(self.config), hours = _a.hours, minutes = _a.minutes, seconds = _a.seconds;
            setHours(hours, minutes, seconds);
        }
        self.redraw();
        if (triggerChangeEvent) triggerEvent("onChange");
    }
    function close() {
        self.isOpen = false;
        if (!self.isMobile) {
            if (self.calendarContainer !== undefined) self.calendarContainer.classList.remove("open");
            if (self._input !== undefined) self._input.classList.remove("active");
        }
        triggerEvent("onClose");
    }
    function destroy() {
        if (self.config !== undefined) triggerEvent("onDestroy");
        for(var i = self._handlers.length; i--;)self._handlers[i].remove();
        self._handlers = [];
        if (self.mobileInput) {
            if (self.mobileInput.parentNode) self.mobileInput.parentNode.removeChild(self.mobileInput);
            self.mobileInput = undefined;
        } else if (self.calendarContainer && self.calendarContainer.parentNode) {
            if (self.config.static && self.calendarContainer.parentNode) {
                var wrapper = self.calendarContainer.parentNode;
                wrapper.lastChild && wrapper.removeChild(wrapper.lastChild);
                if (wrapper.parentNode) {
                    while(wrapper.firstChild)wrapper.parentNode.insertBefore(wrapper.firstChild, wrapper);
                    wrapper.parentNode.removeChild(wrapper);
                }
            } else self.calendarContainer.parentNode.removeChild(self.calendarContainer);
        }
        if (self.altInput) {
            self.input.type = "text";
            if (self.altInput.parentNode) self.altInput.parentNode.removeChild(self.altInput);
            delete self.altInput;
        }
        if (self.input) {
            self.input.type = self.input._type;
            self.input.classList.remove("flatpickr-input");
            self.input.removeAttribute("readonly");
        }
        [
            "_showTimeInput",
            "latestSelectedDateObj",
            "_hideNextMonthArrow",
            "_hidePrevMonthArrow",
            "__hideNextMonthArrow",
            "__hidePrevMonthArrow",
            "isMobile",
            "isOpen",
            "selectedDateElem",
            "minDateHasTime",
            "maxDateHasTime",
            "days",
            "daysContainer",
            "_input",
            "_positionElement",
            "innerContainer",
            "rContainer",
            "monthNav",
            "todayDateElem",
            "calendarContainer",
            "weekdayContainer",
            "prevMonthNav",
            "nextMonthNav",
            "monthsDropdownContainer",
            "currentMonthElement",
            "currentYearElement",
            "navigationCurrentMonth",
            "selectedDateElem",
            "config"
        ].forEach(function(k) {
            try {
                delete self[k];
            } catch (_) {}
        });
    }
    function isCalendarElem(elem) {
        return self.calendarContainer.contains(elem);
    }
    function documentClick(e) {
        if (self.isOpen && !self.config.inline) {
            var eventTarget_1 = (0, $46627959f4a6cf8e$export$e58f029f0fbfdb29)(e);
            var isCalendarElement = isCalendarElem(eventTarget_1);
            var isInput = eventTarget_1 === self.input || eventTarget_1 === self.altInput || self.element.contains(eventTarget_1) || e.path && e.path.indexOf && (~e.path.indexOf(self.input) || ~e.path.indexOf(self.altInput));
            var lostFocus = !isInput && !isCalendarElement && !isCalendarElem(e.relatedTarget);
            var isIgnored = !self.config.ignoredFocusElements.some(function(elem) {
                return elem.contains(eventTarget_1);
            });
            if (lostFocus && isIgnored) {
                if (self.config.allowInput) self.setDate(self._input.value, false, self.config.altInput ? self.config.altFormat : self.config.dateFormat);
                if (self.timeContainer !== undefined && self.minuteElement !== undefined && self.hourElement !== undefined && self.input.value !== "" && self.input.value !== undefined) updateTime();
                self.close();
                if (self.config && self.config.mode === "range" && self.selectedDates.length === 1) self.clear(false);
            }
        }
    }
    function changeYear(newYear) {
        if (!newYear || self.config.minDate && newYear < self.config.minDate.getFullYear() || self.config.maxDate && newYear > self.config.maxDate.getFullYear()) return;
        var newYearNum = newYear, isNewYear = self.currentYear !== newYearNum;
        self.currentYear = newYearNum || self.currentYear;
        if (self.config.maxDate && self.currentYear === self.config.maxDate.getFullYear()) self.currentMonth = Math.min(self.config.maxDate.getMonth(), self.currentMonth);
        else if (self.config.minDate && self.currentYear === self.config.minDate.getFullYear()) self.currentMonth = Math.max(self.config.minDate.getMonth(), self.currentMonth);
        if (isNewYear) {
            self.redraw();
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
    }
    function isEnabled(date, timeless) {
        var _a;
        if (timeless === void 0) timeless = true;
        var dateToCheck = self.parseDate(date, undefined, timeless);
        if (self.config.minDate && dateToCheck && (0, $68991a5a65b43fc7$export$c4c806e061935577)(dateToCheck, self.config.minDate, timeless !== undefined ? timeless : !self.minDateHasTime) < 0 || self.config.maxDate && dateToCheck && (0, $68991a5a65b43fc7$export$c4c806e061935577)(dateToCheck, self.config.maxDate, timeless !== undefined ? timeless : !self.maxDateHasTime) > 0) return false;
        if (!self.config.enable && self.config.disable.length === 0) return true;
        if (dateToCheck === undefined) return false;
        var bool = !!self.config.enable, array = (_a = self.config.enable) !== null && _a !== void 0 ? _a : self.config.disable;
        for(var i = 0, d = void 0; i < array.length; i++){
            d = array[i];
            if (typeof d === "function" && d(dateToCheck)) return bool;
            else if (d instanceof Date && dateToCheck !== undefined && d.getTime() === dateToCheck.getTime()) return bool;
            else if (typeof d === "string") {
                var parsed = self.parseDate(d, undefined, true);
                return parsed && parsed.getTime() === dateToCheck.getTime() ? bool : !bool;
            } else if (typeof d === "object" && dateToCheck !== undefined && d.from && d.to && dateToCheck.getTime() >= d.from.getTime() && dateToCheck.getTime() <= d.to.getTime()) return bool;
        }
        return !bool;
    }
    function isInView(elem) {
        if (self.daysContainer !== undefined) return elem.className.indexOf("hidden") === -1 && elem.className.indexOf("flatpickr-disabled") === -1 && self.daysContainer.contains(elem);
        return false;
    }
    function onBlur(e) {
        var isInput = e.target === self._input;
        var valueChanged = self._input.value.trimEnd() !== getDateStr();
        if (isInput && valueChanged && !(e.relatedTarget && isCalendarElem(e.relatedTarget))) self.setDate(self._input.value, true, e.target === self.altInput ? self.config.altFormat : self.config.dateFormat);
    }
    function onKeyDown(e) {
        var eventTarget = (0, $46627959f4a6cf8e$export$e58f029f0fbfdb29)(e);
        var isInput = self.config.wrap ? element.contains(eventTarget) : eventTarget === self._input;
        var allowInput = self.config.allowInput;
        var allowKeydown = self.isOpen && (!allowInput || !isInput);
        var allowInlineKeydown = self.config.inline && isInput && !allowInput;
        if (e.keyCode === 13 && isInput) {
            if (allowInput) {
                self.setDate(self._input.value, true, eventTarget === self.altInput ? self.config.altFormat : self.config.dateFormat);
                self.close();
                return eventTarget.blur();
            } else self.open();
        } else if (isCalendarElem(eventTarget) || allowKeydown || allowInlineKeydown) {
            var isTimeObj = !!self.timeContainer && self.timeContainer.contains(eventTarget);
            switch(e.keyCode){
                case 13:
                    if (isTimeObj) {
                        e.preventDefault();
                        updateTime();
                        focusAndClose();
                    } else selectDate(e);
                    break;
                case 27:
                    e.preventDefault();
                    focusAndClose();
                    break;
                case 8:
                case 46:
                    if (isInput && !self.config.allowInput) {
                        e.preventDefault();
                        self.clear();
                    }
                    break;
                case 37:
                case 39:
                    if (!isTimeObj && !isInput) {
                        e.preventDefault();
                        var activeElement = getClosestActiveElement();
                        if (self.daysContainer !== undefined && (allowInput === false || activeElement && isInView(activeElement))) {
                            var delta_1 = e.keyCode === 39 ? 1 : -1;
                            if (!e.ctrlKey) focusOnDay(undefined, delta_1);
                            else {
                                e.stopPropagation();
                                changeMonth(delta_1);
                                focusOnDay(getFirstAvailableDay(1), 0);
                            }
                        }
                    } else if (self.hourElement) self.hourElement.focus();
                    break;
                case 38:
                case 40:
                    e.preventDefault();
                    var delta = e.keyCode === 40 ? 1 : -1;
                    if (self.daysContainer && eventTarget.$i !== undefined || eventTarget === self.input || eventTarget === self.altInput) {
                        if (e.ctrlKey) {
                            e.stopPropagation();
                            changeYear(self.currentYear - delta);
                            focusOnDay(getFirstAvailableDay(1), 0);
                        } else if (!isTimeObj) focusOnDay(undefined, delta * 7);
                    } else if (eventTarget === self.currentYearElement) changeYear(self.currentYear - delta);
                    else if (self.config.enableTime) {
                        if (!isTimeObj && self.hourElement) self.hourElement.focus();
                        updateTime(e);
                        self._debouncedChange();
                    }
                    break;
                case 9:
                    if (isTimeObj) {
                        var elems = [
                            self.hourElement,
                            self.minuteElement,
                            self.secondElement,
                            self.amPM
                        ].concat(self.pluginElements).filter(function(x) {
                            return x;
                        });
                        var i = elems.indexOf(eventTarget);
                        if (i !== -1) {
                            var target = elems[i + (e.shiftKey ? -1 : 1)];
                            e.preventDefault();
                            (target || self._input).focus();
                        }
                    } else if (!self.config.noCalendar && self.daysContainer && self.daysContainer.contains(eventTarget) && e.shiftKey) {
                        e.preventDefault();
                        self._input.focus();
                    }
                    break;
                default:
                    break;
            }
        }
        if (self.amPM !== undefined && eventTarget === self.amPM) switch(e.key){
            case self.l10n.amPM[0].charAt(0):
            case self.l10n.amPM[0].charAt(0).toLowerCase():
                self.amPM.textContent = self.l10n.amPM[0];
                setHoursFromInputs();
                updateValue();
                break;
            case self.l10n.amPM[1].charAt(0):
            case self.l10n.amPM[1].charAt(0).toLowerCase():
                self.amPM.textContent = self.l10n.amPM[1];
                setHoursFromInputs();
                updateValue();
                break;
        }
        if (isInput || isCalendarElem(eventTarget)) triggerEvent("onKeyDown", e);
    }
    function onMouseOver(elem, cellClass) {
        if (cellClass === void 0) cellClass = "flatpickr-day";
        if (self.selectedDates.length !== 1 || elem && (!elem.classList.contains(cellClass) || elem.classList.contains("flatpickr-disabled"))) return;
        var hoverDate = elem ? elem.dateObj.getTime() : self.days.firstElementChild.dateObj.getTime(), initialDate = self.parseDate(self.selectedDates[0], undefined, true).getTime(), rangeStartDate = Math.min(hoverDate, self.selectedDates[0].getTime()), rangeEndDate = Math.max(hoverDate, self.selectedDates[0].getTime());
        var containsDisabled = false;
        var minRange = 0, maxRange = 0;
        for(var t = rangeStartDate; t < rangeEndDate; t += (0, $68991a5a65b43fc7$export$1f34108aa9eb96ab).DAY)if (!isEnabled(new Date(t), true)) {
            containsDisabled = containsDisabled || t > rangeStartDate && t < rangeEndDate;
            if (t < initialDate && (!minRange || t > minRange)) minRange = t;
            else if (t > initialDate && (!maxRange || t < maxRange)) maxRange = t;
        }
        var hoverableCells = Array.from(self.rContainer.querySelectorAll("*:nth-child(-n+" + self.config.showMonths + ") > ." + cellClass));
        hoverableCells.forEach(function(dayElem) {
            var date = dayElem.dateObj;
            var timestamp = date.getTime();
            var outOfRange = minRange > 0 && timestamp < minRange || maxRange > 0 && timestamp > maxRange;
            if (outOfRange) {
                dayElem.classList.add("notAllowed");
                [
                    "inRange",
                    "startRange",
                    "endRange"
                ].forEach(function(c) {
                    dayElem.classList.remove(c);
                });
                return;
            } else if (containsDisabled && !outOfRange) return;
            [
                "startRange",
                "inRange",
                "endRange",
                "notAllowed"
            ].forEach(function(c) {
                dayElem.classList.remove(c);
            });
            if (elem !== undefined) {
                elem.classList.add(hoverDate <= self.selectedDates[0].getTime() ? "startRange" : "endRange");
                if (initialDate < hoverDate && timestamp === initialDate) dayElem.classList.add("startRange");
                else if (initialDate > hoverDate && timestamp === initialDate) dayElem.classList.add("endRange");
                if (timestamp >= minRange && (maxRange === 0 || timestamp <= maxRange) && (0, $68991a5a65b43fc7$export$a4d69fb5f2026c35)(timestamp, initialDate, hoverDate)) dayElem.classList.add("inRange");
            }
        });
    }
    function onResize() {
        if (self.isOpen && !self.config.static && !self.config.inline) positionCalendar();
    }
    function open(e, positionElement) {
        if (positionElement === void 0) positionElement = self._positionElement;
        if (self.isMobile === true) {
            if (e) {
                e.preventDefault();
                var eventTarget = (0, $46627959f4a6cf8e$export$e58f029f0fbfdb29)(e);
                if (eventTarget) eventTarget.blur();
            }
            if (self.mobileInput !== undefined) {
                self.mobileInput.focus();
                self.mobileInput.click();
            }
            triggerEvent("onOpen");
            return;
        } else if (self._input.disabled || self.config.inline) return;
        var wasOpen = self.isOpen;
        self.isOpen = true;
        if (!wasOpen) {
            self.calendarContainer.classList.add("open");
            self._input.classList.add("active");
            triggerEvent("onOpen");
            positionCalendar(positionElement);
        }
        if (self.config.enableTime === true && self.config.noCalendar === true) {
            if (self.config.allowInput === false && (e === undefined || !self.timeContainer.contains(e.relatedTarget))) setTimeout(function() {
                return self.hourElement.select();
            }, 50);
        }
    }
    function minMaxDateSetter(type) {
        return function(date) {
            var dateObj = self.config["_" + type + "Date"] = self.parseDate(date, self.config.dateFormat);
            var inverseDateObj = self.config["_" + (type === "min" ? "max" : "min") + "Date"];
            if (dateObj !== undefined) self[type === "min" ? "minDateHasTime" : "maxDateHasTime"] = dateObj.getHours() > 0 || dateObj.getMinutes() > 0 || dateObj.getSeconds() > 0;
            if (self.selectedDates) {
                self.selectedDates = self.selectedDates.filter(function(d) {
                    return isEnabled(d);
                });
                if (!self.selectedDates.length && type === "min") setHoursFromDate(dateObj);
                updateValue();
            }
            if (self.daysContainer) {
                redraw();
                if (dateObj !== undefined) self.currentYearElement[type] = dateObj.getFullYear().toString();
                else self.currentYearElement.removeAttribute(type);
                self.currentYearElement.disabled = !!inverseDateObj && dateObj !== undefined && inverseDateObj.getFullYear() === dateObj.getFullYear();
            }
        };
    }
    function parseConfig() {
        var boolOpts = [
            "wrap",
            "weekNumbers",
            "allowInput",
            "allowInvalidPreload",
            "clickOpens",
            "time_24hr",
            "enableTime",
            "noCalendar",
            "altInput",
            "shorthandCurrentMonth",
            "inline",
            "static",
            "enableSeconds",
            "disableMobile"
        ];
        var userConfig = $f56a17c2fb2ad30e$var$__assign($f56a17c2fb2ad30e$var$__assign({}, JSON.parse(JSON.stringify(element.dataset || {}))), instanceConfig);
        var formats = {};
        self.config.parseDate = userConfig.parseDate;
        self.config.formatDate = userConfig.formatDate;
        Object.defineProperty(self.config, "enable", {
            get: function() {
                return self.config._enable;
            },
            set: function(dates) {
                self.config._enable = parseDateRules(dates);
            }
        });
        Object.defineProperty(self.config, "disable", {
            get: function() {
                return self.config._disable;
            },
            set: function(dates) {
                self.config._disable = parseDateRules(dates);
            }
        });
        var timeMode = userConfig.mode === "time";
        if (!userConfig.dateFormat && (userConfig.enableTime || timeMode)) {
            var defaultDateFormat = $f56a17c2fb2ad30e$var$flatpickr.defaultConfig.dateFormat || (0, $d0e6c103fdd72c14$export$ebe90cb607ad99e).dateFormat;
            formats.dateFormat = userConfig.noCalendar || timeMode ? "H:i" + (userConfig.enableSeconds ? ":S" : "") : defaultDateFormat + " H:i" + (userConfig.enableSeconds ? ":S" : "");
        }
        if (userConfig.altInput && (userConfig.enableTime || timeMode) && !userConfig.altFormat) {
            var defaultAltFormat = $f56a17c2fb2ad30e$var$flatpickr.defaultConfig.altFormat || (0, $d0e6c103fdd72c14$export$ebe90cb607ad99e).altFormat;
            formats.altFormat = userConfig.noCalendar || timeMode ? "h:i" + (userConfig.enableSeconds ? ":S K" : " K") : defaultAltFormat + (" h:i" + (userConfig.enableSeconds ? ":S" : "") + " K");
        }
        Object.defineProperty(self.config, "minDate", {
            get: function() {
                return self.config._minDate;
            },
            set: minMaxDateSetter("min")
        });
        Object.defineProperty(self.config, "maxDate", {
            get: function() {
                return self.config._maxDate;
            },
            set: minMaxDateSetter("max")
        });
        var minMaxTimeSetter = function(type) {
            return function(val) {
                self.config[type === "min" ? "_minTime" : "_maxTime"] = self.parseDate(val, "H:i:S");
            };
        };
        Object.defineProperty(self.config, "minTime", {
            get: function() {
                return self.config._minTime;
            },
            set: minMaxTimeSetter("min")
        });
        Object.defineProperty(self.config, "maxTime", {
            get: function() {
                return self.config._maxTime;
            },
            set: minMaxTimeSetter("max")
        });
        if (userConfig.mode === "time") {
            self.config.noCalendar = true;
            self.config.enableTime = true;
        }
        Object.assign(self.config, formats, userConfig);
        for(var i = 0; i < boolOpts.length; i++)self.config[boolOpts[i]] = self.config[boolOpts[i]] === true || self.config[boolOpts[i]] === "true";
        (0, $d0e6c103fdd72c14$export$c34bb18505e1e253).filter(function(hook) {
            return self.config[hook] !== undefined;
        }).forEach(function(hook) {
            self.config[hook] = (0, $7c36d6f76aae5f22$export$3131421a7d01b4fb)(self.config[hook] || []).map(bindToInstance);
        });
        self.isMobile = !self.config.disableMobile && !self.config.inline && self.config.mode === "single" && !self.config.disable.length && !self.config.enable && !self.config.weekNumbers && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        for(var i = 0; i < self.config.plugins.length; i++){
            var pluginConf = self.config.plugins[i](self) || {};
            for(var key in pluginConf){
                if ((0, $d0e6c103fdd72c14$export$c34bb18505e1e253).indexOf(key) > -1) self.config[key] = (0, $7c36d6f76aae5f22$export$3131421a7d01b4fb)(pluginConf[key]).map(bindToInstance).concat(self.config[key]);
                else if (typeof userConfig[key] === "undefined") self.config[key] = pluginConf[key];
            }
        }
        if (!userConfig.altInputClass) self.config.altInputClass = getInputElem().className + " " + self.config.altInputClass;
        triggerEvent("onParseConfig");
    }
    function getInputElem() {
        return self.config.wrap ? element.querySelector("[data-input]") : element;
    }
    function setupLocale() {
        if (typeof self.config.locale !== "object" && typeof $f56a17c2fb2ad30e$var$flatpickr.l10ns[self.config.locale] === "undefined") self.config.errorHandler(new Error("flatpickr: invalid locale " + self.config.locale));
        self.l10n = $f56a17c2fb2ad30e$var$__assign($f56a17c2fb2ad30e$var$__assign({}, $f56a17c2fb2ad30e$var$flatpickr.l10ns.default), typeof self.config.locale === "object" ? self.config.locale : self.config.locale !== "default" ? $f56a17c2fb2ad30e$var$flatpickr.l10ns[self.config.locale] : undefined);
        (0, $bc1b2819a5a95bf4$export$f5a8dc72fbf63af5).D = "(" + self.l10n.weekdays.shorthand.join("|") + ")";
        (0, $bc1b2819a5a95bf4$export$f5a8dc72fbf63af5).l = "(" + self.l10n.weekdays.longhand.join("|") + ")";
        (0, $bc1b2819a5a95bf4$export$f5a8dc72fbf63af5).M = "(" + self.l10n.months.shorthand.join("|") + ")";
        (0, $bc1b2819a5a95bf4$export$f5a8dc72fbf63af5).F = "(" + self.l10n.months.longhand.join("|") + ")";
        (0, $bc1b2819a5a95bf4$export$f5a8dc72fbf63af5).K = "(" + self.l10n.amPM[0] + "|" + self.l10n.amPM[1] + "|" + self.l10n.amPM[0].toLowerCase() + "|" + self.l10n.amPM[1].toLowerCase() + ")";
        var userConfig = $f56a17c2fb2ad30e$var$__assign($f56a17c2fb2ad30e$var$__assign({}, instanceConfig), JSON.parse(JSON.stringify(element.dataset || {})));
        if (userConfig.time_24hr === undefined && $f56a17c2fb2ad30e$var$flatpickr.defaultConfig.time_24hr === undefined) self.config.time_24hr = self.l10n.time_24hr;
        self.formatDate = (0, $68991a5a65b43fc7$export$ff1a0b75284ac636)(self);
        self.parseDate = (0, $68991a5a65b43fc7$export$cfa2ef2687faeda2)({
            config: self.config,
            l10n: self.l10n
        });
    }
    function positionCalendar(customPositionElement) {
        if (typeof self.config.position === "function") return void self.config.position(self, customPositionElement);
        if (self.calendarContainer === undefined) return;
        triggerEvent("onPreCalendarPosition");
        var positionElement = customPositionElement || self._positionElement;
        var calendarHeight = Array.prototype.reduce.call(self.calendarContainer.children, function(acc, child) {
            return acc + child.offsetHeight;
        }, 0), calendarWidth = self.calendarContainer.offsetWidth, configPos = self.config.position.split(" "), configPosVertical = configPos[0], configPosHorizontal = configPos.length > 1 ? configPos[1] : null, inputBounds = positionElement.getBoundingClientRect(), distanceFromBottom = window.innerHeight - inputBounds.bottom, showOnTop = configPosVertical === "above" || configPosVertical !== "below" && distanceFromBottom < calendarHeight && inputBounds.top > calendarHeight;
        var top = window.pageYOffset + inputBounds.top + (!showOnTop ? positionElement.offsetHeight + 2 : -calendarHeight - 2);
        (0, $46627959f4a6cf8e$export$4a80062ca50b57c7)(self.calendarContainer, "arrowTop", !showOnTop);
        (0, $46627959f4a6cf8e$export$4a80062ca50b57c7)(self.calendarContainer, "arrowBottom", showOnTop);
        if (self.config.inline) return;
        var left = window.pageXOffset + inputBounds.left;
        var isCenter = false;
        var isRight = false;
        if (configPosHorizontal === "center") {
            left -= (calendarWidth - inputBounds.width) / 2;
            isCenter = true;
        } else if (configPosHorizontal === "right") {
            left -= calendarWidth - inputBounds.width;
            isRight = true;
        }
        (0, $46627959f4a6cf8e$export$4a80062ca50b57c7)(self.calendarContainer, "arrowLeft", !isCenter && !isRight);
        (0, $46627959f4a6cf8e$export$4a80062ca50b57c7)(self.calendarContainer, "arrowCenter", isCenter);
        (0, $46627959f4a6cf8e$export$4a80062ca50b57c7)(self.calendarContainer, "arrowRight", isRight);
        var right = window.document.body.offsetWidth - (window.pageXOffset + inputBounds.right);
        var rightMost = left + calendarWidth > window.document.body.offsetWidth;
        var centerMost = right + calendarWidth > window.document.body.offsetWidth;
        (0, $46627959f4a6cf8e$export$4a80062ca50b57c7)(self.calendarContainer, "rightMost", rightMost);
        if (self.config.static) return;
        self.calendarContainer.style.top = top + "px";
        if (!rightMost) {
            self.calendarContainer.style.left = left + "px";
            self.calendarContainer.style.right = "auto";
        } else if (!centerMost) {
            self.calendarContainer.style.left = "auto";
            self.calendarContainer.style.right = right + "px";
        } else {
            var doc = getDocumentStyleSheet();
            if (doc === undefined) return;
            var bodyWidth = window.document.body.offsetWidth;
            var centerLeft = Math.max(0, bodyWidth / 2 - calendarWidth / 2);
            var centerBefore = ".flatpickr-calendar.centerMost:before";
            var centerAfter = ".flatpickr-calendar.centerMost:after";
            var centerIndex = doc.cssRules.length;
            var centerStyle = "{left:" + inputBounds.left + "px;right:auto;}";
            (0, $46627959f4a6cf8e$export$4a80062ca50b57c7)(self.calendarContainer, "rightMost", false);
            (0, $46627959f4a6cf8e$export$4a80062ca50b57c7)(self.calendarContainer, "centerMost", true);
            doc.insertRule(centerBefore + "," + centerAfter + centerStyle, centerIndex);
            self.calendarContainer.style.left = centerLeft + "px";
            self.calendarContainer.style.right = "auto";
        }
    }
    function getDocumentStyleSheet() {
        var editableSheet = null;
        for(var i = 0; i < document.styleSheets.length; i++){
            var sheet = document.styleSheets[i];
            if (!sheet.cssRules) continue;
            try {
                sheet.cssRules;
            } catch (err) {
                continue;
            }
            editableSheet = sheet;
            break;
        }
        return editableSheet != null ? editableSheet : createStyleSheet();
    }
    function createStyleSheet() {
        var style = document.createElement("style");
        document.head.appendChild(style);
        return style.sheet;
    }
    function redraw() {
        if (self.config.noCalendar || self.isMobile) return;
        buildMonthSwitch();
        updateNavigationCurrentMonth();
        buildDays();
    }
    function focusAndClose() {
        self._input.focus();
        if (window.navigator.userAgent.indexOf("MSIE") !== -1 || navigator.msMaxTouchPoints !== undefined) setTimeout(self.close, 0);
        else self.close();
    }
    function selectDate(e) {
        e.preventDefault();
        e.stopPropagation();
        var isSelectable = function(day) {
            return day.classList && day.classList.contains("flatpickr-day") && !day.classList.contains("flatpickr-disabled") && !day.classList.contains("notAllowed");
        };
        var t = (0, $46627959f4a6cf8e$export$25245567f53f158f)((0, $46627959f4a6cf8e$export$e58f029f0fbfdb29)(e), isSelectable);
        if (t === undefined) return;
        var target = t;
        var selectedDate = self.latestSelectedDateObj = new Date(target.dateObj.getTime());
        var shouldChangeMonth = (selectedDate.getMonth() < self.currentMonth || selectedDate.getMonth() > self.currentMonth + self.config.showMonths - 1) && self.config.mode !== "range";
        self.selectedDateElem = target;
        if (self.config.mode === "single") self.selectedDates = [
            selectedDate
        ];
        else if (self.config.mode === "multiple") {
            var selectedIndex = isDateSelected(selectedDate);
            if (selectedIndex) self.selectedDates.splice(parseInt(selectedIndex), 1);
            else self.selectedDates.push(selectedDate);
        } else if (self.config.mode === "range") {
            if (self.selectedDates.length === 2) self.clear(false, false);
            self.latestSelectedDateObj = selectedDate;
            self.selectedDates.push(selectedDate);
            if ((0, $68991a5a65b43fc7$export$c4c806e061935577)(selectedDate, self.selectedDates[0], true) !== 0) self.selectedDates.sort(function(a, b) {
                return a.getTime() - b.getTime();
            });
        }
        setHoursFromInputs();
        if (shouldChangeMonth) {
            var isNewYear = self.currentYear !== selectedDate.getFullYear();
            self.currentYear = selectedDate.getFullYear();
            self.currentMonth = selectedDate.getMonth();
            if (isNewYear) {
                triggerEvent("onYearChange");
                buildMonthSwitch();
            }
            triggerEvent("onMonthChange");
        }
        updateNavigationCurrentMonth();
        buildDays();
        updateValue();
        if (!shouldChangeMonth && self.config.mode !== "range" && self.config.showMonths === 1) focusOnDayElem(target);
        else if (self.selectedDateElem !== undefined && self.hourElement === undefined) self.selectedDateElem && self.selectedDateElem.focus();
        if (self.hourElement !== undefined) self.hourElement !== undefined && self.hourElement.focus();
        if (self.config.closeOnSelect) {
            var single = self.config.mode === "single" && !self.config.enableTime;
            var range = self.config.mode === "range" && self.selectedDates.length === 2 && !self.config.enableTime;
            if (single || range) focusAndClose();
        }
        triggerChange();
    }
    var CALLBACKS = {
        locale: [
            setupLocale,
            updateWeekdays
        ],
        showMonths: [
            buildMonths,
            setCalendarWidth,
            buildWeekdays
        ],
        minDate: [
            jumpToDate
        ],
        maxDate: [
            jumpToDate
        ],
        positionElement: [
            updatePositionElement
        ],
        clickOpens: [
            function() {
                if (self.config.clickOpens === true) {
                    bind(self._input, "focus", self.open);
                    bind(self._input, "click", self.open);
                } else {
                    self._input.removeEventListener("focus", self.open);
                    self._input.removeEventListener("click", self.open);
                }
            }
        ]
    };
    function set(option, value) {
        if (option !== null && typeof option === "object") {
            Object.assign(self.config, option);
            for(var key in option)if (CALLBACKS[key] !== undefined) CALLBACKS[key].forEach(function(x) {
                return x();
            });
        } else {
            self.config[option] = value;
            if (CALLBACKS[option] !== undefined) CALLBACKS[option].forEach(function(x) {
                return x();
            });
            else if ((0, $d0e6c103fdd72c14$export$c34bb18505e1e253).indexOf(option) > -1) self.config[option] = (0, $7c36d6f76aae5f22$export$3131421a7d01b4fb)(value);
        }
        self.redraw();
        updateValue(true);
    }
    function setSelectedDate(inputDate, format) {
        var dates = [];
        if (inputDate instanceof Array) dates = inputDate.map(function(d) {
            return self.parseDate(d, format);
        });
        else if (inputDate instanceof Date || typeof inputDate === "number") dates = [
            self.parseDate(inputDate, format)
        ];
        else if (typeof inputDate === "string") switch(self.config.mode){
            case "single":
            case "time":
                dates = [
                    self.parseDate(inputDate, format)
                ];
                break;
            case "multiple":
                dates = inputDate.split(self.config.conjunction).map(function(date) {
                    return self.parseDate(date, format);
                });
                break;
            case "range":
                dates = inputDate.split(self.l10n.rangeSeparator).map(function(date) {
                    return self.parseDate(date, format);
                });
                break;
            default:
                break;
        }
        else self.config.errorHandler(new Error("Invalid date supplied: " + JSON.stringify(inputDate)));
        self.selectedDates = self.config.allowInvalidPreload ? dates : dates.filter(function(d) {
            return d instanceof Date && isEnabled(d, false);
        });
        if (self.config.mode === "range") self.selectedDates.sort(function(a, b) {
            return a.getTime() - b.getTime();
        });
    }
    function setDate(date, triggerChange, format) {
        if (triggerChange === void 0) triggerChange = false;
        if (format === void 0) format = self.config.dateFormat;
        if (date !== 0 && !date || date instanceof Array && date.length === 0) return self.clear(triggerChange);
        setSelectedDate(date, format);
        self.latestSelectedDateObj = self.selectedDates[self.selectedDates.length - 1];
        self.redraw();
        jumpToDate(undefined, triggerChange);
        setHoursFromDate();
        if (self.selectedDates.length === 0) self.clear(false);
        updateValue(triggerChange);
        if (triggerChange) triggerEvent("onChange");
    }
    function parseDateRules(arr) {
        return arr.slice().map(function(rule) {
            if (typeof rule === "string" || typeof rule === "number" || rule instanceof Date) return self.parseDate(rule, undefined, true);
            else if (rule && typeof rule === "object" && rule.from && rule.to) return {
                from: self.parseDate(rule.from, undefined),
                to: self.parseDate(rule.to, undefined)
            };
            return rule;
        }).filter(function(x) {
            return x;
        });
    }
    function setupDates() {
        self.selectedDates = [];
        self.now = self.parseDate(self.config.now) || new Date();
        var preloadedDate = self.config.defaultDate || ((self.input.nodeName === "INPUT" || self.input.nodeName === "TEXTAREA") && self.input.placeholder && self.input.value === self.input.placeholder ? null : self.input.value);
        if (preloadedDate) setSelectedDate(preloadedDate, self.config.dateFormat);
        self._initialDate = self.selectedDates.length > 0 ? self.selectedDates[0] : self.config.minDate && self.config.minDate.getTime() > self.now.getTime() ? self.config.minDate : self.config.maxDate && self.config.maxDate.getTime() < self.now.getTime() ? self.config.maxDate : self.now;
        self.currentYear = self._initialDate.getFullYear();
        self.currentMonth = self._initialDate.getMonth();
        if (self.selectedDates.length > 0) self.latestSelectedDateObj = self.selectedDates[0];
        if (self.config.minTime !== undefined) self.config.minTime = self.parseDate(self.config.minTime, "H:i");
        if (self.config.maxTime !== undefined) self.config.maxTime = self.parseDate(self.config.maxTime, "H:i");
        self.minDateHasTime = !!self.config.minDate && (self.config.minDate.getHours() > 0 || self.config.minDate.getMinutes() > 0 || self.config.minDate.getSeconds() > 0);
        self.maxDateHasTime = !!self.config.maxDate && (self.config.maxDate.getHours() > 0 || self.config.maxDate.getMinutes() > 0 || self.config.maxDate.getSeconds() > 0);
    }
    function setupInputs() {
        self.input = getInputElem();
        if (!self.input) {
            self.config.errorHandler(new Error("Invalid input element specified"));
            return;
        }
        self.input._type = self.input.type;
        self.input.type = "text";
        self.input.classList.add("flatpickr-input");
        self._input = self.input;
        if (self.config.altInput) {
            self.altInput = (0, $46627959f4a6cf8e$export$c8a8987d4410bf2d)(self.input.nodeName, self.config.altInputClass);
            self._input = self.altInput;
            self.altInput.placeholder = self.input.placeholder;
            self.altInput.disabled = self.input.disabled;
            self.altInput.required = self.input.required;
            self.altInput.tabIndex = self.input.tabIndex;
            self.altInput.type = "text";
            self.input.setAttribute("type", "hidden");
            if (!self.config.static && self.input.parentNode) self.input.parentNode.insertBefore(self.altInput, self.input.nextSibling);
        }
        if (!self.config.allowInput) self._input.setAttribute("readonly", "readonly");
        updatePositionElement();
    }
    function updatePositionElement() {
        self._positionElement = self.config.positionElement || self._input;
    }
    function setupMobile() {
        var inputType = self.config.enableTime ? self.config.noCalendar ? "time" : "datetime-local" : "date";
        self.mobileInput = (0, $46627959f4a6cf8e$export$c8a8987d4410bf2d)("input", self.input.className + " flatpickr-mobile");
        self.mobileInput.tabIndex = 1;
        self.mobileInput.type = inputType;
        self.mobileInput.disabled = self.input.disabled;
        self.mobileInput.required = self.input.required;
        self.mobileInput.placeholder = self.input.placeholder;
        self.mobileFormatStr = inputType === "datetime-local" ? "Y-m-d\\TH:i:S" : inputType === "date" ? "Y-m-d" : "H:i:S";
        if (self.selectedDates.length > 0) self.mobileInput.defaultValue = self.mobileInput.value = self.formatDate(self.selectedDates[0], self.mobileFormatStr);
        if (self.config.minDate) self.mobileInput.min = self.formatDate(self.config.minDate, "Y-m-d");
        if (self.config.maxDate) self.mobileInput.max = self.formatDate(self.config.maxDate, "Y-m-d");
        if (self.input.getAttribute("step")) self.mobileInput.step = String(self.input.getAttribute("step"));
        self.input.type = "hidden";
        if (self.altInput !== undefined) self.altInput.type = "hidden";
        try {
            if (self.input.parentNode) self.input.parentNode.insertBefore(self.mobileInput, self.input.nextSibling);
        } catch (_a) {}
        bind(self.mobileInput, "change", function(e) {
            self.setDate((0, $46627959f4a6cf8e$export$e58f029f0fbfdb29)(e).value, false, self.mobileFormatStr);
            triggerEvent("onChange");
            triggerEvent("onClose");
        });
    }
    function toggle(e) {
        if (self.isOpen === true) return self.close();
        self.open(e);
    }
    function triggerEvent(event, data) {
        if (self.config === undefined) return;
        var hooks = self.config[event];
        if (hooks !== undefined && hooks.length > 0) for(var i = 0; hooks[i] && i < hooks.length; i++)hooks[i](self.selectedDates, self.input.value, self, data);
        if (event === "onChange") {
            self.input.dispatchEvent(createEvent("change"));
            self.input.dispatchEvent(createEvent("input"));
        }
    }
    function createEvent(name) {
        var e = document.createEvent("Event");
        e.initEvent(name, true, true);
        return e;
    }
    function isDateSelected(date) {
        for(var i = 0; i < self.selectedDates.length; i++){
            var selectedDate = self.selectedDates[i];
            if (selectedDate instanceof Date && (0, $68991a5a65b43fc7$export$c4c806e061935577)(selectedDate, date) === 0) return "" + i;
        }
        return false;
    }
    function isDateInRange(date) {
        if (self.config.mode !== "range" || self.selectedDates.length < 2) return false;
        return (0, $68991a5a65b43fc7$export$c4c806e061935577)(date, self.selectedDates[0]) >= 0 && (0, $68991a5a65b43fc7$export$c4c806e061935577)(date, self.selectedDates[1]) <= 0;
    }
    function updateNavigationCurrentMonth() {
        if (self.config.noCalendar || self.isMobile || !self.monthNav) return;
        self.yearElements.forEach(function(yearElement, i) {
            var d = new Date(self.currentYear, self.currentMonth, 1);
            d.setMonth(self.currentMonth + i);
            if (self.config.showMonths > 1 || self.config.monthSelectorType === "static") self.monthElements[i].textContent = (0, $bc1b2819a5a95bf4$export$27a2dd9af757e89c)(d.getMonth(), self.config.shorthandCurrentMonth, self.l10n) + " ";
            else self.monthsDropdownContainer.value = d.getMonth().toString();
            yearElement.value = d.getFullYear().toString();
        });
        self._hidePrevMonthArrow = self.config.minDate !== undefined && (self.currentYear === self.config.minDate.getFullYear() ? self.currentMonth <= self.config.minDate.getMonth() : self.currentYear < self.config.minDate.getFullYear());
        self._hideNextMonthArrow = self.config.maxDate !== undefined && (self.currentYear === self.config.maxDate.getFullYear() ? self.currentMonth + 1 > self.config.maxDate.getMonth() : self.currentYear > self.config.maxDate.getFullYear());
    }
    function getDateStr(specificFormat) {
        var format = specificFormat || (self.config.altInput ? self.config.altFormat : self.config.dateFormat);
        return self.selectedDates.map(function(dObj) {
            return self.formatDate(dObj, format);
        }).filter(function(d, i, arr) {
            return self.config.mode !== "range" || self.config.enableTime || arr.indexOf(d) === i;
        }).join(self.config.mode !== "range" ? self.config.conjunction : self.l10n.rangeSeparator);
    }
    function updateValue(triggerChange) {
        if (triggerChange === void 0) triggerChange = true;
        if (self.mobileInput !== undefined && self.mobileFormatStr) self.mobileInput.value = self.latestSelectedDateObj !== undefined ? self.formatDate(self.latestSelectedDateObj, self.mobileFormatStr) : "";
        self.input.value = getDateStr(self.config.dateFormat);
        if (self.altInput !== undefined) self.altInput.value = getDateStr(self.config.altFormat);
        if (triggerChange !== false) triggerEvent("onValueUpdate");
    }
    function onMonthNavClick(e) {
        var eventTarget = (0, $46627959f4a6cf8e$export$e58f029f0fbfdb29)(e);
        var isPrevMonth = self.prevMonthNav.contains(eventTarget);
        var isNextMonth = self.nextMonthNav.contains(eventTarget);
        if (isPrevMonth || isNextMonth) changeMonth(isPrevMonth ? -1 : 1);
        else if (self.yearElements.indexOf(eventTarget) >= 0) eventTarget.select();
        else if (eventTarget.classList.contains("arrowUp")) self.changeYear(self.currentYear + 1);
        else if (eventTarget.classList.contains("arrowDown")) self.changeYear(self.currentYear - 1);
    }
    function timeWrapper(e) {
        e.preventDefault();
        var isKeyDown = e.type === "keydown", eventTarget = (0, $46627959f4a6cf8e$export$e58f029f0fbfdb29)(e), input = eventTarget;
        if (self.amPM !== undefined && eventTarget === self.amPM) self.amPM.textContent = self.l10n.amPM[(0, $7c36d6f76aae5f22$export$7d260a2a5f8bc19e)(self.amPM.textContent === self.l10n.amPM[0])];
        var min = parseFloat(input.getAttribute("min")), max = parseFloat(input.getAttribute("max")), step = parseFloat(input.getAttribute("step")), curValue = parseInt(input.value, 10), delta = e.delta || (isKeyDown ? e.which === 38 ? 1 : -1 : 0);
        var newValue = curValue + step * delta;
        if (typeof input.value !== "undefined" && input.value.length === 2) {
            var isHourElem = input === self.hourElement, isMinuteElem = input === self.minuteElement;
            if (newValue < min) {
                newValue = max + newValue + (0, $7c36d6f76aae5f22$export$7d260a2a5f8bc19e)(!isHourElem) + ((0, $7c36d6f76aae5f22$export$7d260a2a5f8bc19e)(isHourElem) && (0, $7c36d6f76aae5f22$export$7d260a2a5f8bc19e)(!self.amPM));
                if (isMinuteElem) incrementNumInput(undefined, -1, self.hourElement);
            } else if (newValue > max) {
                newValue = input === self.hourElement ? newValue - max - (0, $7c36d6f76aae5f22$export$7d260a2a5f8bc19e)(!self.amPM) : min;
                if (isMinuteElem) incrementNumInput(undefined, 1, self.hourElement);
            }
            if (self.amPM && isHourElem && (step === 1 ? newValue + curValue === 23 : Math.abs(newValue - curValue) > step)) self.amPM.textContent = self.l10n.amPM[(0, $7c36d6f76aae5f22$export$7d260a2a5f8bc19e)(self.amPM.textContent === self.l10n.amPM[0])];
            input.value = (0, $7c36d6f76aae5f22$export$5d04458e2a6c373e)(newValue);
        }
    }
    init();
    return self;
}
function $f56a17c2fb2ad30e$var$_flatpickr(nodeList, config) {
    var nodes = Array.prototype.slice.call(nodeList).filter(function(x) {
        return x instanceof HTMLElement;
    });
    var instances = [];
    for(var i = 0; i < nodes.length; i++){
        var node = nodes[i];
        try {
            if (node.getAttribute("data-fp-omit") !== null) continue;
            if (node._flatpickr !== undefined) {
                node._flatpickr.destroy();
                node._flatpickr = undefined;
            }
            node._flatpickr = $f56a17c2fb2ad30e$var$FlatpickrInstance(node, config || {});
            instances.push(node._flatpickr);
        } catch (e) {
            console.error(e);
        }
    }
    return instances.length === 1 ? instances[0] : instances;
}
if (typeof HTMLElement !== "undefined" && typeof HTMLCollection !== "undefined" && typeof NodeList !== "undefined") {
    HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function(config) {
        return $f56a17c2fb2ad30e$var$_flatpickr(this, config);
    };
    HTMLElement.prototype.flatpickr = function(config) {
        return $f56a17c2fb2ad30e$var$_flatpickr([
            this
        ], config);
    };
}
var $f56a17c2fb2ad30e$var$flatpickr = function(selector, config) {
    if (typeof selector === "string") return $f56a17c2fb2ad30e$var$_flatpickr(window.document.querySelectorAll(selector), config);
    else if (selector instanceof Node) return $f56a17c2fb2ad30e$var$_flatpickr([
        selector
    ], config);
    else return $f56a17c2fb2ad30e$var$_flatpickr(selector, config);
};
$f56a17c2fb2ad30e$var$flatpickr.defaultConfig = {};
$f56a17c2fb2ad30e$var$flatpickr.l10ns = {
    en: $f56a17c2fb2ad30e$var$__assign({}, (0, $01c55b35388eeff4$export$2e2bcd8739ae039)),
    default: $f56a17c2fb2ad30e$var$__assign({}, (0, $01c55b35388eeff4$export$2e2bcd8739ae039))
};
$f56a17c2fb2ad30e$var$flatpickr.localize = function(l10n) {
    $f56a17c2fb2ad30e$var$flatpickr.l10ns.default = $f56a17c2fb2ad30e$var$__assign($f56a17c2fb2ad30e$var$__assign({}, $f56a17c2fb2ad30e$var$flatpickr.l10ns.default), l10n);
};
$f56a17c2fb2ad30e$var$flatpickr.setDefaults = function(config) {
    $f56a17c2fb2ad30e$var$flatpickr.defaultConfig = $f56a17c2fb2ad30e$var$__assign($f56a17c2fb2ad30e$var$__assign({}, $f56a17c2fb2ad30e$var$flatpickr.defaultConfig), config);
};
$f56a17c2fb2ad30e$var$flatpickr.parseDate = (0, $68991a5a65b43fc7$export$cfa2ef2687faeda2)({});
$f56a17c2fb2ad30e$var$flatpickr.formatDate = (0, $68991a5a65b43fc7$export$ff1a0b75284ac636)({});
$f56a17c2fb2ad30e$var$flatpickr.compareDates = (0, $68991a5a65b43fc7$export$c4c806e061935577);
if (typeof jQuery !== "undefined" && typeof jQuery.fn !== "undefined") jQuery.fn.flatpickr = function(config) {
    return $f56a17c2fb2ad30e$var$_flatpickr(this, config);
};
Date.prototype.fp_incr = function(days) {
    return new Date(this.getFullYear(), this.getMonth(), this.getDate() + (typeof days === "string" ? parseInt(days, 10) : days));
};
if (typeof window !== "undefined") window.flatpickr = $f56a17c2fb2ad30e$var$flatpickr;
var $f56a17c2fb2ad30e$export$2e2bcd8739ae039 = $f56a17c2fb2ad30e$var$flatpickr;


var $2ade3731c09697fa$exports = {};
(function(global, factory) {
    factory($2ade3731c09697fa$exports);
})($2ade3731c09697fa$exports, function(exports1) {
    'use strict';
    var fp = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
        l10ns: {}
    };
    var Czech = {
        weekdays: {
            shorthand: [
                "Ne",
                "Po",
                "\xdat",
                "St",
                "\u010Ct",
                "P\xe1",
                "So"
            ],
            longhand: [
                "Ned\u011Ble",
                "Pond\u011Bl\xed",
                "\xdater\xfd",
                "St\u0159eda",
                "\u010Ctvrtek",
                "P\xe1tek",
                "Sobota"
            ]
        },
        months: {
            shorthand: [
                "Led",
                "\xdan",
                "B\u0159e",
                "Dub",
                "Kv\u011B",
                "\u010Cer",
                "\u010Cvc",
                "Srp",
                "Z\xe1\u0159",
                "\u0158\xedj",
                "Lis",
                "Pro"
            ],
            longhand: [
                "Leden",
                "\xdanor",
                "B\u0159ezen",
                "Duben",
                "Kv\u011Bten",
                "\u010Cerven",
                "\u010Cervenec",
                "Srpen",
                "Z\xe1\u0159\xed",
                "\u0158\xedjen",
                "Listopad",
                "Prosinec"
            ]
        },
        firstDayOfWeek: 1,
        ordinal: function() {
            return ".";
        },
        rangeSeparator: " do ",
        weekAbbreviation: "T\xfdd.",
        scrollTitle: "Rolujte pro zm\u011Bnu",
        toggleTitle: "P\u0159epnout dopoledne/odpoledne",
        amPM: [
            "dop.",
            "odp."
        ],
        yearAriaLabel: "Rok",
        time_24hr: true
    };
    fp.l10ns.cs = Czech;
    var cs = fp.l10ns;
    exports1.Czech = Czech;
    exports1.default = cs;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});



function $fce77b49c90d569f$export$2e2bcd8739ae039(root) {
    Array.from(root.querySelectorAll('input[data-flatpickr]')).forEach((el)=>{
        $fce77b49c90d569f$var$setup(el).then((disabledDates)=>{
            (0, $f56a17c2fb2ad30e$export$2e2bcd8739ae039)(el, {
                locale: (0, $2ade3731c09697fa$exports.Czech),
                enableTime: false,
                dateFormat: 'j. n. Y',
                minDate: el.dataset.minDate ? el.dataset.minDate : null,
                disable: disabledDates,
                onReady: function(selectedDates, dateStr, instance) {
                    const event = new CustomEvent('flatpickrReady', {
                        detail: instance
                    });
                    el.dispatchEvent(event);
                }
            });
        });
    });
    Array.from(root.querySelectorAll('input[data-flatpickr-time]')).forEach((el)=>{
        $fce77b49c90d569f$var$setup(el).then((disabledDates)=>{
            (0, $f56a17c2fb2ad30e$export$2e2bcd8739ae039)(el, {
                locale: (0, $2ade3731c09697fa$exports.Czech),
                enableTime: true,
                noCalendar: true,
                dateFormat: 'H:i',
                defaultHour: el.dataset.hour ? el.dataset.hour : 9,
                minDate: el.dataset.minDate ? el.dataset.minDate : null,
                disable: disabledDates,
                onReady: function() {
                    const event = new Event('flatpickrReady');
                    el.dispatchEvent(event);
                }
            });
        });
    });
    Array.from(root.querySelectorAll('input[data-flatpickr-datetime]')).forEach((el)=>{
        $fce77b49c90d569f$var$setup(el).then((disabledDates)=>{
            (0, $f56a17c2fb2ad30e$export$2e2bcd8739ae039)(el, {
                locale: (0, $2ade3731c09697fa$exports.Czech),
                enableTime: true,
                dateFormat: 'j. n. Y H:i',
                defaultHour: el.dataset.hour ? el.dataset.hour : 9,
                minDate: el.dataset.minDate ? el.dataset.minDate : null,
                disable: disabledDates,
                onReady: function() {
                    const event = new Event('flatpickrReady');
                    el.dispatchEvent(event);
                }
            });
        });
    });
}
async function $fce77b49c90d569f$var$setup(el) {
    let disabledDates = [];
    const payload = await $fce77b49c90d569f$var$fetchDisabledDates(el.dataset.fetchDisabledDates);
    if (typeof payload.disabledDates === 'object') disabledDates = payload.disabledDates;
    return new Promise((resolve)=>{
        resolve(disabledDates);
    });
}
let $fce77b49c90d569f$var$fetchDisabledDatesResults = {};
function $fce77b49c90d569f$var$fetchDisabledDates(url) {
    if (url) {
        if (typeof $fce77b49c90d569f$var$fetchDisabledDatesResults[url] === 'undefined') $fce77b49c90d569f$var$fetchDisabledDatesResults[url] = (0, $da6d917fcd2d3fe8$export$2e2bcd8739ae039).makeRequest('GET', url, null, {
            history: false
        });
        return $fce77b49c90d569f$var$fetchDisabledDatesResults[url];
    } else return new Promise((resolve)=>{
        resolve({});
    });
}


/*!
	By André Rinas, www.andrerinas.de
	Documentation, www.simplelightbox.com
	Available for use under the MIT License
	Version 2.14.3
*/ class $570cb41b188e1f83$var$SimpleLightbox {
    defaultOptions = {
        sourceAttr: 'href',
        overlay: true,
        overlayOpacity: 0.7,
        spinner: true,
        nav: true,
        navText: [
            '&lsaquo;',
            '&rsaquo;'
        ],
        captions: true,
        captionDelay: 0,
        captionSelector: 'img',
        captionType: 'attr',
        captionsData: 'title',
        captionPosition: 'bottom',
        captionClass: '',
        captionHTML: true,
        close: true,
        closeText: '&times;',
        swipeClose: true,
        showCounter: true,
        fileExt: 'png|jpg|jpeg|gif|webp|avif',
        animationSlide: true,
        animationSpeed: 250,
        preloading: true,
        enableKeyboard: true,
        loop: true,
        rel: false,
        docClose: true,
        swipeTolerance: 50,
        className: 'simple-lightbox',
        widthRatio: 0.8,
        heightRatio: 0.9,
        scaleImageToRatio: false,
        disableRightClick: false,
        disableScroll: true,
        alertError: true,
        alertErrorMessage: 'Image not found, next image will be loaded',
        additionalHtml: false,
        history: true,
        throttleInterval: 0,
        doubleTapZoom: 2,
        maxZoom: 10,
        htmlClass: 'has-lightbox',
        rtl: false,
        fixedClass: 'sl-fixed',
        fadeSpeed: 300,
        uniqueImages: true,
        focus: true,
        scrollZoom: true,
        scrollZoomFactor: 0.5,
        download: false
    };
    transitionPrefix;
    isPassiveEventsSupported;
    transitionCapable = false;
    isTouchDevice = 'ontouchstart' in window;
    isAppleDevice = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
    initialLocationHash;
    pushStateSupport = 'pushState' in history;
    isOpen = false;
    isAnimating = false;
    isClosing = false;
    isFadeIn = false;
    urlChangedOnce = false;
    hashReseted = false;
    historyHasChanges = false;
    historyUpdateTimeout = null;
    currentImage;
    eventNamespace = 'simplelightbox';
    domNodes = {};
    loadedImages = [];
    initialImageIndex = 0;
    currentImageIndex = 0;
    initialSelector = null;
    globalScrollbarWidth = 0;
    controlCoordinates = {
        swipeDiff: 0,
        swipeYDiff: 0,
        swipeStart: 0,
        swipeEnd: 0,
        swipeYStart: 0,
        swipeYEnd: 0,
        mousedown: false,
        imageLeft: 0,
        zoomed: false,
        containerHeight: 0,
        containerWidth: 0,
        containerOffsetX: 0,
        containerOffsetY: 0,
        imgHeight: 0,
        imgWidth: 0,
        capture: false,
        initialOffsetX: 0,
        initialOffsetY: 0,
        initialPointerOffsetX: 0,
        initialPointerOffsetY: 0,
        initialPointerOffsetX2: 0,
        initialPointerOffsetY2: 0,
        initialScale: 1,
        initialPinchDistance: 0,
        pointerOffsetX: 0,
        pointerOffsetY: 0,
        pointerOffsetX2: 0,
        pointerOffsetY2: 0,
        targetOffsetX: 0,
        targetOffsetY: 0,
        targetScale: 0,
        pinchOffsetX: 0,
        pinchOffsetY: 0,
        limitOffsetX: 0,
        limitOffsetY: 0,
        scaleDifference: 0,
        targetPinchDistance: 0,
        touchCount: 0,
        doubleTapped: false,
        touchmoveCount: 0
    };
    constructor(elements, options){
        this.options = Object.assign(this.defaultOptions, options);
        this.isPassiveEventsSupported = this.checkPassiveEventsSupport();
        if (typeof elements === 'string') {
            this.initialSelector = elements;
            this.elements = Array.from(document.querySelectorAll(elements));
        } else this.elements = typeof elements.length !== 'undefined' && elements.length > 0 ? Array.from(elements) : [
            elements
        ];
        this.relatedElements = [];
        this.transitionPrefix = this.calculateTransitionPrefix();
        this.transitionCapable = this.transitionPrefix !== false;
        this.initialLocationHash = this.hash;
        // this should be handled by attribute selector IMHO! => 'a[rel=bla]'...
        if (this.options.rel) this.elements = this.getRelated(this.options.rel);
        if (this.options.uniqueImages) {
            let imgArr = [];
            this.elements = Array.from(this.elements).filter((element)=>{
                let src = element.getAttribute(this.options.sourceAttr);
                if (imgArr.indexOf(src) === -1) {
                    imgArr.push(src);
                    return true;
                }
                return false;
            });
        }
        this.createDomNodes();
        if (this.options.close) this.domNodes.wrapper.appendChild(this.domNodes.closeButton);
        if (this.options.nav) this.domNodes.wrapper.appendChild(this.domNodes.navigation);
        if (this.options.spinner) this.domNodes.wrapper.appendChild(this.domNodes.spinner);
        this.addEventListener(this.elements, 'click.' + this.eventNamespace, (event)=>{
            if (this.isValidLink(event.currentTarget)) {
                event.preventDefault();
                if (this.isAnimating) return false;
                this.initialImageIndex = this.elements.indexOf(event.currentTarget);
                this.openImage(event.currentTarget);
            }
        });
        // close addEventListener click addEventListener doc
        if (this.options.docClose) this.addEventListener(this.domNodes.wrapper, [
            'click.' + this.eventNamespace,
            'touchstart.' + this.eventNamespace
        ], (event)=>{
            if (this.isOpen && event.target === event.currentTarget) this.close();
        });
        // disable rightclick
        if (this.options.disableRightClick) this.addEventListener(document.body, 'contextmenu.' + this.eventNamespace, (event)=>{
            if (event.target.parentElement.classList.contains("sl-image")) event.preventDefault();
        });
        // keyboard-control
        if (this.options.enableKeyboard) this.addEventListener(document.body, 'keyup.' + this.eventNamespace, this.throttle((event)=>{
            this.controlCoordinates.swipeDiff = 0;
            // keyboard control only if lightbox is open
            if (this.isAnimating && event.key === 'Escape') {
                this.currentImage.setAttribute('src', '');
                this.isAnimating = false;
                this.close();
                return;
            }
            if (this.isOpen) {
                event.preventDefault();
                if (event.key === 'Escape') this.close();
                if (!this.isAnimating && [
                    'ArrowLeft',
                    'ArrowRight'
                ].indexOf(event.key) > -1) this.loadImage(event.key === 'ArrowRight' ? 1 : -1);
            }
        }, this.options.throttleInterval));
        this.addEvents();
    }
    checkPassiveEventsSupport() {
        // https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md#feature-detection
        // Test via a getter in the options object to see if the passive property is accessed
        let supportsPassive = false;
        try {
            let opts = Object.defineProperty({}, 'passive', {
                get: function() {
                    supportsPassive = true;
                }
            });
            window.addEventListener("testPassive", null, opts);
            window.removeEventListener("testPassive", null, opts);
        } catch (e) {}
        return supportsPassive;
    }
    getCaptionElement(elem) {
        // look at sibling selector
        if (this.options.captionSelector.startsWith('+')) {
            let selector = this.options.captionSelector.replace(/^\+/, '').trimStart();
            let sibling = elem.nextElementSibling;
            if (sibling && sibling.matches(selector)) return sibling;
            return false;
        } else if (this.options.captionSelector.startsWith('>')) {
            let selector = this.options.captionSelector.replace(/^>/, '').trimStart();
            return elem.querySelector(selector);
        } else return elem.querySelector(this.options.captionSelector);
    }
    generateQuerySelector(elem) {
        const { tagName: tagName, id: id, className: className, parentNode: parentNode } = elem;
        if (tagName === 'HTML') return 'HTML';
        let str = tagName;
        str += id !== '' ? `#${id}` : '';
        if (className) {
            const classes = className.trim().split(/\s/);
            for(let i = 0; i < classes.length; i++)str += `.${classes[i]}`;
        }
        let childIndex = 1;
        for(let e = elem; e.previousElementSibling; e = e.previousElementSibling)childIndex += 1;
        str += `:nth-child(${childIndex})`;
        return `${this.generateQuerySelector(parentNode)} > ${str}`;
    }
    createDomNodes() {
        this.domNodes.overlay = document.createElement('div');
        this.domNodes.overlay.classList.add('sl-overlay');
        this.domNodes.overlay.dataset.opacityTarget = this.options.overlayOpacity;
        this.domNodes.closeButton = document.createElement('button');
        this.domNodes.closeButton.classList.add('sl-close');
        this.domNodes.closeButton.innerHTML = this.options.closeText;
        this.domNodes.spinner = document.createElement('div');
        this.domNodes.spinner.classList.add('sl-spinner');
        this.domNodes.spinner.innerHTML = '<div></div>';
        this.domNodes.navigation = document.createElement('div');
        this.domNodes.navigation.classList.add('sl-navigation');
        this.domNodes.navigation.innerHTML = `<button class="sl-prev">${this.options.navText[0]}</button><button class="sl-next">${this.options.navText[1]}</button>`;
        this.domNodes.counter = document.createElement('div');
        this.domNodes.counter.classList.add('sl-counter');
        this.domNodes.counter.innerHTML = '<span class="sl-current"></span>/<span class="sl-total"></span>';
        this.domNodes.download = document.createElement('div');
        this.domNodes.download.classList.add('sl-download');
        this.domNodes.downloadLink = document.createElement('a');
        this.domNodes.downloadLink.setAttribute('download', '');
        this.domNodes.downloadLink.textContent = this.options.download;
        this.domNodes.download.appendChild(this.domNodes.downloadLink);
        this.domNodes.caption = document.createElement('div');
        this.domNodes.caption.classList.add('sl-caption', 'pos-' + this.options.captionPosition);
        if (this.options.captionClass) {
            let captionClasses = this.options.captionClass.split(/[\s,]+/);
            this.domNodes.caption.classList.add(...captionClasses);
        }
        this.domNodes.image = document.createElement('div');
        this.domNodes.image.classList.add('sl-image');
        this.domNodes.wrapper = document.createElement('div');
        this.domNodes.wrapper.classList.add('sl-wrapper');
        this.domNodes.wrapper.setAttribute('tabindex', -1);
        this.domNodes.wrapper.setAttribute('role', 'dialog');
        this.domNodes.wrapper.setAttribute('aria-hidden', false);
        if (this.options.className) this.domNodes.wrapper.classList.add(this.options.className);
        if (this.options.rtl) this.domNodes.wrapper.classList.add('sl-dir-rtl');
    }
    throttle(func, limit) {
        let inThrottle;
        return function() {
            if (!inThrottle) {
                func.apply(this, arguments);
                inThrottle = true;
                setTimeout(function() {
                    return inThrottle = false;
                }, limit);
            }
        };
    }
    isValidLink(element) {
        return !this.options.fileExt || element.getAttribute(this.options.sourceAttr) && new RegExp('(' + this.options.fileExt + ')($|\\?.*$)', 'i').test(element.getAttribute(this.options.sourceAttr));
    }
    calculateTransitionPrefix() {
        let s = (document.body || document.documentElement).style;
        return 'transition' in s ? '' : 'WebkitTransition' in s ? '-webkit-' : 'MozTransition' in s ? '-moz-' : 'OTransition' in s ? '-o' : false;
    }
    getScrollbarWidth() {
        let scrollbarWidth = 0;
        let scrollDiv = document.createElement('div');
        scrollDiv.classList.add('sl-scrollbar-measure');
        document.body.appendChild(scrollDiv);
        scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
        document.body.removeChild(scrollDiv);
        return scrollbarWidth;
    }
    toggleScrollbar(type) {
        let scrollbarWidth = 0;
        let fixedElements = [].slice.call(document.querySelectorAll('.' + this.options.fixedClass));
        if (type === 'hide') {
            let fullWindowWidth = window.innerWidth;
            if (!fullWindowWidth) {
                let documentElementRect = document.documentElement.getBoundingClientRect();
                fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left);
            }
            if (document.body.clientWidth < fullWindowWidth || this.isAppleDevice) {
                let paddingRight = parseInt(window.getComputedStyle(document.body).paddingRight || 0, 10);
                scrollbarWidth = this.getScrollbarWidth();
                document.body.dataset.originalPaddingRight = paddingRight;
                if (scrollbarWidth > 0 || scrollbarWidth == 0 && this.isAppleDevice) {
                    document.body.classList.add('hidden-scroll');
                    document.body.style.paddingRight = paddingRight + scrollbarWidth + 'px';
                    fixedElements.forEach((element)=>{
                        const actualPadding = element.style.paddingRight;
                        const calculatedPadding = window.getComputedStyle(element)['padding-right'];
                        element.dataset.originalPaddingRight = actualPadding;
                        element.style.paddingRight = `${parseFloat(calculatedPadding) + scrollbarWidth}px`;
                    });
                }
            }
        } else {
            document.body.classList.remove('hidden-scroll');
            document.body.style.paddingRight = document.body.dataset.originalPaddingRight + 'px';
            fixedElements.forEach((element)=>{
                const padding = element.dataset.originalPaddingRight;
                if (typeof padding !== 'undefined') element.style.paddingRight = padding;
            });
        }
        return scrollbarWidth;
    }
    close() {
        if (!this.isOpen || this.isAnimating || this.isClosing) return false;
        this.isClosing = true;
        let element = this.relatedElements[this.currentImageIndex];
        element.dispatchEvent(new Event('close.simplelightbox'));
        if (this.options.history) {
            this.historyHasChanges = false;
            if (!this.hashReseted) this.resetHash();
        }
        this.removeEventListener(document, 'focusin.' + this.eventNamespace);
        this.fadeOut(this.domNodes.overlay, this.options.fadeSpeed);
        this.fadeOut(document.querySelectorAll('.sl-image img,  .sl-close, .sl-navigation, .sl-image .sl-caption, .sl-counter'), this.options.fadeSpeed, ()=>{
            if (this.options.disableScroll) this.toggleScrollbar('show');
            if (this.options.htmlClass && this.options.htmlClass !== '') document.querySelector('html').classList.remove(this.options.htmlClass);
            document.body.removeChild(this.domNodes.wrapper);
            if (this.options.overlay) document.body.removeChild(this.domNodes.overlay);
            this.domNodes.additionalHtml = null;
            this.domNodes.download = null;
            element.dispatchEvent(new Event('closed.simplelightbox'));
            this.isClosing = false;
        });
        this.currentImage = null;
        this.isOpen = false;
        this.isAnimating = false;
        // reset touchcontrol coordinates
        for(let key in this.controlCoordinates)this.controlCoordinates[key] = 0;
        this.controlCoordinates.mousedown = false;
        this.controlCoordinates.zoomed = false;
        this.controlCoordinates.capture = false;
        this.controlCoordinates.initialScale = this.minMax(1, 1, this.options.maxZoom);
        this.controlCoordinates.doubleTapped = false;
    }
    get hash() {
        return window.location.hash.substring(1);
    }
    preload() {
        let index = this.currentImageIndex, length = this.relatedElements.length, next = index + 1 < 0 ? length - 1 : index + 1 >= length - 1 ? 0 : index + 1, prev = index - 1 < 0 ? length - 1 : index - 1 >= length - 1 ? 0 : index - 1, nextImage = new Image(), prevImage = new Image();
        nextImage.addEventListener('load', (event)=>{
            let src = event.target.getAttribute('src');
            if (this.loadedImages.indexOf(src) === -1) this.loadedImages.push(src);
            this.relatedElements[index].dispatchEvent(new Event('nextImageLoaded.' + this.eventNamespace));
        });
        nextImage.setAttribute('src', this.relatedElements[next].getAttribute(this.options.sourceAttr));
        prevImage.addEventListener('load', (event)=>{
            let src = event.target.getAttribute('src');
            if (this.loadedImages.indexOf(src) === -1) this.loadedImages.push(src);
            this.relatedElements[index].dispatchEvent(new Event('prevImageLoaded.' + this.eventNamespace));
        });
        prevImage.setAttribute('src', this.relatedElements[prev].getAttribute(this.options.sourceAttr));
    }
    loadImage(direction) {
        let slideDirection = direction;
        if (this.options.rtl) direction = -direction;
        this.relatedElements[this.currentImageIndex].dispatchEvent(new Event('change.' + this.eventNamespace));
        this.relatedElements[this.currentImageIndex].dispatchEvent(new Event((direction === 1 ? 'next' : 'prev') + '.' + this.eventNamespace));
        let newIndex = this.currentImageIndex + direction;
        if (this.isAnimating || (newIndex < 0 || newIndex >= this.relatedElements.length) && this.options.loop === false) return false;
        this.currentImageIndex = newIndex < 0 ? this.relatedElements.length - 1 : newIndex > this.relatedElements.length - 1 ? 0 : newIndex;
        this.domNodes.counter.querySelector('.sl-current').innerHTML = this.currentImageIndex + 1;
        if (this.options.animationSlide) this.slide(this.options.animationSpeed / 1000, -100 * slideDirection - this.controlCoordinates.swipeDiff + 'px');
        this.fadeOut(this.domNodes.image, this.options.fadeSpeed, ()=>{
            this.isAnimating = true;
            if (!this.isClosing) setTimeout(()=>{
                let element = this.relatedElements[this.currentImageIndex];
                if (!this.currentImage) return;
                this.currentImage.setAttribute('src', element.getAttribute(this.options.sourceAttr));
                if (this.loadedImages.indexOf(element.getAttribute(this.options.sourceAttr)) === -1) this.show(this.domNodes.spinner);
                if (this.domNodes.image.contains(this.domNodes.caption)) this.domNodes.image.removeChild(this.domNodes.caption);
                this.adjustImage(slideDirection);
                if (this.options.preloading) this.preload();
            }, 100);
            else this.isAnimating = false;
        });
    }
    adjustImage(direction) {
        if (!this.currentImage) return false;
        let tmpImage = new Image(), windowWidth = window.innerWidth * this.options.widthRatio, windowHeight = window.innerHeight * this.options.heightRatio;
        tmpImage.setAttribute('src', this.currentImage.getAttribute('src'));
        this.currentImage.dataset.scale = 1;
        this.currentImage.dataset.translateX = 0;
        this.currentImage.dataset.translateY = 0;
        this.zoomPanElement(0, 0, 1);
        tmpImage.addEventListener('error', (event)=>{
            this.relatedElements[this.currentImageIndex].dispatchEvent(new Event('error.' + this.eventNamespace));
            this.isAnimating = false;
            this.isOpen = true;
            this.domNodes.spinner.style.display = 'none';
            let dirIsDefined = direction === 1 || direction === -1;
            if (this.initialImageIndex === this.currentImageIndex && dirIsDefined) return this.close();
            if (this.options.alertError) alert(this.options.alertErrorMessage);
            this.loadImage(dirIsDefined ? direction : 1);
        });
        tmpImage.addEventListener('load', (event)=>{
            if (typeof direction !== 'undefined') {
                this.relatedElements[this.currentImageIndex].dispatchEvent(new Event('changed.' + this.eventNamespace));
                this.relatedElements[this.currentImageIndex].dispatchEvent(new Event((direction === 1 ? 'nextDone' : 'prevDone') + '.' + this.eventNamespace));
            }
            // history
            if (this.options.history) this.updateURL();
            if (this.loadedImages.indexOf(this.currentImage.getAttribute('src')) === -1) this.loadedImages.push(this.currentImage.getAttribute('src'));
            let imageWidth = event.target.width, imageHeight = event.target.height;
            if (this.options.scaleImageToRatio || imageWidth > windowWidth || imageHeight > windowHeight) {
                let ratio = imageWidth / imageHeight > windowWidth / windowHeight ? imageWidth / windowWidth : imageHeight / windowHeight;
                imageWidth /= ratio;
                imageHeight /= ratio;
            }
            this.domNodes.image.style.top = (window.innerHeight - imageHeight) / 2 + 'px';
            this.domNodes.image.style.left = (window.innerWidth - imageWidth - this.globalScrollbarWidth) / 2 + 'px';
            this.domNodes.image.style.width = imageWidth + 'px';
            this.domNodes.image.style.height = imageHeight + 'px';
            this.domNodes.spinner.style.display = 'none';
            if (this.options.focus) this.forceFocus();
            this.fadeIn(this.currentImage, this.options.fadeSpeed, ()=>{
                if (this.options.focus) this.domNodes.wrapper.focus();
            });
            this.isOpen = true;
            let captionContainer, captionText;
            if (typeof this.options.captionSelector === 'string') captionContainer = this.options.captionSelector === 'self' ? this.relatedElements[this.currentImageIndex] : this.getCaptionElement(this.relatedElements[this.currentImageIndex]);
            else if (typeof this.options.captionSelector === 'function') captionContainer = this.options.captionSelector(this.relatedElements[this.currentImageIndex]);
            if (this.options.captions && captionContainer) {
                if (this.options.captionType === 'data') captionText = captionContainer.dataset[this.options.captionsData];
                else if (this.options.captionType === 'text') captionText = captionContainer.innerHTML;
                else captionText = captionContainer.getAttribute(this.options.captionsData);
            }
            if (!this.options.loop) {
                if (this.currentImageIndex === 0) this.hide(this.domNodes.navigation.querySelector('.sl-prev'));
                if (this.currentImageIndex >= this.relatedElements.length - 1) this.hide(this.domNodes.navigation.querySelector('.sl-next'));
                if (this.currentImageIndex > 0) this.show(this.domNodes.navigation.querySelector('.sl-prev'));
                if (this.currentImageIndex < this.relatedElements.length - 1) this.show(this.domNodes.navigation.querySelector('.sl-next'));
            } else if (this.relatedElements.length === 1) this.hide(this.domNodes.navigation.querySelectorAll('.sl-prev, .sl-next'));
            else this.show(this.domNodes.navigation.querySelectorAll('.sl-prev, .sl-next'));
            if (direction === 1 || direction === -1) {
                if (this.options.animationSlide) {
                    this.slide(0, 100 * direction + 'px');
                    setTimeout(()=>{
                        this.slide(this.options.animationSpeed / 1000, "0px");
                    }, 50);
                }
                this.fadeIn(this.domNodes.image, this.options.fadeSpeed, ()=>{
                    this.isAnimating = false;
                    this.setCaption(captionText, imageWidth);
                });
            } else {
                this.isAnimating = false;
                this.setCaption(captionText, imageWidth);
            }
            if (this.options.additionalHtml && !this.domNodes.additionalHtml) {
                this.domNodes.additionalHtml = document.createElement('div');
                this.domNodes.additionalHtml.classList.add('sl-additional-html');
                this.domNodes.additionalHtml.innerHTML = this.options.additionalHtml;
                this.domNodes.image.appendChild(this.domNodes.additionalHtml);
            }
            if (this.options.download) this.domNodes.downloadLink.setAttribute('href', this.currentImage.getAttribute('src'));
        });
    }
    zoomPanElement(targetOffsetX, targetOffsetY, targetScale) {
        this.currentImage.style[this.transitionPrefix + 'transform'] = 'translate(' + targetOffsetX + ',' + targetOffsetY + ') scale(' + targetScale + ')';
    }
    minMax(value, min, max) {
        return value < min ? min : value > max ? max : value;
    }
    setZoomData(initialScale, targetOffsetX, targetOffsetY) {
        this.currentImage.dataset.scale = initialScale;
        this.currentImage.dataset.translateX = targetOffsetX;
        this.currentImage.dataset.translateY = targetOffsetY;
    }
    hashchangeHandler() {
        if (this.isOpen && this.hash === this.initialLocationHash) {
            this.hashReseted = true;
            this.close();
        }
    }
    addEvents() {
        // resize/responsive
        this.addEventListener(window, 'resize.' + this.eventNamespace, (event)=>{
            //this.adjustImage.bind(this)
            if (this.isOpen) this.adjustImage();
        });
        this.addEventListener(this.domNodes.closeButton, [
            'click.' + this.eventNamespace,
            'touchstart.' + this.eventNamespace
        ], this.close.bind(this));
        if (this.options.history) setTimeout(()=>{
            this.addEventListener(window, 'hashchange.' + this.eventNamespace, (event)=>{
                if (this.isOpen) this.hashchangeHandler();
            });
        }, 40);
        this.addEventListener(this.domNodes.navigation.getElementsByTagName('button'), 'click.' + this.eventNamespace, (event)=>{
            if (!event.currentTarget.tagName.match(/button/i)) return true;
            event.preventDefault();
            this.controlCoordinates.swipeDiff = 0;
            this.loadImage(event.currentTarget.classList.contains('sl-next') ? 1 : -1);
        });
        if (this.options.scrollZoom) {
            let scale = 1;
            this.addEventListener(this.domNodes.image, [
                'mousewheel',
                'DOMMouseScroll'
            ], (event)=>{
                if (this.controlCoordinates.mousedown || this.isAnimating || this.isClosing || !this.isOpen) return true;
                if (this.controlCoordinates.containerHeight == 0) {
                    this.controlCoordinates.containerHeight = this.getDimensions(this.domNodes.image).height;
                    this.controlCoordinates.containerWidth = this.getDimensions(this.domNodes.image).width;
                    this.controlCoordinates.imgHeight = this.getDimensions(this.currentImage).height;
                    this.controlCoordinates.imgWidth = this.getDimensions(this.currentImage).width;
                    this.controlCoordinates.containerOffsetX = this.domNodes.image.offsetLeft;
                    this.controlCoordinates.containerOffsetY = this.domNodes.image.offsetTop;
                    this.controlCoordinates.initialOffsetX = parseFloat(this.currentImage.dataset.translateX);
                    this.controlCoordinates.initialOffsetY = parseFloat(this.currentImage.dataset.translateY);
                }
                // event.preventDefault();
                let delta = event.delta || event.wheelDelta;
                if (delta === undefined) //we are on firefox
                delta = event.detail;
                delta = Math.max(-1, Math.min(1, delta)); // cap the delta to [-1,1] for cross browser consistency
                // apply zoom
                scale += delta * this.options.scrollZoomFactor * scale;
                scale = Math.max(1, Math.min(this.options.maxZoom, scale));
                this.controlCoordinates.targetScale = scale;
                let scrollTopPos = document.documentElement.scrollTop || document.body.scrollTop;
                this.controlCoordinates.pinchOffsetX = event.pageX;
                this.controlCoordinates.pinchOffsetY = event.pageY - scrollTopPos || 0; // need to substract the scroll position
                this.controlCoordinates.limitOffsetX = (this.controlCoordinates.imgWidth * this.controlCoordinates.targetScale - this.controlCoordinates.containerWidth) / 2;
                this.controlCoordinates.limitOffsetY = (this.controlCoordinates.imgHeight * this.controlCoordinates.targetScale - this.controlCoordinates.containerHeight) / 2;
                this.controlCoordinates.scaleDifference = this.controlCoordinates.targetScale - this.controlCoordinates.initialScale;
                this.controlCoordinates.targetOffsetX = this.controlCoordinates.imgWidth * this.controlCoordinates.targetScale <= this.controlCoordinates.containerWidth ? 0 : this.minMax(this.controlCoordinates.initialOffsetX - (this.controlCoordinates.pinchOffsetX - this.controlCoordinates.containerOffsetX - this.controlCoordinates.containerWidth / 2 - this.controlCoordinates.initialOffsetX) / (this.controlCoordinates.targetScale - this.controlCoordinates.scaleDifference) * this.controlCoordinates.scaleDifference, this.controlCoordinates.limitOffsetX * -1, this.controlCoordinates.limitOffsetX);
                this.controlCoordinates.targetOffsetY = this.controlCoordinates.imgHeight * this.controlCoordinates.targetScale <= this.controlCoordinates.containerHeight ? 0 : this.minMax(this.controlCoordinates.initialOffsetY - (this.controlCoordinates.pinchOffsetY - this.controlCoordinates.containerOffsetY - this.controlCoordinates.containerHeight / 2 - this.controlCoordinates.initialOffsetY) / (this.controlCoordinates.targetScale - this.controlCoordinates.scaleDifference) * this.controlCoordinates.scaleDifference, this.controlCoordinates.limitOffsetY * -1, this.controlCoordinates.limitOffsetY);
                this.zoomPanElement(this.controlCoordinates.targetOffsetX + "px", this.controlCoordinates.targetOffsetY + "px", this.controlCoordinates.targetScale);
                if (this.controlCoordinates.targetScale > 1) {
                    this.controlCoordinates.zoomed = true;
                    if ((!this.domNodes.caption.style.opacity || this.domNodes.caption.style.opacity > 0) && this.domNodes.caption.style.display !== 'none') this.fadeOut(this.domNodes.caption, this.options.fadeSpeed);
                } else {
                    if (this.controlCoordinates.initialScale === 1) {
                        this.controlCoordinates.zoomed = false;
                        if (this.domNodes.caption.style.display === 'none') this.fadeIn(this.domNodes.caption, this.options.fadeSpeed);
                    }
                    this.controlCoordinates.initialPinchDistance = null;
                    this.controlCoordinates.capture = false;
                }
                this.controlCoordinates.initialPinchDistance = this.controlCoordinates.targetPinchDistance;
                this.controlCoordinates.initialScale = this.controlCoordinates.targetScale;
                this.controlCoordinates.initialOffsetX = this.controlCoordinates.targetOffsetX;
                this.controlCoordinates.initialOffsetY = this.controlCoordinates.targetOffsetY;
                this.setZoomData(this.controlCoordinates.targetScale, this.controlCoordinates.targetOffsetX, this.controlCoordinates.targetOffsetY);
                this.zoomPanElement(this.controlCoordinates.targetOffsetX + "px", this.controlCoordinates.targetOffsetY + "px", this.controlCoordinates.targetScale);
            });
        }
        this.addEventListener(this.domNodes.image, [
            'touchstart.' + this.eventNamespace,
            'mousedown.' + this.eventNamespace
        ], (event)=>{
            if (event.target.tagName === 'A' && event.type === 'touchstart') return true;
            if (event.type === 'mousedown') {
                event.preventDefault();
                this.controlCoordinates.initialPointerOffsetX = event.clientX;
                this.controlCoordinates.initialPointerOffsetY = event.clientY;
                this.controlCoordinates.containerHeight = this.getDimensions(this.domNodes.image).height;
                this.controlCoordinates.containerWidth = this.getDimensions(this.domNodes.image).width;
                this.controlCoordinates.imgHeight = this.getDimensions(this.currentImage).height;
                this.controlCoordinates.imgWidth = this.getDimensions(this.currentImage).width;
                this.controlCoordinates.containerOffsetX = this.domNodes.image.offsetLeft;
                this.controlCoordinates.containerOffsetY = this.domNodes.image.offsetTop;
                this.controlCoordinates.initialOffsetX = parseFloat(this.currentImage.dataset.translateX);
                this.controlCoordinates.initialOffsetY = parseFloat(this.currentImage.dataset.translateY);
                this.controlCoordinates.capture = true;
            } else {
                this.controlCoordinates.touchCount = event.touches.length;
                this.controlCoordinates.initialPointerOffsetX = event.touches[0].clientX;
                this.controlCoordinates.initialPointerOffsetY = event.touches[0].clientY;
                this.controlCoordinates.containerHeight = this.getDimensions(this.domNodes.image).height;
                this.controlCoordinates.containerWidth = this.getDimensions(this.domNodes.image).width;
                this.controlCoordinates.imgHeight = this.getDimensions(this.currentImage).height;
                this.controlCoordinates.imgWidth = this.getDimensions(this.currentImage).width;
                this.controlCoordinates.containerOffsetX = this.domNodes.image.offsetLeft;
                this.controlCoordinates.containerOffsetY = this.domNodes.image.offsetTop;
                if (this.controlCoordinates.touchCount === 1) /* Single touch */ {
                    if (!this.controlCoordinates.doubleTapped) {
                        this.controlCoordinates.doubleTapped = true;
                        setTimeout(()=>{
                            this.controlCoordinates.doubleTapped = false;
                        }, 300);
                    } else {
                        this.currentImage.classList.add('sl-transition');
                        if (!this.controlCoordinates.zoomed) {
                            this.controlCoordinates.initialScale = this.options.doubleTapZoom;
                            this.setZoomData(this.controlCoordinates.initialScale, 0, 0);
                            this.zoomPanElement("0px", "0px", this.controlCoordinates.initialScale);
                            if ((!this.domNodes.caption.style.opacity || this.domNodes.caption.style.opacity > 0) && this.domNodes.caption.style.display !== 'none') this.fadeOut(this.domNodes.caption, this.options.fadeSpeed);
                            this.controlCoordinates.zoomed = true;
                        } else {
                            this.controlCoordinates.initialScale = 1;
                            this.setZoomData(this.controlCoordinates.initialScale, 0, 0);
                            this.zoomPanElement("0px", "0px", this.controlCoordinates.initialScale);
                            this.controlCoordinates.zoomed = false;
                        }
                        setTimeout(()=>{
                            if (this.currentImage) this.currentImage.classList.remove('sl-transition');
                        }, 200);
                        return false;
                    }
                    this.controlCoordinates.initialOffsetX = parseFloat(this.currentImage.dataset.translateX);
                    this.controlCoordinates.initialOffsetY = parseFloat(this.currentImage.dataset.translateY);
                } else if (this.controlCoordinates.touchCount === 2) /* Pinch */ {
                    this.controlCoordinates.initialPointerOffsetX2 = event.touches[1].clientX;
                    this.controlCoordinates.initialPointerOffsetY2 = event.touches[1].clientY;
                    this.controlCoordinates.initialOffsetX = parseFloat(this.currentImage.dataset.translateX);
                    this.controlCoordinates.initialOffsetY = parseFloat(this.currentImage.dataset.translateY);
                    this.controlCoordinates.pinchOffsetX = (this.controlCoordinates.initialPointerOffsetX + this.controlCoordinates.initialPointerOffsetX2) / 2;
                    this.controlCoordinates.pinchOffsetY = (this.controlCoordinates.initialPointerOffsetY + this.controlCoordinates.initialPointerOffsetY2) / 2;
                    this.controlCoordinates.initialPinchDistance = Math.sqrt((this.controlCoordinates.initialPointerOffsetX - this.controlCoordinates.initialPointerOffsetX2) * (this.controlCoordinates.initialPointerOffsetX - this.controlCoordinates.initialPointerOffsetX2) + (this.controlCoordinates.initialPointerOffsetY - this.controlCoordinates.initialPointerOffsetY2) * (this.controlCoordinates.initialPointerOffsetY - this.controlCoordinates.initialPointerOffsetY2));
                }
                this.controlCoordinates.capture = true;
            }
            if (this.controlCoordinates.mousedown) return true;
            if (this.transitionCapable) this.controlCoordinates.imageLeft = parseInt(this.domNodes.image.style.left, 10);
            this.controlCoordinates.mousedown = true;
            this.controlCoordinates.swipeDiff = 0;
            this.controlCoordinates.swipeYDiff = 0;
            this.controlCoordinates.swipeStart = event.pageX || event.touches[0].pageX;
            this.controlCoordinates.swipeYStart = event.pageY || event.touches[0].pageY;
            return false;
        });
        this.addEventListener(this.domNodes.image, [
            'touchmove.' + this.eventNamespace,
            'mousemove.' + this.eventNamespace,
            'MSPointerMove'
        ], (event)=>{
            if (!this.controlCoordinates.mousedown) return true;
            if (event.type === 'touchmove') {
                if (this.controlCoordinates.capture === false) return false;
                this.controlCoordinates.pointerOffsetX = event.touches[0].clientX;
                this.controlCoordinates.pointerOffsetY = event.touches[0].clientY;
                this.controlCoordinates.touchCount = event.touches.length;
                this.controlCoordinates.touchmoveCount++;
                if (this.controlCoordinates.touchCount > 1) /* Pinch */ {
                    this.controlCoordinates.pointerOffsetX2 = event.touches[1].clientX;
                    this.controlCoordinates.pointerOffsetY2 = event.touches[1].clientY;
                    this.controlCoordinates.targetPinchDistance = Math.sqrt((this.controlCoordinates.pointerOffsetX - this.controlCoordinates.pointerOffsetX2) * (this.controlCoordinates.pointerOffsetX - this.controlCoordinates.pointerOffsetX2) + (this.controlCoordinates.pointerOffsetY - this.controlCoordinates.pointerOffsetY2) * (this.controlCoordinates.pointerOffsetY - this.controlCoordinates.pointerOffsetY2));
                    if (this.controlCoordinates.initialPinchDistance === null) this.controlCoordinates.initialPinchDistance = this.controlCoordinates.targetPinchDistance;
                    if (Math.abs(this.controlCoordinates.initialPinchDistance - this.controlCoordinates.targetPinchDistance) >= 1) {
                        /* Initialize helpers */ this.controlCoordinates.targetScale = this.minMax(this.controlCoordinates.targetPinchDistance / this.controlCoordinates.initialPinchDistance * this.controlCoordinates.initialScale, 1, this.options.maxZoom);
                        this.controlCoordinates.limitOffsetX = (this.controlCoordinates.imgWidth * this.controlCoordinates.targetScale - this.controlCoordinates.containerWidth) / 2;
                        this.controlCoordinates.limitOffsetY = (this.controlCoordinates.imgHeight * this.controlCoordinates.targetScale - this.controlCoordinates.containerHeight) / 2;
                        this.controlCoordinates.scaleDifference = this.controlCoordinates.targetScale - this.controlCoordinates.initialScale;
                        this.controlCoordinates.targetOffsetX = this.controlCoordinates.imgWidth * this.controlCoordinates.targetScale <= this.controlCoordinates.containerWidth ? 0 : this.minMax(this.controlCoordinates.initialOffsetX - (this.controlCoordinates.pinchOffsetX - this.controlCoordinates.containerOffsetX - this.controlCoordinates.containerWidth / 2 - this.controlCoordinates.initialOffsetX) / (this.controlCoordinates.targetScale - this.controlCoordinates.scaleDifference) * this.controlCoordinates.scaleDifference, this.controlCoordinates.limitOffsetX * -1, this.controlCoordinates.limitOffsetX);
                        this.controlCoordinates.targetOffsetY = this.controlCoordinates.imgHeight * this.controlCoordinates.targetScale <= this.controlCoordinates.containerHeight ? 0 : this.minMax(this.controlCoordinates.initialOffsetY - (this.controlCoordinates.pinchOffsetY - this.controlCoordinates.containerOffsetY - this.controlCoordinates.containerHeight / 2 - this.controlCoordinates.initialOffsetY) / (this.controlCoordinates.targetScale - this.controlCoordinates.scaleDifference) * this.controlCoordinates.scaleDifference, this.controlCoordinates.limitOffsetY * -1, this.controlCoordinates.limitOffsetY);
                        this.zoomPanElement(this.controlCoordinates.targetOffsetX + "px", this.controlCoordinates.targetOffsetY + "px", this.controlCoordinates.targetScale);
                        if (this.controlCoordinates.targetScale > 1) {
                            this.controlCoordinates.zoomed = true;
                            if ((!this.domNodes.caption.style.opacity || this.domNodes.caption.style.opacity > 0) && this.domNodes.caption.style.display !== 'none') this.fadeOut(this.domNodes.caption, this.options.fadeSpeed);
                        }
                        this.controlCoordinates.initialPinchDistance = this.controlCoordinates.targetPinchDistance;
                        this.controlCoordinates.initialScale = this.controlCoordinates.targetScale;
                        this.controlCoordinates.initialOffsetX = this.controlCoordinates.targetOffsetX;
                        this.controlCoordinates.initialOffsetY = this.controlCoordinates.targetOffsetY;
                    }
                } else {
                    this.controlCoordinates.targetScale = this.controlCoordinates.initialScale;
                    this.controlCoordinates.limitOffsetX = (this.controlCoordinates.imgWidth * this.controlCoordinates.targetScale - this.controlCoordinates.containerWidth) / 2;
                    this.controlCoordinates.limitOffsetY = (this.controlCoordinates.imgHeight * this.controlCoordinates.targetScale - this.controlCoordinates.containerHeight) / 2;
                    this.controlCoordinates.targetOffsetX = this.controlCoordinates.imgWidth * this.controlCoordinates.targetScale <= this.controlCoordinates.containerWidth ? 0 : this.minMax(this.controlCoordinates.pointerOffsetX - (this.controlCoordinates.initialPointerOffsetX - this.controlCoordinates.initialOffsetX), this.controlCoordinates.limitOffsetX * -1, this.controlCoordinates.limitOffsetX);
                    this.controlCoordinates.targetOffsetY = this.controlCoordinates.imgHeight * this.controlCoordinates.targetScale <= this.controlCoordinates.containerHeight ? 0 : this.minMax(this.controlCoordinates.pointerOffsetY - (this.controlCoordinates.initialPointerOffsetY - this.controlCoordinates.initialOffsetY), this.controlCoordinates.limitOffsetY * -1, this.controlCoordinates.limitOffsetY);
                    if (Math.abs(this.controlCoordinates.targetOffsetX) === Math.abs(this.controlCoordinates.limitOffsetX)) {
                        this.controlCoordinates.initialOffsetX = this.controlCoordinates.targetOffsetX;
                        this.controlCoordinates.initialPointerOffsetX = this.controlCoordinates.pointerOffsetX;
                    }
                    if (Math.abs(this.controlCoordinates.targetOffsetY) === Math.abs(this.controlCoordinates.limitOffsetY)) {
                        this.controlCoordinates.initialOffsetY = this.controlCoordinates.targetOffsetY;
                        this.controlCoordinates.initialPointerOffsetY = this.controlCoordinates.pointerOffsetY;
                    }
                    this.setZoomData(this.controlCoordinates.initialScale, this.controlCoordinates.targetOffsetX, this.controlCoordinates.targetOffsetY);
                    this.zoomPanElement(this.controlCoordinates.targetOffsetX + "px", this.controlCoordinates.targetOffsetY + "px", this.controlCoordinates.targetScale);
                }
            }
            /* Mouse Move implementation */ if (event.type === 'mousemove' && this.controlCoordinates.mousedown) {
                if (event.type == 'touchmove') return true;
                event.preventDefault();
                if (this.controlCoordinates.capture === false) return false;
                this.controlCoordinates.pointerOffsetX = event.clientX;
                this.controlCoordinates.pointerOffsetY = event.clientY;
                this.controlCoordinates.targetScale = this.controlCoordinates.initialScale;
                this.controlCoordinates.limitOffsetX = (this.controlCoordinates.imgWidth * this.controlCoordinates.targetScale - this.controlCoordinates.containerWidth) / 2;
                this.controlCoordinates.limitOffsetY = (this.controlCoordinates.imgHeight * this.controlCoordinates.targetScale - this.controlCoordinates.containerHeight) / 2;
                this.controlCoordinates.targetOffsetX = this.controlCoordinates.imgWidth * this.controlCoordinates.targetScale <= this.controlCoordinates.containerWidth ? 0 : this.minMax(this.controlCoordinates.pointerOffsetX - (this.controlCoordinates.initialPointerOffsetX - this.controlCoordinates.initialOffsetX), this.controlCoordinates.limitOffsetX * -1, this.controlCoordinates.limitOffsetX);
                this.controlCoordinates.targetOffsetY = this.controlCoordinates.imgHeight * this.controlCoordinates.targetScale <= this.controlCoordinates.containerHeight ? 0 : this.minMax(this.controlCoordinates.pointerOffsetY - (this.controlCoordinates.initialPointerOffsetY - this.controlCoordinates.initialOffsetY), this.controlCoordinates.limitOffsetY * -1, this.controlCoordinates.limitOffsetY);
                if (Math.abs(this.controlCoordinates.targetOffsetX) === Math.abs(this.controlCoordinates.limitOffsetX)) {
                    this.controlCoordinates.initialOffsetX = this.controlCoordinates.targetOffsetX;
                    this.controlCoordinates.initialPointerOffsetX = this.controlCoordinates.pointerOffsetX;
                }
                if (Math.abs(this.controlCoordinates.targetOffsetY) === Math.abs(this.controlCoordinates.limitOffsetY)) {
                    this.controlCoordinates.initialOffsetY = this.controlCoordinates.targetOffsetY;
                    this.controlCoordinates.initialPointerOffsetY = this.controlCoordinates.pointerOffsetY;
                }
                this.setZoomData(this.controlCoordinates.initialScale, this.controlCoordinates.targetOffsetX, this.controlCoordinates.targetOffsetY);
                this.zoomPanElement(this.controlCoordinates.targetOffsetX + "px", this.controlCoordinates.targetOffsetY + "px", this.controlCoordinates.targetScale);
            }
            if (!this.controlCoordinates.zoomed) {
                this.controlCoordinates.swipeEnd = event.pageX || event.touches[0].pageX;
                this.controlCoordinates.swipeYEnd = event.pageY || event.touches[0].pageY;
                this.controlCoordinates.swipeDiff = this.controlCoordinates.swipeStart - this.controlCoordinates.swipeEnd;
                this.controlCoordinates.swipeYDiff = this.controlCoordinates.swipeYStart - this.controlCoordinates.swipeYEnd;
                if (this.options.animationSlide) this.slide(0, -this.controlCoordinates.swipeDiff + 'px');
            }
        });
        this.addEventListener(this.domNodes.image, [
            'touchend.' + this.eventNamespace,
            'mouseup.' + this.eventNamespace,
            'touchcancel.' + this.eventNamespace,
            'mouseleave.' + this.eventNamespace,
            'pointerup',
            'pointercancel',
            'MSPointerUp',
            'MSPointerCancel'
        ], (event)=>{
            if (this.isTouchDevice && event.type === 'touchend') {
                this.controlCoordinates.touchCount = event.touches.length;
                if (this.controlCoordinates.touchCount === 0) /* No touch */ {
                    /* Set attributes */ if (this.currentImage) this.setZoomData(this.controlCoordinates.initialScale, this.controlCoordinates.targetOffsetX, this.controlCoordinates.targetOffsetY);
                    if (this.controlCoordinates.initialScale === 1) {
                        this.controlCoordinates.zoomed = false;
                        if (this.domNodes.caption.style.display === 'none') this.fadeIn(this.domNodes.caption, this.options.fadeSpeed);
                    }
                    this.controlCoordinates.initialPinchDistance = null;
                    this.controlCoordinates.capture = false;
                } else if (this.controlCoordinates.touchCount === 1) /* Single touch */ {
                    this.controlCoordinates.initialPointerOffsetX = event.touches[0].clientX;
                    this.controlCoordinates.initialPointerOffsetY = event.touches[0].clientY;
                } else if (this.controlCoordinates.touchCount > 1) this.controlCoordinates.initialPinchDistance = null;
            }
            if (this.controlCoordinates.mousedown) {
                this.controlCoordinates.mousedown = false;
                let possibleDir = true;
                if (!this.options.loop) {
                    if (this.currentImageIndex === 0 && this.controlCoordinates.swipeDiff < 0) possibleDir = false;
                    if (this.currentImageIndex >= this.relatedElements.length - 1 && this.controlCoordinates.swipeDiff > 0) possibleDir = false;
                }
                if (Math.abs(this.controlCoordinates.swipeDiff) > this.options.swipeTolerance && possibleDir) this.loadImage(this.controlCoordinates.swipeDiff > 0 ? 1 : -1);
                else if (this.options.animationSlide) this.slide(this.options.animationSpeed / 1000, "0px");
                if (this.options.swipeClose && Math.abs(this.controlCoordinates.swipeYDiff) > 50 && Math.abs(this.controlCoordinates.swipeDiff) < this.options.swipeTolerance) this.close();
            }
        });
        this.addEventListener(this.domNodes.image, [
            'dblclick'
        ], (event)=>{
            if (this.isTouchDevice) return;
            this.controlCoordinates.initialPointerOffsetX = event.clientX;
            this.controlCoordinates.initialPointerOffsetY = event.clientY;
            this.controlCoordinates.containerHeight = this.getDimensions(this.domNodes.image).height;
            this.controlCoordinates.containerWidth = this.getDimensions(this.domNodes.image).width;
            this.controlCoordinates.imgHeight = this.getDimensions(this.currentImage).height;
            this.controlCoordinates.imgWidth = this.getDimensions(this.currentImage).width;
            this.controlCoordinates.containerOffsetX = this.domNodes.image.offsetLeft;
            this.controlCoordinates.containerOffsetY = this.domNodes.image.offsetTop;
            this.currentImage.classList.add('sl-transition');
            if (!this.controlCoordinates.zoomed) {
                this.controlCoordinates.initialScale = this.options.doubleTapZoom;
                this.setZoomData(this.controlCoordinates.initialScale, 0, 0);
                this.zoomPanElement("0px", "0px", this.controlCoordinates.initialScale);
                if ((!this.domNodes.caption.style.opacity || this.domNodes.caption.style.opacity > 0) && this.domNodes.caption.style.display !== 'none') this.fadeOut(this.domNodes.caption, this.options.fadeSpeed);
                this.controlCoordinates.zoomed = true;
            } else {
                this.controlCoordinates.initialScale = 1;
                this.setZoomData(this.controlCoordinates.initialScale, 0, 0);
                this.zoomPanElement("0px", "0px", this.controlCoordinates.initialScale);
                this.controlCoordinates.zoomed = false;
                if (this.domNodes.caption.style.display === 'none') this.fadeIn(this.domNodes.caption, this.options.fadeSpeed);
            }
            setTimeout(()=>{
                if (this.currentImage) {
                    this.currentImage.classList.remove('sl-transition');
                    this.currentImage.style[this.transitionPrefix + 'transform-origin'] = null;
                }
            }, 200);
            this.controlCoordinates.capture = true;
            return false;
        });
    }
    getDimensions(element) {
        let styles = window.getComputedStyle(element), height = element.offsetHeight, width = element.offsetWidth, borderTopWidth = parseFloat(styles.borderTopWidth), borderBottomWidth = parseFloat(styles.borderBottomWidth), paddingTop = parseFloat(styles.paddingTop), paddingBottom = parseFloat(styles.paddingBottom), borderLeftWidth = parseFloat(styles.borderLeftWidth), borderRightWidth = parseFloat(styles.borderRightWidth), paddingLeft = parseFloat(styles.paddingLeft), paddingRight = parseFloat(styles.paddingRight);
        return {
            height: height - borderBottomWidth - borderTopWidth - paddingTop - paddingBottom,
            width: width - borderLeftWidth - borderRightWidth - paddingLeft - paddingRight
        };
    }
    updateHash() {
        let newHash = 'pid=' + (this.currentImageIndex + 1), newURL = window.location.href.split('#')[0] + '#' + newHash;
        this.hashReseted = false;
        if (this.pushStateSupport) window.history[this.historyHasChanges ? 'replaceState' : 'pushState']('', document.title, newURL);
        else // what is the browser target of this?
        if (this.historyHasChanges) window.location.replace(newURL);
        else window.location.hash = newHash;
        if (!this.historyHasChanges) this.urlChangedOnce = true;
        this.historyHasChanges = true;
    }
    resetHash() {
        this.hashReseted = true;
        if (this.urlChangedOnce) history.back();
        else if (this.pushStateSupport) history.pushState('', document.title, window.location.pathname + window.location.search);
        else window.location.hash = '';
        //
        //in case an history operation is still pending
        clearTimeout(this.historyUpdateTimeout);
    }
    updateURL() {
        clearTimeout(this.historyUpdateTimeout);
        if (!this.historyHasChanges) this.updateHash(); // first time
        else this.historyUpdateTimeout = setTimeout(this.updateHash.bind(this), 800);
    }
    setCaption(captionText, imageWidth, allowHTML) {
        if (this.options.captions && captionText && captionText !== '' && typeof captionText !== "undefined") {
            const property = allowHTML ?? this.options.captionHTML ?? true ? 'innerHTML' : 'innerText';
            this.hide(this.domNodes.caption);
            this.domNodes.caption.style.width = imageWidth + 'px';
            this.domNodes.caption[property] = captionText;
            this.domNodes.image.appendChild(this.domNodes.caption);
            setTimeout(()=>{
                this.fadeIn(this.domNodes.caption, this.options.fadeSpeed);
            }, this.options.captionDelay);
        }
    }
    slide(speed, pos) {
        if (!this.transitionCapable) return this.domNodes.image.style.left = pos;
        this.domNodes.image.style[this.transitionPrefix + 'transform'] = 'translateX(' + pos + ')';
        this.domNodes.image.style[this.transitionPrefix + 'transition'] = this.transitionPrefix + 'transform ' + speed + 's linear';
    }
    getRelated(rel) {
        let elems;
        if (rel && rel !== false && rel !== 'nofollow') elems = Array.from(this.elements).filter((element)=>element.getAttribute('rel') === rel);
        else elems = this.elements;
        return elems;
    }
    openImage(element) {
        element.dispatchEvent(new Event('show.' + this.eventNamespace));
        this.globalScrollbarWidth = this.getScrollbarWidth();
        if (this.options.disableScroll) {
            this.toggleScrollbar('hide');
            this.globalScrollbarWidth = 0;
        }
        if (this.options.htmlClass && this.options.htmlClass !== '') document.querySelector('html').classList.add(this.options.htmlClass);
        document.body.appendChild(this.domNodes.wrapper);
        this.domNodes.wrapper.appendChild(this.domNodes.image);
        if (this.options.overlay) document.body.appendChild(this.domNodes.overlay);
        this.relatedElements = this.getRelated(element.rel);
        if (this.options.showCounter) {
            if (this.relatedElements.length == 1 && this.domNodes.wrapper.contains(this.domNodes.counter)) this.domNodes.wrapper.removeChild(this.domNodes.counter);
            else if (this.relatedElements.length > 1 && !this.domNodes.wrapper.contains(this.domNodes.counter)) this.domNodes.wrapper.appendChild(this.domNodes.counter);
        }
        if (this.options.download && this.domNodes.download) this.domNodes.wrapper.appendChild(this.domNodes.download);
        this.isAnimating = true;
        this.currentImageIndex = this.relatedElements.indexOf(element);
        let targetURL = element.getAttribute(this.options.sourceAttr);
        this.currentImage = document.createElement('img');
        this.currentImage.style.display = 'none';
        this.currentImage.setAttribute('src', targetURL);
        this.currentImage.dataset.scale = 1;
        this.currentImage.dataset.translateX = 0;
        this.currentImage.dataset.translateY = 0;
        if (this.loadedImages.indexOf(targetURL) === -1) this.loadedImages.push(targetURL);
        this.domNodes.image.innerHTML = '';
        this.domNodes.image.setAttribute('style', '');
        this.domNodes.image.appendChild(this.currentImage);
        this.fadeIn(this.domNodes.overlay, this.options.fadeSpeed);
        this.fadeIn([
            this.domNodes.counter,
            this.domNodes.navigation,
            this.domNodes.closeButton,
            this.domNodes.download
        ], this.options.fadeSpeed);
        this.show(this.domNodes.spinner);
        this.domNodes.counter.querySelector('.sl-current').innerHTML = this.currentImageIndex + 1;
        this.domNodes.counter.querySelector('.sl-total').innerHTML = this.relatedElements.length;
        this.adjustImage();
        if (this.options.preloading) this.preload();
        setTimeout(()=>{
            element.dispatchEvent(new Event('shown.' + this.eventNamespace));
        }, this.options.animationSpeed);
    }
    forceFocus() {
        this.removeEventListener(document, 'focusin.' + this.eventNamespace);
        this.addEventListener(document, 'focusin.' + this.eventNamespace, (event)=>{
            if (document !== event.target && this.domNodes.wrapper !== event.target && !this.domNodes.wrapper.contains(event.target)) this.domNodes.wrapper.focus();
        });
    }
    // utility
    addEventListener(elements, events, callback, opts) {
        elements = this.wrap(elements);
        events = this.wrap(events);
        for (let element of elements){
            if (!element.namespaces) element.namespaces = {};
             // save the namespaces addEventListener the DOM element itself
            for (let event of events){
                let options = opts || false;
                let needsPassiveFix = [
                    'touchstart',
                    'touchmove',
                    'mousewheel',
                    'DOMMouseScroll'
                ].indexOf(event.split('.')[0]) >= 0;
                if (needsPassiveFix && this.isPassiveEventsSupported) {
                    if (typeof options === 'object') options.passive = true;
                    else options = {
                        passive: true
                    };
                }
                element.namespaces[event] = callback;
                element.addEventListener(event.split('.')[0], callback, options);
            }
        }
    }
    removeEventListener(elements, events) {
        elements = this.wrap(elements);
        events = this.wrap(events);
        for (let element of elements){
            for (let event of events)if (element.namespaces && element.namespaces[event]) {
                element.removeEventListener(event.split('.')[0], element.namespaces[event]);
                delete element.namespaces[event];
            }
        }
    }
    fadeOut(elements, duration, callback) {
        elements = this.wrap(elements);
        for (let element of elements)element.style.opacity = parseFloat(element) || window.getComputedStyle(element).getPropertyValue("opacity");
        this.isFadeIn = false;
        let step = 16.66666 / (duration || this.options.fadeSpeed), fade = ()=>{
            let currentOpacity = parseFloat(elements[0].style.opacity);
            if ((currentOpacity -= step) < 0) {
                for (let element of elements){
                    element.style.display = "none";
                    // element.style.opacity = '';
                    element.style.opacity = 1;
                }
                callback && callback.call(this, elements);
            } else {
                for (let element of elements)element.style.opacity = currentOpacity;
                requestAnimationFrame(fade);
            }
        };
        fade();
    }
    fadeIn(elements, duration, callback, display) {
        elements = this.wrap(elements);
        for (let element of elements)if (element) {
            element.style.opacity = 0;
            element.style.display = display || "block";
        }
        this.isFadeIn = true;
        let opacityTarget = parseFloat(elements[0].dataset.opacityTarget || 1), step = 16.66666 * opacityTarget / (duration || this.options.fadeSpeed), fade = ()=>{
            let currentOpacity = parseFloat(elements[0].style.opacity);
            if (!((currentOpacity += step) > opacityTarget)) {
                for (let element of elements)if (element) element.style.opacity = currentOpacity;
                if (!this.isFadeIn) return;
                requestAnimationFrame(fade);
            } else {
                for (let element of elements)if (element) element.style.opacity = opacityTarget;
                callback && callback.call(this, elements);
            }
        };
        fade();
    }
    hide(elements) {
        elements = this.wrap(elements);
        for (let element of elements){
            if (element.style.display != 'none') element.dataset.initialDisplay = element.style.display;
            element.style.display = 'none';
        }
    }
    show(elements, display) {
        elements = this.wrap(elements);
        for (let element of elements)element.style.display = element.dataset.initialDisplay || display || 'block';
    }
    wrap(input) {
        return typeof input[Symbol.iterator] === 'function' && typeof input !== 'string' ? input : [
            input
        ];
    }
    on(events, callback) {
        events = this.wrap(events);
        for (let element of this.elements){
            if (!element.fullyNamespacedEvents) element.fullyNamespacedEvents = {};
            for (let event of events){
                element.fullyNamespacedEvents[event] = callback;
                element.addEventListener(event, callback);
            }
        }
        return this;
    }
    off(events) {
        events = this.wrap(events);
        for (let element of this.elements){
            for (let event of events)if (typeof element.fullyNamespacedEvents !== 'undefined' && event in element.fullyNamespacedEvents) element.removeEventListener(event, element.fullyNamespacedEvents[event]);
        }
        return this;
    }
    // api
    open(elem, position = 0) {
        elem = elem || this.elements[0];
        if (typeof jQuery !== "undefined" && elem instanceof jQuery) elem = elem.get(0);
        if (position > 0) elem = this.elements[position];
        this.initialImageIndex = this.elements.indexOf(elem);
        if (this.initialImageIndex > -1) this.openImage(elem);
    }
    openPosition(position) {
        let elem = this.elements[position];
        this.open(elem, position);
    }
    next() {
        this.loadImage(1);
    }
    prev() {
        this.loadImage(-1);
    }
    // get some useful data
    getLighboxData() {
        return {
            currentImageIndex: this.currentImageIndex,
            currentImage: this.currentImage,
            globalScrollbarWidth: this.globalScrollbarWidth
        };
    }
    //close is exposed anyways..
    destroy() {
        //remove all custom event listeners from elements
        this.off([
            'close.' + this.eventNamespace,
            'closed.' + this.eventNamespace,
            'nextImageLoaded.' + this.eventNamespace,
            'prevImageLoaded.' + this.eventNamespace,
            'change.' + this.eventNamespace,
            'nextDone.' + this.eventNamespace,
            'prevDone.' + this.eventNamespace,
            'error.' + this.eventNamespace,
            'changed.' + this.eventNamespace,
            'next.' + this.eventNamespace,
            'prev.' + this.eventNamespace,
            'show.' + this.eventNamespace,
            'shown.' + this.eventNamespace
        ]);
        this.removeEventListener(this.elements, 'click.' + this.eventNamespace);
        this.removeEventListener(document, 'focusin.' + this.eventNamespace);
        this.removeEventListener(document.body, 'contextmenu.' + this.eventNamespace);
        this.removeEventListener(document.body, 'keyup.' + this.eventNamespace);
        this.removeEventListener(this.domNodes.navigation.getElementsByTagName('button'), 'click.' + this.eventNamespace);
        this.removeEventListener(this.domNodes.closeButton, 'click.' + this.eventNamespace);
        this.removeEventListener(window, 'resize.' + this.eventNamespace);
        this.removeEventListener(window, 'hashchange.' + this.eventNamespace);
        this.close();
        if (this.isOpen) {
            document.body.removeChild(this.domNodes.wrapper);
            document.body.removeChild(this.domNodes.overlay);
        }
        this.elements = null;
    }
    refresh() {
        if (!this.initialSelector) throw 'refreshing only works when you initialize using a selector!';
        let options = this.options, selector = this.initialSelector;
        this.destroy();
        this.constructor(selector, options);
        return this;
    }
}
var $570cb41b188e1f83$export$2e2bcd8739ae039 = $570cb41b188e1f83$var$SimpleLightbox;
$parcel$global.SimpleLightbox = $570cb41b188e1f83$var$SimpleLightbox;


function $b31357567f9a717b$export$2e2bcd8739ae039(root) {
    let rel = [];
    let lightboxSelector = '.lightbox[rel]';
    Array.from(root.querySelectorAll(lightboxSelector)).forEach((node)=>{
        let relSelector = node.getAttribute('rel');
        if (typeof rel[relSelector] === "undefined") rel[relSelector] = new (0, $570cb41b188e1f83$export$2e2bcd8739ae039)(lightboxSelector, {
            rel: relSelector,
            history: false
        });
    });
}



function $956303e800ad0259$export$2e2bcd8739ae039() {
    Array.from(document.querySelectorAll('[data-fxs-toggle="adjustColumns"]')).forEach((el)=>{
        el.addEventListener('click', (e)=>{
            e.preventDefault();
            if (!el.dataset.state) el.dataset.state = 'true';
            const state = el.dataset.state === 'true';
            Array.from(el.closest('.dropdown-menu').querySelectorAll('.adjustable-columns input[type=checkbox]')).forEach((el)=>{
                el.checked = state;
            });
            el.dataset.state = state ? 'false' : 'true';
        });
    });
    Array.from(document.querySelectorAll('input[type="checkbox"][data-fxs-toggle="allItems"]')).forEach((checkbox)=>{
        checkbox.addEventListener('change', (e)=>{
            Array.from(checkbox.closest('.datagrid').querySelectorAll('td.selectable input[name^=item]')).forEach((el)=>{
                el.checked = checkbox.checked;
            });
            const url = checkbox.dataset.fxsUrl;
            (0, $da6d917fcd2d3fe8$export$2e2bcd8739ae039).makeRequest('POST', url, {
                state: checkbox.checked
            }, {
                history: false
            }).then((payload)=>{
                const root = checkbox.closest('.datagrid');
                Array.from(root.querySelectorAll('tr[id^=item]')).forEach((tr)=>{
                    tr.classList.remove('table-success');
                });
                if (payload.selectedItems) {
                    for(const itemId in payload.selectedItems)Array.from(root.querySelectorAll("tr[id='item" + itemId + "']")).forEach((tr)=>{
                        tr.classList.add('table-success');
                    });
                    const count = root.querySelector('#numberOfSelectedItems');
                    if (count) count.textContent = Object.entries(payload.selectedItems).length;
                }
            }).catch((err)=>{
                alert(err);
            });
        });
    });
    Array.from(document.querySelectorAll('input[type="checkbox"][data-fxs-toggle="item"]')).forEach((checkbox)=>{
        checkbox.addEventListener('change', (e)=>{
            const url = checkbox.dataset.fxsUrl;
            (0, $da6d917fcd2d3fe8$export$2e2bcd8739ae039).makeRequest('POST', url, {
                state: checkbox.checked
            }, {
                history: false
            }).then((payload)=>{
                const root = checkbox.closest('.datagrid');
                const count = root.querySelector('#numberOfSelectedItems');
                if (payload.selected) {
                    checkbox.closest('tr').classList.add('table-success');
                    if (count) count.textContent = parseInt(count.textContent) + 1;
                } else {
                    checkbox.closest('tr').classList.remove('table-success');
                    if (count) count.textContent = parseInt(count.textContent) - 1;
                }
            }).catch((err)=>{
                alert(err);
            });
        });
    });
}




function $c8b9396e7e1848cb$export$2e2bcd8739ae039(root) {
    Array.from(root.querySelectorAll('[data-bs-toggle="tooltip"]')).forEach((tooltipNode)=>{
        new (0, $91ca15859685b28b$export$28c660c63b792dea)(tooltipNode);
    });
}



function $11f8bd0231fd003c$export$2e2bcd8739ae039(html) {
    Array.from(html.querySelectorAll('.modal[data-show="true"]')).forEach((el)=>{
        new (0, $91ca15859685b28b$export$2b77a92f1a5ad772)(el, {}).show();
    });
}


function $c3c577fb288a0e50$export$2e2bcd8739ae039(options) {
    if (!window.tinymce) return;
    const tinymce = window.tinymce;
    let setup = {
        selector: options.selector,
        language: document.querySelector('html').getAttribute('lang'),
        menubar: false,
        plugins: 'link code fullscreen',
        content_css: window.location.origin + '/assets/dist/css/tinymce.css',
        advlist_bullet_styles: 'square',
        advlist_number_styles: 'default',
        height: options.height,
        statusbar: false,
        resize: false,
        browser_spellcheck: true,
        relative_urls: false,
        remove_script_host: false,
        document_base_url: new URL(window.location.href).origin,
        setup: (editor)=>{
            editor.on('keyup', (e)=>{
                window.tinymce.triggerSave();
                const input = document.querySelector(options.selector);
                const parent = input?.parentElement;
                const helper = parent?.querySelector('.tinymce-helper');
                if (helper) helper.innerHTML = window.tinymce.activeEditor?.getContent();
            });
            editor.on('init', (e)=>{
                e.target.targetElm.classList.add('tinymce-initiated');
                const parent = e.target.targetElm.parentElement;
                parent.querySelector('.editor-loader')?.classList.add('d-none');
                parent.querySelector('.tinymce-helper')?.classList.add('d-none');
                if (options.autofocus) editor.focus();
                if (e.target.targetElm.dataset.onInitHide === "true") window.tinymce.get(e.target.targetElm.getAttribute('id')).hide();
            });
            editor.on('detach', (e)=>{
                const input = e.target.targetElm;
                const parent = input.parentElement;
                const helper = parent.querySelector('.tinymce-helper');
                input.classList.add('d-none');
                if (helper) {
                    helper.classList.add('d-none');
                    if (helper.textContent === '') input.classList.remove('d-none');
                    else helper.classList.remove('d-none');
                }
            });
            editor.on('focus', (e)=>{
                const input = document.querySelector(options.selector);
                if (input) {
                    input.classList.add('d-none');
                    const parent = input.parentElement;
                    const helper = parent.querySelector('.tinymce-helper');
                    helper?.classList.add('d-none');
                }
            });
            editor.on('blur', (e)=>{
                window.tinymce.triggerSave();
                const input = document.querySelector(options.selector);
                const parent = input?.parentElement;
                const helper = parent?.querySelector('.tinymce-helper');
                if (helper) {
                    const editor = window.tinymce.get(e.target.targetElm.getAttribute('id'));
                    if (editor) {
                        if (editor.getContent({
                            format: 'text'
                        }) === '') input.classList.remove('d-none');
                        else helper.classList.remove('d-none');
                        editor.hide();
                    }
                }
            });
        }
    };
    if (options.toolbar === false) setup.toolbar = false;
    else setup.toolbar = 'undo redo paste removeformat fullscreen | blocks fontsize | bold italic underline strikethrough | align lineheight | checklist numlist bullist indent outdent | link unlink | forecolor backcolor | table | code';
    tinymce.init(setup);
}





function $7a2680a035a53094$export$2e2bcd8739ae039(html) {
    const form = html.querySelector('form#frm-articleManager-articleForm');
    if (form) {
        const ajaxStartCallback = (event)=>{
            if (event.detail.request.method !== 'GET') html.querySelector('#ajaxLoader')?.classList.remove('d-none');
            html.querySelectorAll('.modal').forEach((el)=>{
                if (!el.dataset.ajaxHideSkip) (0, $91ca15859685b28b$export$2b77a92f1a5ad772).getInstance(el)?.hide();
            });
        };
        const snippetAfterUpdateCallback = ()=>{
            html.querySelector('#ajaxLoader')?.classList.add('d-none');
        };
        (0, $da6d917fcd2d3fe8$export$2e2bcd8739ae039).removeEventListener('start', ajaxStartCallback);
        (0, $da6d917fcd2d3fe8$export$2e2bcd8739ae039).addEventListener('start', ajaxStartCallback);
        (0, $da6d917fcd2d3fe8$export$2e2bcd8739ae039).snippetHandler.removeEventListener('afterUpdate', snippetAfterUpdateCallback);
        (0, $da6d917fcd2d3fe8$export$2e2bcd8739ae039).snippetHandler.addEventListener('afterUpdate', snippetAfterUpdateCallback);
        const redirectHandler = (event)=>{
            if (!event.detail.url.includes('editorMode=')) event.detail.setHardRedirect(true);
        };
        (0, $da6d917fcd2d3fe8$export$2e2bcd8739ae039).redirectHandler.removeEventListener('redirect', redirectHandler);
        (0, $da6d917fcd2d3fe8$export$2e2bcd8739ae039).redirectHandler.addEventListener('redirect', redirectHandler);
        form.querySelectorAll('.modal.topics .topic').forEach((topic)=>{
            topic.classList.add('d-none');
        });
        form.querySelectorAll('input[type=radio][name=template]').forEach((el)=>{
            el.addEventListener('change', (e)=>{
                form.querySelectorAll('.modal.topics .topic').forEach((topic)=>{
                    topic.classList.add('d-none');
                });
                form.querySelectorAll('.modal.topics [data-article-template-' + e.currentTarget.value + ']').forEach((topic)=>{
                    topic.classList.remove('d-none');
                });
            });
        });
        const template = form.querySelector('input[type=radio][name=template]:checked');
        if (template) form.querySelectorAll('.modal.topics [data-article-template-' + template.value + ']').forEach((topic)=>{
            topic.classList.remove('d-none');
        });
        for (let selector of [
            '#topic1Modal',
            '#topic2Modal'
        ]){
            const btn = html.querySelector('button[data-bs-target="' + selector + '"]');
            html.querySelectorAll(selector + ' input[type=radio]').forEach((el)=>{
                el.addEventListener('change', (e)=>{
                    btn.classList.add('placeholder');
                    btn.classList.remove('btn');
                    btn.classList.remove('btn-outline-blue');
                    btn.classList.remove('text-uppercase');
                    btn.textContent = btn.dataset.text;
                    const el = e.target;
                    if (el.checked) {
                        btn.classList.remove('placeholder');
                        btn.classList.add('btn');
                        btn.classList.add('btn-outline-blue');
                        btn.classList.add('text-uppercase');
                        btn.textContent = el.nextElementSibling.textContent;
                    }
                });
            });
            html.querySelector(selector + ' button.reset').addEventListener('click', (e)=>{
                e.preventDefault();
                e.currentTarget.closest('.modal').querySelectorAll('input[type=radio]').forEach((el)=>{
                    el.checked = false;
                    btn.classList.add('placeholder');
                    btn.classList.remove('btn');
                    btn.classList.remove('btn-outline-blue');
                    btn.classList.remove('text-uppercase');
                    btn.textContent = btn.dataset.text;
                });
            });
        }
        form.querySelectorAll('textarea[rows="1"]').forEach((el)=>{
            el.addEventListener('keydown', (e)=>{
                if (e.keyCode === 13) e.preventDefault();
            });
        });
        form.querySelectorAll('[data-tinymce]').forEach((el)=>{
            el.addEventListener('focus', (e)=>{
                e.currentTarget.previousElementSibling.classList.remove('visually-hidden');
                (0, $c3c577fb288a0e50$export$2e2bcd8739ae039)({
                    selector: 'textarea#' + e.currentTarget.getAttribute('id') + '[data-tinymce]',
                    height: 360,
                    autofocus: true
                });
                window.tinymce.get(e.currentTarget.getAttribute('id'))?.show();
            });
        });
        form.querySelectorAll('.tinymce-helper').forEach((el)=>{
            el.addEventListener('click', (e)=>{
                const parent = e.currentTarget.parentElement;
                const helper = parent.querySelector('.tinymce-helper');
                helper.classList.add('d-none');
                const input = parent.querySelector('[data-tinymce]');
                input.classList.remove('d-none');
                input.focus();
                const editor = window.tinymce.get(input.getAttribute('id'));
                editor.show();
                editor.focus();
            });
        });
        form.querySelectorAll('.upload-helper, .upload-more').forEach((el)=>{
            const input = el.querySelector('input[type=file]');
            input?.addEventListener('change', (e)=>{
                const multiple = e.currentTarget.hasAttribute('multiple');
                let row = el.classList.contains('upload-more') ? e.currentTarget.closest('.upload-more').previousElementSibling.previousElementSibling : e.currentTarget.closest('.upload-helper').nextElementSibling;
                row.querySelectorAll('.img-preview.not-uploaded, .file-preview.not-uploaded').forEach((el)=>{
                    el.remove();
                });
                for (const file of e.target.files)if (file.type.startsWith("image/")) {
                    const col = document.createElement("div");
                    const remove = document.createElement("button");
                    const img = document.createElement("img");
                    col.classList.add('img-preview');
                    col.classList.add('not-uploaded');
                    if (multiple) col.classList.add('multiple');
                    remove.setAttribute('type', 'button');
                    remove.classList.add('remove');
                    remove.innerHTML = '<i class="fas fa-times"></i>';
                    remove.addEventListener('click', (e)=>{
                        row.querySelectorAll('.img-preview.not-uploaded, .file-preview.not-uploaded').forEach((el)=>{
                            el.remove();
                        });
                        input.value = null;
                        if (row.querySelectorAll('.img-preview, .file-preview').length === 0) {
                            el.classList.remove('d-none');
                            el.parentElement.querySelector('.upload-more')?.classList.add('d-none');
                        }
                    });
                    img.file = file;
                    img.classList.add('img-fluid');
                    if (multiple) img.setAttribute('style', 'max-height: 120px');
                    col.appendChild(remove);
                    col.appendChild(img);
                    row.appendChild(col);
                    el.parentElement.querySelector('.upload-more')?.classList.remove('d-none');
                    const reader = new FileReader();
                    reader.onload = ()=>{
                        if (typeof reader.result === 'string') img.src = reader.result;
                    };
                    reader.readAsDataURL(file);
                } else {
                    const col = document.createElement("div");
                    const text = document.createElement("div");
                    const remove = document.createElement("button");
                    col.classList.add('file-preview');
                    col.classList.add('not-uploaded');
                    if (multiple) col.classList.add('multiple');
                    remove.setAttribute('type', 'button');
                    remove.classList.add('remove');
                    remove.innerHTML = '<i class="fas fa-times"></i>';
                    remove.addEventListener('click', (e)=>{
                        row.querySelectorAll('.img-preview.not-uploaded, .file-preview.not-uploaded').forEach((el)=>{
                            el.remove();
                        });
                        input.value = null;
                        if (row.querySelectorAll('.img-preview, .file-preview').length === 0) {
                            el.classList.remove('d-none');
                            el.parentElement.querySelector('.upload-more')?.classList.add('d-none');
                        }
                    });
                    text.classList.add('file');
                    text.classList.add('text-nowrap');
                    text.innerHTML = '<i class="fas fa-file me-2"></i>' + file.name;
                    col.appendChild(remove);
                    col.appendChild(text);
                    row.appendChild(col);
                    el.parentElement.querySelector('.upload-more')?.classList.remove('d-none');
                }
                if (!el.classList.contains('upload-more')) el.classList.add('d-none');
            });
        });
        html.querySelectorAll('input[name=section]').forEach((el)=>{
            el.addEventListener('change', (e)=>{
                const web = html.querySelector('input[name=parentWeb]').closest('.web');
                const intranet = html.querySelector('input[name=parentIntranet]').closest('.intranet');
                const value = e.currentTarget.value;
                if (web && intranet) {
                    const webText = web.querySelector('.form-text');
                    const intranetText = intranet.querySelector('.form-text');
                    web.classList.add('d-none');
                    webText.classList.add('d-none');
                    intranet.classList.add('d-none');
                    intranetText.classList.add('d-none');
                    if (value === 'web') web.classList.remove('d-none');
                    else if (value === 'intranet') intranet.classList.remove('d-none');
                    else if (value === 'both') {
                        web.classList.remove('d-none');
                        webText.classList.remove('d-none');
                        intranet.classList.remove('d-none');
                        intranetText.classList.remove('d-none');
                    }
                }
            });
        });
        html.querySelectorAll('input[name=otherArticles]').forEach((el)=>{
            el.addEventListener('change', (e)=>{
                const value = e.currentTarget.value;
                const root = e.currentTarget.closest('.d-flex');
                const auto = root.querySelectorAll('.auto');
                const custom = root.querySelectorAll('.custom');
                auto.forEach((el)=>{
                    el.classList.add('d-none');
                });
                custom.forEach((el)=>{
                    el.classList.add('d-none');
                });
                if (value === 'auto') auto.forEach((el)=>{
                    el.classList.remove('d-none');
                });
                else if (value === 'custom') custom.forEach((el)=>{
                    el.classList.remove('d-none');
                });
            });
        });
        html.querySelectorAll('.img-preview button.remove, .file-preview button.remove').forEach((el)=>{
            el.addEventListener('click', (e)=>{
                const root = e.currentTarget.closest('.d-flex');
                const stack = root.nextElementSibling;
                stack.value += e.currentTarget.dataset.id + ';';
                e.currentTarget.closest('.img-preview')?.remove();
                e.currentTarget.closest('.file-preview')?.remove();
                if (root.querySelectorAll('.img-preview, .file-preview').length === 0) {
                    root.previousElementSibling.classList.remove('d-none');
                    root.parentElement.querySelector('.upload-more')?.classList.add('d-none');
                }
            });
        });
        form.querySelectorAll('input[type=radio][name=section]').forEach((el)=>{
            el.addEventListener('change', (e)=>{
                form.querySelectorAll('.modal.departments .department').forEach((department)=>{
                    department.classList.add('d-none');
                });
                const values = e.currentTarget.value === 'both' ? [
                    'web',
                    'intranet'
                ] : [
                    e.currentTarget.value
                ];
                for (let value of values)form.querySelectorAll('.modal.departments [data-' + value + ']').forEach((department)=>{
                    department.classList.remove('d-none');
                });
            });
        });
        const section = form.querySelector('input[type=radio][name=section]:checked');
        if (section) {
            const values = section.value === 'both' ? [
                'web',
                'intranet'
            ] : [
                section.value
            ];
            for (let value of values)form.querySelectorAll('.modal.departments [data-' + value + ']').forEach((department)=>{
                department.classList.remove('d-none');
            });
        }
        for (let section of [
            'web',
            'intranet'
        ]){
            const selector = '[data-bs-toggle=modal][data-' + section + '-url]';
            html.querySelectorAll(selector).forEach((el)=>{
                el.addEventListener('click', (e)=>{
                    const loader = document.querySelector('#contentPreviewLoader');
                    loader.classList.remove('d-none');
                    const iframe = document.querySelector('#contentPreviewModal iframe.' + section);
                    iframe.classList.add('d-none');
                    const url = e.currentTarget.getAttribute('data-' + section + '-url');
                    if (url) {
                        const callback = (e)=>{
                            loader.classList.add('d-none');
                            e.currentTarget.classList.remove('d-none');
                        };
                        iframe.removeEventListener('load', callback);
                        iframe.addEventListener('load', callback);
                        iframe.setAttribute('src', url);
                    } else alert('URL not found.');
                });
            });
        }
        form.querySelectorAll('input[type=checkbox][name="departments[]"]').forEach((el)=>{
            el.addEventListener('change', (e)=>{
                const value = e.currentTarget.value;
                const box = form.querySelector('.departments-box');
                const list = form.querySelector('.departments-list');
                if (el.checked) {
                    box.classList.add('d-none');
                    list.querySelector('[data-code="' + value + '"]')?.classList.remove('d-none');
                } else {
                    list.querySelector('[data-code="' + value + '"]')?.classList.add('d-none');
                    if (form.querySelectorAll('input[type=checkbox][name="departments[]"]:checked').length === 0) box.classList.remove('d-none');
                }
            });
        });
        const gallery = (0, $db58504db5b9e911$export$2e2bcd8739ae039)('.sortable-gallery', {
            forcePlaceholderSize: true,
            placeholder: '<div class="sortable-placeholder"><div class="placeholder-area">' + html.querySelector('.sortable-gallery').dataset.placeholderText + '</div></div>',
            acceptFrom: '.sortable-gallery'
        })[0];
        gallery.addEventListener('sortstart', (e)=>{
            const height = e.detail.item.offsetHeight;
            const interval = setInterval(()=>{
                const ph = e.detail.item.closest('.sortable-gallery').querySelector('.sortable-placeholder');
                if (ph) {
                    clearInterval(interval);
                    ph.className += ' ' + e.detail.item.className;
                    ph.classList.remove('sortable-dragging');
                    ph.querySelector('.placeholder-area').style.height = `${height}px`;
                    ph.style.height = height + 'px';
                }
            }, 10);
        });
        gallery.addEventListener('sortupdate', (e)=>{
            const fileId = e.detail.item.dataset.fileId;
            const destination = e.detail.destination.index;
            const url = e.detail.item.closest('.sortable-gallery').dataset.url;
            (0, $da6d917fcd2d3fe8$export$2e2bcd8739ae039).makeRequest('GET', url, {
                fileId: fileId,
                destination: destination
            }, {
                history: false
            }).catch((err)=>{
                alert(err);
            });
        });
        const attachemnts = (0, $db58504db5b9e911$export$2e2bcd8739ae039)('.sortable-attachments', {
            forcePlaceholderSize: true,
            placeholder: '<div class="sortable-placeholder"><div class="placeholder-area">' + html.querySelector('.sortable-attachments').dataset.placeholderText + '</div></div>',
            acceptFrom: '.sortable-attachments'
        })[0];
        attachemnts.addEventListener('sortstart', (e)=>{
            const height = e.detail.item.offsetHeight;
            const interval = setInterval(()=>{
                const ph = e.detail.item.closest('.sortable-attachments').querySelector('.sortable-placeholder');
                if (ph) {
                    clearInterval(interval);
                    ph.className += ' ' + e.detail.item.className;
                    ph.classList.remove('sortable-dragging');
                    ph.querySelector('.placeholder-area').style.height = `${height}px`;
                    ph.style.height = height + 'px';
                }
            }, 10);
        });
        attachemnts.addEventListener('sortupdate', (e)=>{
            const fileId = e.detail.item.dataset.fileId;
            const destination = e.detail.destination.index;
            const url = e.detail.item.closest('.sortable-attachments').dataset.url;
            (0, $da6d917fcd2d3fe8$export$2e2bcd8739ae039).makeRequest('GET', url, {
                fileId: fileId,
                destination: destination
            }, {
                history: false
            }).catch((err)=>{
                alert(err);
            });
        });
    }
}






function $05690cdbf9f6b44d$export$2e2bcd8739ae039(html) {
    const form = html.querySelector('form#frm-pageManager-pageForm');
    if (form) {
        const ajaxStartCallback = (event)=>{
            const url = new URL(event.detail.request.url);
            const params = new URLSearchParams(url.search);
            if (event.detail.request.method !== 'GET' || params.get('ajaxLoader')?.toString() === "true") html.querySelector('#ajaxLoader')?.classList.remove('d-none');
            html.querySelectorAll('.modal').forEach((el)=>{
                if (!el.dataset.ajaxHideSkip) (0, $91ca15859685b28b$export$2b77a92f1a5ad772).getInstance(el)?.hide();
            });
        };
        const snippetBeforeUpdateCallback = ()=>{
            html.querySelectorAll('.tinymce-initiated').forEach((el)=>{
                const editor = window.tinymce.get(el.getAttribute('id'));
                editor.remove();
            });
        };
        const snippetAfterUpdateCallback = ()=>{
            html.querySelector('#ajaxLoader')?.classList.add('d-none');
        };
        const redirectHandler = (event)=>{
            if (!event.detail.url.includes('editorMode=') || event.detail.url.includes('forceRedirect=1')) event.detail.setHardRedirect(true);
        };
        (0, $da6d917fcd2d3fe8$export$2e2bcd8739ae039).removeEventListener('start', ajaxStartCallback);
        (0, $da6d917fcd2d3fe8$export$2e2bcd8739ae039).addEventListener('start', ajaxStartCallback);
        (0, $da6d917fcd2d3fe8$export$2e2bcd8739ae039).snippetHandler.removeEventListener('beforeUpdate', snippetBeforeUpdateCallback);
        (0, $da6d917fcd2d3fe8$export$2e2bcd8739ae039).snippetHandler.addEventListener('beforeUpdate', snippetBeforeUpdateCallback);
        (0, $da6d917fcd2d3fe8$export$2e2bcd8739ae039).snippetHandler.removeEventListener('afterUpdate', snippetAfterUpdateCallback);
        (0, $da6d917fcd2d3fe8$export$2e2bcd8739ae039).snippetHandler.addEventListener('afterUpdate', snippetAfterUpdateCallback);
        (0, $da6d917fcd2d3fe8$export$2e2bcd8739ae039).redirectHandler.removeEventListener('redirect', redirectHandler);
        (0, $da6d917fcd2d3fe8$export$2e2bcd8739ae039).redirectHandler.addEventListener('redirect', redirectHandler);
        const showPageType = (value)=>{
            const dynamic = form.querySelector('.row.dynamic').closest('.container');
            const people = form.querySelector('.row.people').closest('.container');
            const otherPageType = form.querySelector('.row.other-page-type').closest('.container');
            dynamic.classList.add('d-none');
            people.classList.add('d-none');
            otherPageType.classList.add('d-none');
            form.querySelectorAll('.other-page-type-topic').forEach((el)=>{
                el.classList.add('d-none');
            });
            if (value === 'dynamic') dynamic.classList.remove('d-none');
            else if (value === 'people') {
                people.classList.remove('d-none');
                form.querySelectorAll('.other-page-type-topic[data-page-type-people]').forEach((el)=>{
                    el.classList.remove('d-none');
                });
            } else if (value === 'news') {
                otherPageType.classList.remove('d-none');
                form.querySelectorAll('.other-page-type-topic[data-page-type-news]').forEach((el)=>{
                    el.classList.remove('d-none');
                });
            } else if (value === 'official_desk') {
                otherPageType.classList.remove('d-none');
                form.querySelectorAll('.other-page-type-topic[data-page-type-official_desk]').forEach((el)=>{
                    el.classList.remove('d-none');
                });
            } else if (value === 'documents') {
                otherPageType.classList.remove('d-none');
                form.querySelectorAll('.other-page-type-topic[data-page-type-documents]').forEach((el)=>{
                    el.classList.remove('d-none');
                });
            }
        };
        (0, $c3c577fb288a0e50$export$2e2bcd8739ae039)({
            selector: 'textarea[data-tinymce]:not(.tinymce-initiated)',
            height: 360
        });
        form.querySelectorAll('input[type=radio][name=type]').forEach((el)=>{
            el.addEventListener('change', (e)=>{
                showPageType(e.currentTarget.value);
            });
        });
        form.querySelectorAll('.modal.topics .topic').forEach((topic)=>{
            topic.classList.add('d-none');
        });
        form.querySelectorAll('input[type=radio][name=type]').forEach((el)=>{
            el.addEventListener('change', (e)=>{
                form.querySelectorAll('.modal.topics .topic').forEach((topic)=>{
                    topic.classList.add('d-none');
                });
                form.querySelectorAll('.modal.topics [data-page-type-' + e.currentTarget.value + ']').forEach((topic)=>{
                    topic.classList.remove('d-none');
                });
            });
        });
        const type = form.querySelector('input[type=radio][name=type]:checked');
        if (type) {
            showPageType(type.value);
            form.querySelectorAll('.modal.topics [data-page-type-' + type.value + ']').forEach((topic)=>{
                topic.classList.remove('d-none');
            });
        }
        for (let selector of [
            '#topic1Modal',
            '#topic2Modal'
        ]){
            const btn = html.querySelector('button[data-bs-target="' + selector + '"]');
            html.querySelectorAll(selector + ' input[type=radio]').forEach((el)=>{
                el.addEventListener('change', (e)=>{
                    btn.classList.add('placeholder');
                    btn.classList.remove('btn');
                    btn.classList.remove('btn-outline-blue');
                    btn.classList.remove('text-uppercase');
                    btn.textContent = btn.dataset.text;
                    const el = e.target;
                    if (el.checked) {
                        btn.classList.remove('placeholder');
                        btn.classList.add('btn');
                        btn.classList.add('btn-outline-blue');
                        btn.classList.add('text-uppercase');
                        btn.textContent = el.nextElementSibling.textContent;
                    }
                });
            });
            html.querySelector(selector + ' button.reset').addEventListener('click', (e)=>{
                e.preventDefault();
                e.currentTarget.closest('.modal').querySelectorAll('input[type=radio]').forEach((el)=>{
                    el.checked = false;
                    btn.classList.add('placeholder');
                    btn.classList.remove('btn');
                    btn.classList.remove('btn-outline-blue');
                    btn.classList.remove('text-uppercase');
                    btn.textContent = btn.dataset.text;
                });
            });
        }
        form.querySelectorAll('input[type=radio][name=section]').forEach((el)=>{
            el.addEventListener('change', (e)=>{
                form.querySelectorAll('.modal.departments .department').forEach((department)=>{
                    department.classList.add('d-none');
                });
                const values = e.currentTarget.value === 'both' ? [
                    'web',
                    'intranet'
                ] : [
                    e.currentTarget.value
                ];
                for (let value of values)form.querySelectorAll('.modal.departments [data-' + value + ']').forEach((department)=>{
                    department.classList.remove('d-none');
                });
            });
        });
        const section = form.querySelector('input[type=radio][name=section]:checked');
        if (section) {
            const values = section.value === 'both' ? [
                'web',
                'intranet'
            ] : [
                section.value
            ];
            for (let value of values)form.querySelectorAll('.modal.departments [data-' + value + ']').forEach((department)=>{
                department.classList.remove('d-none');
            });
        }
        form.querySelectorAll('button.upload-more').forEach((el)=>{
            el.addEventListener('click', (e)=>{
                e.preventDefault();
                if (e.isTrusted) e.currentTarget.closest('.widget').querySelector('.drop-zone').click();
            });
        });
        form.querySelectorAll('.upload-helper, .upload-more').forEach((el)=>{
            const input = el.querySelector('input[type=file]');
            if (input) {
                input.addEventListener('change', (e)=>{
                    const multiple = e.currentTarget.hasAttribute('multiple');
                    let row = el.classList.contains('upload-more') ? e.currentTarget.closest('.upload-more').previousElementSibling.previousElementSibling : e.currentTarget.closest('.upload-helper').nextElementSibling;
                    let widgetFiles = e.currentTarget.closest('.widget.files');
                    row.querySelectorAll('.img-preview.not-uploaded, .file-preview.not-uploaded').forEach((el)=>{
                        el.remove();
                    });
                    for (const file of e.target.files)if (!widgetFiles && file.type.startsWith("image/")) {
                        const col = document.createElement("div");
                        const remove = document.createElement("button");
                        const img = document.createElement("img");
                        col.classList.add('img-preview');
                        col.classList.add('not-uploaded');
                        if (multiple) col.classList.add('multiple');
                        remove.setAttribute('type', 'button');
                        remove.classList.add('remove');
                        remove.innerHTML = '<i class="fas fa-times"></i>';
                        remove.addEventListener('click', (e)=>{
                            row.querySelectorAll('.img-preview.not-uploaded, .file-preview.not-uploaded').forEach((el)=>{
                                el.remove();
                            });
                            input.value = null;
                            if (row.querySelectorAll('.img-preview, .file-preview').length === 0) {
                                el.classList.remove('d-none');
                                el.parentElement.querySelector('.upload-more')?.classList.add('d-none');
                            }
                        });
                        img.file = file;
                        img.classList.add('img-fluid');
                        if (multiple) img.setAttribute('style', 'max-height: 120px');
                        col.appendChild(remove);
                        col.appendChild(img);
                        row.appendChild(col);
                        el.parentElement.querySelector('.upload-more')?.classList.remove('d-none');
                        const reader = new FileReader();
                        reader.onload = ()=>{
                            if (typeof reader.result === 'string') img.src = reader.result;
                        };
                        reader.readAsDataURL(file);
                    } else {
                        const col = document.createElement("div");
                        const text = document.createElement("div");
                        const remove = document.createElement("button");
                        col.classList.add('file-preview');
                        col.classList.add('not-uploaded');
                        if (multiple) col.classList.add('multiple');
                        remove.setAttribute('type', 'button');
                        remove.classList.add('remove');
                        remove.innerHTML = '<i class="fas fa-times"></i>';
                        remove.addEventListener('click', (e)=>{
                            row.querySelectorAll('.img-preview.not-uploaded, .file-preview.not-uploaded').forEach((el)=>{
                                el.remove();
                            });
                            input.value = null;
                            if (row.querySelectorAll('.img-preview, .file-preview').length === 0) {
                                el.classList.remove('d-none');
                                el.parentElement.querySelector('.upload-more')?.classList.add('d-none');
                            }
                        });
                        text.classList.add('file');
                        text.classList.add('text-nowrap');
                        text.innerHTML = '<i class="fas fa-file me-2"></i>' + file.name;
                        col.appendChild(remove);
                        col.appendChild(text);
                        row.appendChild(col);
                        el.parentElement.querySelector('.upload-more')?.classList.remove('d-none');
                    }
                    if (!el.classList.contains('upload-more')) el.classList.add('d-none');
                });
                const dropZone = el.querySelector('.drop-zone');
                if (dropZone) {
                    dropZone.addEventListener('dragover', (e)=>{
                        e.preventDefault();
                        dropZone.classList.remove('btn-outline-blue');
                        dropZone.classList.add('btn-blue');
                    });
                    dropZone.addEventListener('dragleave', (e)=>{
                        e.preventDefault();
                        dropZone.classList.remove('btn-blue');
                        dropZone.classList.add('btn-outline-blue');
                    });
                    dropZone.addEventListener('drop', (e)=>{
                        e.preventDefault();
                        dropZone.classList.remove('btn-blue');
                        dropZone.classList.add('btn-outline-blue');
                        input.files = e.dataTransfer.files;
                        input.dispatchEvent(new Event('change'));
                    });
                }
                el.addEventListener('click', (e)=>{
                    const input = el.querySelector('input[type=file]');
                    if (input) input.click();
                });
            }
        });
        html.querySelectorAll('input[name=section]').forEach((el)=>{
            el.addEventListener('change', (e)=>{
                const web = html.querySelector('input[name=parentWeb]').closest('.web');
                const intranet = html.querySelector('input[name=parentIntranet]').closest('.intranet');
                const value = e.currentTarget.value;
                if (web && intranet) {
                    const webText = web.querySelector('.form-text');
                    const intranetText = intranet.querySelector('.form-text');
                    web.classList.add('d-none');
                    webText.classList.add('d-none');
                    intranet.classList.add('d-none');
                    intranetText.classList.add('d-none');
                    if (value === 'web') web.classList.remove('d-none');
                    else if (value === 'intranet') intranet.classList.remove('d-none');
                    else if (value === 'both') {
                        web.classList.remove('d-none');
                        webText.classList.remove('d-none');
                        intranet.classList.remove('d-none');
                        intranetText.classList.remove('d-none');
                    }
                }
            });
        });
        html.querySelectorAll('.img-preview button.remove, .file-preview button.remove').forEach((el)=>{
            el.addEventListener('click', (e)=>{
                const root = e.currentTarget.closest('.d-flex');
                const stack = root.nextElementSibling;
                stack.value += e.currentTarget.dataset.id + ';';
                e.currentTarget.closest('.img-preview')?.remove();
                e.currentTarget.closest('.file-preview')?.remove();
                if (root.querySelectorAll('.img-preview, .file-preview').length === 0) {
                    root.previousElementSibling.classList.remove('d-none');
                    root.parentElement.querySelector('.upload-more')?.classList.add('d-none');
                }
            });
        });
        for (let section of [
            'web',
            'intranet'
        ]){
            const selector = '[data-bs-toggle=modal][data-' + section + '-url]';
            html.querySelectorAll(selector).forEach((el)=>{
                el.addEventListener('click', (e)=>{
                    const loader = document.querySelector('#contentPreviewLoader');
                    loader.classList.remove('d-none');
                    const iframe = document.querySelector('#contentPreviewModal iframe.' + section);
                    iframe.classList.add('d-none');
                    const url = e.currentTarget.getAttribute('data-' + section + '-url');
                    if (url) {
                        const callback = (e)=>{
                            loader.classList.add('d-none');
                            e.currentTarget.classList.remove('d-none');
                        };
                        iframe.removeEventListener('load', callback);
                        iframe.addEventListener('load', callback);
                        iframe.setAttribute('src', url);
                    } else alert('URL not found.');
                });
            });
        }
        form.querySelectorAll('input[type=checkbox][name="departments[]"]').forEach((el)=>{
            el.addEventListener('change', (e)=>{
                const value = e.currentTarget.value;
                const box = form.querySelector('.departments-box');
                const list = form.querySelector('.departments-list');
                if (el.checked) {
                    box.classList.add('d-none');
                    list.querySelector('[data-code="' + value + '"]')?.classList.remove('d-none');
                } else {
                    list.querySelector('[data-code="' + value + '"]')?.classList.add('d-none');
                    if (form.querySelectorAll('input[type=checkbox][name="departments[]"]:checked').length === 0) box.classList.remove('d-none');
                }
            });
        });
        $05690cdbf9f6b44d$var$initWidgetArticles(html);
        $05690cdbf9f6b44d$var$initWidgetInfobox(html);
        $05690cdbf9f6b44d$var$initWidgetContacts(html);
        $05690cdbf9f6b44d$var$initWidgetPeople(html);
        $05690cdbf9f6b44d$var$initDynamicPageSortable(html);
        $05690cdbf9f6b44d$var$initWidgetFilesSortable(html);
    }
}
function $05690cdbf9f6b44d$var$initWidgetArticles(html) {
    html.querySelectorAll('.widget.articles').forEach((widget)=>{
        // Source callback
        const sourceCallback = (value)=>{
            const departments = widget.querySelectorAll('.row.departments');
            const topics = widget.querySelectorAll('.row.topics');
            const author = widget.querySelectorAll('.row.author');
            departments.forEach((el)=>{
                el.classList.add('d-none');
            });
            topics.forEach((el)=>{
                el.classList.add('d-none');
            });
            author.forEach((el)=>{
                el.classList.add('d-none');
            });
            if (value === 'department') departments.forEach((el)=>{
                el.classList.remove('d-none');
            });
            else if (value === 'topic') topics.forEach((el)=>{
                el.classList.remove('d-none');
            });
            else if (value === 'author') author.forEach((el)=>{
                el.classList.remove('d-none');
            });
        };
        // Selection callback
        const selectionCallback = (value)=>{
            const auto = widget.querySelectorAll('.row.auto');
            const manually = widget.querySelectorAll('.row.manually');
            auto.forEach((el)=>{
                el.classList.add('d-none');
            });
            manually.forEach((el)=>{
                el.classList.add('d-none');
            });
            if (value === 'auto') {
                auto.forEach((el)=>{
                    el.classList.remove('d-none');
                });
                sourceCallback(null);
                widget.querySelectorAll('input[name*="Source"]:checked').forEach((el)=>{
                    sourceCallback(el.value);
                });
            } else if (value === 'manually') manually.forEach((el)=>{
                el.classList.remove('d-none');
            });
        };
        widget.querySelectorAll('input[name*="Selection"]').forEach((el)=>{
            el.addEventListener('change', (e)=>{
                selectionCallback(e.currentTarget.value);
            });
        });
        widget.querySelectorAll('input[name*="Selection"]:checked').forEach((el)=>{
            selectionCallback(el.value);
        });
        widget.querySelectorAll('input[name*="Source"]').forEach((el)=>{
            el.addEventListener('change', (e)=>{
                sourceCallback(e.currentTarget.value);
            });
        });
        widget.querySelectorAll('input[name*="Source"]:checked').forEach((el)=>{
            sourceCallback(el.value);
        });
        widget.querySelectorAll('.typeahead input[name*="ArticleId"]').forEach((el)=>{
            el.addEventListener('complete', (e)=>{
                const typeahead = e.target.previousElementSibling;
                const user = typeahead.value;
                const userId = parseInt(e.target.value);
                if (!userId) return;
                const name = typeahead.getAttribute('name').replace(/Article]/, 'Articles][]');
                const check = document.createElement('div');
                check.classList.add('form-check');
                const input = document.createElement('input');
                input.setAttribute('type', 'checkbox');
                input.setAttribute('name', name);
                input.setAttribute('id', name + 'user' + userId);
                input.classList.add('form-check-input');
                input.value = userId.toString();
                input.checked = true;
                const label = document.createElement('label');
                label.setAttribute('for', name + 'user' + userId);
                label.classList.add('form-check-label');
                label.textContent = user;
                check.append(input);
                check.append(label);
                const articles = typeahead.closest('.row.articles').nextElementSibling.querySelector('.col-9');
                articles.append(check);
                e.target.value = '';
                typeahead.value = '';
            });
        });
    });
}
function $05690cdbf9f6b44d$var$initWidgetInfobox(html) {
    html.querySelectorAll('.widget.infobox').forEach((widget)=>{
        // Contact callback
        const contactCallback = (row, value)=>{
            const departments = widget.querySelectorAll('.row.departments[data-part="' + row.dataset.part + '"]');
            const persons = widget.querySelectorAll('.row.persons[data-part="' + row.dataset.part + '"]');
            departments.forEach((el)=>{
                el.classList.add('d-none');
            });
            persons.forEach((el)=>{
                el.classList.add('d-none');
            });
            if (value === 'department') departments.forEach((el)=>{
                el.classList.remove('d-none');
            });
            else if (value === 'people') persons.forEach((el)=>{
                el.classList.remove('d-none');
            });
        };
        // Information callback
        const informationCallback = (row, value)=>{
            const text = widget.querySelectorAll('.row.text[data-part="' + row.dataset.part + '"]');
            const contact = widget.querySelectorAll('.row.contact[data-part="' + row.dataset.part + '"]');
            text.forEach((el)=>{
                el.classList.add('d-none');
            });
            contact.forEach((el)=>{
                el.classList.add('d-none');
            });
            if (value === 'text') text.forEach((el)=>{
                (0, $c3c577fb288a0e50$export$2e2bcd8739ae039)({
                    selector: 'textarea[data-tinymce-text][data-part-' + row.dataset.part + ']',
                    height: 360
                });
                el.classList.remove('d-none');
            });
            else {
                contact.forEach((el)=>{
                    el.classList.remove('d-none');
                });
                contactCallback(row, null);
                row.querySelectorAll('input[name*="Contact"]:checked').forEach((el)=>{
                    contactCallback(row, el.value);
                });
            }
        };
        widget.querySelectorAll('input[name*="Information"]').forEach((el)=>{
            el.addEventListener('change', (e)=>{
                const row = e.currentTarget.closest('.row');
                informationCallback(row, e.currentTarget.value);
            });
        });
        widget.querySelectorAll('input[name*="Information"]:checked').forEach((el)=>{
            const row = el.closest('.row');
            informationCallback(row, el.value);
        });
        widget.querySelectorAll('input[name*="Contact"]').forEach((el)=>{
            el.addEventListener('change', (e)=>{
                const row = e.currentTarget.closest('.row');
                contactCallback(row, e.currentTarget.value);
            });
        });
        widget.querySelectorAll('input[name*="Contact"]:checked').forEach((el)=>{
            const row = el.closest('.row');
            contactCallback(row, el.value);
        });
        // Persons
        widget.querySelectorAll('.typeahead input[name*="PersonId"]').forEach((el)=>{
            el.addEventListener('complete', (e)=>{
                const typeahead = e.target.previousElementSibling;
                const user = typeahead.value;
                const userId = parseInt(e.target.value);
                if (!userId) return;
                const name = typeahead.getAttribute('name').replace(/Person]/, 'Persons][]');
                const check = document.createElement('div');
                check.classList.add('form-check');
                const input = document.createElement('input');
                input.setAttribute('type', 'checkbox');
                input.setAttribute('name', name);
                input.setAttribute('id', name + 'user' + userId);
                input.classList.add('form-check-input');
                input.value = userId.toString();
                input.checked = true;
                const label = document.createElement('label');
                label.setAttribute('for', name + 'user' + userId);
                label.classList.add('form-check-label');
                label.textContent = user;
                check.append(input);
                check.append(label);
                const persons = typeahead.closest('.row.persons').nextElementSibling.querySelector('.col-9');
                persons.append(check);
                e.target.value = '';
                typeahead.value = '';
            });
        });
        widget.querySelectorAll('.infobox-next-part').forEach((el)=>{
            el.addEventListener('click', (e)=>{
                e.preventDefault();
                const part = parseInt(el.dataset.part) + 1;
                el.closest('.widget').querySelectorAll('.shown.infobox-part-' + part).forEach((el)=>{
                    el.classList.remove('d-none');
                });
                el.dataset.part = part.toString();
            });
        });
    });
}
function $05690cdbf9f6b44d$var$initWidgetContacts(html) {
    html.querySelectorAll('.widget.contacts').forEach((widget)=>{
        const selectionCallback = (value)=>{
            const departments = widget.querySelectorAll('.row.departments');
            const persons = widget.querySelectorAll('.row.persons');
            departments.forEach((el)=>{
                el.classList.add('d-none');
            });
            persons.forEach((el)=>{
                el.classList.add('d-none');
            });
            if (value === 'department') departments.forEach((el)=>{
                el.classList.remove('d-none');
            });
            else persons.forEach((el)=>{
                el.classList.remove('d-none');
            });
        };
        widget.querySelectorAll('input[name*="Selection"]').forEach((el)=>{
            el.addEventListener('change', (e)=>{
                selectionCallback(e.currentTarget.value);
            });
        });
        widget.querySelectorAll('input[name*="Selection"]:checked').forEach((el)=>{
            selectionCallback(el.value);
        });
        widget.querySelectorAll('.typeahead input[name*="PersonId"]').forEach((el)=>{
            el.addEventListener('complete', (e)=>{
                const typeahead = e.target.previousElementSibling;
                const user = typeahead.value;
                const userId = parseInt(e.target.value);
                if (!userId) return;
                const name = typeahead.getAttribute('name').replace(/Person]/, 'Persons][]');
                const check = document.createElement('div');
                check.classList.add('form-check');
                const input = document.createElement('input');
                input.setAttribute('type', 'checkbox');
                input.setAttribute('name', name);
                input.setAttribute('id', name + 'user' + userId);
                input.classList.add('form-check-input');
                input.value = userId.toString();
                input.checked = true;
                const label = document.createElement('label');
                label.setAttribute('for', name + 'user' + userId);
                label.classList.add('form-check-label');
                label.textContent = user;
                check.append(input);
                check.append(label);
                const persons = typeahead.closest('.row.persons').nextElementSibling.querySelector('.col-9');
                persons.append(check);
                e.target.value = '';
                typeahead.value = '';
            });
        });
    });
}
function $05690cdbf9f6b44d$var$initWidgetPeople(html) {
    html.querySelectorAll('.widget.people').forEach((widget)=>{
        const linkCallback = (row, value)=>{
            const url = widget.querySelectorAll('.row.url[data-part="' + row.dataset.part + '"]');
            url.forEach((el)=>{
                el.classList.add('d-none');
            });
            if (value === 'page') url.forEach((el)=>{
                el.classList.remove('d-none');
            });
        };
        widget.querySelectorAll('input[name*="Link"]').forEach((el)=>{
            el.addEventListener('change', (e)=>{
                const row = e.currentTarget.closest('.row');
                linkCallback(row, e.currentTarget.value);
            });
        });
        widget.querySelectorAll('input[name*="Link"]:checked').forEach((el)=>{
            const row = el.closest('.row');
            linkCallback(row, el.value);
        });
        widget.querySelectorAll('.people-next-part').forEach((el)=>{
            el.addEventListener('click', (e)=>{
                e.preventDefault();
                const part = parseInt(el.dataset.part) + 1;
                el.closest('.widget').querySelectorAll('.shown.people-part-' + part).forEach((el)=>{
                    el.classList.remove('d-none');
                });
                el.dataset.part = part.toString();
            });
        });
    });
}
function $05690cdbf9f6b44d$var$initDynamicPageSortable(html) {
    for (let el of (0, $db58504db5b9e911$export$2e2bcd8739ae039)('.rows-sortable', {
        forcePlaceholderSize: false,
        placeholder: '<div class="sortable-placeholder"><div class="placeholder-area">' + html.querySelector('.row.dynamic').dataset.placeholderText + '</div></div>',
        handle: '.sortable-row-move'
    })){
        el.addEventListener('sortstart', (e)=>{
            const height = e.detail.item.offsetHeight;
            const interval = setInterval(()=>{
                const ph = e.detail.item.closest('.rows-sortable').querySelector('.sortable-placeholder');
                if (ph) {
                    clearInterval(interval);
                    ph.className += ' ' + e.detail.item.className;
                    ph.classList.remove('sortable-dragging');
                    ph.querySelector('.placeholder-area').style.height = `${height}px`;
                    ph.style.height = height + 'px';
                }
            }, 10);
        });
        el.addEventListener('sortstop', (e)=>{
            e.detail.item.querySelectorAll('.tinymce-initiated').forEach((input)=>{
                let editor = window.tinymce.get(input.getAttribute('id'));
                if (editor) {
                    editor.save();
                    window.tinymce.remove(editor);
                    input.classList.remove('tinymce-initiated');
                    (0, $c3c577fb288a0e50$export$2e2bcd8739ae039)({
                        selector: 'textarea#' + input.getAttribute('id'),
                        height: 360
                    });
                }
            });
        });
        el.addEventListener('sortupdate', (e)=>{
            const originRowIndex = e.detail.item.dataset.rowIndex;
            const newRowIndex = e.detail.destination.index;
            const url = e.detail.item.closest('.rows-sortable').dataset.url;
            (0, $da6d917fcd2d3fe8$export$2e2bcd8739ae039).makeRequest('GET', url, {
                origin: originRowIndex,
                destination: newRowIndex,
                ajaxLoader: 'true'
            }, {
                history: false
            }).catch((err)=>{
                alert(err);
            });
        });
    }
    for (let el of (0, $db58504db5b9e911$export$2e2bcd8739ae039)('.cols-sortable', {
        forcePlaceholderSize: false,
        placeholder: '<div class="sortable-placeholder"><div class="placeholder-area">' + html.querySelector('.row.dynamic').dataset.placeholderText + '</div></div>',
        handle: '.sortable-col-move',
        orientation: "horizontal"
    })){
        el.addEventListener('sortstart', (e)=>{
            const height = e.detail.item.offsetHeight;
            const interval = setInterval(()=>{
                const ph = e.detail.item.closest('.cols-sortable').querySelector('.sortable-placeholder');
                if (ph) {
                    clearInterval(interval);
                    ph.className += ' ' + e.detail.item.className;
                    ph.classList.remove('sortable-dragging');
                    ph.querySelector('.placeholder-area').style.height = `${height}px`;
                    ph.style.height = height + 'px';
                }
            }, 10);
        });
        el.addEventListener('sortstop', (e)=>{
            e.detail.item.querySelectorAll('.tinymce-initiated').forEach((input)=>{
                let editor = window.tinymce.get(input.getAttribute('id'));
                if (editor) {
                    editor.save();
                    window.tinymce.remove(editor);
                    input.classList.remove('tinymce-initiated');
                    (0, $c3c577fb288a0e50$export$2e2bcd8739ae039)({
                        selector: 'textarea#' + input.getAttribute('id'),
                        height: 360
                    });
                }
            });
        });
        el.addEventListener('sortupdate', (e)=>{
            const rowIndex = e.detail.item.dataset.rowIndex;
            const originColIndex = e.detail.item.dataset.colIndex;
            const newColIndex = e.detail.destination.index;
            const url = e.detail.item.closest('.cols-sortable').dataset.url;
            (0, $da6d917fcd2d3fe8$export$2e2bcd8739ae039).makeRequest('GET', url, {
                rowIndex: rowIndex,
                origin: originColIndex,
                destination: newColIndex,
                ajaxLoader: 'true'
            }, {
                history: false
            }).catch((err)=>{
                alert(err);
            });
        });
    }
    for (let el of (0, $db58504db5b9e911$export$2e2bcd8739ae039)('.widgets-sortable', {
        forcePlaceholderSize: false,
        placeholder: '<div class="sortable-placeholder"><div class="placeholder-area">' + html.querySelector('.row.dynamic').dataset.placeholderText + '</div></div>',
        handle: '.sortable-widget-move',
        acceptFrom: '.widgets-sortable'
    })){
        el.addEventListener('sortstart', (e)=>{
            const height = e.detail.item.offsetHeight;
            const interval = setInterval(()=>{
                const ph = e.detail.item.closest('.widgets-sortable').querySelector('.sortable-placeholder');
                if (ph) {
                    clearInterval(interval);
                    ph.className += ' ' + e.detail.item.className;
                    ph.classList.remove('sortable-dragging');
                    ph.querySelector('.placeholder-area').style.height = `${height}px`;
                    ph.style.height = height + 'px';
                }
            }, 10);
        });
        el.addEventListener('sortstop', (e)=>{
            e.detail.item.querySelectorAll('.tinymce-initiated').forEach((input)=>{
                let editor = window.tinymce.get(input.getAttribute('id'));
                if (editor) {
                    editor.save();
                    window.tinymce.remove(editor);
                    input.classList.remove('tinymce-initiated');
                    (0, $c3c577fb288a0e50$export$2e2bcd8739ae039)({
                        selector: 'textarea#' + input.getAttribute('id'),
                        height: 360
                    });
                }
            });
        });
        el.addEventListener('sortupdate', (e)=>{
            const rowIndex = e.detail.item.dataset.rowIndex;
            const colIndex = e.detail.item.dataset.colIndex;
            const originWidgetIndex = e.detail.item.dataset.widgetIndex;
            const newWidgetIndex = e.detail.destination.index;
            const newRowIndex = e.detail.destination.container.dataset.row;
            const newColIndex = e.detail.destination.container.dataset.col;
            const url = e.detail.item.closest('.widgets-sortable').dataset.url;
            (0, $da6d917fcd2d3fe8$export$2e2bcd8739ae039).makeRequest('GET', url, {
                rowIndex: rowIndex,
                colIndex: colIndex,
                origin: originWidgetIndex,
                destination: newWidgetIndex,
                newRowIndex: newRowIndex,
                newColIndex: newColIndex,
                ajaxLoader: 'true'
            }, {
                history: false
            }).catch((err)=>{
                alert(err);
            });
        });
    }
}
function $05690cdbf9f6b44d$var$initWidgetFilesSortable(html) {
    for (let el of (0, $db58504db5b9e911$export$2e2bcd8739ae039)('.widget-files-sortable', {
        forcePlaceholderSize: true,
        placeholderClass: 'sortable-file-placeholder',
        placeholder: '<div class="sortable-file-placeholder"><div class="file-placeholder-area">' + html.querySelector('.widget-files-sortable')?.dataset.placeholderText + '</div></div>',
        orientation: "horizontal"
    }))el.addEventListener('sortupdate', (e)=>{
        const pageColumnWidgetId = e.detail.item.dataset.pageColumnWidgetId;
        const widgetName = e.detail.item.dataset.widgetName;
        const fileId = e.detail.item.dataset.fileId;
        const destination = e.detail.destination.index;
        const url = e.detail.item.closest('.widget-files-sortable').dataset.url;
        (0, $da6d917fcd2d3fe8$export$2e2bcd8739ae039).makeRequest('GET', url, {
            pageColumnWidgetId: pageColumnWidgetId,
            widgetName: widgetName,
            fileId: fileId,
            destination: destination,
            ajaxLoader: 'true'
        }, {
            history: false
        }).catch((err)=>{
            alert(err);
        });
    });
}





function $e96e7bd2600a346a$export$2e2bcd8739ae039(html) {
    const form = html.querySelector('form#frm-profileManager-profileForm');
    if (form) {
        const ajaxStartCallback = (event)=>{
            if (event.detail.request.method !== 'GET') html.querySelector('#ajaxLoader')?.classList.remove('d-none');
            html.querySelectorAll('.modal').forEach((el)=>{
                if (!el.dataset.ajaxHideSkip) (0, $91ca15859685b28b$export$2b77a92f1a5ad772).getInstance(el)?.hide();
            });
        };
        const snippetAfterUpdateCallback = ()=>{
            html.querySelector('#ajaxLoader')?.classList.add('d-none');
        };
        (0, $da6d917fcd2d3fe8$export$2e2bcd8739ae039).removeEventListener('start', ajaxStartCallback);
        (0, $da6d917fcd2d3fe8$export$2e2bcd8739ae039).addEventListener('start', ajaxStartCallback);
        (0, $da6d917fcd2d3fe8$export$2e2bcd8739ae039).snippetHandler.removeEventListener('afterUpdate', snippetAfterUpdateCallback);
        (0, $da6d917fcd2d3fe8$export$2e2bcd8739ae039).snippetHandler.addEventListener('afterUpdate', snippetAfterUpdateCallback);
        const redirectHandler = (event)=>{
            if (!event.detail.url.includes('editorMode=')) event.detail.setHardRedirect(true);
        };
        (0, $da6d917fcd2d3fe8$export$2e2bcd8739ae039).redirectHandler.removeEventListener('redirect', redirectHandler);
        (0, $da6d917fcd2d3fe8$export$2e2bcd8739ae039).redirectHandler.addEventListener('redirect', redirectHandler);
        form.querySelectorAll('textarea[rows="1"]').forEach((el)=>{
            el.addEventListener('keydown', (e)=>{
                if (e.keyCode === 13) e.preventDefault();
            });
        });
        form.querySelectorAll('[data-tinymce]').forEach((el)=>{
            el.addEventListener('focus', (e)=>{
                e.currentTarget.previousElementSibling.classList.remove('visually-hidden');
                (0, $c3c577fb288a0e50$export$2e2bcd8739ae039)({
                    selector: 'textarea#' + e.currentTarget.getAttribute('id') + '[data-tinymce]',
                    height: 360,
                    autofocus: true
                });
                window.tinymce.get(e.currentTarget.getAttribute('id'))?.show();
            });
        });
        form.querySelectorAll('.tinymce-helper').forEach((el)=>{
            el.addEventListener('click', (e)=>{
                const parent = e.currentTarget.parentElement;
                const helper = parent.querySelector('.tinymce-helper');
                helper.classList.add('d-none');
                const input = parent.querySelector('[data-tinymce]');
                input.classList.remove('d-none');
                input.focus();
                const editor = window.tinymce.get(input.getAttribute('id'));
                editor.show();
                editor.focus();
            });
        });
        form.querySelectorAll('.upload-helper').forEach((el)=>{
            const input = el.querySelector('input[type=file]');
            input.addEventListener('change', (e)=>{
                const multiple = e.currentTarget.hasAttribute('multiple');
                let row = e.currentTarget.closest('.upload-helper').nextElementSibling;
                for (const file of e.target.files)if (file.type.startsWith("image/")) {
                    const col = document.createElement("div");
                    const remove = document.createElement("button");
                    const img = document.createElement("img");
                    col.classList.add('img-preview');
                    col.classList.add('not-uploaded');
                    if (multiple) col.classList.add('multiple');
                    remove.setAttribute('type', 'button');
                    remove.classList.add('remove');
                    remove.innerHTML = '<i class="fas fa-times"></i>';
                    remove.addEventListener('click', (e)=>{
                        row.querySelectorAll('.img-preview.not-uploaded, .file-preview.not-uploaded').forEach((el)=>{
                            el.remove();
                        });
                        input.value = null;
                        if (row.querySelectorAll('.img-preview, .file-preview').length === 0) {
                            el.classList.remove('d-none');
                            el.parentElement.querySelector('.upload-more')?.classList.add('d-none');
                        }
                    });
                    img.file = file;
                    img.classList.add('img-fluid');
                    if (multiple) img.setAttribute('style', 'max-height: 120px');
                    col.appendChild(remove);
                    col.appendChild(img);
                    row.appendChild(col);
                    el.parentElement.querySelector('.upload-more')?.classList.remove('d-none');
                    const reader = new FileReader();
                    reader.onload = ()=>{
                        if (typeof reader.result === 'string') img.src = reader.result;
                    };
                    reader.readAsDataURL(file);
                } else {
                    const col = document.createElement("div");
                    const text = document.createElement("div");
                    const remove = document.createElement("button");
                    col.classList.add('file-preview');
                    col.classList.add('not-uploaded');
                    if (multiple) col.classList.add('multiple');
                    remove.setAttribute('type', 'button');
                    remove.classList.add('remove');
                    remove.innerHTML = '<i class="fas fa-times"></i>';
                    remove.addEventListener('click', (e)=>{
                        row.querySelectorAll('.img-preview.not-uploaded, .file-preview.not-uploaded').forEach((el)=>{
                            el.remove();
                        });
                        input.value = null;
                        if (row.querySelectorAll('.img-preview, .file-preview').length === 0) {
                            el.classList.remove('d-none');
                            el.parentElement.querySelector('.upload-more')?.classList.add('d-none');
                        }
                    });
                    text.classList.add('file');
                    text.classList.add('text-nowrap');
                    text.innerHTML = '<i class="fas fa-file me-2"></i>' + file.name;
                    col.appendChild(remove);
                    col.appendChild(text);
                    row.appendChild(col);
                    el.parentElement.querySelector('.upload-more')?.classList.remove('d-none');
                }
                el.classList.add('d-none');
            });
            el.addEventListener('click', (e)=>{
                const input = el.querySelector('input[type=file]');
                if (input) input.click();
            });
        });
        html.querySelectorAll('.img-preview button.remove, .file-preview button.remove').forEach((el)=>{
            el.addEventListener('click', (e)=>{
                const root = e.currentTarget.closest('.d-flex');
                const stack = root.nextElementSibling;
                stack.value += e.currentTarget.dataset.id + ';';
                e.currentTarget.closest('.img-preview')?.remove();
                e.currentTarget.closest('.file-preview')?.remove();
                if (root.querySelectorAll('.img-preview, .file-preview').length === 0) {
                    root.previousElementSibling.classList.remove('d-none');
                    root.parentElement.querySelector('.upload-more')?.classList.add('d-none');
                }
            });
        });
        html.querySelectorAll('[data-bs-toggle=modal][data-url]').forEach((el)=>{
            el.addEventListener('click', (e)=>{
                const loader = document.querySelector('#contentPreviewLoader');
                loader.classList.remove('d-none');
                const iframe = document.querySelector('#contentPreviewModal iframe');
                iframe.classList.add('d-none');
                const url = e.currentTarget.getAttribute('data-url');
                if (url) {
                    const callback = (e)=>{
                        loader.classList.add('d-none');
                        e.currentTarget.classList.remove('d-none');
                    };
                    iframe.removeEventListener('load', callback);
                    iframe.addEventListener('load', callback);
                    iframe.setAttribute('src', url);
                } else alert('URL not found.');
            });
        });
    }
}


(0, $da6d917fcd2d3fe8$export$2e2bcd8739ae039).initialize();
(0, $6861aaaf6af71002$export$2e2bcd8739ae039)();
(0, $956303e800ad0259$export$2e2bcd8739ae039)();
const $120d39244fd9022f$var$html = document.querySelector('html');
if ($120d39244fd9022f$var$html.dataset.scope) {
    const scope = $120d39244fd9022f$var$html.dataset.scope;
    const target = scope.split('.').join('_');
    (0, $80a6e9b40f3a75de$export$2e2bcd8739ae039)($120d39244fd9022f$var$html, target);
}
const $120d39244fd9022f$var$ajax = new (0, $114f9ddfce66cf9a$export$7a330199b2e76989)(document, false);
$120d39244fd9022f$var$ajax.onAfterUpdate((root)=>{
    (0, $9bd69b859d31db4a$export$2e2bcd8739ae039)(root);
    (0, $c8b9396e7e1848cb$export$2e2bcd8739ae039)(root);
    (0, $b3610fc8bdb53218$export$2e2bcd8739ae039)(root);
    (0, $9fc87da71ba88662$export$2e2bcd8739ae039)(root);
    (0, $fce77b49c90d569f$export$2e2bcd8739ae039)(root);
    (0, $b31357567f9a717b$export$2e2bcd8739ae039)(root);
    (0, $11f8bd0231fd003c$export$2e2bcd8739ae039)(root);
}).run();
const $120d39244fd9022f$var$cms = new (0, $114f9ddfce66cf9a$export$7a330199b2e76989)(document);
$120d39244fd9022f$var$cms.onAfterUpdate((root)=>{
    (0, $7a2680a035a53094$export$2e2bcd8739ae039)(root);
    (0, $05690cdbf9f6b44d$export$2e2bcd8739ae039)(root);
    (0, $e96e7bd2600a346a$export$2e2bcd8739ae039)(root);
}).run();
const $120d39244fd9022f$var$isLoggedInUrl = $120d39244fd9022f$var$html.dataset.isLoggedIn;
const $120d39244fd9022f$var$timeout = $120d39244fd9022f$var$html.dataset.signedInTimeout;
if ($120d39244fd9022f$var$isLoggedInUrl && $120d39244fd9022f$var$timeout) $120d39244fd9022f$var$checkUserIsLoggedIn();
function $120d39244fd9022f$var$checkUserIsLoggedIn() {
    setTimeout(()=>{
        (0, $da6d917fcd2d3fe8$export$2e2bcd8739ae039).makeRequest('GET', $120d39244fd9022f$var$isLoggedInUrl, null, {
            history: false
        }).then((payload)=>{
            if (!payload.response) window.location = '/';
            else $120d39244fd9022f$var$checkUserIsLoggedIn();
        }).catch((error)=>{});
    }, 1000 * parseInt($120d39244fd9022f$var$timeout) + 30000);
}

})();
//# sourceMappingURL=main.js.map
